/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!(function (e, t) {
  'use strict';
  'object' == typeof module && 'object' == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document) throw new Error('jQuery requires a window with a document');
            return t(e);
          })
    : t(e);
})('undefined' != typeof window ? window : this, function (ie, e) {
  'use strict';
  var oe = [],
    r = Object.getPrototypeOf,
    ae = oe.slice,
    g = oe.flat
      ? function (e) {
          return oe.flat.call(e);
        }
      : function (e) {
          return oe.concat.apply([], e);
        },
    s = oe.push,
    se = oe.indexOf,
    n = {},
    i = n.toString,
    ue = n.hasOwnProperty,
    o = ue.toString,
    a = o.call(Object),
    le = {},
    v = function (e) {
      return 'function' == typeof e && 'number' != typeof e.nodeType && 'function' != typeof e.item;
    },
    y = function (e) {
      return null != e && e === e.window;
    },
    C = ie.document,
    u = {type: !0, src: !0, nonce: !0, noModule: !0};
  function m(e, t, n) {
    var r,
      i,
      o = (n = n || C).createElement('script');
    if (((o.text = e), t)) for (r in u) (i = t[r] || (t.getAttribute && t.getAttribute(r))) && o.setAttribute(r, i);
    n.head.appendChild(o).parentNode.removeChild(o);
  }
  function x(e) {
    return null == e ? e + '' : 'object' == typeof e || 'function' == typeof e ? n[i.call(e)] || 'object' : typeof e;
  }
  var t = '3.7.1',
    l = /HTML$/i,
    ce = function (e, t) {
      return new ce.fn.init(e, t);
    };
  function c(e) {
    var t = !!e && 'length' in e && e.length,
      n = x(e);
    return !v(e) && !y(e) && ('array' === n || 0 === t || ('number' == typeof t && 0 < t && t - 1 in e));
  }
  function fe(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  (ce.fn = ce.prototype =
    {
      jquery: t,
      constructor: ce,
      length: 0,
      toArray: function () {
        return ae.call(this);
      },
      get: function (e) {
        return null == e ? ae.call(this) : e < 0 ? this[e + this.length] : this[e];
      },
      pushStack: function (e) {
        var t = ce.merge(this.constructor(), e);
        return (t.prevObject = this), t;
      },
      each: function (e) {
        return ce.each(this, e);
      },
      map: function (n) {
        return this.pushStack(
          ce.map(this, function (e, t) {
            return n.call(e, t, e);
          })
        );
      },
      slice: function () {
        return this.pushStack(ae.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      even: function () {
        return this.pushStack(
          ce.grep(this, function (e, t) {
            return (t + 1) % 2;
          })
        );
      },
      odd: function () {
        return this.pushStack(
          ce.grep(this, function (e, t) {
            return t % 2;
          })
        );
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (e < 0 ? t : 0);
        return this.pushStack(0 <= n && n < t ? [this[n]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: s,
      sort: oe.sort,
      splice: oe.splice,
    }),
    (ce.extend = ce.fn.extend =
      function () {
        var e,
          t,
          n,
          r,
          i,
          o,
          a = arguments[0] || {},
          s = 1,
          u = arguments.length,
          l = !1;
        for (
          'boolean' == typeof a && ((l = a), (a = arguments[s] || {}), s++),
            'object' == typeof a || v(a) || (a = {}),
            s === u && ((a = this), s--);
          s < u;
          s++
        )
          if (null != (e = arguments[s]))
            for (t in e)
              (r = e[t]),
                '__proto__' !== t &&
                  a !== r &&
                  (l && r && (ce.isPlainObject(r) || (i = Array.isArray(r)))
                    ? ((n = a[t]),
                      (o = i && !Array.isArray(n) ? [] : i || ce.isPlainObject(n) ? n : {}),
                      (i = !1),
                      (a[t] = ce.extend(l, o, r)))
                    : void 0 !== r && (a[t] = r));
        return a;
      }),
    ce.extend({
      expando: 'jQuery' + (t + Math.random()).replace(/\D/g, ''),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, n;
        return (
          !(!e || '[object Object]' !== i.call(e)) &&
          (!(t = r(e)) || ('function' == typeof (n = ue.call(t, 'constructor') && t.constructor) && o.call(n) === a))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e, t, n) {
        m(e, {nonce: t && t.nonce}, n);
      },
      each: function (e, t) {
        var n,
          r = 0;
        if (c(e)) {
          for (n = e.length; r < n; r++) if (!1 === t.call(e[r], r, e[r])) break;
        } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
        return e;
      },
      text: function (e) {
        var t,
          n = '',
          r = 0,
          i = e.nodeType;
        if (!i) while ((t = e[r++])) n += ce.text(t);
        return 1 === i || 11 === i
          ? e.textContent
          : 9 === i
            ? e.documentElement.textContent
            : 3 === i || 4 === i
              ? e.nodeValue
              : n;
      },
      makeArray: function (e, t) {
        var n = t || [];
        return null != e && (c(Object(e)) ? ce.merge(n, 'string' == typeof e ? [e] : e) : s.call(n, e)), n;
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : se.call(t, e, n);
      },
      isXMLDoc: function (e) {
        var t = e && e.namespaceURI,
          n = e && (e.ownerDocument || e).documentElement;
        return !l.test(t || (n && n.nodeName) || 'HTML');
      },
      merge: function (e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
        return (e.length = i), e;
      },
      grep: function (e, t, n) {
        for (var r = [], i = 0, o = e.length, a = !n; i < o; i++) !t(e[i], i) !== a && r.push(e[i]);
        return r;
      },
      map: function (e, t, n) {
        var r,
          i,
          o = 0,
          a = [];
        if (c(e)) for (r = e.length; o < r; o++) null != (i = t(e[o], o, n)) && a.push(i);
        else for (o in e) null != (i = t(e[o], o, n)) && a.push(i);
        return g(a);
      },
      guid: 1,
      support: le,
    }),
    'function' == typeof Symbol && (ce.fn[Symbol.iterator] = oe[Symbol.iterator]),
    ce.each('Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '), function (e, t) {
      n['[object ' + t + ']'] = t.toLowerCase();
    });
  var pe = oe.pop,
    de = oe.sort,
    he = oe.splice,
    ge = '[\\x20\\t\\r\\n\\f]',
    ve = new RegExp('^' + ge + '+|((?:^|[^\\\\])(?:\\\\.)*)' + ge + '+$', 'g');
  ce.contains = function (e, t) {
    var n = t && t.parentNode;
    return (
      e === n ||
      !(
        !n ||
        1 !== n.nodeType ||
        !(e.contains ? e.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n))
      )
    );
  };
  var f = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
  function p(e, t) {
    return t
      ? '\0' === e
        ? '\ufffd'
        : e.slice(0, -1) + '\\' + e.charCodeAt(e.length - 1).toString(16) + ' '
      : '\\' + e;
  }
  ce.escapeSelector = function (e) {
    return (e + '').replace(f, p);
  };
  var ye = C,
    me = s;
  !(function () {
    var e,
      b,
      w,
      o,
      a,
      T,
      r,
      C,
      d,
      i,
      k = me,
      S = ce.expando,
      E = 0,
      n = 0,
      s = W(),
      c = W(),
      u = W(),
      h = W(),
      l = function (e, t) {
        return e === t && (a = !0), 0;
      },
      f =
        'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
      t = '(?:\\\\[\\da-fA-F]{1,6}' + ge + '?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
      p =
        '\\[' +
        ge +
        '*(' +
        t +
        ')(?:' +
        ge +
        '*([*^$|!~]?=)' +
        ge +
        '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
        t +
        '))|)' +
        ge +
        '*\\]',
      g =
        ':(' +
        t +
        ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
        p +
        ')*)|.*)\\)|)',
      v = new RegExp(ge + '+', 'g'),
      y = new RegExp('^' + ge + '*,' + ge + '*'),
      m = new RegExp('^' + ge + '*([>+~]|' + ge + ')' + ge + '*'),
      x = new RegExp(ge + '|>'),
      j = new RegExp(g),
      A = new RegExp('^' + t + '$'),
      D = {
        ID: new RegExp('^#(' + t + ')'),
        CLASS: new RegExp('^\\.(' + t + ')'),
        TAG: new RegExp('^(' + t + '|[*])'),
        ATTR: new RegExp('^' + p),
        PSEUDO: new RegExp('^' + g),
        CHILD: new RegExp(
          '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
            ge +
            '*(even|odd|(([+-]|)(\\d*)n|)' +
            ge +
            '*(?:([+-]|)' +
            ge +
            '*(\\d+)|))' +
            ge +
            '*\\)|)',
          'i'
        ),
        bool: new RegExp('^(?:' + f + ')$', 'i'),
        needsContext: new RegExp(
          '^' +
            ge +
            '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
            ge +
            '*((?:-\\d)?\\d*)' +
            ge +
            '*\\)|)(?=[^-]|$)',
          'i'
        ),
      },
      N = /^(?:input|select|textarea|button)$/i,
      q = /^h\d$/i,
      L = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      H = /[+~]/,
      O = new RegExp('\\\\[\\da-fA-F]{1,6}' + ge + '?|\\\\([^\\r\\n\\f])', 'g'),
      P = function (e, t) {
        var n = '0x' + e.slice(1) - 65536;
        return (
          t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
        );
      },
      M = function () {
        V();
      },
      R = J(
        function (e) {
          return !0 === e.disabled && fe(e, 'fieldset');
        },
        {dir: 'parentNode', next: 'legend'}
      );
    try {
      k.apply((oe = ae.call(ye.childNodes)), ye.childNodes), oe[ye.childNodes.length].nodeType;
    } catch (e) {
      k = {
        apply: function (e, t) {
          me.apply(e, ae.call(t));
        },
        call: function (e) {
          me.apply(e, ae.call(arguments, 1));
        },
      };
    }
    function I(t, e, n, r) {
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f = e && e.ownerDocument,
        p = e ? e.nodeType : 9;
      if (((n = n || []), 'string' != typeof t || !t || (1 !== p && 9 !== p && 11 !== p))) return n;
      if (!r && (V(e), (e = e || T), C)) {
        if (11 !== p && (u = L.exec(t)))
          if ((i = u[1])) {
            if (9 === p) {
              if (!(a = e.getElementById(i))) return n;
              if (a.id === i) return k.call(n, a), n;
            } else if (f && (a = f.getElementById(i)) && I.contains(e, a) && a.id === i) return k.call(n, a), n;
          } else {
            if (u[2]) return k.apply(n, e.getElementsByTagName(t)), n;
            if ((i = u[3]) && e.getElementsByClassName) return k.apply(n, e.getElementsByClassName(i)), n;
          }
        if (!(h[t + ' '] || (d && d.test(t)))) {
          if (((c = t), (f = e), 1 === p && (x.test(t) || m.test(t)))) {
            ((f = (H.test(t) && U(e.parentNode)) || e) == e && le.scope) ||
              ((s = e.getAttribute('id')) ? (s = ce.escapeSelector(s)) : e.setAttribute('id', (s = S))),
              (o = (l = Y(t)).length);
            while (o--) l[o] = (s ? '#' + s : ':scope') + ' ' + Q(l[o]);
            c = l.join(',');
          }
          try {
            return k.apply(n, f.querySelectorAll(c)), n;
          } catch (e) {
            h(t, !0);
          } finally {
            s === S && e.removeAttribute('id');
          }
        }
      }
      return re(t.replace(ve, '$1'), e, n, r);
    }
    function W() {
      var r = [];
      return function e(t, n) {
        return r.push(t + ' ') > b.cacheLength && delete e[r.shift()], (e[t + ' '] = n);
      };
    }
    function F(e) {
      return (e[S] = !0), e;
    }
    function $(e) {
      var t = T.createElement('fieldset');
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function B(t) {
      return function (e) {
        return fe(e, 'input') && e.type === t;
      };
    }
    function _(t) {
      return function (e) {
        return (fe(e, 'input') || fe(e, 'button')) && e.type === t;
      };
    }
    function z(t) {
      return function (e) {
        return 'form' in e
          ? e.parentNode && !1 === e.disabled
            ? 'label' in e
              ? 'label' in e.parentNode
                ? e.parentNode.disabled === t
                : e.disabled === t
              : e.isDisabled === t || (e.isDisabled !== !t && R(e) === t)
            : e.disabled === t
          : 'label' in e && e.disabled === t;
      };
    }
    function X(a) {
      return F(function (o) {
        return (
          (o = +o),
          F(function (e, t) {
            var n,
              r = a([], e.length, o),
              i = r.length;
            while (i--) e[(n = r[i])] && (e[n] = !(t[n] = e[n]));
          })
        );
      });
    }
    function U(e) {
      return e && 'undefined' != typeof e.getElementsByTagName && e;
    }
    function V(e) {
      var t,
        n = e ? e.ownerDocument || e : ye;
      return (
        n != T &&
          9 === n.nodeType &&
          n.documentElement &&
          ((r = (T = n).documentElement),
          (C = !ce.isXMLDoc(T)),
          (i = r.matches || r.webkitMatchesSelector || r.msMatchesSelector),
          r.msMatchesSelector && ye != T && (t = T.defaultView) && t.top !== t && t.addEventListener('unload', M),
          (le.getById = $(function (e) {
            return (r.appendChild(e).id = ce.expando), !T.getElementsByName || !T.getElementsByName(ce.expando).length;
          })),
          (le.disconnectedMatch = $(function (e) {
            return i.call(e, '*');
          })),
          (le.scope = $(function () {
            return T.querySelectorAll(':scope');
          })),
          (le.cssHas = $(function () {
            try {
              return T.querySelector(':has(*,:jqfake)'), !1;
            } catch (e) {
              return !0;
            }
          })),
          le.getById
            ? ((b.filter.ID = function (e) {
                var t = e.replace(O, P);
                return function (e) {
                  return e.getAttribute('id') === t;
                };
              }),
              (b.find.ID = function (e, t) {
                if ('undefined' != typeof t.getElementById && C) {
                  var n = t.getElementById(e);
                  return n ? [n] : [];
                }
              }))
            : ((b.filter.ID = function (e) {
                var n = e.replace(O, P);
                return function (e) {
                  var t = 'undefined' != typeof e.getAttributeNode && e.getAttributeNode('id');
                  return t && t.value === n;
                };
              }),
              (b.find.ID = function (e, t) {
                if ('undefined' != typeof t.getElementById && C) {
                  var n,
                    r,
                    i,
                    o = t.getElementById(e);
                  if (o) {
                    if ((n = o.getAttributeNode('id')) && n.value === e) return [o];
                    (i = t.getElementsByName(e)), (r = 0);
                    while ((o = i[r++])) if ((n = o.getAttributeNode('id')) && n.value === e) return [o];
                  }
                  return [];
                }
              })),
          (b.find.TAG = function (e, t) {
            return 'undefined' != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : t.querySelectorAll(e);
          }),
          (b.find.CLASS = function (e, t) {
            if ('undefined' != typeof t.getElementsByClassName && C) return t.getElementsByClassName(e);
          }),
          (d = []),
          $(function (e) {
            var t;
            (r.appendChild(e).innerHTML =
              "<a id='" +
              S +
              "' href='' disabled='disabled'></a><select id='" +
              S +
              "-\r\\' disabled='disabled'><option selected=''></option></select>"),
              e.querySelectorAll('[selected]').length || d.push('\\[' + ge + '*(?:value|' + f + ')'),
              e.querySelectorAll('[id~=' + S + '-]').length || d.push('~='),
              e.querySelectorAll('a#' + S + '+*').length || d.push('.#.+[+~]'),
              e.querySelectorAll(':checked').length || d.push(':checked'),
              (t = T.createElement('input')).setAttribute('type', 'hidden'),
              e.appendChild(t).setAttribute('name', 'D'),
              (r.appendChild(e).disabled = !0),
              2 !== e.querySelectorAll(':disabled').length && d.push(':enabled', ':disabled'),
              (t = T.createElement('input')).setAttribute('name', ''),
              e.appendChild(t),
              e.querySelectorAll("[name='']").length || d.push('\\[' + ge + '*name' + ge + '*=' + ge + '*(?:\'\'|"")');
          }),
          le.cssHas || d.push(':has'),
          (d = d.length && new RegExp(d.join('|'))),
          (l = function (e, t) {
            if (e === t) return (a = !0), 0;
            var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
            return (
              n ||
              (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) ||
              (!le.sortDetached && t.compareDocumentPosition(e) === n)
                ? e === T || (e.ownerDocument == ye && I.contains(ye, e))
                  ? -1
                  : t === T || (t.ownerDocument == ye && I.contains(ye, t))
                    ? 1
                    : o
                      ? se.call(o, e) - se.call(o, t)
                      : 0
                : 4 & n
                  ? -1
                  : 1)
            );
          })),
        T
      );
    }
    for (e in ((I.matches = function (e, t) {
      return I(e, null, null, t);
    }),
    (I.matchesSelector = function (e, t) {
      if ((V(e), C && !h[t + ' '] && (!d || !d.test(t))))
        try {
          var n = i.call(e, t);
          if (n || le.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return n;
        } catch (e) {
          h(t, !0);
        }
      return 0 < I(t, T, null, [e]).length;
    }),
    (I.contains = function (e, t) {
      return (e.ownerDocument || e) != T && V(e), ce.contains(e, t);
    }),
    (I.attr = function (e, t) {
      (e.ownerDocument || e) != T && V(e);
      var n = b.attrHandle[t.toLowerCase()],
        r = n && ue.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !C) : void 0;
      return void 0 !== r ? r : e.getAttribute(t);
    }),
    (I.error = function (e) {
      throw new Error('Syntax error, unrecognized expression: ' + e);
    }),
    (ce.uniqueSort = function (e) {
      var t,
        n = [],
        r = 0,
        i = 0;
      if (((a = !le.sortStable), (o = !le.sortStable && ae.call(e, 0)), de.call(e, l), a)) {
        while ((t = e[i++])) t === e[i] && (r = n.push(i));
        while (r--) he.call(e, n[r], 1);
      }
      return (o = null), e;
    }),
    (ce.fn.uniqueSort = function () {
      return this.pushStack(ce.uniqueSort(ae.apply(this)));
    }),
    ((b = ce.expr =
      {
        cacheLength: 50,
        createPseudo: F,
        match: D,
        attrHandle: {},
        find: {},
        relative: {
          '>': {dir: 'parentNode', first: !0},
          ' ': {dir: 'parentNode'},
          '+': {dir: 'previousSibling', first: !0},
          '~': {dir: 'previousSibling'},
        },
        preFilter: {
          ATTR: function (e) {
            return (
              (e[1] = e[1].replace(O, P)),
              (e[3] = (e[3] || e[4] || e[5] || '').replace(O, P)),
              '~=' === e[2] && (e[3] = ' ' + e[3] + ' '),
              e.slice(0, 4)
            );
          },
          CHILD: function (e) {
            return (
              (e[1] = e[1].toLowerCase()),
              'nth' === e[1].slice(0, 3)
                ? (e[3] || I.error(e[0]),
                  (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ('even' === e[3] || 'odd' === e[3]))),
                  (e[5] = +(e[7] + e[8] || 'odd' === e[3])))
                : e[3] && I.error(e[0]),
              e
            );
          },
          PSEUDO: function (e) {
            var t,
              n = !e[6] && e[2];
            return D.CHILD.test(e[0])
              ? null
              : (e[3]
                  ? (e[2] = e[4] || e[5] || '')
                  : n &&
                    j.test(n) &&
                    (t = Y(n, !0)) &&
                    (t = n.indexOf(')', n.length - t) - n.length) &&
                    ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                e.slice(0, 3));
          },
        },
        filter: {
          TAG: function (e) {
            var t = e.replace(O, P).toLowerCase();
            return '*' === e
              ? function () {
                  return !0;
                }
              : function (e) {
                  return fe(e, t);
                };
          },
          CLASS: function (e) {
            var t = s[e + ' '];
            return (
              t ||
              ((t = new RegExp('(^|' + ge + ')' + e + '(' + ge + '|$)')) &&
                s(e, function (e) {
                  return t.test(
                    ('string' == typeof e.className && e.className) ||
                      ('undefined' != typeof e.getAttribute && e.getAttribute('class')) ||
                      ''
                  );
                }))
            );
          },
          ATTR: function (n, r, i) {
            return function (e) {
              var t = I.attr(e, n);
              return null == t
                ? '!=' === r
                : !r ||
                    ((t += ''),
                    '=' === r
                      ? t === i
                      : '!=' === r
                        ? t !== i
                        : '^=' === r
                          ? i && 0 === t.indexOf(i)
                          : '*=' === r
                            ? i && -1 < t.indexOf(i)
                            : '$=' === r
                              ? i && t.slice(-i.length) === i
                              : '~=' === r
                                ? -1 < (' ' + t.replace(v, ' ') + ' ').indexOf(i)
                                : '|=' === r && (t === i || t.slice(0, i.length + 1) === i + '-'));
            };
          },
          CHILD: function (d, e, t, h, g) {
            var v = 'nth' !== d.slice(0, 3),
              y = 'last' !== d.slice(-4),
              m = 'of-type' === e;
            return 1 === h && 0 === g
              ? function (e) {
                  return !!e.parentNode;
                }
              : function (e, t, n) {
                  var r,
                    i,
                    o,
                    a,
                    s,
                    u = v !== y ? 'nextSibling' : 'previousSibling',
                    l = e.parentNode,
                    c = m && e.nodeName.toLowerCase(),
                    f = !n && !m,
                    p = !1;
                  if (l) {
                    if (v) {
                      while (u) {
                        o = e;
                        while ((o = o[u])) if (m ? fe(o, c) : 1 === o.nodeType) return !1;
                        s = u = 'only' === d && !s && 'nextSibling';
                      }
                      return !0;
                    }
                    if (((s = [y ? l.firstChild : l.lastChild]), y && f)) {
                      (p = (a = (r = (i = l[S] || (l[S] = {}))[d] || [])[0] === E && r[1]) && r[2]),
                        (o = a && l.childNodes[a]);
                      while ((o = (++a && o && o[u]) || (p = a = 0) || s.pop()))
                        if (1 === o.nodeType && ++p && o === e) {
                          i[d] = [E, a, p];
                          break;
                        }
                    } else if ((f && (p = a = (r = (i = e[S] || (e[S] = {}))[d] || [])[0] === E && r[1]), !1 === p))
                      while ((o = (++a && o && o[u]) || (p = a = 0) || s.pop()))
                        if (
                          (m ? fe(o, c) : 1 === o.nodeType) &&
                          ++p &&
                          (f && ((i = o[S] || (o[S] = {}))[d] = [E, p]), o === e)
                        )
                          break;
                    return (p -= g) === h || (p % h == 0 && 0 <= p / h);
                  }
                };
          },
          PSEUDO: function (e, o) {
            var t,
              a = b.pseudos[e] || b.setFilters[e.toLowerCase()] || I.error('unsupported pseudo: ' + e);
            return a[S]
              ? a(o)
              : 1 < a.length
                ? ((t = [e, e, '', o]),
                  b.setFilters.hasOwnProperty(e.toLowerCase())
                    ? F(function (e, t) {
                        var n,
                          r = a(e, o),
                          i = r.length;
                        while (i--) e[(n = se.call(e, r[i]))] = !(t[n] = r[i]);
                      })
                    : function (e) {
                        return a(e, 0, t);
                      })
                : a;
          },
        },
        pseudos: {
          not: F(function (e) {
            var r = [],
              i = [],
              s = ne(e.replace(ve, '$1'));
            return s[S]
              ? F(function (e, t, n, r) {
                  var i,
                    o = s(e, null, r, []),
                    a = e.length;
                  while (a--) (i = o[a]) && (e[a] = !(t[a] = i));
                })
              : function (e, t, n) {
                  return (r[0] = e), s(r, null, n, i), (r[0] = null), !i.pop();
                };
          }),
          has: F(function (t) {
            return function (e) {
              return 0 < I(t, e).length;
            };
          }),
          contains: F(function (t) {
            return (
              (t = t.replace(O, P)),
              function (e) {
                return -1 < (e.textContent || ce.text(e)).indexOf(t);
              }
            );
          }),
          lang: F(function (n) {
            return (
              A.test(n || '') || I.error('unsupported lang: ' + n),
              (n = n.replace(O, P).toLowerCase()),
              function (e) {
                var t;
                do {
                  if ((t = C ? e.lang : e.getAttribute('xml:lang') || e.getAttribute('lang')))
                    return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + '-');
                } while ((e = e.parentNode) && 1 === e.nodeType);
                return !1;
              }
            );
          }),
          target: function (e) {
            var t = ie.location && ie.location.hash;
            return t && t.slice(1) === e.id;
          },
          root: function (e) {
            return e === r;
          },
          focus: function (e) {
            return (
              e ===
                (function () {
                  try {
                    return T.activeElement;
                  } catch (e) {}
                })() &&
              T.hasFocus() &&
              !!(e.type || e.href || ~e.tabIndex)
            );
          },
          enabled: z(!1),
          disabled: z(!0),
          checked: function (e) {
            return (fe(e, 'input') && !!e.checked) || (fe(e, 'option') && !!e.selected);
          },
          selected: function (e) {
            return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
          },
          empty: function (e) {
            for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
            return !0;
          },
          parent: function (e) {
            return !b.pseudos.empty(e);
          },
          header: function (e) {
            return q.test(e.nodeName);
          },
          input: function (e) {
            return N.test(e.nodeName);
          },
          button: function (e) {
            return (fe(e, 'input') && 'button' === e.type) || fe(e, 'button');
          },
          text: function (e) {
            var t;
            return (
              fe(e, 'input') &&
              'text' === e.type &&
              (null == (t = e.getAttribute('type')) || 'text' === t.toLowerCase())
            );
          },
          first: X(function () {
            return [0];
          }),
          last: X(function (e, t) {
            return [t - 1];
          }),
          eq: X(function (e, t, n) {
            return [n < 0 ? n + t : n];
          }),
          even: X(function (e, t) {
            for (var n = 0; n < t; n += 2) e.push(n);
            return e;
          }),
          odd: X(function (e, t) {
            for (var n = 1; n < t; n += 2) e.push(n);
            return e;
          }),
          lt: X(function (e, t, n) {
            var r;
            for (r = n < 0 ? n + t : t < n ? t : n; 0 <= --r; ) e.push(r);
            return e;
          }),
          gt: X(function (e, t, n) {
            for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
            return e;
          }),
        },
      }).pseudos.nth = b.pseudos.eq),
    {radio: !0, checkbox: !0, file: !0, password: !0, image: !0}))
      b.pseudos[e] = B(e);
    for (e in {submit: !0, reset: !0}) b.pseudos[e] = _(e);
    function G() {}
    function Y(e, t) {
      var n,
        r,
        i,
        o,
        a,
        s,
        u,
        l = c[e + ' '];
      if (l) return t ? 0 : l.slice(0);
      (a = e), (s = []), (u = b.preFilter);
      while (a) {
        for (o in ((n && !(r = y.exec(a))) || (r && (a = a.slice(r[0].length) || a), s.push((i = []))),
        (n = !1),
        (r = m.exec(a)) && ((n = r.shift()), i.push({value: n, type: r[0].replace(ve, ' ')}), (a = a.slice(n.length))),
        b.filter))
          !(r = D[o].exec(a)) ||
            (u[o] && !(r = u[o](r))) ||
            ((n = r.shift()), i.push({value: n, type: o, matches: r}), (a = a.slice(n.length)));
        if (!n) break;
      }
      return t ? a.length : a ? I.error(e) : c(e, s).slice(0);
    }
    function Q(e) {
      for (var t = 0, n = e.length, r = ''; t < n; t++) r += e[t].value;
      return r;
    }
    function J(a, e, t) {
      var s = e.dir,
        u = e.next,
        l = u || s,
        c = t && 'parentNode' === l,
        f = n++;
      return e.first
        ? function (e, t, n) {
            while ((e = e[s])) if (1 === e.nodeType || c) return a(e, t, n);
            return !1;
          }
        : function (e, t, n) {
            var r,
              i,
              o = [E, f];
            if (n) {
              while ((e = e[s])) if ((1 === e.nodeType || c) && a(e, t, n)) return !0;
            } else
              while ((e = e[s]))
                if (1 === e.nodeType || c)
                  if (((i = e[S] || (e[S] = {})), u && fe(e, u))) e = e[s] || e;
                  else {
                    if ((r = i[l]) && r[0] === E && r[1] === f) return (o[2] = r[2]);
                    if (((i[l] = o)[2] = a(e, t, n))) return !0;
                  }
            return !1;
          };
    }
    function K(i) {
      return 1 < i.length
        ? function (e, t, n) {
            var r = i.length;
            while (r--) if (!i[r](e, t, n)) return !1;
            return !0;
          }
        : i[0];
    }
    function Z(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
        (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
      return a;
    }
    function ee(d, h, g, v, y, e) {
      return (
        v && !v[S] && (v = ee(v)),
        y && !y[S] && (y = ee(y, e)),
        F(function (e, t, n, r) {
          var i,
            o,
            a,
            s,
            u = [],
            l = [],
            c = t.length,
            f =
              e ||
              (function (e, t, n) {
                for (var r = 0, i = t.length; r < i; r++) I(e, t[r], n);
                return n;
              })(h || '*', n.nodeType ? [n] : n, []),
            p = !d || (!e && h) ? f : Z(f, u, d, n, r);
          if ((g ? g(p, (s = y || (e ? d : c || v) ? [] : t), n, r) : (s = p), v)) {
            (i = Z(s, l)), v(i, [], n, r), (o = i.length);
            while (o--) (a = i[o]) && (s[l[o]] = !(p[l[o]] = a));
          }
          if (e) {
            if (y || d) {
              if (y) {
                (i = []), (o = s.length);
                while (o--) (a = s[o]) && i.push((p[o] = a));
                y(null, (s = []), i, r);
              }
              o = s.length;
              while (o--) (a = s[o]) && -1 < (i = y ? se.call(e, a) : u[o]) && (e[i] = !(t[i] = a));
            }
          } else (s = Z(s === t ? s.splice(c, s.length) : s)), y ? y(null, t, s, r) : k.apply(t, s);
        })
      );
    }
    function te(e) {
      for (
        var i,
          t,
          n,
          r = e.length,
          o = b.relative[e[0].type],
          a = o || b.relative[' '],
          s = o ? 1 : 0,
          u = J(
            function (e) {
              return e === i;
            },
            a,
            !0
          ),
          l = J(
            function (e) {
              return -1 < se.call(i, e);
            },
            a,
            !0
          ),
          c = [
            function (e, t, n) {
              var r = (!o && (n || t != w)) || ((i = t).nodeType ? u(e, t, n) : l(e, t, n));
              return (i = null), r;
            },
          ];
        s < r;
        s++
      )
        if ((t = b.relative[e[s].type])) c = [J(K(c), t)];
        else {
          if ((t = b.filter[e[s].type].apply(null, e[s].matches))[S]) {
            for (n = ++s; n < r; n++) if (b.relative[e[n].type]) break;
            return ee(
              1 < s && K(c),
              1 < s && Q(e.slice(0, s - 1).concat({value: ' ' === e[s - 2].type ? '*' : ''})).replace(ve, '$1'),
              t,
              s < n && te(e.slice(s, n)),
              n < r && te((e = e.slice(n))),
              n < r && Q(e)
            );
          }
          c.push(t);
        }
      return K(c);
    }
    function ne(e, t) {
      var n,
        v,
        y,
        m,
        x,
        r,
        i = [],
        o = [],
        a = u[e + ' '];
      if (!a) {
        t || (t = Y(e)), (n = t.length);
        while (n--) (a = te(t[n]))[S] ? i.push(a) : o.push(a);
        (a = u(
          e,
          ((v = o),
          (m = 0 < (y = i).length),
          (x = 0 < v.length),
          (r = function (e, t, n, r, i) {
            var o,
              a,
              s,
              u = 0,
              l = '0',
              c = e && [],
              f = [],
              p = w,
              d = e || (x && b.find.TAG('*', i)),
              h = (E += null == p ? 1 : Math.random() || 0.1),
              g = d.length;
            for (i && (w = t == T || t || i); l !== g && null != (o = d[l]); l++) {
              if (x && o) {
                (a = 0), t || o.ownerDocument == T || (V(o), (n = !C));
                while ((s = v[a++]))
                  if (s(o, t || T, n)) {
                    k.call(r, o);
                    break;
                  }
                i && (E = h);
              }
              m && ((o = !s && o) && u--, e && c.push(o));
            }
            if (((u += l), m && l !== u)) {
              a = 0;
              while ((s = y[a++])) s(c, f, t, n);
              if (e) {
                if (0 < u) while (l--) c[l] || f[l] || (f[l] = pe.call(r));
                f = Z(f);
              }
              k.apply(r, f), i && !e && 0 < f.length && 1 < u + y.length && ce.uniqueSort(r);
            }
            return i && ((E = h), (w = p)), c;
          }),
          m ? F(r) : r)
        )).selector = e;
      }
      return a;
    }
    function re(e, t, n, r) {
      var i,
        o,
        a,
        s,
        u,
        l = 'function' == typeof e && e,
        c = !r && Y((e = l.selector || e));
      if (((n = n || []), 1 === c.length)) {
        if (
          2 < (o = c[0] = c[0].slice(0)).length &&
          'ID' === (a = o[0]).type &&
          9 === t.nodeType &&
          C &&
          b.relative[o[1].type]
        ) {
          if (!(t = (b.find.ID(a.matches[0].replace(O, P), t) || [])[0])) return n;
          l && (t = t.parentNode), (e = e.slice(o.shift().value.length));
        }
        i = D.needsContext.test(e) ? 0 : o.length;
        while (i--) {
          if (((a = o[i]), b.relative[(s = a.type)])) break;
          if ((u = b.find[s]) && (r = u(a.matches[0].replace(O, P), (H.test(o[0].type) && U(t.parentNode)) || t))) {
            if ((o.splice(i, 1), !(e = r.length && Q(o)))) return k.apply(n, r), n;
            break;
          }
        }
      }
      return (l || ne(e, c))(r, t, !C, n, !t || (H.test(e) && U(t.parentNode)) || t), n;
    }
    (G.prototype = b.filters = b.pseudos),
      (b.setFilters = new G()),
      (le.sortStable = S.split('').sort(l).join('') === S),
      V(),
      (le.sortDetached = $(function (e) {
        return 1 & e.compareDocumentPosition(T.createElement('fieldset'));
      })),
      (ce.find = I),
      (ce.expr[':'] = ce.expr.pseudos),
      (ce.unique = ce.uniqueSort),
      (I.compile = ne),
      (I.select = re),
      (I.setDocument = V),
      (I.tokenize = Y),
      (I.escape = ce.escapeSelector),
      (I.getText = ce.text),
      (I.isXML = ce.isXMLDoc),
      (I.selectors = ce.expr),
      (I.support = ce.support),
      (I.uniqueSort = ce.uniqueSort);
  })();
  var d = function (e, t, n) {
      var r = [],
        i = void 0 !== n;
      while ((e = e[t]) && 9 !== e.nodeType)
        if (1 === e.nodeType) {
          if (i && ce(e).is(n)) break;
          r.push(e);
        }
      return r;
    },
    h = function (e, t) {
      for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    b = ce.expr.match.needsContext,
    w = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function T(e, n, r) {
    return v(n)
      ? ce.grep(e, function (e, t) {
          return !!n.call(e, t, e) !== r;
        })
      : n.nodeType
        ? ce.grep(e, function (e) {
            return (e === n) !== r;
          })
        : 'string' != typeof n
          ? ce.grep(e, function (e) {
              return -1 < se.call(n, e) !== r;
            })
          : ce.filter(n, e, r);
  }
  (ce.filter = function (e, t, n) {
    var r = t[0];
    return (
      n && (e = ':not(' + e + ')'),
      1 === t.length && 1 === r.nodeType
        ? ce.find.matchesSelector(r, e)
          ? [r]
          : []
        : ce.find.matches(
            e,
            ce.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    ce.fn.extend({
      find: function (e) {
        var t,
          n,
          r = this.length,
          i = this;
        if ('string' != typeof e)
          return this.pushStack(
            ce(e).filter(function () {
              for (t = 0; t < r; t++) if (ce.contains(i[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < r; t++) ce.find(e, i[t], n);
        return 1 < r ? ce.uniqueSort(n) : n;
      },
      filter: function (e) {
        return this.pushStack(T(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(T(this, e || [], !0));
      },
      is: function (e) {
        return !!T(this, 'string' == typeof e && b.test(e) ? ce(e) : e || [], !1).length;
      },
    });
  var k,
    S = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((ce.fn.init = function (e, t, n) {
    var r, i;
    if (!e) return this;
    if (((n = n || k), 'string' == typeof e)) {
      if (!(r = '<' === e[0] && '>' === e[e.length - 1] && 3 <= e.length ? [null, e, null] : S.exec(e)) || (!r[1] && t))
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (r[1]) {
        if (
          ((t = t instanceof ce ? t[0] : t),
          ce.merge(this, ce.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : C, !0)),
          w.test(r[1]) && ce.isPlainObject(t))
        )
          for (r in t) v(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
        return this;
      }
      return (i = C.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this;
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : v(e)
        ? void 0 !== n.ready
          ? n.ready(e)
          : e(ce)
        : ce.makeArray(e, this);
  }).prototype = ce.fn),
    (k = ce(C));
  var E = /^(?:parents|prev(?:Until|All))/,
    j = {children: !0, contents: !0, next: !0, prev: !0};
  function A(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType);
    return e;
  }
  ce.fn.extend({
    has: function (e) {
      var t = ce(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (ce.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var n,
        r = 0,
        i = this.length,
        o = [],
        a = 'string' != typeof e && ce(e);
      if (!b.test(e))
        for (; r < i; r++)
          for (n = this[r]; n && n !== t; n = n.parentNode)
            if (n.nodeType < 11 && (a ? -1 < a.index(n) : 1 === n.nodeType && ce.find.matchesSelector(n, e))) {
              o.push(n);
              break;
            }
      return this.pushStack(1 < o.length ? ce.uniqueSort(o) : o);
    },
    index: function (e) {
      return e
        ? 'string' == typeof e
          ? se.call(ce(e), this[0])
          : se.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
    },
    add: function (e, t) {
      return this.pushStack(ce.uniqueSort(ce.merge(this.get(), ce(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    ce.each(
      {
        parent: function (e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function (e) {
          return d(e, 'parentNode');
        },
        parentsUntil: function (e, t, n) {
          return d(e, 'parentNode', n);
        },
        next: function (e) {
          return A(e, 'nextSibling');
        },
        prev: function (e) {
          return A(e, 'previousSibling');
        },
        nextAll: function (e) {
          return d(e, 'nextSibling');
        },
        prevAll: function (e) {
          return d(e, 'previousSibling');
        },
        nextUntil: function (e, t, n) {
          return d(e, 'nextSibling', n);
        },
        prevUntil: function (e, t, n) {
          return d(e, 'previousSibling', n);
        },
        siblings: function (e) {
          return h((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return h(e.firstChild);
        },
        contents: function (e) {
          return null != e.contentDocument && r(e.contentDocument)
            ? e.contentDocument
            : (fe(e, 'template') && (e = e.content || e), ce.merge([], e.childNodes));
        },
      },
      function (r, i) {
        ce.fn[r] = function (e, t) {
          var n = ce.map(this, i, e);
          return (
            'Until' !== r.slice(-5) && (t = e),
            t && 'string' == typeof t && (n = ce.filter(t, n)),
            1 < this.length && (j[r] || ce.uniqueSort(n), E.test(r) && n.reverse()),
            this.pushStack(n)
          );
        };
      }
    );
  var D = /[^\x20\t\r\n\f]+/g;
  function N(e) {
    return e;
  }
  function q(e) {
    throw e;
  }
  function L(e, t, n, r) {
    var i;
    try {
      e && v((i = e.promise))
        ? i.call(e).done(t).fail(n)
        : e && v((i = e.then))
          ? i.call(e, t, n)
          : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  (ce.Callbacks = function (r) {
    var e, n;
    r =
      'string' == typeof r
        ? ((e = r),
          (n = {}),
          ce.each(e.match(D) || [], function (e, t) {
            n[t] = !0;
          }),
          n)
        : ce.extend({}, r);
    var i,
      t,
      o,
      a,
      s = [],
      u = [],
      l = -1,
      c = function () {
        for (a = a || r.once, o = i = !0; u.length; l = -1) {
          t = u.shift();
          while (++l < s.length) !1 === s[l].apply(t[0], t[1]) && r.stopOnFalse && ((l = s.length), (t = !1));
        }
        r.memory || (t = !1), (i = !1), a && (s = t ? [] : '');
      },
      f = {
        add: function () {
          return (
            s &&
              (t && !i && ((l = s.length - 1), u.push(t)),
              (function n(e) {
                ce.each(e, function (e, t) {
                  v(t) ? (r.unique && f.has(t)) || s.push(t) : t && t.length && 'string' !== x(t) && n(t);
                });
              })(arguments),
              t && !i && c()),
            this
          );
        },
        remove: function () {
          return (
            ce.each(arguments, function (e, t) {
              var n;
              while (-1 < (n = ce.inArray(t, s, n))) s.splice(n, 1), n <= l && l--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? -1 < ce.inArray(e, s) : 0 < s.length;
        },
        empty: function () {
          return s && (s = []), this;
        },
        disable: function () {
          return (a = u = []), (s = t = ''), this;
        },
        disabled: function () {
          return !s;
        },
        lock: function () {
          return (a = u = []), t || i || (s = t = ''), this;
        },
        locked: function () {
          return !!a;
        },
        fireWith: function (e, t) {
          return a || ((t = [e, (t = t || []).slice ? t.slice() : t]), u.push(t), i || c()), this;
        },
        fire: function () {
          return f.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!o;
        },
      };
    return f;
  }),
    ce.extend({
      Deferred: function (e) {
        var o = [
            ['notify', 'progress', ce.Callbacks('memory'), ce.Callbacks('memory'), 2],
            ['resolve', 'done', ce.Callbacks('once memory'), ce.Callbacks('once memory'), 0, 'resolved'],
            ['reject', 'fail', ce.Callbacks('once memory'), ce.Callbacks('once memory'), 1, 'rejected'],
          ],
          i = 'pending',
          a = {
            state: function () {
              return i;
            },
            always: function () {
              return s.done(arguments).fail(arguments), this;
            },
            catch: function (e) {
              return a.then(null, e);
            },
            pipe: function () {
              var i = arguments;
              return ce
                .Deferred(function (r) {
                  ce.each(o, function (e, t) {
                    var n = v(i[t[4]]) && i[t[4]];
                    s[t[1]](function () {
                      var e = n && n.apply(this, arguments);
                      e && v(e.promise)
                        ? e.promise().progress(r.notify).done(r.resolve).fail(r.reject)
                        : r[t[0] + 'With'](this, n ? [e] : arguments);
                    });
                  }),
                    (i = null);
                })
                .promise();
            },
            then: function (t, n, r) {
              var u = 0;
              function l(i, o, a, s) {
                return function () {
                  var n = this,
                    r = arguments,
                    e = function () {
                      var e, t;
                      if (!(i < u)) {
                        if ((e = a.apply(n, r)) === o.promise()) throw new TypeError('Thenable self-resolution');
                        (t = e && ('object' == typeof e || 'function' == typeof e) && e.then),
                          v(t)
                            ? s
                              ? t.call(e, l(u, o, N, s), l(u, o, q, s))
                              : (u++, t.call(e, l(u, o, N, s), l(u, o, q, s), l(u, o, N, o.notifyWith)))
                            : (a !== N && ((n = void 0), (r = [e])), (s || o.resolveWith)(n, r));
                      }
                    },
                    t = s
                      ? e
                      : function () {
                          try {
                            e();
                          } catch (e) {
                            ce.Deferred.exceptionHook && ce.Deferred.exceptionHook(e, t.error),
                              u <= i + 1 && (a !== q && ((n = void 0), (r = [e])), o.rejectWith(n, r));
                          }
                        };
                  i
                    ? t()
                    : (ce.Deferred.getErrorHook
                        ? (t.error = ce.Deferred.getErrorHook())
                        : ce.Deferred.getStackHook && (t.error = ce.Deferred.getStackHook()),
                      ie.setTimeout(t));
                };
              }
              return ce
                .Deferred(function (e) {
                  o[0][3].add(l(0, e, v(r) ? r : N, e.notifyWith)),
                    o[1][3].add(l(0, e, v(t) ? t : N)),
                    o[2][3].add(l(0, e, v(n) ? n : q));
                })
                .promise();
            },
            promise: function (e) {
              return null != e ? ce.extend(e, a) : a;
            },
          },
          s = {};
        return (
          ce.each(o, function (e, t) {
            var n = t[2],
              r = t[5];
            (a[t[1]] = n.add),
              r &&
                n.add(
                  function () {
                    i = r;
                  },
                  o[3 - e][2].disable,
                  o[3 - e][3].disable,
                  o[0][2].lock,
                  o[0][3].lock
                ),
              n.add(t[3].fire),
              (s[t[0]] = function () {
                return s[t[0] + 'With'](this === s ? void 0 : this, arguments), this;
              }),
              (s[t[0] + 'With'] = n.fireWith);
          }),
          a.promise(s),
          e && e.call(s, s),
          s
        );
      },
      when: function (e) {
        var n = arguments.length,
          t = n,
          r = Array(t),
          i = ae.call(arguments),
          o = ce.Deferred(),
          a = function (t) {
            return function (e) {
              (r[t] = this), (i[t] = 1 < arguments.length ? ae.call(arguments) : e), --n || o.resolveWith(r, i);
            };
          };
        if (n <= 1 && (L(e, o.done(a(t)).resolve, o.reject, !n), 'pending' === o.state() || v(i[t] && i[t].then)))
          return o.then();
        while (t--) L(i[t], a(t), o.reject);
        return o.promise();
      },
    });
  var H = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (ce.Deferred.exceptionHook = function (e, t) {
    ie.console &&
      ie.console.warn &&
      e &&
      H.test(e.name) &&
      ie.console.warn('jQuery.Deferred exception: ' + e.message, e.stack, t);
  }),
    (ce.readyException = function (e) {
      ie.setTimeout(function () {
        throw e;
      });
    });
  var O = ce.Deferred();
  function P() {
    C.removeEventListener('DOMContentLoaded', P), ie.removeEventListener('load', P), ce.ready();
  }
  (ce.fn.ready = function (e) {
    return (
      O.then(e)['catch'](function (e) {
        ce.readyException(e);
      }),
      this
    );
  }),
    ce.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --ce.readyWait : ce.isReady) ||
          ((ce.isReady = !0) !== e && 0 < --ce.readyWait) ||
          O.resolveWith(C, [ce]);
      },
    }),
    (ce.ready.then = O.then),
    'complete' === C.readyState || ('loading' !== C.readyState && !C.documentElement.doScroll)
      ? ie.setTimeout(ce.ready)
      : (C.addEventListener('DOMContentLoaded', P), ie.addEventListener('load', P));
  var M = function (e, t, n, r, i, o, a) {
      var s = 0,
        u = e.length,
        l = null == n;
      if ('object' === x(n)) for (s in ((i = !0), n)) M(e, t, s, n[s], !0, o, a);
      else if (
        void 0 !== r &&
        ((i = !0),
        v(r) || (a = !0),
        l &&
          (a
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function (e, t, n) {
                return l.call(ce(e), n);
              }))),
        t)
      )
        for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
    },
    R = /^-ms-/,
    I = /-([a-z])/g;
  function W(e, t) {
    return t.toUpperCase();
  }
  function F(e) {
    return e.replace(R, 'ms-').replace(I, W);
  }
  var $ = function (e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };
  function B() {
    this.expando = ce.expando + B.uid++;
  }
  (B.uid = 1),
    (B.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            $(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {value: t, configurable: !0}))),
          t
        );
      },
      set: function (e, t, n) {
        var r,
          i = this.cache(e);
        if ('string' == typeof t) i[F(t)] = n;
        else for (r in t) i[F(r)] = t[r];
        return i;
      },
      get: function (e, t) {
        return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][F(t)];
      },
      access: function (e, t, n) {
        return void 0 === t || (t && 'string' == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          r = e[this.expando];
        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t) ? t.map(F) : (t = F(t)) in r ? [t] : t.match(D) || []).length;
            while (n--) delete r[t[n]];
          }
          (void 0 === t || ce.isEmptyObject(r)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !ce.isEmptyObject(t);
      },
    });
  var _ = new B(),
    z = new B(),
    X = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    U = /[A-Z]/g;
  function V(e, t, n) {
    var r, i;
    if (void 0 === n && 1 === e.nodeType)
      if (((r = 'data-' + t.replace(U, '-$&').toLowerCase()), 'string' == typeof (n = e.getAttribute(r)))) {
        try {
          n =
            'true' === (i = n) ||
            ('false' !== i && ('null' === i ? null : i === +i + '' ? +i : X.test(i) ? JSON.parse(i) : i));
        } catch (e) {}
        z.set(e, t, n);
      } else n = void 0;
    return n;
  }
  ce.extend({
    hasData: function (e) {
      return z.hasData(e) || _.hasData(e);
    },
    data: function (e, t, n) {
      return z.access(e, t, n);
    },
    removeData: function (e, t) {
      z.remove(e, t);
    },
    _data: function (e, t, n) {
      return _.access(e, t, n);
    },
    _removeData: function (e, t) {
      _.remove(e, t);
    },
  }),
    ce.fn.extend({
      data: function (n, e) {
        var t,
          r,
          i,
          o = this[0],
          a = o && o.attributes;
        if (void 0 === n) {
          if (this.length && ((i = z.get(o)), 1 === o.nodeType && !_.get(o, 'hasDataAttrs'))) {
            t = a.length;
            while (t--) a[t] && 0 === (r = a[t].name).indexOf('data-') && ((r = F(r.slice(5))), V(o, r, i[r]));
            _.set(o, 'hasDataAttrs', !0);
          }
          return i;
        }
        return 'object' == typeof n
          ? this.each(function () {
              z.set(this, n);
            })
          : M(
              this,
              function (e) {
                var t;
                if (o && void 0 === e) return void 0 !== (t = z.get(o, n)) ? t : void 0 !== (t = V(o, n)) ? t : void 0;
                this.each(function () {
                  z.set(this, n, e);
                });
              },
              null,
              e,
              1 < arguments.length,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          z.remove(this, e);
        });
      },
    }),
    ce.extend({
      queue: function (e, t, n) {
        var r;
        if (e)
          return (
            (t = (t || 'fx') + 'queue'),
            (r = _.get(e, t)),
            n && (!r || Array.isArray(n) ? (r = _.access(e, t, ce.makeArray(n))) : r.push(n)),
            r || []
          );
      },
      dequeue: function (e, t) {
        t = t || 'fx';
        var n = ce.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = ce._queueHooks(e, t);
        'inprogress' === i && ((i = n.shift()), r--),
          i &&
            ('fx' === t && n.unshift('inprogress'),
            delete o.stop,
            i.call(
              e,
              function () {
                ce.dequeue(e, t);
              },
              o
            )),
          !r && o && o.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + 'queueHooks';
        return (
          _.get(e, n) ||
          _.access(e, n, {
            empty: ce.Callbacks('once memory').add(function () {
              _.remove(e, [t + 'queue', n]);
            }),
          })
        );
      },
    }),
    ce.fn.extend({
      queue: function (t, n) {
        var e = 2;
        return (
          'string' != typeof t && ((n = t), (t = 'fx'), e--),
          arguments.length < e
            ? ce.queue(this[0], t)
            : void 0 === n
              ? this
              : this.each(function () {
                  var e = ce.queue(this, t, n);
                  ce._queueHooks(this, t), 'fx' === t && 'inprogress' !== e[0] && ce.dequeue(this, t);
                })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          ce.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || 'fx', []);
      },
      promise: function (e, t) {
        var n,
          r = 1,
          i = ce.Deferred(),
          o = this,
          a = this.length,
          s = function () {
            --r || i.resolveWith(o, [o]);
          };
        'string' != typeof e && ((t = e), (e = void 0)), (e = e || 'fx');
        while (a--) (n = _.get(o[a], e + 'queueHooks')) && n.empty && (r++, n.empty.add(s));
        return s(), i.promise(t);
      },
    });
  var G = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    Y = new RegExp('^(?:([+-])=|)(' + G + ')([a-z%]*)$', 'i'),
    Q = ['Top', 'Right', 'Bottom', 'Left'],
    J = C.documentElement,
    K = function (e) {
      return ce.contains(e.ownerDocument, e);
    },
    Z = {composed: !0};
  J.getRootNode &&
    (K = function (e) {
      return ce.contains(e.ownerDocument, e) || e.getRootNode(Z) === e.ownerDocument;
    });
  var ee = function (e, t) {
    return 'none' === (e = t || e).style.display || ('' === e.style.display && K(e) && 'none' === ce.css(e, 'display'));
  };
  function te(e, t, n, r) {
    var i,
      o,
      a = 20,
      s = r
        ? function () {
            return r.cur();
          }
        : function () {
            return ce.css(e, t, '');
          },
      u = s(),
      l = (n && n[3]) || (ce.cssNumber[t] ? '' : 'px'),
      c = e.nodeType && (ce.cssNumber[t] || ('px' !== l && +u)) && Y.exec(ce.css(e, t));
    if (c && c[3] !== l) {
      (u /= 2), (l = l || c[3]), (c = +u || 1);
      while (a--) ce.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0), (c /= o);
      (c *= 2), ce.style(e, t, c + l), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    );
  }
  var ne = {};
  function re(e, t) {
    for (var n, r, i, o, a, s, u, l = [], c = 0, f = e.length; c < f; c++)
      (r = e[c]).style &&
        ((n = r.style.display),
        t
          ? ('none' === n && ((l[c] = _.get(r, 'display') || null), l[c] || (r.style.display = '')),
            '' === r.style.display &&
              ee(r) &&
              (l[c] =
                ((u = a = o = void 0),
                (a = (i = r).ownerDocument),
                (s = i.nodeName),
                (u = ne[s]) ||
                  ((o = a.body.appendChild(a.createElement(s))),
                  (u = ce.css(o, 'display')),
                  o.parentNode.removeChild(o),
                  'none' === u && (u = 'block'),
                  (ne[s] = u)))))
          : 'none' !== n && ((l[c] = 'none'), _.set(r, 'display', n)));
    for (c = 0; c < f; c++) null != l[c] && (e[c].style.display = l[c]);
    return e;
  }
  ce.fn.extend({
    show: function () {
      return re(this, !0);
    },
    hide: function () {
      return re(this);
    },
    toggle: function (e) {
      return 'boolean' == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ee(this) ? ce(this).show() : ce(this).hide();
          });
    },
  });
  var xe,
    be,
    we = /^(?:checkbox|radio)$/i,
    Te = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
    Ce = /^$|^module$|\/(?:java|ecma)script/i;
  (xe = C.createDocumentFragment().appendChild(C.createElement('div'))),
    (be = C.createElement('input')).setAttribute('type', 'radio'),
    be.setAttribute('checked', 'checked'),
    be.setAttribute('name', 't'),
    xe.appendChild(be),
    (le.checkClone = xe.cloneNode(!0).cloneNode(!0).lastChild.checked),
    (xe.innerHTML = '<textarea>x</textarea>'),
    (le.noCloneChecked = !!xe.cloneNode(!0).lastChild.defaultValue),
    (xe.innerHTML = '<option></option>'),
    (le.option = !!xe.lastChild);
  var ke = {
    thead: [1, '<table>', '</table>'],
    col: [2, '<table><colgroup>', '</colgroup></table>'],
    tr: [2, '<table><tbody>', '</tbody></table>'],
    td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
    _default: [0, '', ''],
  };
  function Se(e, t) {
    var n;
    return (
      (n =
        'undefined' != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || '*')
          : 'undefined' != typeof e.querySelectorAll
            ? e.querySelectorAll(t || '*')
            : []),
      void 0 === t || (t && fe(e, t)) ? ce.merge([e], n) : n
    );
  }
  function Ee(e, t) {
    for (var n = 0, r = e.length; n < r; n++) _.set(e[n], 'globalEval', !t || _.get(t[n], 'globalEval'));
  }
  (ke.tbody = ke.tfoot = ke.colgroup = ke.caption = ke.thead),
    (ke.th = ke.td),
    le.option || (ke.optgroup = ke.option = [1, "<select multiple='multiple'>", '</select>']);
  var je = /<|&#?\w+;/;
  function Ae(e, t, n, r, i) {
    for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++)
      if ((o = e[d]) || 0 === o)
        if ('object' === x(o)) ce.merge(p, o.nodeType ? [o] : o);
        else if (je.test(o)) {
          (a = a || f.appendChild(t.createElement('div'))),
            (s = (Te.exec(o) || ['', ''])[1].toLowerCase()),
            (u = ke[s] || ke._default),
            (a.innerHTML = u[1] + ce.htmlPrefilter(o) + u[2]),
            (c = u[0]);
          while (c--) a = a.lastChild;
          ce.merge(p, a.childNodes), ((a = f.firstChild).textContent = '');
        } else p.push(t.createTextNode(o));
    (f.textContent = ''), (d = 0);
    while ((o = p[d++]))
      if (r && -1 < ce.inArray(o, r)) i && i.push(o);
      else if (((l = K(o)), (a = Se(f.appendChild(o), 'script')), l && Ee(a), n)) {
        c = 0;
        while ((o = a[c++])) Ce.test(o.type || '') && n.push(o);
      }
    return f;
  }
  var De = /^([^.]*)(?:\.(.+)|)/;
  function Ne() {
    return !0;
  }
  function qe() {
    return !1;
  }
  function Le(e, t, n, r, i, o) {
    var a, s;
    if ('object' == typeof t) {
      for (s in ('string' != typeof n && ((r = r || n), (n = void 0)), t)) Le(e, s, n, r, t[s], o);
      return e;
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i && ('string' == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = qe;
    else if (!i) return e;
    return (
      1 === o &&
        ((a = i),
        ((i = function (e) {
          return ce().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = ce.guid++))),
      e.each(function () {
        ce.event.add(this, t, i, r, n);
      })
    );
  }
  function He(e, r, t) {
    t
      ? (_.set(e, r, !1),
        ce.event.add(e, r, {
          namespace: !1,
          handler: function (e) {
            var t,
              n = _.get(this, r);
            if (1 & e.isTrigger && this[r]) {
              if (n) (ce.event.special[r] || {}).delegateType && e.stopPropagation();
              else if (
                ((n = ae.call(arguments)),
                _.set(this, r, n),
                this[r](),
                (t = _.get(this, r)),
                _.set(this, r, !1),
                n !== t)
              )
                return e.stopImmediatePropagation(), e.preventDefault(), t;
            } else
              n &&
                (_.set(this, r, ce.event.trigger(n[0], n.slice(1), this)),
                e.stopPropagation(),
                (e.isImmediatePropagationStopped = Ne));
          },
        }))
      : void 0 === _.get(e, r) && ce.event.add(e, r, Ne);
  }
  (ce.event = {
    global: {},
    add: function (t, e, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        v = _.get(t);
      if ($(t)) {
        n.handler && ((n = (o = n).handler), (i = o.selector)),
          i && ce.find.matchesSelector(J, i),
          n.guid || (n.guid = ce.guid++),
          (u = v.events) || (u = v.events = Object.create(null)),
          (a = v.handle) ||
            (a = v.handle =
              function (e) {
                return 'undefined' != typeof ce && ce.event.triggered !== e.type
                  ? ce.event.dispatch.apply(t, arguments)
                  : void 0;
              }),
          (l = (e = (e || '').match(D) || ['']).length);
        while (l--)
          (d = g = (s = De.exec(e[l]) || [])[1]),
            (h = (s[2] || '').split('.').sort()),
            d &&
              ((f = ce.event.special[d] || {}),
              (d = (i ? f.delegateType : f.bindType) || d),
              (f = ce.event.special[d] || {}),
              (c = ce.extend(
                {
                  type: d,
                  origType: g,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && ce.expr.match.needsContext.test(i),
                  namespace: h.join('.'),
                },
                o
              )),
              (p = u[d]) ||
                (((p = u[d] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(t, r, h, a)) || (t.addEventListener && t.addEventListener(d, a))),
              f.add && (f.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (ce.event.global[d] = !0));
      }
    },
    remove: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        v = _.hasData(e) && _.get(e);
      if (v && (u = v.events)) {
        l = (t = (t || '').match(D) || ['']).length;
        while (l--)
          if (((d = g = (s = De.exec(t[l]) || [])[1]), (h = (s[2] || '').split('.').sort()), d)) {
            (f = ce.event.special[d] || {}),
              (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
              (s = s[2] && new RegExp('(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)')),
              (a = o = p.length);
            while (o--)
              (c = p[o]),
                (!i && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (s && !s.test(c.namespace)) ||
                  (r && r !== c.selector && ('**' !== r || !c.selector)) ||
                  (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
            a &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, h, v.handle)) || ce.removeEvent(e, d, v.handle), delete u[d]);
          } else for (d in u) ce.event.remove(e, d + t[l], n, r, !0);
        ce.isEmptyObject(u) && _.remove(e, 'handle events');
      }
    },
    dispatch: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s = new Array(arguments.length),
        u = ce.event.fix(e),
        l = (_.get(this, 'events') || Object.create(null))[u.type] || [],
        c = ce.event.special[u.type] || {};
      for (s[0] = u, t = 1; t < arguments.length; t++) s[t] = arguments[t];
      if (((u.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, u))) {
        (a = ce.event.handlers.call(this, u, l)), (t = 0);
        while ((i = a[t++]) && !u.isPropagationStopped()) {
          (u.currentTarget = i.elem), (n = 0);
          while ((o = i.handlers[n++]) && !u.isImmediatePropagationStopped())
            (u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace)) ||
              ((u.handleObj = o),
              (u.data = o.data),
              void 0 !== (r = ((ce.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) &&
                !1 === (u.result = r) &&
                (u.preventDefault(), u.stopPropagation()));
        }
        return c.postDispatch && c.postDispatch.call(this, u), u.result;
      }
    },
    handlers: function (e, t) {
      var n,
        r,
        i,
        o,
        a,
        s = [],
        u = t.delegateCount,
        l = e.target;
      if (u && l.nodeType && !('click' === e.type && 1 <= e.button))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ('click' !== e.type || !0 !== l.disabled)) {
            for (o = [], a = {}, n = 0; n < u; n++)
              void 0 === a[(i = (r = t[n]).selector + ' ')] &&
                (a[i] = r.needsContext ? -1 < ce(i, this).index(l) : ce.find(i, this, null, [l]).length),
                a[i] && o.push(r);
            o.length && s.push({elem: l, handlers: o});
          }
      return (l = this), u < t.length && s.push({elem: l, handlers: t.slice(u)}), s;
    },
    addProp: function (t, e) {
      Object.defineProperty(ce.Event.prototype, t, {
        enumerable: !0,
        configurable: !0,
        get: v(e)
          ? function () {
              if (this.originalEvent) return e(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[t];
            },
        set: function (e) {
          Object.defineProperty(this, t, {enumerable: !0, configurable: !0, writable: !0, value: e});
        },
      });
    },
    fix: function (e) {
      return e[ce.expando] ? e : new ce.Event(e);
    },
    special: {
      load: {noBubble: !0},
      click: {
        setup: function (e) {
          var t = this || e;
          return we.test(t.type) && t.click && fe(t, 'input') && He(t, 'click', !0), !1;
        },
        trigger: function (e) {
          var t = this || e;
          return we.test(t.type) && t.click && fe(t, 'input') && He(t, 'click'), !0;
        },
        _default: function (e) {
          var t = e.target;
          return (we.test(t.type) && t.click && fe(t, 'input') && _.get(t, 'click')) || fe(t, 'a');
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (ce.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (ce.Event = function (e, t) {
      if (!(this instanceof ce.Event)) return new ce.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? Ne : qe),
          (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && ce.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[ce.expando] = !0);
    }),
    (ce.Event.prototype = {
      constructor: ce.Event,
      isDefaultPrevented: qe,
      isPropagationStopped: qe,
      isImmediatePropagationStopped: qe,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = Ne), e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = Ne), e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = Ne),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    ce.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: !0,
      },
      ce.event.addProp
    ),
    ce.each({focus: 'focusin', blur: 'focusout'}, function (r, i) {
      function o(e) {
        if (C.documentMode) {
          var t = _.get(this, 'handle'),
            n = ce.event.fix(e);
          (n.type = 'focusin' === e.type ? 'focus' : 'blur'),
            (n.isSimulated = !0),
            t(e),
            n.target === n.currentTarget && t(n);
        } else ce.event.simulate(i, e.target, ce.event.fix(e));
      }
      (ce.event.special[r] = {
        setup: function () {
          var e;
          if ((He(this, r, !0), !C.documentMode)) return !1;
          (e = _.get(this, i)) || this.addEventListener(i, o), _.set(this, i, (e || 0) + 1);
        },
        trigger: function () {
          return He(this, r), !0;
        },
        teardown: function () {
          var e;
          if (!C.documentMode) return !1;
          (e = _.get(this, i) - 1) ? _.set(this, i, e) : (this.removeEventListener(i, o), _.remove(this, i));
        },
        _default: function (e) {
          return _.get(e.target, r);
        },
        delegateType: i,
      }),
        (ce.event.special[i] = {
          setup: function () {
            var e = this.ownerDocument || this.document || this,
              t = C.documentMode ? this : e,
              n = _.get(t, i);
            n || (C.documentMode ? this.addEventListener(i, o) : e.addEventListener(r, o, !0)),
              _.set(t, i, (n || 0) + 1);
          },
          teardown: function () {
            var e = this.ownerDocument || this.document || this,
              t = C.documentMode ? this : e,
              n = _.get(t, i) - 1;
            n
              ? _.set(t, i, n)
              : (C.documentMode ? this.removeEventListener(i, o) : e.removeEventListener(r, o, !0), _.remove(t, i));
          },
        });
    }),
    ce.each(
      {mouseenter: 'mouseover', mouseleave: 'mouseout', pointerenter: 'pointerover', pointerleave: 'pointerout'},
      function (e, i) {
        ce.event.special[e] = {
          delegateType: i,
          bindType: i,
          handle: function (e) {
            var t,
              n = e.relatedTarget,
              r = e.handleObj;
            return (
              (n && (n === this || ce.contains(this, n))) ||
                ((e.type = r.origType), (t = r.handler.apply(this, arguments)), (e.type = i)),
              t
            );
          },
        };
      }
    ),
    ce.fn.extend({
      on: function (e, t, n, r) {
        return Le(this, e, t, n, r);
      },
      one: function (e, t, n, r) {
        return Le(this, e, t, n, r, 1);
      },
      off: function (e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            ce(e.delegateTarget).off(r.namespace ? r.origType + '.' + r.namespace : r.origType, r.selector, r.handler),
            this
          );
        if ('object' == typeof e) {
          for (i in e) this.off(i, t, e[i]);
          return this;
        }
        return (
          (!1 !== t && 'function' != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = qe),
          this.each(function () {
            ce.event.remove(this, e, n, t);
          })
        );
      },
    });
  var Oe = /<script|<style|<link/i,
    Pe = /checked\s*(?:[^=]|=\s*.checked.)/i,
    Me = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
  function Re(e, t) {
    return (fe(e, 'table') && fe(11 !== t.nodeType ? t : t.firstChild, 'tr') && ce(e).children('tbody')[0]) || e;
  }
  function Ie(e) {
    return (e.type = (null !== e.getAttribute('type')) + '/' + e.type), e;
  }
  function We(e) {
    return 'true/' === (e.type || '').slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute('type'), e;
  }
  function Fe(e, t) {
    var n, r, i, o, a, s;
    if (1 === t.nodeType) {
      if (_.hasData(e) && (s = _.get(e).events))
        for (i in (_.remove(t, 'handle events'), s))
          for (n = 0, r = s[i].length; n < r; n++) ce.event.add(t, i, s[i][n]);
      z.hasData(e) && ((o = z.access(e)), (a = ce.extend({}, o)), z.set(t, a));
    }
  }
  function $e(n, r, i, o) {
    r = g(r);
    var e,
      t,
      a,
      s,
      u,
      l,
      c = 0,
      f = n.length,
      p = f - 1,
      d = r[0],
      h = v(d);
    if (h || (1 < f && 'string' == typeof d && !le.checkClone && Pe.test(d)))
      return n.each(function (e) {
        var t = n.eq(e);
        h && (r[0] = d.call(this, e, t.html())), $e(t, r, i, o);
      });
    if (
      f &&
      ((t = (e = Ae(r, n[0].ownerDocument, !1, n, o)).firstChild), 1 === e.childNodes.length && (e = t), t || o)
    ) {
      for (s = (a = ce.map(Se(e, 'script'), Ie)).length; c < f; c++)
        (u = e), c !== p && ((u = ce.clone(u, !0, !0)), s && ce.merge(a, Se(u, 'script'))), i.call(n[c], u, c);
      if (s)
        for (l = a[a.length - 1].ownerDocument, ce.map(a, We), c = 0; c < s; c++)
          (u = a[c]),
            Ce.test(u.type || '') &&
              !_.access(u, 'globalEval') &&
              ce.contains(l, u) &&
              (u.src && 'module' !== (u.type || '').toLowerCase()
                ? ce._evalUrl && !u.noModule && ce._evalUrl(u.src, {nonce: u.nonce || u.getAttribute('nonce')}, l)
                : m(u.textContent.replace(Me, ''), u, l));
    }
    return n;
  }
  function Be(e, t, n) {
    for (var r, i = t ? ce.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || ce.cleanData(Se(r)),
        r.parentNode && (n && K(r) && Ee(Se(r, 'script')), r.parentNode.removeChild(r));
    return e;
  }
  ce.extend({
    htmlPrefilter: function (e) {
      return e;
    },
    clone: function (e, t, n) {
      var r,
        i,
        o,
        a,
        s,
        u,
        l,
        c = e.cloneNode(!0),
        f = K(e);
      if (!(le.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || ce.isXMLDoc(e)))
        for (a = Se(c), r = 0, i = (o = Se(e)).length; r < i; r++)
          (s = o[r]),
            (u = a[r]),
            void 0,
            'input' === (l = u.nodeName.toLowerCase()) && we.test(s.type)
              ? (u.checked = s.checked)
              : ('input' !== l && 'textarea' !== l) || (u.defaultValue = s.defaultValue);
      if (t)
        if (n) for (o = o || Se(e), a = a || Se(c), r = 0, i = o.length; r < i; r++) Fe(o[r], a[r]);
        else Fe(e, c);
      return 0 < (a = Se(c, 'script')).length && Ee(a, !f && Se(e, 'script')), c;
    },
    cleanData: function (e) {
      for (var t, n, r, i = ce.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if ($(n)) {
          if ((t = n[_.expando])) {
            if (t.events) for (r in t.events) i[r] ? ce.event.remove(n, r) : ce.removeEvent(n, r, t.handle);
            n[_.expando] = void 0;
          }
          n[z.expando] && (n[z.expando] = void 0);
        }
    },
  }),
    ce.fn.extend({
      detach: function (e) {
        return Be(this, e, !0);
      },
      remove: function (e) {
        return Be(this, e);
      },
      text: function (e) {
        return M(
          this,
          function (e) {
            return void 0 === e
              ? ce.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return $e(this, arguments, function (e) {
          (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Re(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return $e(this, arguments, function (e) {
          if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
            var t = Re(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return $e(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return $e(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (ce.cleanData(Se(e, !1)), (e.textContent = ''));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return ce.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return M(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if ('string' == typeof e && !Oe.test(e) && !ke[(Te.exec(e) || ['', ''])[1].toLowerCase()]) {
              e = ce.htmlPrefilter(e);
              try {
                for (; n < r; n++) 1 === (t = this[n] || {}).nodeType && (ce.cleanData(Se(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var n = [];
        return $e(
          this,
          arguments,
          function (e) {
            var t = this.parentNode;
            ce.inArray(this, n) < 0 && (ce.cleanData(Se(this)), t && t.replaceChild(e, this));
          },
          n
        );
      },
    }),
    ce.each(
      {
        appendTo: 'append',
        prependTo: 'prepend',
        insertBefore: 'before',
        insertAfter: 'after',
        replaceAll: 'replaceWith',
      },
      function (e, a) {
        ce.fn[e] = function (e) {
          for (var t, n = [], r = ce(e), i = r.length - 1, o = 0; o <= i; o++)
            (t = o === i ? this : this.clone(!0)), ce(r[o])[a](t), s.apply(n, t.get());
          return this.pushStack(n);
        };
      }
    );
  var _e = new RegExp('^(' + G + ')(?!px)[a-z%]+$', 'i'),
    ze = /^--/,
    Xe = function (e) {
      var t = e.ownerDocument.defaultView;
      return (t && t.opener) || (t = ie), t.getComputedStyle(e);
    },
    Ue = function (e, t, n) {
      var r,
        i,
        o = {};
      for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
      for (i in ((r = n.call(e)), t)) e.style[i] = o[i];
      return r;
    },
    Ve = new RegExp(Q.join('|'), 'i');
  function Ge(e, t, n) {
    var r,
      i,
      o,
      a,
      s = ze.test(t),
      u = e.style;
    return (
      (n = n || Xe(e)) &&
        ((a = n.getPropertyValue(t) || n[t]),
        s && a && (a = a.replace(ve, '$1') || void 0),
        '' !== a || K(e) || (a = ce.style(e, t)),
        !le.pixelBoxStyles() &&
          _e.test(a) &&
          Ve.test(t) &&
          ((r = u.width),
          (i = u.minWidth),
          (o = u.maxWidth),
          (u.minWidth = u.maxWidth = u.width = a),
          (a = n.width),
          (u.width = r),
          (u.minWidth = i),
          (u.maxWidth = o))),
      void 0 !== a ? a + '' : a
    );
  }
  function Ye(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      },
    };
  }
  !(function () {
    function e() {
      if (l) {
        (u.style.cssText = 'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
          (l.style.cssText =
            'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
          J.appendChild(u).appendChild(l);
        var e = ie.getComputedStyle(l);
        (n = '1%' !== e.top),
          (s = 12 === t(e.marginLeft)),
          (l.style.right = '60%'),
          (o = 36 === t(e.right)),
          (r = 36 === t(e.width)),
          (l.style.position = 'absolute'),
          (i = 12 === t(l.offsetWidth / 3)),
          J.removeChild(u),
          (l = null);
      }
    }
    function t(e) {
      return Math.round(parseFloat(e));
    }
    var n,
      r,
      i,
      o,
      a,
      s,
      u = C.createElement('div'),
      l = C.createElement('div');
    l.style &&
      ((l.style.backgroundClip = 'content-box'),
      (l.cloneNode(!0).style.backgroundClip = ''),
      (le.clearCloneStyle = 'content-box' === l.style.backgroundClip),
      ce.extend(le, {
        boxSizingReliable: function () {
          return e(), r;
        },
        pixelBoxStyles: function () {
          return e(), o;
        },
        pixelPosition: function () {
          return e(), n;
        },
        reliableMarginLeft: function () {
          return e(), s;
        },
        scrollboxSize: function () {
          return e(), i;
        },
        reliableTrDimensions: function () {
          var e, t, n, r;
          return (
            null == a &&
              ((e = C.createElement('table')),
              (t = C.createElement('tr')),
              (n = C.createElement('div')),
              (e.style.cssText = 'position:absolute;left:-11111px;border-collapse:separate'),
              (t.style.cssText = 'box-sizing:content-box;border:1px solid'),
              (t.style.height = '1px'),
              (n.style.height = '9px'),
              (n.style.display = 'block'),
              J.appendChild(e).appendChild(t).appendChild(n),
              (r = ie.getComputedStyle(t)),
              (a =
                parseInt(r.height, 10) + parseInt(r.borderTopWidth, 10) + parseInt(r.borderBottomWidth, 10) ===
                t.offsetHeight),
              J.removeChild(e)),
            a
          );
        },
      }));
  })();
  var Qe = ['Webkit', 'Moz', 'ms'],
    Je = C.createElement('div').style,
    Ke = {};
  function Ze(e) {
    var t = ce.cssProps[e] || Ke[e];
    return (
      t ||
      (e in Je
        ? e
        : (Ke[e] =
            (function (e) {
              var t = e[0].toUpperCase() + e.slice(1),
                n = Qe.length;
              while (n--) if ((e = Qe[n] + t) in Je) return e;
            })(e) || e))
    );
  }
  var et = /^(none|table(?!-c[ea]).+)/,
    tt = {position: 'absolute', visibility: 'hidden', display: 'block'},
    nt = {letterSpacing: '0', fontWeight: '400'};
  function rt(e, t, n) {
    var r = Y.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || 'px') : t;
  }
  function it(e, t, n, r, i, o) {
    var a = 'width' === t ? 1 : 0,
      s = 0,
      u = 0,
      l = 0;
    if (n === (r ? 'border' : 'content')) return 0;
    for (; a < 4; a += 2)
      'margin' === n && (l += ce.css(e, n + Q[a], !0, i)),
        r
          ? ('content' === n && (u -= ce.css(e, 'padding' + Q[a], !0, i)),
            'margin' !== n && (u -= ce.css(e, 'border' + Q[a] + 'Width', !0, i)))
          : ((u += ce.css(e, 'padding' + Q[a], !0, i)),
            'padding' !== n
              ? (u += ce.css(e, 'border' + Q[a] + 'Width', !0, i))
              : (s += ce.css(e, 'border' + Q[a] + 'Width', !0, i)));
    return (
      !r &&
        0 <= o &&
        (u += Math.max(0, Math.ceil(e['offset' + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5)) || 0),
      u + l
    );
  }
  function ot(e, t, n) {
    var r = Xe(e),
      i = (!le.boxSizingReliable() || n) && 'border-box' === ce.css(e, 'boxSizing', !1, r),
      o = i,
      a = Ge(e, t, r),
      s = 'offset' + t[0].toUpperCase() + t.slice(1);
    if (_e.test(a)) {
      if (!n) return a;
      a = 'auto';
    }
    return (
      ((!le.boxSizingReliable() && i) ||
        (!le.reliableTrDimensions() && fe(e, 'tr')) ||
        'auto' === a ||
        (!parseFloat(a) && 'inline' === ce.css(e, 'display', !1, r))) &&
        e.getClientRects().length &&
        ((i = 'border-box' === ce.css(e, 'boxSizing', !1, r)), (o = s in e) && (a = e[s])),
      (a = parseFloat(a) || 0) + it(e, t, n || (i ? 'border' : 'content'), o, r, a) + 'px'
    );
  }
  function at(e, t, n, r, i) {
    return new at.prototype.init(e, t, n, r, i);
  }
  ce.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = Ge(e, 'opacity');
            return '' === n ? '1' : n;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageSlice: !0,
      columnCount: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      scale: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
    },
    cssProps: {},
    style: function (e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          a,
          s = F(t),
          u = ze.test(t),
          l = e.style;
        if ((u || (t = Ze(s)), (a = ce.cssHooks[t] || ce.cssHooks[s]), void 0 === n))
          return a && 'get' in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        'string' === (o = typeof n) && (i = Y.exec(n)) && i[1] && ((n = te(e, t, i)), (o = 'number')),
          null != n &&
            n == n &&
            ('number' !== o || u || (n += (i && i[3]) || (ce.cssNumber[s] ? '' : 'px')),
            le.clearCloneStyle || '' !== n || 0 !== t.indexOf('background') || (l[t] = 'inherit'),
            (a && 'set' in a && void 0 === (n = a.set(e, n, r))) || (u ? l.setProperty(t, n) : (l[t] = n)));
      }
    },
    css: function (e, t, n, r) {
      var i,
        o,
        a,
        s = F(t);
      return (
        ze.test(t) || (t = Ze(s)),
        (a = ce.cssHooks[t] || ce.cssHooks[s]) && 'get' in a && (i = a.get(e, !0, n)),
        void 0 === i && (i = Ge(e, t, r)),
        'normal' === i && t in nt && (i = nt[t]),
        '' === n || n ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i) : i
      );
    },
  }),
    ce.each(['height', 'width'], function (e, u) {
      ce.cssHooks[u] = {
        get: function (e, t, n) {
          if (t)
            return !et.test(ce.css(e, 'display')) || (e.getClientRects().length && e.getBoundingClientRect().width)
              ? ot(e, u, n)
              : Ue(e, tt, function () {
                  return ot(e, u, n);
                });
        },
        set: function (e, t, n) {
          var r,
            i = Xe(e),
            o = !le.scrollboxSize() && 'absolute' === i.position,
            a = (o || n) && 'border-box' === ce.css(e, 'boxSizing', !1, i),
            s = n ? it(e, u, n, a, i) : 0;
          return (
            a &&
              o &&
              (s -= Math.ceil(
                e['offset' + u[0].toUpperCase() + u.slice(1)] - parseFloat(i[u]) - it(e, u, 'border', !1, i) - 0.5
              )),
            s && (r = Y.exec(t)) && 'px' !== (r[3] || 'px') && ((e.style[u] = t), (t = ce.css(e, u))),
            rt(0, t, s)
          );
        },
      };
    }),
    (ce.cssHooks.marginLeft = Ye(le.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(Ge(e, 'marginLeft')) ||
            e.getBoundingClientRect().left -
              Ue(e, {marginLeft: 0}, function () {
                return e.getBoundingClientRect().left;
              })) + 'px'
        );
    })),
    ce.each({margin: '', padding: '', border: 'Width'}, function (i, o) {
      (ce.cssHooks[i + o] = {
        expand: function (e) {
          for (var t = 0, n = {}, r = 'string' == typeof e ? e.split(' ') : [e]; t < 4; t++)
            n[i + Q[t] + o] = r[t] || r[t - 2] || r[0];
          return n;
        },
      }),
        'margin' !== i && (ce.cssHooks[i + o].set = rt);
    }),
    ce.fn.extend({
      css: function (e, t) {
        return M(
          this,
          function (e, t, n) {
            var r,
              i,
              o = {},
              a = 0;
            if (Array.isArray(t)) {
              for (r = Xe(e), i = t.length; a < i; a++) o[t[a]] = ce.css(e, t[a], !1, r);
              return o;
            }
            return void 0 !== n ? ce.style(e, t, n) : ce.css(e, t);
          },
          e,
          t,
          1 < arguments.length
        );
      },
    }),
    (((ce.Tween = at).prototype = {
      constructor: at,
      init: function (e, t, n, r, i, o) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = i || ce.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (ce.cssNumber[n] ? '' : 'px'));
      },
      cur: function () {
        var e = at.propHooks[this.prop];
        return e && e.get ? e.get(this) : at.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          n = at.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t = ce.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step && this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : at.propHooks._default.set(this),
          this
        );
      },
    }).init.prototype = at.prototype),
    ((at.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = ce.css(e.elem, e.prop, '')) && 'auto' !== t
              ? t
              : 0;
        },
        set: function (e) {
          ce.fx.step[e.prop]
            ? ce.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType || (!ce.cssHooks[e.prop] && null == e.elem.style[Ze(e.prop)])
              ? (e.elem[e.prop] = e.now)
              : ce.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }).scrollTop = at.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (ce.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: 'swing',
    }),
    (ce.fx = at.prototype.init),
    (ce.fx.step = {});
  var st,
    ut,
    lt,
    ct,
    ft = /^(?:toggle|show|hide)$/,
    pt = /queueHooks$/;
  function dt() {
    ut &&
      (!1 === C.hidden && ie.requestAnimationFrame ? ie.requestAnimationFrame(dt) : ie.setTimeout(dt, ce.fx.interval),
      ce.fx.tick());
  }
  function ht() {
    return (
      ie.setTimeout(function () {
        st = void 0;
      }),
      (st = Date.now())
    );
  }
  function gt(e, t) {
    var n,
      r = 0,
      i = {height: e};
    for (t = t ? 1 : 0; r < 4; r += 2 - t) i['margin' + (n = Q[r])] = i['padding' + n] = e;
    return t && (i.opacity = i.width = e), i;
  }
  function vt(e, t, n) {
    for (var r, i = (yt.tweeners[t] || []).concat(yt.tweeners['*']), o = 0, a = i.length; o < a; o++)
      if ((r = i[o].call(n, t, e))) return r;
  }
  function yt(o, e, t) {
    var n,
      a,
      r = 0,
      i = yt.prefilters.length,
      s = ce.Deferred().always(function () {
        delete u.elem;
      }),
      u = function () {
        if (a) return !1;
        for (
          var e = st || ht(),
            t = Math.max(0, l.startTime + l.duration - e),
            n = 1 - (t / l.duration || 0),
            r = 0,
            i = l.tweens.length;
          r < i;
          r++
        )
          l.tweens[r].run(n);
        return (
          s.notifyWith(o, [l, n, t]), n < 1 && i ? t : (i || s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l]), !1)
        );
      },
      l = s.promise({
        elem: o,
        props: ce.extend({}, e),
        opts: ce.extend(!0, {specialEasing: {}, easing: ce.easing._default}, t),
        originalProperties: e,
        originalOptions: t,
        startTime: st || ht(),
        duration: t.duration,
        tweens: [],
        createTween: function (e, t) {
          var n = ce.Tween(o, l.opts, e, t, l.opts.specialEasing[e] || l.opts.easing);
          return l.tweens.push(n), n;
        },
        stop: function (e) {
          var t = 0,
            n = e ? l.tweens.length : 0;
          if (a) return this;
          for (a = !0; t < n; t++) l.tweens[t].run(1);
          return e ? (s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l, e])) : s.rejectWith(o, [l, e]), this;
        },
      }),
      c = l.props;
    for (
      !(function (e, t) {
        var n, r, i, o, a;
        for (n in e)
          if (
            ((i = t[(r = F(n))]),
            (o = e[n]),
            Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
            n !== r && ((e[r] = o), delete e[n]),
            (a = ce.cssHooks[r]) && ('expand' in a))
          )
            for (n in ((o = a.expand(o)), delete e[r], o)) (n in e) || ((e[n] = o[n]), (t[n] = i));
          else t[r] = i;
      })(c, l.opts.specialEasing);
      r < i;
      r++
    )
      if ((n = yt.prefilters[r].call(l, o, c, l.opts)))
        return v(n.stop) && (ce._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)), n;
    return (
      ce.map(c, vt, l),
      v(l.opts.start) && l.opts.start.call(o, l),
      l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always),
      ce.fx.timer(ce.extend(u, {elem: o, anim: l, queue: l.opts.queue})),
      l
    );
  }
  (ce.Animation = ce.extend(yt, {
    tweeners: {
      '*': [
        function (e, t) {
          var n = this.createTween(e, t);
          return te(n.elem, e, Y.exec(t), n), n;
        },
      ],
    },
    tweener: function (e, t) {
      v(e) ? ((t = e), (e = ['*'])) : (e = e.match(D));
      for (var n, r = 0, i = e.length; r < i; r++)
        (n = e[r]), (yt.tweeners[n] = yt.tweeners[n] || []), yt.tweeners[n].unshift(t);
    },
    prefilters: [
      function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c,
          f = 'width' in t || 'height' in t,
          p = this,
          d = {},
          h = e.style,
          g = e.nodeType && ee(e),
          v = _.get(e, 'fxshow');
        for (r in (n.queue ||
          (null == (a = ce._queueHooks(e, 'fx')).unqueued &&
            ((a.unqueued = 0),
            (s = a.empty.fire),
            (a.empty.fire = function () {
              a.unqueued || s();
            })),
          a.unqueued++,
          p.always(function () {
            p.always(function () {
              a.unqueued--, ce.queue(e, 'fx').length || a.empty.fire();
            });
          })),
        t))
          if (((i = t[r]), ft.test(i))) {
            if ((delete t[r], (o = o || 'toggle' === i), i === (g ? 'hide' : 'show'))) {
              if ('show' !== i || !v || void 0 === v[r]) continue;
              g = !0;
            }
            d[r] = (v && v[r]) || ce.style(e, r);
          }
        if ((u = !ce.isEmptyObject(t)) || !ce.isEmptyObject(d))
          for (r in (f &&
            1 === e.nodeType &&
            ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
            null == (l = v && v.display) && (l = _.get(e, 'display')),
            'none' === (c = ce.css(e, 'display')) &&
              (l ? (c = l) : (re([e], !0), (l = e.style.display || l), (c = ce.css(e, 'display')), re([e]))),
            ('inline' === c || ('inline-block' === c && null != l)) &&
              'none' === ce.css(e, 'float') &&
              (u ||
                (p.done(function () {
                  h.display = l;
                }),
                null == l && ((c = h.display), (l = 'none' === c ? '' : c))),
              (h.display = 'inline-block'))),
          n.overflow &&
            ((h.overflow = 'hidden'),
            p.always(function () {
              (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
            })),
          (u = !1),
          d))
            u ||
              (v ? 'hidden' in v && (g = v.hidden) : (v = _.access(e, 'fxshow', {display: l})),
              o && (v.hidden = !g),
              g && re([e], !0),
              p.done(function () {
                for (r in (g || re([e]), _.remove(e, 'fxshow'), d)) ce.style(e, r, d[r]);
              })),
              (u = vt(g ? v[r] : 0, r, p)),
              r in v || ((v[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? yt.prefilters.unshift(e) : yt.prefilters.push(e);
    },
  })),
    (ce.speed = function (e, t, n) {
      var r =
        e && 'object' == typeof e
          ? ce.extend({}, e)
          : {complete: n || (!n && t) || (v(e) && e), duration: e, easing: (n && t) || (t && !v(t) && t)};
      return (
        ce.fx.off
          ? (r.duration = 0)
          : 'number' != typeof r.duration &&
            (r.duration in ce.fx.speeds
              ? (r.duration = ce.fx.speeds[r.duration])
              : (r.duration = ce.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = 'fx'),
        (r.old = r.complete),
        (r.complete = function () {
          v(r.old) && r.old.call(this), r.queue && ce.dequeue(this, r.queue);
        }),
        r
      );
    }),
    ce.fn.extend({
      fadeTo: function (e, t, n, r) {
        return this.filter(ee).css('opacity', 0).show().end().animate({opacity: t}, e, n, r);
      },
      animate: function (t, e, n, r) {
        var i = ce.isEmptyObject(t),
          o = ce.speed(e, n, r),
          a = function () {
            var e = yt(this, ce.extend({}, t), o);
            (i || _.get(this, 'finish')) && e.stop(!0);
          };
        return (a.finish = a), i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
      },
      stop: function (i, e, o) {
        var a = function (e) {
          var t = e.stop;
          delete e.stop, t(o);
        };
        return (
          'string' != typeof i && ((o = e), (e = i), (i = void 0)),
          e && this.queue(i || 'fx', []),
          this.each(function () {
            var e = !0,
              t = null != i && i + 'queueHooks',
              n = ce.timers,
              r = _.get(this);
            if (t) r[t] && r[t].stop && a(r[t]);
            else for (t in r) r[t] && r[t].stop && pt.test(t) && a(r[t]);
            for (t = n.length; t--; )
              n[t].elem !== this || (null != i && n[t].queue !== i) || (n[t].anim.stop(o), (e = !1), n.splice(t, 1));
            (!e && o) || ce.dequeue(this, i);
          })
        );
      },
      finish: function (a) {
        return (
          !1 !== a && (a = a || 'fx'),
          this.each(function () {
            var e,
              t = _.get(this),
              n = t[a + 'queue'],
              r = t[a + 'queueHooks'],
              i = ce.timers,
              o = n ? n.length : 0;
            for (t.finish = !0, ce.queue(this, a, []), r && r.stop && r.stop.call(this, !0), e = i.length; e--; )
              i[e].elem === this && i[e].queue === a && (i[e].anim.stop(!0), i.splice(e, 1));
            for (e = 0; e < o; e++) n[e] && n[e].finish && n[e].finish.call(this);
            delete t.finish;
          })
        );
      },
    }),
    ce.each(['toggle', 'show', 'hide'], function (e, r) {
      var i = ce.fn[r];
      ce.fn[r] = function (e, t, n) {
        return null == e || 'boolean' == typeof e ? i.apply(this, arguments) : this.animate(gt(r, !0), e, t, n);
      };
    }),
    ce.each(
      {
        slideDown: gt('show'),
        slideUp: gt('hide'),
        slideToggle: gt('toggle'),
        fadeIn: {opacity: 'show'},
        fadeOut: {opacity: 'hide'},
        fadeToggle: {opacity: 'toggle'},
      },
      function (e, r) {
        ce.fn[e] = function (e, t, n) {
          return this.animate(r, e, t, n);
        };
      }
    ),
    (ce.timers = []),
    (ce.fx.tick = function () {
      var e,
        t = 0,
        n = ce.timers;
      for (st = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || ce.fx.stop(), (st = void 0);
    }),
    (ce.fx.timer = function (e) {
      ce.timers.push(e), ce.fx.start();
    }),
    (ce.fx.interval = 13),
    (ce.fx.start = function () {
      ut || ((ut = !0), dt());
    }),
    (ce.fx.stop = function () {
      ut = null;
    }),
    (ce.fx.speeds = {slow: 600, fast: 200, _default: 400}),
    (ce.fn.delay = function (r, e) {
      return (
        (r = (ce.fx && ce.fx.speeds[r]) || r),
        (e = e || 'fx'),
        this.queue(e, function (e, t) {
          var n = ie.setTimeout(e, r);
          t.stop = function () {
            ie.clearTimeout(n);
          };
        })
      );
    }),
    (lt = C.createElement('input')),
    (ct = C.createElement('select').appendChild(C.createElement('option'))),
    (lt.type = 'checkbox'),
    (le.checkOn = '' !== lt.value),
    (le.optSelected = ct.selected),
    ((lt = C.createElement('input')).value = 't'),
    (lt.type = 'radio'),
    (le.radioValue = 't' === lt.value);
  var mt,
    xt = ce.expr.attrHandle;
  ce.fn.extend({
    attr: function (e, t) {
      return M(this, ce.attr, e, t, 1 < arguments.length);
    },
    removeAttr: function (e) {
      return this.each(function () {
        ce.removeAttr(this, e);
      });
    },
  }),
    ce.extend({
      attr: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return 'undefined' == typeof e.getAttribute
            ? ce.prop(e, t, n)
            : ((1 === o && ce.isXMLDoc(e)) ||
                (i = ce.attrHooks[t.toLowerCase()] || (ce.expr.match.bool.test(t) ? mt : void 0)),
              void 0 !== n
                ? null === n
                  ? void ce.removeAttr(e, t)
                  : i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                    ? r
                    : (e.setAttribute(t, n + ''), n)
                : i && 'get' in i && null !== (r = i.get(e, t))
                  ? r
                  : null == (r = ce.find.attr(e, t))
                    ? void 0
                    : r);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!le.radioValue && 'radio' === t && fe(e, 'input')) {
              var n = e.value;
              return e.setAttribute('type', t), n && (e.value = n), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var n,
          r = 0,
          i = t && t.match(D);
        if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
      },
    }),
    (mt = {
      set: function (e, t, n) {
        return !1 === t ? ce.removeAttr(e, n) : e.setAttribute(n, n), n;
      },
    }),
    ce.each(ce.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var a = xt[t] || ce.find.attr;
      xt[t] = function (e, t, n) {
        var r,
          i,
          o = t.toLowerCase();
        return n || ((i = xt[o]), (xt[o] = r), (r = null != a(e, t, n) ? o : null), (xt[o] = i)), r;
      };
    });
  var bt = /^(?:input|select|textarea|button)$/i,
    wt = /^(?:a|area)$/i;
  function Tt(e) {
    return (e.match(D) || []).join(' ');
  }
  function Ct(e) {
    return (e.getAttribute && e.getAttribute('class')) || '';
  }
  function kt(e) {
    return Array.isArray(e) ? e : ('string' == typeof e && e.match(D)) || [];
  }
  ce.fn.extend({
    prop: function (e, t) {
      return M(this, ce.prop, e, t, 1 < arguments.length);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[ce.propFix[e] || e];
      });
    },
  }),
    ce.extend({
      prop: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && ce.isXMLDoc(e)) || ((t = ce.propFix[t] || t), (i = ce.propHooks[t])),
            void 0 !== n
              ? i && 'set' in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && 'get' in i && null !== (r = i.get(e, t))
                ? r
                : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = ce.find.attr(e, 'tabindex');
            return t ? parseInt(t, 10) : bt.test(e.nodeName) || (wt.test(e.nodeName) && e.href) ? 0 : -1;
          },
        },
      },
      propFix: {for: 'htmlFor', class: 'className'},
    }),
    le.optSelected ||
      (ce.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        },
      }),
    ce.each(
      [
        'tabIndex',
        'readOnly',
        'maxLength',
        'cellSpacing',
        'cellPadding',
        'rowSpan',
        'colSpan',
        'useMap',
        'frameBorder',
        'contentEditable',
      ],
      function () {
        ce.propFix[this.toLowerCase()] = this;
      }
    ),
    ce.fn.extend({
      addClass: function (t) {
        var e, n, r, i, o, a;
        return v(t)
          ? this.each(function (e) {
              ce(this).addClass(t.call(this, e, Ct(this)));
            })
          : (e = kt(t)).length
            ? this.each(function () {
                if (((r = Ct(this)), (n = 1 === this.nodeType && ' ' + Tt(r) + ' '))) {
                  for (o = 0; o < e.length; o++) (i = e[o]), n.indexOf(' ' + i + ' ') < 0 && (n += i + ' ');
                  (a = Tt(n)), r !== a && this.setAttribute('class', a);
                }
              })
            : this;
      },
      removeClass: function (t) {
        var e, n, r, i, o, a;
        return v(t)
          ? this.each(function (e) {
              ce(this).removeClass(t.call(this, e, Ct(this)));
            })
          : arguments.length
            ? (e = kt(t)).length
              ? this.each(function () {
                  if (((r = Ct(this)), (n = 1 === this.nodeType && ' ' + Tt(r) + ' '))) {
                    for (o = 0; o < e.length; o++) {
                      i = e[o];
                      while (-1 < n.indexOf(' ' + i + ' ')) n = n.replace(' ' + i + ' ', ' ');
                    }
                    (a = Tt(n)), r !== a && this.setAttribute('class', a);
                  }
                })
              : this
            : this.attr('class', '');
      },
      toggleClass: function (t, n) {
        var e,
          r,
          i,
          o,
          a = typeof t,
          s = 'string' === a || Array.isArray(t);
        return v(t)
          ? this.each(function (e) {
              ce(this).toggleClass(t.call(this, e, Ct(this), n), n);
            })
          : 'boolean' == typeof n && s
            ? n
              ? this.addClass(t)
              : this.removeClass(t)
            : ((e = kt(t)),
              this.each(function () {
                if (s)
                  for (o = ce(this), i = 0; i < e.length; i++)
                    (r = e[i]), o.hasClass(r) ? o.removeClass(r) : o.addClass(r);
                else
                  (void 0 !== t && 'boolean' !== a) ||
                    ((r = Ct(this)) && _.set(this, '__className__', r),
                    this.setAttribute &&
                      this.setAttribute('class', r || !1 === t ? '' : _.get(this, '__className__') || ''));
              }));
      },
      hasClass: function (e) {
        var t,
          n,
          r = 0;
        t = ' ' + e + ' ';
        while ((n = this[r++])) if (1 === n.nodeType && -1 < (' ' + Tt(Ct(n)) + ' ').indexOf(t)) return !0;
        return !1;
      },
    });
  var St = /\r/g;
  ce.fn.extend({
    val: function (n) {
      var r,
        e,
        i,
        t = this[0];
      return arguments.length
        ? ((i = v(n)),
          this.each(function (e) {
            var t;
            1 === this.nodeType &&
              (null == (t = i ? n.call(this, e, ce(this).val()) : n)
                ? (t = '')
                : 'number' == typeof t
                  ? (t += '')
                  : Array.isArray(t) &&
                    (t = ce.map(t, function (e) {
                      return null == e ? '' : e + '';
                    })),
              ((r = ce.valHooks[this.type] || ce.valHooks[this.nodeName.toLowerCase()]) &&
                'set' in r &&
                void 0 !== r.set(this, t, 'value')) ||
                (this.value = t));
          }))
        : t
          ? (r = ce.valHooks[t.type] || ce.valHooks[t.nodeName.toLowerCase()]) &&
            'get' in r &&
            void 0 !== (e = r.get(t, 'value'))
            ? e
            : 'string' == typeof (e = t.value)
              ? e.replace(St, '')
              : null == e
                ? ''
                : e
          : void 0;
    },
  }),
    ce.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = ce.find.attr(e, 'value');
            return null != t ? t : Tt(ce.text(e));
          },
        },
        select: {
          get: function (e) {
            var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = 'select-one' === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;
            for (r = o < 0 ? u : a ? o : 0; r < u; r++)
              if (
                ((n = i[r]).selected || r === o) &&
                !n.disabled &&
                (!n.parentNode.disabled || !fe(n.parentNode, 'optgroup'))
              ) {
                if (((t = ce(n).val()), a)) return t;
                s.push(t);
              }
            return s;
          },
          set: function (e, t) {
            var n,
              r,
              i = e.options,
              o = ce.makeArray(t),
              a = i.length;
            while (a--) ((r = i[a]).selected = -1 < ce.inArray(ce.valHooks.option.get(r), o)) && (n = !0);
            return n || (e.selectedIndex = -1), o;
          },
        },
      },
    }),
    ce.each(['radio', 'checkbox'], function () {
      (ce.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t)) return (e.checked = -1 < ce.inArray(ce(e).val(), t));
        },
      }),
        le.checkOn ||
          (ce.valHooks[this].get = function (e) {
            return null === e.getAttribute('value') ? 'on' : e.value;
          });
    });
  var Et = ie.location,
    jt = {guid: Date.now()},
    At = /\?/;
  ce.parseXML = function (e) {
    var t, n;
    if (!e || 'string' != typeof e) return null;
    try {
      t = new ie.DOMParser().parseFromString(e, 'text/xml');
    } catch (e) {}
    return (
      (n = t && t.getElementsByTagName('parsererror')[0]),
      (t && !n) ||
        ce.error(
          'Invalid XML: ' +
            (n
              ? ce
                  .map(n.childNodes, function (e) {
                    return e.textContent;
                  })
                  .join('\n')
              : e)
        ),
      t
    );
  };
  var Dt = /^(?:focusinfocus|focusoutblur)$/,
    Nt = function (e) {
      e.stopPropagation();
    };
  ce.extend(ce.event, {
    trigger: function (e, t, n, r) {
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p = [n || C],
        d = ue.call(e, 'type') ? e.type : e,
        h = ue.call(e, 'namespace') ? e.namespace.split('.') : [];
      if (
        ((o = f = a = n = n || C),
        3 !== n.nodeType &&
          8 !== n.nodeType &&
          !Dt.test(d + ce.event.triggered) &&
          (-1 < d.indexOf('.') && ((d = (h = d.split('.')).shift()), h.sort()),
          (u = d.indexOf(':') < 0 && 'on' + d),
          ((e = e[ce.expando] ? e : new ce.Event(d, 'object' == typeof e && e)).isTrigger = r ? 2 : 3),
          (e.namespace = h.join('.')),
          (e.rnamespace = e.namespace ? new RegExp('(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)') : null),
          (e.result = void 0),
          e.target || (e.target = n),
          (t = null == t ? [e] : ce.makeArray(t, [e])),
          (c = ce.event.special[d] || {}),
          r || !c.trigger || !1 !== c.trigger.apply(n, t)))
      ) {
        if (!r && !c.noBubble && !y(n)) {
          for (s = c.delegateType || d, Dt.test(s + d) || (o = o.parentNode); o; o = o.parentNode) p.push(o), (a = o);
          a === (n.ownerDocument || C) && p.push(a.defaultView || a.parentWindow || ie);
        }
        i = 0;
        while ((o = p[i++]) && !e.isPropagationStopped())
          (f = o),
            (e.type = 1 < i ? s : c.bindType || d),
            (l = (_.get(o, 'events') || Object.create(null))[e.type] && _.get(o, 'handle')) && l.apply(o, t),
            (l = u && o[u]) && l.apply && $(o) && ((e.result = l.apply(o, t)), !1 === e.result && e.preventDefault());
        return (
          (e.type = d),
          r ||
            e.isDefaultPrevented() ||
            (c._default && !1 !== c._default.apply(p.pop(), t)) ||
            !$(n) ||
            (u &&
              v(n[d]) &&
              !y(n) &&
              ((a = n[u]) && (n[u] = null),
              (ce.event.triggered = d),
              e.isPropagationStopped() && f.addEventListener(d, Nt),
              n[d](),
              e.isPropagationStopped() && f.removeEventListener(d, Nt),
              (ce.event.triggered = void 0),
              a && (n[u] = a))),
          e.result
        );
      }
    },
    simulate: function (e, t, n) {
      var r = ce.extend(new ce.Event(), n, {type: e, isSimulated: !0});
      ce.event.trigger(r, null, t);
    },
  }),
    ce.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          ce.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        if (n) return ce.event.trigger(e, t, n, !0);
      },
    });
  var qt = /\[\]$/,
    Lt = /\r?\n/g,
    Ht = /^(?:submit|button|image|reset|file)$/i,
    Ot = /^(?:input|select|textarea|keygen)/i;
  function Pt(n, e, r, i) {
    var t;
    if (Array.isArray(e))
      ce.each(e, function (e, t) {
        r || qt.test(n) ? i(n, t) : Pt(n + '[' + ('object' == typeof t && null != t ? e : '') + ']', t, r, i);
      });
    else if (r || 'object' !== x(e)) i(n, e);
    else for (t in e) Pt(n + '[' + t + ']', e[t], r, i);
  }
  (ce.param = function (e, t) {
    var n,
      r = [],
      i = function (e, t) {
        var n = v(t) ? t() : t;
        r[r.length] = encodeURIComponent(e) + '=' + encodeURIComponent(null == n ? '' : n);
      };
    if (null == e) return '';
    if (Array.isArray(e) || (e.jquery && !ce.isPlainObject(e)))
      ce.each(e, function () {
        i(this.name, this.value);
      });
    else for (n in e) Pt(n, e[n], t, i);
    return r.join('&');
  }),
    ce.fn.extend({
      serialize: function () {
        return ce.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = ce.prop(this, 'elements');
          return e ? ce.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !ce(this).is(':disabled') &&
              Ot.test(this.nodeName) &&
              !Ht.test(e) &&
              (this.checked || !we.test(e))
            );
          })
          .map(function (e, t) {
            var n = ce(this).val();
            return null == n
              ? null
              : Array.isArray(n)
                ? ce.map(n, function (e) {
                    return {name: t.name, value: e.replace(Lt, '\r\n')};
                  })
                : {name: t.name, value: n.replace(Lt, '\r\n')};
          })
          .get();
      },
    });
  var Mt = /%20/g,
    Rt = /#.*$/,
    It = /([?&])_=[^&]*/,
    Wt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Ft = /^(?:GET|HEAD)$/,
    $t = /^\/\//,
    Bt = {},
    _t = {},
    zt = '*/'.concat('*'),
    Xt = C.createElement('a');
  function Ut(o) {
    return function (e, t) {
      'string' != typeof e && ((t = e), (e = '*'));
      var n,
        r = 0,
        i = e.toLowerCase().match(D) || [];
      if (v(t))
        while ((n = i[r++]))
          '+' === n[0] ? ((n = n.slice(1) || '*'), (o[n] = o[n] || []).unshift(t)) : (o[n] = o[n] || []).push(t);
    };
  }
  function Vt(t, i, o, a) {
    var s = {},
      u = t === _t;
    function l(e) {
      var r;
      return (
        (s[e] = !0),
        ce.each(t[e] || [], function (e, t) {
          var n = t(i, o, a);
          return 'string' != typeof n || u || s[n] ? (u ? !(r = n) : void 0) : (i.dataTypes.unshift(n), l(n), !1);
        }),
        r
      );
    }
    return l(i.dataTypes[0]) || (!s['*'] && l('*'));
  }
  function Gt(e, t) {
    var n,
      r,
      i = ce.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    return r && ce.extend(!0, e, r), e;
  }
  (Xt.href = Et.href),
    ce.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Et.href,
        type: 'GET',
        isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        accepts: {
          '*': zt,
          text: 'text/plain',
          html: 'text/html',
          xml: 'application/xml, text/xml',
          json: 'application/json, text/javascript',
        },
        contents: {xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/},
        responseFields: {xml: 'responseXML', text: 'responseText', json: 'responseJSON'},
        converters: {'* text': String, 'text html': !0, 'text json': JSON.parse, 'text xml': ce.parseXML},
        flatOptions: {url: !0, context: !0},
      },
      ajaxSetup: function (e, t) {
        return t ? Gt(Gt(e, ce.ajaxSettings), t) : Gt(ce.ajaxSettings, e);
      },
      ajaxPrefilter: Ut(Bt),
      ajaxTransport: Ut(_t),
      ajax: function (e, t) {
        'object' == typeof e && ((t = e), (e = void 0)), (t = t || {});
        var c,
          f,
          p,
          n,
          d,
          r,
          h,
          g,
          i,
          o,
          v = ce.ajaxSetup({}, t),
          y = v.context || v,
          m = v.context && (y.nodeType || y.jquery) ? ce(y) : ce.event,
          x = ce.Deferred(),
          b = ce.Callbacks('once memory'),
          w = v.statusCode || {},
          a = {},
          s = {},
          u = 'canceled',
          T = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (h) {
                if (!n) {
                  n = {};
                  while ((t = Wt.exec(p)))
                    n[t[1].toLowerCase() + ' '] = (n[t[1].toLowerCase() + ' '] || []).concat(t[2]);
                }
                t = n[e.toLowerCase() + ' '];
              }
              return null == t ? null : t.join(', ');
            },
            getAllResponseHeaders: function () {
              return h ? p : null;
            },
            setRequestHeader: function (e, t) {
              return null == h && ((e = s[e.toLowerCase()] = s[e.toLowerCase()] || e), (a[e] = t)), this;
            },
            overrideMimeType: function (e) {
              return null == h && (v.mimeType = e), this;
            },
            statusCode: function (e) {
              var t;
              if (e)
                if (h) T.always(e[T.status]);
                else for (t in e) w[t] = [w[t], e[t]];
              return this;
            },
            abort: function (e) {
              var t = e || u;
              return c && c.abort(t), l(0, t), this;
            },
          };
        if (
          (x.promise(T),
          (v.url = ((e || v.url || Et.href) + '').replace($t, Et.protocol + '//')),
          (v.type = t.method || t.type || v.method || v.type),
          (v.dataTypes = (v.dataType || '*').toLowerCase().match(D) || ['']),
          null == v.crossDomain)
        ) {
          r = C.createElement('a');
          try {
            (r.href = v.url),
              (r.href = r.href),
              (v.crossDomain = Xt.protocol + '//' + Xt.host != r.protocol + '//' + r.host);
          } catch (e) {
            v.crossDomain = !0;
          }
        }
        if (
          (v.data && v.processData && 'string' != typeof v.data && (v.data = ce.param(v.data, v.traditional)),
          Vt(Bt, v, t, T),
          h)
        )
          return T;
        for (i in ((g = ce.event && v.global) && 0 == ce.active++ && ce.event.trigger('ajaxStart'),
        (v.type = v.type.toUpperCase()),
        (v.hasContent = !Ft.test(v.type)),
        (f = v.url.replace(Rt, '')),
        v.hasContent
          ? v.data &&
            v.processData &&
            0 === (v.contentType || '').indexOf('application/x-www-form-urlencoded') &&
            (v.data = v.data.replace(Mt, '+'))
          : ((o = v.url.slice(f.length)),
            v.data &&
              (v.processData || 'string' == typeof v.data) &&
              ((f += (At.test(f) ? '&' : '?') + v.data), delete v.data),
            !1 === v.cache && ((f = f.replace(It, '$1')), (o = (At.test(f) ? '&' : '?') + '_=' + jt.guid++ + o)),
            (v.url = f + o)),
        v.ifModified &&
          (ce.lastModified[f] && T.setRequestHeader('If-Modified-Since', ce.lastModified[f]),
          ce.etag[f] && T.setRequestHeader('If-None-Match', ce.etag[f])),
        ((v.data && v.hasContent && !1 !== v.contentType) || t.contentType) &&
          T.setRequestHeader('Content-Type', v.contentType),
        T.setRequestHeader(
          'Accept',
          v.dataTypes[0] && v.accepts[v.dataTypes[0]]
            ? v.accepts[v.dataTypes[0]] + ('*' !== v.dataTypes[0] ? ', ' + zt + '; q=0.01' : '')
            : v.accepts['*']
        ),
        v.headers))
          T.setRequestHeader(i, v.headers[i]);
        if (v.beforeSend && (!1 === v.beforeSend.call(y, T, v) || h)) return T.abort();
        if (((u = 'abort'), b.add(v.complete), T.done(v.success), T.fail(v.error), (c = Vt(_t, v, t, T)))) {
          if (((T.readyState = 1), g && m.trigger('ajaxSend', [T, v]), h)) return T;
          v.async &&
            0 < v.timeout &&
            (d = ie.setTimeout(function () {
              T.abort('timeout');
            }, v.timeout));
          try {
            (h = !1), c.send(a, l);
          } catch (e) {
            if (h) throw e;
            l(-1, e);
          }
        } else l(-1, 'No Transport');
        function l(e, t, n, r) {
          var i,
            o,
            a,
            s,
            u,
            l = t;
          h ||
            ((h = !0),
            d && ie.clearTimeout(d),
            (c = void 0),
            (p = r || ''),
            (T.readyState = 0 < e ? 4 : 0),
            (i = (200 <= e && e < 300) || 304 === e),
            n &&
              (s = (function (e, t, n) {
                var r,
                  i,
                  o,
                  a,
                  s = e.contents,
                  u = e.dataTypes;
                while ('*' === u[0]) u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader('Content-Type'));
                if (r)
                  for (i in s)
                    if (s[i] && s[i].test(r)) {
                      u.unshift(i);
                      break;
                    }
                if (u[0] in n) o = u[0];
                else {
                  for (i in n) {
                    if (!u[0] || e.converters[i + ' ' + u[0]]) {
                      o = i;
                      break;
                    }
                    a || (a = i);
                  }
                  o = o || a;
                }
                if (o) return o !== u[0] && u.unshift(o), n[o];
              })(v, T, n)),
            !i &&
              -1 < ce.inArray('script', v.dataTypes) &&
              ce.inArray('json', v.dataTypes) < 0 &&
              (v.converters['text script'] = function () {}),
            (s = (function (e, t, n, r) {
              var i,
                o,
                a,
                s,
                u,
                l = {},
                c = e.dataTypes.slice();
              if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
              o = c.shift();
              while (o)
                if (
                  (e.responseFields[o] && (n[e.responseFields[o]] = t),
                  !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (u = o),
                  (o = c.shift()))
                )
                  if ('*' === o) o = u;
                  else if ('*' !== u && u !== o) {
                    if (!(a = l[u + ' ' + o] || l['* ' + o]))
                      for (i in l)
                        if ((s = i.split(' '))[1] === o && (a = l[u + ' ' + s[0]] || l['* ' + s[0]])) {
                          !0 === a ? (a = l[i]) : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                          break;
                        }
                    if (!0 !== a)
                      if (a && e['throws']) t = a(t);
                      else
                        try {
                          t = a(t);
                        } catch (e) {
                          return {state: 'parsererror', error: a ? e : 'No conversion from ' + u + ' to ' + o};
                        }
                  }
              return {state: 'success', data: t};
            })(v, s, T, i)),
            i
              ? (v.ifModified &&
                  ((u = T.getResponseHeader('Last-Modified')) && (ce.lastModified[f] = u),
                  (u = T.getResponseHeader('etag')) && (ce.etag[f] = u)),
                204 === e || 'HEAD' === v.type
                  ? (l = 'nocontent')
                  : 304 === e
                    ? (l = 'notmodified')
                    : ((l = s.state), (o = s.data), (i = !(a = s.error))))
              : ((a = l), (!e && l) || ((l = 'error'), e < 0 && (e = 0))),
            (T.status = e),
            (T.statusText = (t || l) + ''),
            i ? x.resolveWith(y, [o, l, T]) : x.rejectWith(y, [T, l, a]),
            T.statusCode(w),
            (w = void 0),
            g && m.trigger(i ? 'ajaxSuccess' : 'ajaxError', [T, v, i ? o : a]),
            b.fireWith(y, [T, l]),
            g && (m.trigger('ajaxComplete', [T, v]), --ce.active || ce.event.trigger('ajaxStop')));
        }
        return T;
      },
      getJSON: function (e, t, n) {
        return ce.get(e, t, n, 'json');
      },
      getScript: function (e, t) {
        return ce.get(e, void 0, t, 'script');
      },
    }),
    ce.each(['get', 'post'], function (e, i) {
      ce[i] = function (e, t, n, r) {
        return (
          v(t) && ((r = r || n), (n = t), (t = void 0)),
          ce.ajax(ce.extend({url: e, type: i, dataType: r, data: t, success: n}, ce.isPlainObject(e) && e))
        );
      };
    }),
    ce.ajaxPrefilter(function (e) {
      var t;
      for (t in e.headers) 'content-type' === t.toLowerCase() && (e.contentType = e.headers[t] || '');
    }),
    (ce._evalUrl = function (e, t, n) {
      return ce.ajax({
        url: e,
        type: 'GET',
        dataType: 'script',
        cache: !0,
        async: !1,
        global: !1,
        converters: {'text script': function () {}},
        dataFilter: function (e) {
          ce.globalEval(e, t, n);
        },
      });
    }),
    ce.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (v(e) && (e = e.call(this[0])),
            (t = ce(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                var e = this;
                while (e.firstElementChild) e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (n) {
        return v(n)
          ? this.each(function (e) {
              ce(this).wrapInner(n.call(this, e));
            })
          : this.each(function () {
              var e = ce(this),
                t = e.contents();
              t.length ? t.wrapAll(n) : e.append(n);
            });
      },
      wrap: function (t) {
        var n = v(t);
        return this.each(function (e) {
          ce(this).wrapAll(n ? t.call(this, e) : t);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not('body')
            .each(function () {
              ce(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (ce.expr.pseudos.hidden = function (e) {
      return !ce.expr.pseudos.visible(e);
    }),
    (ce.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (ce.ajaxSettings.xhr = function () {
      try {
        return new ie.XMLHttpRequest();
      } catch (e) {}
    });
  var Yt = {0: 200, 1223: 204},
    Qt = ce.ajaxSettings.xhr();
  (le.cors = !!Qt && 'withCredentials' in Qt),
    (le.ajax = Qt = !!Qt),
    ce.ajaxTransport(function (i) {
      var o, a;
      if (le.cors || (Qt && !i.crossDomain))
        return {
          send: function (e, t) {
            var n,
              r = i.xhr();
            if ((r.open(i.type, i.url, i.async, i.username, i.password), i.xhrFields))
              for (n in i.xhrFields) r[n] = i.xhrFields[n];
            for (n in (i.mimeType && r.overrideMimeType && r.overrideMimeType(i.mimeType),
            i.crossDomain || e['X-Requested-With'] || (e['X-Requested-With'] = 'XMLHttpRequest'),
            e))
              r.setRequestHeader(n, e[n]);
            (o = function (e) {
              return function () {
                o &&
                  ((o = a = r.onload = r.onerror = r.onabort = r.ontimeout = r.onreadystatechange = null),
                  'abort' === e
                    ? r.abort()
                    : 'error' === e
                      ? 'number' != typeof r.status
                        ? t(0, 'error')
                        : t(r.status, r.statusText)
                      : t(
                          Yt[r.status] || r.status,
                          r.statusText,
                          'text' !== (r.responseType || 'text') || 'string' != typeof r.responseText
                            ? {binary: r.response}
                            : {text: r.responseText},
                          r.getAllResponseHeaders()
                        ));
              };
            }),
              (r.onload = o()),
              (a = r.onerror = r.ontimeout = o('error')),
              void 0 !== r.onabort
                ? (r.onabort = a)
                : (r.onreadystatechange = function () {
                    4 === r.readyState &&
                      ie.setTimeout(function () {
                        o && a();
                      });
                  }),
              (o = o('abort'));
            try {
              r.send((i.hasContent && i.data) || null);
            } catch (e) {
              if (o) throw e;
            }
          },
          abort: function () {
            o && o();
          },
        };
    }),
    ce.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    ce.ajaxSetup({
      accepts: {script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript'},
      contents: {script: /\b(?:java|ecma)script\b/},
      converters: {
        'text script': function (e) {
          return ce.globalEval(e), e;
        },
      },
    }),
    ce.ajaxPrefilter('script', function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = 'GET');
    }),
    ce.ajaxTransport('script', function (n) {
      var r, i;
      if (n.crossDomain || n.scriptAttrs)
        return {
          send: function (e, t) {
            (r = ce('<script>')
              .attr(n.scriptAttrs || {})
              .prop({charset: n.scriptCharset, src: n.url})
              .on(
                'load error',
                (i = function (e) {
                  r.remove(), (i = null), e && t('error' === e.type ? 404 : 200, e.type);
                })
              )),
              C.head.appendChild(r[0]);
          },
          abort: function () {
            i && i();
          },
        };
    });
  var Jt,
    Kt = [],
    Zt = /(=)\?(?=&|$)|\?\?/;
  ce.ajaxSetup({
    jsonp: 'callback',
    jsonpCallback: function () {
      var e = Kt.pop() || ce.expando + '_' + jt.guid++;
      return (this[e] = !0), e;
    },
  }),
    ce.ajaxPrefilter('json jsonp', function (e, t, n) {
      var r,
        i,
        o,
        a =
          !1 !== e.jsonp &&
          (Zt.test(e.url)
            ? 'url'
            : 'string' == typeof e.data &&
              0 === (e.contentType || '').indexOf('application/x-www-form-urlencoded') &&
              Zt.test(e.data) &&
              'data');
      if (a || 'jsonp' === e.dataTypes[0])
        return (
          (r = e.jsonpCallback = v(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
          a
            ? (e[a] = e[a].replace(Zt, '$1' + r))
            : !1 !== e.jsonp && (e.url += (At.test(e.url) ? '&' : '?') + e.jsonp + '=' + r),
          (e.converters['script json'] = function () {
            return o || ce.error(r + ' was not called'), o[0];
          }),
          (e.dataTypes[0] = 'json'),
          (i = ie[r]),
          (ie[r] = function () {
            o = arguments;
          }),
          n.always(function () {
            void 0 === i ? ce(ie).removeProp(r) : (ie[r] = i),
              e[r] && ((e.jsonpCallback = t.jsonpCallback), Kt.push(r)),
              o && v(i) && i(o[0]),
              (o = i = void 0);
          }),
          'script'
        );
    }),
    (le.createHTMLDocument =
      (((Jt = C.implementation.createHTMLDocument('').body).innerHTML = '<form></form><form></form>'),
      2 === Jt.childNodes.length)),
    (ce.parseHTML = function (e, t, n) {
      return 'string' != typeof e
        ? []
        : ('boolean' == typeof t && ((n = t), (t = !1)),
          t ||
            (le.createHTMLDocument
              ? (((r = (t = C.implementation.createHTMLDocument('')).createElement('base')).href = C.location.href),
                t.head.appendChild(r))
              : (t = C)),
          (o = !n && []),
          (i = w.exec(e))
            ? [t.createElement(i[1])]
            : ((i = Ae([e], t, o)), o && o.length && ce(o).remove(), ce.merge([], i.childNodes)));
      var r, i, o;
    }),
    (ce.fn.load = function (e, t, n) {
      var r,
        i,
        o,
        a = this,
        s = e.indexOf(' ');
      return (
        -1 < s && ((r = Tt(e.slice(s))), (e = e.slice(0, s))),
        v(t) ? ((n = t), (t = void 0)) : t && 'object' == typeof t && (i = 'POST'),
        0 < a.length &&
          ce
            .ajax({url: e, type: i || 'GET', dataType: 'html', data: t})
            .done(function (e) {
              (o = arguments), a.html(r ? ce('<div>').append(ce.parseHTML(e)).find(r) : e);
            })
            .always(
              n &&
                function (e, t) {
                  a.each(function () {
                    n.apply(this, o || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    (ce.expr.pseudos.animated = function (t) {
      return ce.grep(ce.timers, function (e) {
        return t === e.elem;
      }).length;
    }),
    (ce.offset = {
      setOffset: function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l = ce.css(e, 'position'),
          c = ce(e),
          f = {};
        'static' === l && (e.style.position = 'relative'),
          (s = c.offset()),
          (o = ce.css(e, 'top')),
          (u = ce.css(e, 'left')),
          ('absolute' === l || 'fixed' === l) && -1 < (o + u).indexOf('auto')
            ? ((a = (r = c.position()).top), (i = r.left))
            : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          v(t) && (t = t.call(e, n, ce.extend({}, s))),
          null != t.top && (f.top = t.top - s.top + a),
          null != t.left && (f.left = t.left - s.left + i),
          'using' in t ? t.using.call(e, f) : c.css(f);
      },
    }),
    ce.fn.extend({
      offset: function (t) {
        if (arguments.length)
          return void 0 === t
            ? this
            : this.each(function (e) {
                ce.offset.setOffset(this, t, e);
              });
        var e,
          n,
          r = this[0];
        return r
          ? r.getClientRects().length
            ? ((e = r.getBoundingClientRect()),
              (n = r.ownerDocument.defaultView),
              {top: e.top + n.pageYOffset, left: e.left + n.pageXOffset})
            : {top: 0, left: 0}
          : void 0;
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n,
            r = this[0],
            i = {top: 0, left: 0};
          if ('fixed' === ce.css(r, 'position')) t = r.getBoundingClientRect();
          else {
            (t = this.offset()), (n = r.ownerDocument), (e = r.offsetParent || n.documentElement);
            while (e && (e === n.body || e === n.documentElement) && 'static' === ce.css(e, 'position'))
              e = e.parentNode;
            e &&
              e !== r &&
              1 === e.nodeType &&
              (((i = ce(e).offset()).top += ce.css(e, 'borderTopWidth', !0)),
              (i.left += ce.css(e, 'borderLeftWidth', !0)));
          }
          return {top: t.top - i.top - ce.css(r, 'marginTop', !0), left: t.left - i.left - ce.css(r, 'marginLeft', !0)};
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var e = this.offsetParent;
          while (e && 'static' === ce.css(e, 'position')) e = e.offsetParent;
          return e || J;
        });
      },
    }),
    ce.each({scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset'}, function (t, i) {
      var o = 'pageYOffset' === i;
      ce.fn[t] = function (e) {
        return M(
          this,
          function (e, t, n) {
            var r;
            if ((y(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView), void 0 === n)) return r ? r[i] : e[t];
            r ? r.scrollTo(o ? r.pageXOffset : n, o ? n : r.pageYOffset) : (e[t] = n);
          },
          t,
          e,
          arguments.length
        );
      };
    }),
    ce.each(['top', 'left'], function (e, n) {
      ce.cssHooks[n] = Ye(le.pixelPosition, function (e, t) {
        if (t) return (t = Ge(e, n)), _e.test(t) ? ce(e).position()[n] + 'px' : t;
      });
    }),
    ce.each({Height: 'height', Width: 'width'}, function (a, s) {
      ce.each({padding: 'inner' + a, content: s, '': 'outer' + a}, function (r, o) {
        ce.fn[o] = function (e, t) {
          var n = arguments.length && (r || 'boolean' != typeof e),
            i = r || (!0 === e || !0 === t ? 'margin' : 'border');
          return M(
            this,
            function (e, t, n) {
              var r;
              return y(e)
                ? 0 === o.indexOf('outer')
                  ? e['inner' + a]
                  : e.document.documentElement['client' + a]
                : 9 === e.nodeType
                  ? ((r = e.documentElement),
                    Math.max(
                      e.body['scroll' + a],
                      r['scroll' + a],
                      e.body['offset' + a],
                      r['offset' + a],
                      r['client' + a]
                    ))
                  : void 0 === n
                    ? ce.css(e, t, i)
                    : ce.style(e, t, n, i);
            },
            s,
            n ? e : void 0,
            n
          );
        };
      });
    }),
    ce.each(['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'], function (e, t) {
      ce.fn[t] = function (e) {
        return this.on(t, e);
      };
    }),
    ce.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length ? this.off(e, '**') : this.off(t, e || '**', n);
      },
      hover: function (e, t) {
        return this.on('mouseenter', e).on('mouseleave', t || e);
      },
    }),
    ce.each(
      'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
        ' '
      ),
      function (e, n) {
        ce.fn[n] = function (e, t) {
          return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n);
        };
      }
    );
  var en = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
  (ce.proxy = function (e, t) {
    var n, r, i;
    if (('string' == typeof t && ((n = e[t]), (t = e), (e = n)), v(e)))
      return (
        (r = ae.call(arguments, 2)),
        ((i = function () {
          return e.apply(t || this, r.concat(ae.call(arguments)));
        }).guid = e.guid =
          e.guid || ce.guid++),
        i
      );
  }),
    (ce.holdReady = function (e) {
      e ? ce.readyWait++ : ce.ready(!0);
    }),
    (ce.isArray = Array.isArray),
    (ce.parseJSON = JSON.parse),
    (ce.nodeName = fe),
    (ce.isFunction = v),
    (ce.isWindow = y),
    (ce.camelCase = F),
    (ce.type = x),
    (ce.now = Date.now),
    (ce.isNumeric = function (e) {
      var t = ce.type(e);
      return ('number' === t || 'string' === t) && !isNaN(e - parseFloat(e));
    }),
    (ce.trim = function (e) {
      return null == e ? '' : (e + '').replace(en, '$1');
    }),
    'function' == typeof define &&
      define.amd &&
      define('jquery', [], function () {
        return ce;
      });
  var tn = ie.jQuery,
    nn = ie.$;
  return (
    (ce.noConflict = function (e) {
      return ie.$ === ce && (ie.$ = nn), e && ie.jQuery === ce && (ie.jQuery = tn), ce;
    }),
    'undefined' == typeof e && (ie.jQuery = ie.$ = ce),
    ce
  );
});

!(function (t, e) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = e())
    : 'function' == typeof define && define.amd
      ? define([], e)
      : 'object' == typeof exports
        ? (exports.UnbxdSearch = e())
        : (t.UnbxdSearch = e());
})(self, () =>
  (() => {
    var t = {
        759(t) {
          var e;
          'undefined' != typeof self && self,
            (e = () =>
              (() => {
                'use strict';
                var t = {
                    d: (e, r) => {
                      for (var a in r)
                        t.o(r, a) && !t.o(e, a) && Object.defineProperty(e, a, {enumerable: !0, get: r[a]});
                    },
                    o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
                  },
                  e = {};
                t.d(e, {default: () => De});
                const r = {
                    siteKey: 'api key',
                    apiKey: 'site key',
                    isFlag: !0,
                    searchEndPoint: 'https://search.unbxd.io/',
                    productType: 'SEARCH',
                    searchPath: '',
                    productAttributes: ['title'],
                    defaultFilters: null,
                    spellCheck: {enabled: !1},
                    pageSize: 5,
                    startPageNo: 0,
                    facetMultiSelect: !0,
                    updateUrls: !0,
                    variants: void 0,
                    extraParams: {},
                    facetMultilevel: !0,
                    facetDepth: 6,
                    showSwatches: !0,
                    allowExternalUrlParams: !1,
                    swatchMap: {},
                    onEvent: function () {},
                    getCategoryId: function () {
                      return (
                        encodeURIComponent(window.UnbxdAnalyticsConf.page) ||
                        decodeURIComponent(location.pathname.split('category-path')[1].split('/').pop())
                      );
                    },
                    setCategoryId: function (t, e) {
                      var r,
                        a = t.level,
                        n = (t.parent, t.name),
                        o = (t.action, []),
                        i = Number(a),
                        s = e.getBreadCrumbsList();
                      s.forEach(function (t, e) {
                        t.filterField;
                        var r = t.value;
                        i >= e && o.push(r);
                      }),
                        i > s.length && o.push(n),
                        (r = o.join('>')),
                        window.UnbxdAnalyticsConf && (window.UnbxdAnalyticsConf.page = 'categoryPath:"' + r + '"');
                    },
                    url: {},
                    applyMultipleFilters: !1,
                    hashMode: !1,
                    pagination: {type: 'INFINITE_SCROLL'},
                    onQueryRedirect: function (t, e, r) {
                      if (e) {
                        var a = e.value;
                        return (
                          'url' === e.type &&
                            (history.state && history.state.replace && history.replaceState(null, '', r),
                            (location.href = a)),
                          !1
                        );
                      }
                    },
                    onBackFromRedirect: function (t) {
                      new URLSearchParams(t ? location.hash.substring(1) : location.search).get('redirected') &&
                        history.go(-1);
                    },
                    onNoUnbxdKeyRouting: function () {
                      history.go();
                    },
                  },
                  a = 'FETCH_ERROR',
                  n = 'AFTER_API_CALL',
                  o = 'BEFORE_API_CALL',
                  i = 'RUNTIME_ERROR',
                  s = {
                    ALLOWED_QUERY_PARAM_SEPARATORS: ['&', '~', '^', ',', '_', ':', ';', '|', '$', '@'],
                    ALLOWED_KEY_VALUE_REPLACERS: ['=', ':'],
                    ALLOWED_VALUE_SEPARATORS: ['&', '~', '^', ',', '-', '_', ':', ';', '|', '$', '@'],
                    ALLOWED_RANGE_SEPARATORS: ['-'],
                    ALLOWED_PAGINATION_TYPE: ['CLICK_N_SCROLL', 'INFINITE_SCROLL', 'FIXED_PAGINATION'],
                    ALLOWED_PRODUCT_TYPE: ['SEARCH', 'CATEGORY'],
                    ALLOWED_DEFAULT_OPEN: ['ALL', 'NONE', 'FIRST'],
                    ALLOWED_SORT_ACTIONS: ['click', 'change'],
                    ALLOWED_PAGESIZE_ACTIONS: ['click', 'change'],
                    ALLOWED_PAGINATION_ACTIONS: ['click', 'change'],
                    EXPECTED_PARAMS: ['QUERY', 'FILTERS', 'PAGE_NUMBER', 'PAGE_SIZE', 'SORT', 'VIEW_TYPE'],
                    DEFAULT_VALUE_SEPARATOR: ',',
                    DEFAULT_KEY_VALUE_REPLACER: '=',
                    DEFAULT_QUERY_PARAM_SEPARATOR: '&',
                    DEFAULT_RANGE_SEPARATOR: '-',
                    DEFAULT_PAGINATION_TYPE: 'CLICK_N_SCROLL',
                    DEFAULT_PRODUCT_TYPE: 'SEARCH',
                    DEFAULT_VALUE_FOR_DEFAULT_OPEN: 'ALL',
                    DEFAULT_SORT_ACTION: 'change',
                    DEFAULT_PAGESIZE_ACTION: 'change',
                    DEFAULT_PAGINATION_ACTION: 'click',
                    MAX_HEIGHT_DIFF_TO_TRIGGER_NEXT_PAGE: 1e3,
                  };
                function c(t) {
                  return (
                    (c =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    c(t)
                  );
                }
                function l(t, e) {
                  if (t === e) return !0;
                  if ('object' !== c(t) || 'object' !== c(e) || null === t || null === e) return !1;
                  if (Object.keys(t).length !== Object.keys(e).length) return !1;
                  for (var r = 0, a = Object.keys(t); r < a.length; r++) {
                    var n = a[r];
                    if (!Object.keys(e).includes(n) || !l(t[n], e[n])) return !1;
                  }
                  return !0;
                }
                var u = {
                  encodeQueryParam: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '';
                    if ('string' != typeof t) return t;
                    var e = t.trim();
                    return (
                      (e = e.replace(/\%26/gim, '&')),
                      (e = (e = encodeURIComponent(e)).replace(/\%20/gim, '+')).replace(/\++/gim, '+')
                    );
                  },
                  decodeQueryParam: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '';
                    if ('string' != typeof t) return t;
                    var e = t.replace(/\+/gim, ' ');
                    return (e = e.replace(/\s{2,}/gim, ' ')), (e = decodeURIComponent(e)).trim();
                  },
                  getDeviceInfo: function () {
                    var t = 'Desktop';
                    return window.outerWidth < 768 ? (t = 'Mobile') : window.outerWidth < 992 && (t = 'Tablet'), t;
                  },
                  decodeAndParse: function (t) {
                    var e = t;
                    return (
                      0 === t.indexOf('"') && (e = t.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\')),
                      this.decodeCookie(e)
                    );
                  },
                  decodeCookie: function (t) {
                    return decodeURIComponent(t.replace(/\+/g, ' '));
                  },
                  cookie: function (t) {
                    for (var e, r = document.cookie.split('; '), a = 0, n = r.length; a < n; a++) {
                      var o = r[a].split('='),
                        i = this.decodeCookie(o.shift()),
                        s = o.join('=');
                      if (t && t === i)
                        try {
                          e = this.decodeAndParse(s);
                          break;
                        } catch (t) {
                          this.log(t);
                        }
                    }
                    return e;
                  },
                  readCookie: function (t) {
                    try {
                      return this.cookie('unbxd.'.concat(t));
                    } catch (t) {
                      this.log(t);
                    }
                  },
                  getUserId: function () {
                    return this.readCookie('userId');
                  },
                  getDefaultRequestHeaders: function (t) {
                    var e = this.getUserId(),
                      r = {'unbxd-device-type': this.getDeviceInfo()};
                    return e && (r['unbxd-user-id'] = e), r;
                  },
                  encodeEachFacetValue: function (t) {
                    var e = this.getValuesSeparatorFacets(),
                      r = t.split(e),
                      a = '';
                    return (
                      r.forEach(function (t, r) {
                        a += 0 === r ? encodeURIComponent(t) : e + encodeURIComponent(t);
                      }),
                      a
                    );
                  },
                  isFilterStr: function (t) {
                    var e = (this.options || {}).url,
                      r = (void 0 === e ? {} : e).facetsParam,
                      a = r.algo,
                      n = r.keyReplacer,
                      o = void 0 === n ? {} : n,
                      i = r.rangeFacets,
                      s = void 0 === i ? [] : i,
                      c = this.getSearchQueryParam(),
                      l = this.getBrowseQueryParam(),
                      u = this.getSortParam(),
                      d = !1;
                    return (
                      [
                        c,
                        l,
                        this.getPageViewParam(),
                        u,
                        this.getPageSizeParam(),
                        this.getPageNoParam(),
                        'count',
                      ].includes(t)
                        ? (d = !1)
                        : 'category-filter' === t
                          ? (d = !0)
                          : 'KEY_VALUE_REPLACER' === a
                            ? (d = Object.values(o).includes(t) || s.includes(t) || t.includes('_uFilter'))
                            : 'DEFAULT' !== a || ('filter' !== t && !t.includes('filter')) || (d = !0),
                      d
                    );
                  },
                  getValuesSeparatorFacets: function () {
                    var t = (this.options || {}).url,
                      e = (void 0 === t ? {} : t).facetsParam,
                      r = (void 0 === e ? {} : e).multiValueSeparator,
                      a = s.DEFAULT_VALUE_SEPARATOR;
                    return s.ALLOWED_VALUE_SEPARATORS.includes(r) ? r : a;
                  },
                  getQueryParamSeparator: function () {
                    var t = (this.options || {}).url,
                      e = (void 0 === t ? {} : t).queryParamSeparator,
                      r = s.DEFAULT_QUERY_PARAM_SEPARATOR;
                    return s.ALLOWED_QUERY_PARAM_SEPARATORS.includes(e) ? e : r;
                  },
                  getKeyValueSeparator: function () {
                    var t = (this.options || {}).url,
                      e = (void 0 === t ? {} : t).keyValueSeparator,
                      r = s.DEFAULT_KEY_VALUE_REPLACER;
                    return s.ALLOWED_KEY_VALUE_REPLACERS.includes(e) ? e : r;
                  },
                  getRangeSeparator: function () {
                    var t = (this.options || {}).url,
                      e = (void 0 === t ? {} : t).facetsParam,
                      r = (void 0 === e ? {} : e).rangeSeparator,
                      a = s.DEFAULT_RANGE_SEPARATOR;
                    return s.ALLOWED_RANGE_SEPARATORS.includes(r) ? r : a;
                  },
                  getSortParam: function () {
                    var t = (this.options || {}).url,
                      e = (void 0 === t ? {} : t).sortParam,
                      r = void 0 === e ? {} : e,
                      a = r.algo,
                      n = r.keyReplacer;
                    return 'KEY_VALUE_REPLACER' === a ? (void 0 === n ? {} : n) : 'sort';
                  },
                  getPageViewParam: function () {
                    var t = (this.options || {}).url,
                      e = (void 0 === t ? {} : t).pageViewParam,
                      r = void 0 === e ? {} : e,
                      a = r.algo,
                      n = r.keyReplacer;
                    return 'KEY_VALUE_REPLACER' === a ? (void 0 === n ? {} : n) : 'viewType';
                  },
                  getPageSizeParam: function () {
                    var t = (this.options || {}).url,
                      e = (void 0 === t ? {} : t).pageSizeParam,
                      r = void 0 === e ? {} : e,
                      a = r.algo,
                      n = r.keyReplacer;
                    return 'KEY_VALUE_REPLACER' === a ? (void 0 === n ? {} : n) : 'rows';
                  },
                  getPageNoParam: function () {
                    var t = (this.options || {}).url,
                      e = (void 0 === t ? {} : t).pageNoParam,
                      r = void 0 === e ? {} : e,
                      a = r.algo,
                      n = r.keyReplacer,
                      o = void 0 === n ? {} : n,
                      i = r.usePageNo;
                    return 'KEY_VALUE_REPLACER' === a ? o : i ? 'page' : 'start';
                  },
                  getHashMode: function () {
                    var t = (this.options || {}).url;
                    return (void 0 === t ? {} : t).hashMode || this.options.hashMode;
                  },
                  getUpdateUrls: function () {
                    return !0;
                  },
                  getAllowExternalUrlParams: function () {
                    var t = (this.options || {}).url;
                    return (void 0 === t ? {} : t).allowExternalUrlParams || this.options.allowExternalUrlParams;
                  },
                  getBrowseQueryParam: function () {
                    var t = this.options.url,
                      e = (void 0 === t ? {} : t).browseQueryParam,
                      r = void 0 === e ? {} : e,
                      a = r.algo,
                      n = void 0 === a ? 'DEFAULT' : a,
                      o = r.keyReplacer;
                    return 'DEFAULT' === n || void 0 === o ? 'p' : o;
                  },
                  getSearchQueryParam: function () {
                    var t = this.options.url,
                      e = (void 0 === t ? {} : t).searchQueryParam,
                      r = void 0 === e ? {} : e,
                      a = r.algo,
                      n = void 0 === a ? 'DEFAULT' : a,
                      o = r.keyReplacer;
                    return 'DEFAULT' === n || void 0 === o ? 'q' : o;
                  },
                  getHeightDiffToTriggerNextPage: function () {
                    var t = (this.options || {}).pagination,
                      e = (void 0 === t ? {} : t).heightDiffToTriggerNextPage,
                      r = s.MAX_HEIGHT_DIFF_TO_TRIGGER_NEXT_PAGE;
                    return (
                      (this.options.pagination.heightDiffToTriggerNextPage = e > r ? r : e),
                      this.options.pagination.heightDiffToTriggerNextPage
                    );
                  },
                  getPaginationType: function () {
                    var t = (this.options || {}).pagination,
                      e = (void 0 === t ? {} : t).type,
                      r = s.ALLOWED_PAGINATION_TYPE,
                      a = s.DEFAULT_PAGINATION_TYPE;
                    return (this.options.pagination.type = r.includes(e) ? e : a), this.options.pagination.type;
                  },
                  getSearchParamValue: function (t) {
                    var e = t;
                    return t || (e = this.getHashMode() ? window.location.hash : window.location.search), e;
                  },
                  getProductType: function () {
                    var t = (this.options || {}).products,
                      e = (void 0 === t ? {} : t).productType,
                      r = s.ALLOWED_PRODUCT_TYPE,
                      a = s.DEFAULT_PRODUCT_TYPE;
                    return (
                      (this.options.products.productType = r.includes(e) ? e : a), this.options.products.productType
                    );
                  },
                  getDefaultOpen: function () {
                    var t = (this.options || {}).facet,
                      e = (void 0 === t ? {} : t).defaultOpen,
                      r = s.ALLOWED_DEFAULT_OPEN,
                      a = s.DEFAULT_VALUE_FOR_DEFAULT_OPEN;
                    return (this.options.facet.defaultOpen = r.includes(e) ? e : a), this.options.facet.defaultOpen;
                  },
                  getSortAction: function () {
                    var t = (this.options || {}).sort,
                      e = (void 0 === t ? {} : t).action,
                      r = s.ALLOWED_SORT_ACTIONS,
                      a = s.DEFAULT_SORT_ACTION;
                    return (this.options.sort.action = r.includes(e) ? e : a), this.options.sort.action;
                  },
                  getPageSizeAction: function () {
                    var t = (this.options || {}).pagesize.action,
                      e = s.ALLOWED_PAGESIZE_ACTIONS,
                      r = s.DEFAULT_PAGESIZE_ACTION;
                    return (this.options.pagesize.action = e.includes(t) ? t : r), this.options.pagesize.action;
                  },
                  getPaginationAction: function () {
                    var t = (this.options || {}).pagination,
                      e = (void 0 === t ? {} : t).action,
                      r = s.ALLOWED_PAGINATION_ACTIONS,
                      a = s.DEFAULT_PAGINATION_ACTION;
                    return (this.options.pagination.action = r.includes(e) ? e : a), this.options.pagination.action;
                  },
                  deepCompareUrlParams: function (t, e) {
                    var r = this.getPageNoParam();
                    return t[r] && delete t[r], e[r] && delete e[r], l(t, e);
                  },
                };
                const d = u;
                function p(t) {
                  return (
                    (p =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    p(t)
                  );
                }
                function h(t, e) {
                  return (
                    (function (t) {
                      if (Array.isArray(t)) return t;
                    })(t) ||
                    (function (t, e) {
                      var r =
                        null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                      if (null != r) {
                        var a,
                          n,
                          o,
                          i,
                          s = [],
                          c = !0,
                          l = !1;
                        try {
                          if (((o = (r = r.call(t)).next), 0 === e)) {
                            if (Object(r) !== r) return;
                            c = !1;
                          } else for (; !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e); c = !0);
                        } catch (t) {
                          (l = !0), (n = t);
                        } finally {
                          try {
                            if (!c && null != r.return && ((i = r.return()), Object(i) !== i)) return;
                          } finally {
                            if (l) throw n;
                          }
                        }
                        return s;
                      }
                    })(t, e) ||
                    (function (t, e) {
                      if (t) {
                        if ('string' == typeof t) return f(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return (
                          'Object' === r && t.constructor && (r = t.constructor.name),
                          'Map' === r || 'Set' === r
                            ? Array.from(t)
                            : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                              ? f(t, e)
                              : void 0
                        );
                      }
                    })(t, e) ||
                    (function () {
                      throw new TypeError(
                        'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                      );
                    })()
                  );
                }
                function f(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function g(t, e) {
                  return (
                    (function (t) {
                      if (Array.isArray(t)) return t;
                    })(t) ||
                    (function (t, e) {
                      var r =
                        null == t ? null : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                      if (null != r) {
                        var a,
                          n,
                          o,
                          i,
                          s = [],
                          c = !0,
                          l = !1;
                        try {
                          if (((o = (r = r.call(t)).next), 0 === e)) {
                            if (Object(r) !== r) return;
                            c = !1;
                          } else for (; !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e); c = !0);
                        } catch (t) {
                          (l = !0), (n = t);
                        } finally {
                          try {
                            if (!c && null != r.return && ((i = r.return()), Object(i) !== i)) return;
                          } finally {
                            if (l) throw n;
                          }
                        }
                        return s;
                      }
                    })(t, e) ||
                    (function (t, e) {
                      if (t) {
                        if ('string' == typeof t) return y(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return (
                          'Object' === r && t.constructor && (r = t.constructor.name),
                          'Map' === r || 'Set' === r
                            ? Array.from(t)
                            : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                              ? y(t, e)
                              : void 0
                        );
                      }
                    })(t, e) ||
                    (function () {
                      throw new TypeError(
                        'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                      );
                    })()
                  );
                }
                function y(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function v(t) {
                  return (
                    (function (t) {
                      if (Array.isArray(t)) return m(t);
                    })(t) ||
                    (function (t) {
                      if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
                        return Array.from(t);
                    })(t) ||
                    (function (t, e) {
                      if (t) {
                        if ('string' == typeof t) return m(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return (
                          'Object' === r && t.constructor && (r = t.constructor.name),
                          'Map' === r || 'Set' === r
                            ? Array.from(t)
                            : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                              ? m(t, e)
                              : void 0
                        );
                      }
                    })(t) ||
                    (function () {
                      throw new TypeError(
                        'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                      );
                    })()
                  );
                }
                function m(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function b(t) {
                  return (
                    (b =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    b(t)
                  );
                }
                function S(t) {
                  return (
                    (S =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    S(t)
                  );
                }
                function E(t) {
                  return (
                    (E =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    E(t)
                  );
                }
                function P(t) {
                  return (
                    (P =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    P(t)
                  );
                }
                function F(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function A(t) {
                  return (
                    (A =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    A(t)
                  );
                }
                function w(t, e, r) {
                  return (
                    (e = (function (t) {
                      var e = (function (t) {
                        if ('object' != A(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                          var r = e.call(t, 'string');
                          if ('object' != A(r)) return r;
                          throw new TypeError('@@toPrimitive must return a primitive value.');
                        }
                        return String(t);
                      })(t);
                      return 'symbol' == A(e) ? e : e + '';
                    })(e)) in t
                      ? Object.defineProperty(t, e, {value: r, enumerable: !0, configurable: !0, writable: !0})
                      : (t[e] = r),
                    t
                  );
                }
                var R = d.isFilterStr,
                  U = {
                    extraParamUrlString: function () {
                      try {
                        var t = this.options.extraParams,
                          e = '';
                        return (
                          Object.keys(t).forEach(function (r) {
                            e += '&'.concat(r, '=').concat('function' == typeof t[r] ? t[r]() : t[r]);
                          }),
                          e
                        );
                      } catch (t) {
                        this.onError('extraParamsFromUrlToString.js', t, i);
                      }
                    },
                    renderFromUrl: function () {
                      var t = this,
                        e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                      try {
                        var r = !1,
                          a = this.getQueryParams(e),
                          n = this.getProductType(),
                          o = this.getSearchQueryParam(),
                          s = this.getBrowseQueryParam(),
                          c = this.getKeyValueSeparator(),
                          l = o;
                        if (('SEARCH' !== n && (a[(l = s)] = this.getCategoryId()), 'object' === p(a) && a[l])) {
                          var u = (this.options || {}).url,
                            h = void 0 === u ? {} : u,
                            f = h.facetsParam,
                            g = void 0 === f ? {} : f,
                            y = h.pageNoParam,
                            v = void 0 === y ? {} : y,
                            m = h.sortParam,
                            b = void 0 === m ? {} : m,
                            S = a[o],
                            E = a[encodeURIComponent(this.getPageNoParam())],
                            P = a[encodeURIComponent(this.getSortParam())],
                            F = a['KEY_VALUE_REPLACER' === g.algo ? g.filterReplacer : 'filter'],
                            A = a[encodeURIComponent(this.getPageSizeParam())];
                          if (
                            ((r = !0),
                            this.state.userInput !== S && (this.state.userInput = d.decodeQueryParam(S)),
                            'KEY_VALUE_REPLACER' === g.algo && !g.showFilterStr)
                          ) {
                            var w = [];
                            Object.keys(a).forEach(function (e) {
                              t.isFilterStr(decodeURIComponent(e)) && w.push(''.concat(e).concat(c).concat(a[e]));
                            }),
                              (F = w);
                          }
                          var R = this.getFilterFromParams(F);
                          (this.state.rangeFacet = R.rangeFacet), (this.state.selectedFacets = R.selectedFilters);
                          var U = this.options.url.seoFriendlyUrl;
                          P && U && 'KEY_VALUE_REPLACER' === b.algo
                            ? (this.state.selectedSort = this.getKeyByValue(b.valueReplacer, decodeURIComponent(P)))
                            : P && U && 'KEY_VALUE_REPLACER' !== b.algo
                              ? (this.state.selectedSort = decodeURIComponent(P))
                              : (this.state.selectedSort = ''),
                            A || (A = Number(this.options.pagesize.pageSize)),
                            v.usePageNo
                              ? (this.state.startPageNo = E ? Number((E - 1) * A) : 0)
                              : (this.state.startPageNo = E ? Number(E) : 0),
                            (this.state.isBack = !1),
                            (this.state.pageSize = A),
                            (this.state.categoryFilter = this.getCategoryFilterFromParams(a)),
                            r && this.getResults();
                        }
                      } catch (t) {
                        this.onError('setStateFromUrl.js', t, i);
                      }
                    },
                    getQueryParams: function (t) {
                      try {
                        var e = this.getQueryParamSeparator(),
                          r = this.getKeyValueSeparator(),
                          a = (
                            t || '' === t
                              ? t
                              : (this.getHashMode() ? window.location.hash : window.location.search).substr(1)
                          ).split(e),
                          n = [];
                        a.forEach(function (t, e) {
                          t.indexOf(r) > 0 ? n.push(t) : (n[e - 1] = ''.concat(n[e - 1], '&').concat(t));
                        });
                        for (var o = {}, s = 0; s < n.length; s++) {
                          var c = h(n[s].split(r), 2),
                            l = c[0],
                            u = c[1];
                          void 0 === o[l]
                            ? (o[l] = u)
                            : 'string' == typeof o[l]
                              ? ((o[l] = [o[l]]), o[l].push(u))
                              : o[l].push(u);
                        }
                        return o;
                      } catch (t) {
                        return this.onError('getQueryParams.js', t, i), -1;
                      }
                    },
                    urlFlattenFacets: function () {
                      try {
                        var t = '',
                          e = this.state.selectedFacets,
                          r = this.options.defaultFilters || {};
                        return (
                          Object.keys(e).forEach(function (a) {
                            var n = e[a];
                            n.length && (t += '&filter='),
                              n.forEach(function (e, n) {
                                var o = e.name,
                                  i = e.dataId;
                                (void 0 !== r[a] && r[a] === o) ||
                                  ((o = ''.concat('%22').concat(i).concat('%22')),
                                  (t += 0 === n ? ''.concat(a, ':').concat(o) : ' OR '.concat(a, ':').concat(o)));
                              });
                          }),
                          t
                        );
                      } catch (t) {
                        return this.onError('facetsToUrlString.js', t, i), -1;
                      }
                    },
                    facetsToWebUrlString: function () {
                      try {
                        var t = (this.options || {}).url,
                          e = (void 0 === t ? {} : t).facetsParam,
                          r = void 0 === e ? {} : e,
                          a = this.getQueryParamSeparator(),
                          n = this.getKeyValueSeparator(),
                          o = r.algo,
                          s = '';
                        if ('KEY_VALUE_REPLACER' === (void 0 === o ? 'DEFAULT' : o)) {
                          var c,
                            l = this.state.selectedFacets,
                            u = this.options.defaultFilters || {},
                            d = Object.keys(l),
                            p = [];
                          (c = d.filter(function (t) {
                            return !p.includes(t);
                          })),
                            (p = [].concat(v(p), v(c)));
                          var h = r.showFilterStr,
                            f = r.filterReplacer,
                            g = r.keyReplacer,
                            y = r.valueReplacer,
                            m = this.getValuesSeparatorFacets();
                          p.forEach(function (t) {
                            var e = l[t],
                              r = '';
                            e.length &&
                              ((s += h ? ''.concat(a).concat(f, '=') : ''.concat(a)),
                              g && Object.keys(g).length > 0 && (r = t in g ? g[t] : ''),
                              (s += ''.concat(r ? encodeURIComponent(r) : t).concat(n))),
                              e.forEach(function (e, r) {
                                var a = e.name,
                                  n = a;
                                (void 0 !== u[t] && u[t] === a) ||
                                  (y && Object.keys(y).length > 0 && y[t] && y[t][a] && (n = y[t][a]),
                                  (s +=
                                    0 === r
                                      ? ''.concat(encodeURIComponent(n))
                                      : ''.concat(m).concat(encodeURIComponent(n))));
                              });
                          });
                        } else {
                          var b = this.state.selectedFacets,
                            S = this.options.defaultFilters || {};
                          Object.keys(b).forEach(function (t) {
                            var e = b[t];
                            e.length &&
                              ('HASH' === r.algo ? (s += '' !== s ? a : '') : (s += ''.concat(a, 'filter').concat(n))),
                              e.forEach(function (e, r) {
                                var a = e.name,
                                  n = e.dataId;
                                (void 0 !== S[t] && S[t] === a) ||
                                  ((a = ''.concat('%22').concat(n).concat('%22')),
                                  (s += 0 === r ? ''.concat(t, ':').concat(a) : ' OR '.concat(t, ':').concat(a)));
                              });
                          });
                        }
                        return s;
                      } catch (t) {
                        return this.onError('facetsToWebUrlString.js', t, i), -1;
                      }
                    },
                    getDefaultFiltersStr: function () {
                      try {
                        var t = '',
                          e = this.options.defaultFilters;
                        return (
                          null !== e &&
                            Object.keys(e).forEach(function (r) {
                              t += '&filter='.concat(r, ':').concat(JSON.stringify(e[r]));
                            }),
                          t
                        );
                      } catch (t) {
                        return this.onError('getDefaultFiltersString.js', t, i), -1;
                      }
                    },
                    getShowVariantsStr: function () {
                      try {
                        var t = this.options.variants;
                        return t && 'boolean' == typeof t.enabled ? '&variants='.concat(t.enabled) : '';
                      } catch (t) {
                        return this.onError('getShowVariantsUrlString.js', t, i), -1;
                      }
                    },
                    getVariantAttributesStr: function () {
                      try {
                        var t = this.options.variants;
                        if (t) {
                          var e = t.enabled,
                            r = t.attributes;
                          return r && e ? '&variants.fields='.concat(r.join(',')) : '';
                        }
                        return '';
                      } catch (t) {
                        return this.onError('getVariantAttributesUrlString.js', t, i), -1;
                      }
                    },
                    getVariantsCountStr: function () {
                      try {
                        var t = this.options.variants;
                        if (t) {
                          var e = t.enabled,
                            r = t.count;
                          return r && e ? '&variants.count='.concat(r) : '';
                        }
                        return '';
                      } catch (t) {
                        return this.onError('getVariantsCountUrlString.js', t, i), -1;
                      }
                    },
                    getVariantsGroupByStr: function () {
                      try {
                        var t = this.options.variants;
                        if (t) {
                          var e = t.enabled,
                            r = t.groupBy;
                          return r && e ? '&variants.groupBy='.concat(r) : '';
                        }
                        return '';
                      } catch (t) {
                        return this.onError('getVariantsGroupByUrlString.js', t, i), -1;
                      }
                    },
                    getProductAttributesStr: function () {
                      try {
                        return this.options.productAttributes
                          ? '&fields='.concat(this.options.productAttributes.join(','))
                          : '';
                      } catch (t) {
                        return this.onError('getProductAttributesUrlString.js', t, i), -1;
                      }
                    },
                    getPageSizeStr: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                      try {
                        var e = (this.options || {}).url,
                          r = (void 0 === e ? {} : e).pageNoParam;
                        return !t && (void 0 === r ? {} : r).usePageNo
                          ? '&count='.concat(this.state.pageSize)
                          : '&rows='.concat(this.state.pageSize);
                      } catch (t) {
                        return this.onError('getPageSizeUrlString.js', t, i), -1;
                      }
                    },
                    getPageStartStr: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                      try {
                        var e = (this.options || {}).url,
                          r = (void 0 === e ? {} : e).pageNoParam;
                        return !t && (void 0 === r ? {} : r).usePageNo
                          ? '&page='.concat(Math.floor(this.state.startPageNo / this.state.pageSize) + 1)
                          : '&start='.concat(this.state.startPageNo);
                      } catch (t) {
                        return this.onError('getPaginationStartUrlString.js', t, i), -1;
                      }
                    },
                    getNewUrlState: function (t) {
                      var e = this;
                      try {
                        var r = this.options,
                          a = r.url,
                          n = void 0 === a ? {} : a,
                          o = n.sortParam,
                          s = void 0 === o ? {} : o,
                          c = n.pageSizeParam,
                          l = void 0 === c ? {} : c,
                          u = n.pageNoParam,
                          p = void 0 === u ? {} : u,
                          h = n.pageViewParam,
                          f = void 0 === h ? {} : h,
                          g = n.browseQueryParam,
                          y = void 0 === g ? {} : g,
                          v = n.searchQueryParam,
                          m = void 0 === v ? {} : v,
                          b = r.browseQueryParam,
                          S = void 0 === b ? 'p' : b,
                          E = this.getProductType(),
                          P = this.getSearchQueryParam(),
                          F = this.getBrowseQueryParam(),
                          A = this.getKeyValueSeparator(),
                          w = this.state.userInput,
                          R = '',
                          U = this.getBaseUrl();
                        if ('BROWSE' === E || 'CATEGORY' === E) {
                          (R = ''), (w = this.getCategoryId());
                          var C = '/category?';
                          (this.webUrl = U + C + (y.addToUrl ? ''.concat(F).concat(A).concat(w) : '')),
                            (this.apiUrl = ''.concat(U).concat(C).concat(S, '=').concat(w));
                        }
                        if (('CATEGORY' === E && (R = '&pagetype=boolean'), 'SEARCH' === E)) {
                          var N = '/search?';
                          (this.webUrl =
                            U + N + (m.addToUrl ? ''.concat(P).concat(A).concat(d.encodeQueryParam(w)) : '')),
                            (this.apiUrl = ''.concat(U).concat(N, 'q=').concat(d.encodeQueryParam(w)));
                        }
                        var O = this.urlFlattenFacets(),
                          T = this.getShowVariantsStr(),
                          L = this.getVariantAttributesStr(),
                          I = this.getVariantsCountStr(),
                          j = this.getVariantsGroupByStr(),
                          k = this.getProductAttributesStr() + this.getDefaultFiltersStr(),
                          _ = this.getSortUrlString(),
                          V = this.getSpellCheckUrlString(),
                          x = this.getRangeFilterStr(),
                          M = this.categoryFilterUrlStr(),
                          X = this.getUcParamUrlString(),
                          D = this.options.facetMultiSelect ? '&facet.multiselect=true' : '&facet.multiselect=false',
                          B =
                            this.apiUrl +
                            M +
                            D +
                            O +
                            T +
                            L +
                            I +
                            j +
                            k +
                            _ +
                            V +
                            x +
                            R +
                            this.getPageSizeStr(!0) +
                            this.getPageStartStr(!0) +
                            this.extraParamUrlString() +
                            '&facet.version=V2' +
                            (X || ''),
                          W =
                            this.webUrl +
                            (function () {
                              var t = (e.options || {}).url,
                                r = (void 0 === t ? {} : t).facetsParam,
                                a = void 0 === r ? {} : r,
                                n = e.getQueryParamSeparator(),
                                o = '';
                              if (a.addToUrl) {
                                var i =
                                  e.categoryFilterWebUrlString() +
                                  e.facetsToWebUrlString() +
                                  e.getRangeFilterWebString();
                                if ('HASH' === a.algo) {
                                  var s = window.btoa(i);
                                  o = s ? ''.concat(n, 'filter=').concat(s) : '';
                                } else o = i;
                              }
                              return o;
                            })() +
                            (s.addToUrl ? this.getSortWebUrlString() : '') +
                            (l.addToUrl ? this.getPageSizeWebUrlString() : '') +
                            (p.addToUrl ? this.getPaginationStartWebUrlString() : '') +
                            (f.addToUrl ? this.getViewTypeForWebUrl() : '') +
                            (window.unbxdImageSearch &&
                            window.unbxdImageSearch.isVisualSearchEnabled &&
                            window.unbxdImageSearch.isVisualSearchEnabled() &&
                            window.unbxdImageSearch.getVisualSearchQueryParams
                              ? window.unbxdImageSearch.getVisualSearchQueryParams()
                              : '');
                        return (this.state.currentApiUrl = B), (this.state.currentWebUrl = W), t ? B : W;
                      } catch (t) {
                        return this.onError('getNewUrlState.js', t, i), -1;
                      }
                    },
                    getRangeFilterStr: function () {
                      try {
                        var t = this.state.rangeFacet,
                          e = Object.keys(t),
                          r = '';
                        return (
                          e.forEach(function (e) {
                            var a = t[e];
                            Array.isArray(a)
                              ? a.length > 0 && (r += '&filter='.concat(e, ':').concat(a.join(' OR '.concat(e, ':'))))
                              : (r += '&filter='.concat(e, ':').concat(a));
                          }),
                          r
                        );
                      } catch (t) {
                        return this.onError('getRangeFilterString.js', t, i), -1;
                      }
                    },
                    getRangeFilterWebString: function () {
                      try {
                        var t = this.options.url,
                          e = (void 0 === t ? {} : t).facetsParam,
                          r = void 0 === e ? {} : e,
                          a = this.getQueryParamSeparator(),
                          n = this.getValuesSeparatorFacets(),
                          o = this.getKeyValueSeparator(),
                          s = '';
                        if ('KEY_VALUE_REPLACER' === r.algo) {
                          var c = this.state.rangeFacet,
                            l = Object.keys(c),
                            u = this.getRangeSeparator();
                          l.forEach(function (t) {
                            (s += ''
                              .concat(a)
                              .concat(
                                Object.keys(r.keyReplacer).length > 0 && t in r.keyReplacer ? r.keyReplacer[t] : t
                              )
                              .concat(o)),
                              c[t].forEach(function (t, e) {
                                s +=
                                  0 === e
                                    ? ''.concat(t.replace(/\[|\]/g, '').split(' TO ').join(u))
                                    : ''.concat(n).concat(t.replace(/\[|\]/g, '').split(' TO ').join(u));
                              });
                          });
                        } else {
                          var d = this.state.rangeFacet;
                          Object.keys(d).forEach(function (t) {
                            var e = d[t];
                            Array.isArray(e)
                              ? e.length > 0 &&
                                ('HASH' === r.algo
                                  ? (s += ''
                                      .concat(a)
                                      .concat(t, ':')
                                      .concat(e.join(' OR '.concat(t, ':'))))
                                  : (s += ''
                                      .concat(a, 'filter')
                                      .concat(o)
                                      .concat(t, ':')
                                      .concat(e.join(' OR '.concat(t, ':')))))
                              : (s += '&filter'.concat(o).concat(t, ':').concat(e));
                          });
                        }
                        return s;
                      } catch (t) {
                        return this.onError('getRangeFilterWebString.js', t, i), -1;
                      }
                    },
                    categoryFilterUrlStr: function () {
                      var t = this;
                      try {
                        var e = this.state.categoryFilter,
                          r = void 0 === e ? {} : e,
                          a = '',
                          n = Object.keys(r),
                          o = '%22';
                        return (
                          n.forEach(function (e) {
                            var n = t.getAFacetByName(e)[0],
                              i = t.getBreadCrumbsList(e),
                              s = null;
                            if (n) {
                              var c = n.filterField,
                                l = n.values,
                                u = r[e].map(function (e, r) {
                                  if (
                                    ((s = l.find(function (r) {
                                      return t.cleanFacetValue(encodeURIComponent(r.name)) === t.cleanFacetValue(e);
                                    })),
                                    i)
                                  ) {
                                    var a = i.find(function (t) {
                                      return t.value === e;
                                    });
                                    a && (s = {name: a.value});
                                  }
                                  return (
                                    s && t.encodeCategoryFacetValue(s.name).split(o).join(''),
                                    r > 0
                                      ? '>'.concat(t.encodeCategoryFacetValue(e).split(o).join(''))
                                      : t.encodeCategoryFacetValue(e).split(o).join('')
                                  );
                                });
                              a +=
                                'categoryPath' === c
                                  ? '&category-filter='.concat(u.join(''))
                                  : '&filter='.concat(c, ':"').concat(u.join(''), '"');
                            } else if (r && r.categoryPath) {
                              var d = '';
                              r.categoryPath.forEach(function (e) {
                                e.split('>').forEach(function (e) {
                                  var r = t.encodeCategoryFacetValue(e).split('%22').join('');
                                  '' !== d ? (d += '>'.concat(r)) : (d = r);
                                });
                              }),
                                (a += '&category-filter='.concat(d));
                            }
                          }),
                          a
                        );
                      } catch (t) {
                        return this.onError('categoryFilterUrlString.js', t, i), -1;
                      }
                    },
                    categoryFilterWebUrlString: function () {
                      var t = this;
                      try {
                        var e = this.state.categoryFilter,
                          r = void 0 === e ? {} : e,
                          a = this.getKeyValueSeparator(),
                          n = '',
                          o = Object.keys(r),
                          s = '%22';
                        return (
                          o.forEach(function (e) {
                            var o = t.getAFacetByName(e)[0],
                              i = t.getBreadCrumbsList(e),
                              c = null,
                              l = t.getQueryParamSeparator();
                            if (o) {
                              var u = o.filterField,
                                d = o.values,
                                p = r[e].map(function (e, r) {
                                  if (
                                    ((c = d.find(function (r) {
                                      return t.cleanFacetValue(encodeURIComponent(r.name)) === t.cleanFacetValue(e);
                                    })),
                                    i)
                                  ) {
                                    var a = i.find(function (t) {
                                      return t.value === e;
                                    });
                                    a && (c = {name: a.value});
                                  }
                                  return (
                                    c && t.encodeCategoryFacetValue(c.name).split(s).join(''),
                                    r > 0
                                      ? '>'.concat(t.encodeCategoryFacetValue(e).split(s).join(''))
                                      : t.encodeCategoryFacetValue(e).split(s).join('')
                                  );
                                });
                              n +=
                                'categoryPath' === u
                                  ? ''.concat(l, 'category-filter').concat(a).concat(p.join(''))
                                  : ''.concat(l, 'filter').concat(a).concat(u, ':"').concat(p.join(''), '"');
                            } else if (r && r.categoryPath) {
                              var h = '';
                              r.categoryPath.forEach(function (e) {
                                e.split('>').forEach(function (e) {
                                  var r = t.encodeCategoryFacetValue(e).split('%22').join('');
                                  '' !== h ? (h += '>'.concat(r)) : (h = r);
                                });
                              }),
                                (n += ''.concat(l, 'category-filter').concat(a).concat(h));
                            }
                          }),
                          n
                        );
                      } catch (t) {
                        return this.onError('categoryFilterWebUrlString.js', t, i), -1;
                      }
                    },
                    getSortUrlString: function () {
                      try {
                        var t = this.getSelectedSort();
                        return t ? '&sort='.concat(encodeURI(t)) : '';
                      } catch (t) {
                        return this.onError('getSortUrlString.js', t, i), -1;
                      }
                    },
                    getSortWebUrlString: function () {
                      try {
                        var t = this.getSelectedSort();
                        if (t) {
                          var e = this.options || {},
                            r = e.url,
                            a = (void 0 === r ? {} : r).sortParam,
                            n = void 0 === a ? {} : a,
                            o = e.url,
                            s = void 0 === o ? {} : o,
                            c = this.getQueryParamSeparator(),
                            l = this.getKeyValueSeparator();
                          if (s && n && 'KEY_VALUE_REPLACER' === n.algo) {
                            var u = n.keyReplacer,
                              d = void 0 === u ? 'sort' : u,
                              p = n.valueReplacer,
                              h = void 0 === p ? {} : p,
                              f = t;
                            return (
                              Object.keys(h).length > 0 && h[t] && (f = h[t]),
                              ''.concat(c).concat(encodeURIComponent(d)).concat(l).concat(encodeURIComponent(f))
                            );
                          }
                          return ''.concat(c, 'sort').concat(l).concat(encodeURI(t));
                        }
                        return '';
                      } catch (t) {
                        return this.onError('getSortWebUrlString.js', t, i), -1;
                      }
                    },
                    getSpellCheckUrlString: function () {
                      try {
                        return this.options.spellCheck.enabled ? '&spellcheck='.concat(!0) : '';
                      } catch (t) {
                        return this.onError('getSpellCheckUrlString.js', t, i), -1;
                      }
                    },
                    getBaseUrl: function () {
                      try {
                        var t = this.options,
                          e = t.searchEndPoint,
                          r = t.siteKey,
                          a = t.apiKey;
                        return ''.concat(e).concat(a, '/').concat(r);
                      } catch (t) {
                        return this.onError('getBaseUrl.js', t, i), -1;
                      }
                    },
                    getStateFromUrl: function () {
                      var t = this;
                      try {
                        var e,
                          r = (this.options || {}).url,
                          a = void 0 === r ? {} : r,
                          n = a.facetsParam,
                          o = void 0 === n ? {} : n,
                          s = a.pageNoParam,
                          c = void 0 === s ? {} : s,
                          l = this.getSearchQueryParam(),
                          u = this.getKeyValueSeparator();
                        e =
                          ('KEY_VALUE_REPLACER' !== o.algo && 'HASH' !== o.algo) || o.showFilterStr
                            ? this.getQueryParams()
                            : this.getCustomQueryParams();
                        var d = {},
                          p = this.options.pagesize.pageSize;
                        if ('object' === b(e)) {
                          var h = e,
                            f = h[l],
                            g = h[encodeURIComponent(this.getPageNoParam())],
                            y = h[encodeURIComponent(this.getPageSizeParam())],
                            v = h[encodeURIComponent(this.getSortParam())],
                            m = h.count,
                            S = h.rows,
                            E = void 0 === S ? p : S,
                            P = e['KEY_VALUE_REPLACER' === o.algo ? o.filterReplacer : 'filter'];
                          if (
                            (this.state.userInput !== f && (d.userInput = f),
                            'KEY_VALUE_REPLACER' === o.algo && !o.showFilterStr)
                          ) {
                            var F = [];
                            Object.keys(e).forEach(function (r) {
                              t.isFilterStr(r) &&
                                (F.length
                                  ? F.push(''.concat(r).concat(u).concat(e[r]))
                                  : F.push(''.concat(r).concat(u).concat(e, '[item]')));
                            }),
                              (P = F);
                          }
                          var A = this.getFilterFromParams(P);
                          (d.rangeFacet = A.rangeFacet),
                            (d.selectedFacets = A.selectedFilters),
                            (d.selectedSort = v || ''),
                            c.usePageNo ? (d.startPageNo = g ? (g - 1) * m : 0) : (d.startPageNo = y || 0),
                            (d.pageSize = Number(E)),
                            (d.categoryFilter = this.getCategoryFilterFromParams(e));
                        }
                        return d;
                      } catch (t) {
                        return this.onError('getStateFromUrl.js', t, i), -1;
                      }
                    },
                    getUcParamUrlString: function () {
                      try {
                        var t = this.getQueryParams();
                        return t.uc_param ? '&uc_param='.concat(t.uc_param) : '';
                      } catch (t) {
                        return this.onError('getUcParamUrlString.js', t, i), -1;
                      }
                    },
                    getViewTypeForWebUrl: function () {
                      try {
                        var t,
                          e = this.state.productViewType,
                          r = this.options.url,
                          a = r.pageViewParam,
                          n = (void 0 === a ? {} : a).valuesReplacer,
                          o = void 0 === n ? {GRID: 'GRID', LIST: 'LIST'} : n,
                          s = r.pageViewParam,
                          c = void 0 === s ? {} : s,
                          l = this.getQueryParamSeparator(),
                          u = this.getKeyValueSeparator(),
                          d = 'KEY_VALUE_REPLACER' === c.algo ? c.keyReplacer : 'viewType';
                        return (
                          (t =
                            'GRID' === e
                              ? 'KEY_VALUE_REPLACER' === c.algo
                                ? encodeURIComponent(o.GRID)
                                : 'GRID'
                              : 'KEY_VALUE_REPLACER' === c.algo
                                ? encodeURIComponent(o.LIST)
                                : 'LIST'),
                          ''.concat(l).concat(encodeURIComponent(d)).concat(u).concat(t)
                        );
                      } catch (e) {
                        return this.onError('getViewTypeForWebUrl.js', e, i), -1;
                      }
                    },
                    getPageSizeWebUrlString: function () {
                      try {
                        var t = (this.options || {}).url,
                          e = (void 0 === t ? {} : t).pageSizeParam,
                          r = void 0 === e ? {} : e,
                          a = r.algo,
                          n = r.keyReplacer,
                          o = this.getQueryParamSeparator(),
                          s = this.getKeyValueSeparator();
                        return ''
                          .concat(o)
                          .concat('KEY_VALUE_REPLACER' === a ? encodeURIComponent(n) : 'rows')
                          .concat(s)
                          .concat(this.state.pageSize);
                      } catch (t) {
                        return this.onError('getPageSizeWebUrlString.js', t, i), -1;
                      }
                    },
                    getPaginationStartWebUrlString: function () {
                      try {
                        var t = this.options.url,
                          e = (void 0 === t ? {} : t).pageNoParam,
                          r = void 0 === e ? {} : e,
                          a = r.algo,
                          n = r.usePageNo,
                          o = r.keyReplacer,
                          s = this.getQueryParamSeparator(),
                          c = this.getKeyValueSeparator(),
                          l = ''.concat(s);
                        return (
                          (l += 'KEY_VALUE_REPLACER' === a ? encodeURIComponent(o) : n ? 'page' : 'start'),
                          (l += ''
                            .concat(c)
                            .concat(
                              n ? Math.ceil(this.state.startPageNo / this.state.pageSize) + 1 : this.state.startPageNo
                            ))
                        );
                      } catch (t) {
                        return this.onError('getPaginationStartWebUrlString.js', t, i), -1;
                      }
                    },
                    getCustomQueryParams: function () {
                      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '';
                      try {
                        var e = (this.options || {}).url,
                          r = void 0 === e ? {} : e,
                          a = r.facetsParam,
                          n = (void 0 === a ? {} : a).showFilterStr,
                          o = r.facetsParam,
                          s = void 0 === o ? {} : o,
                          c = {},
                          l = this.getQueryParamSeparator(),
                          u = this.getKeyValueSeparator();
                        return (
                          n ||
                            this.getSearchParamValue(t)
                              .substr(1)
                              .split(l)
                              .forEach(function (t) {
                                if (t.indexOf(u) > 0)
                                  if ('HASH' === s.algo && 'filter' === t.split('=')[0]) {
                                    var e = g(t.split('filter=')[1], 1)[0];
                                    c.filter = e;
                                  } else {
                                    var r = g(t.split(u), 2),
                                      a = r[0],
                                      n = r[1];
                                    c[a] = n;
                                  }
                              }),
                          c
                        );
                      } catch (t) {
                        return this.onError('getCustomQueryParams.js', t, i), -1;
                      }
                    },
                    readSortWebUrl: function (t) {
                      try {
                        var e = this.options.url.sortParam,
                          r = e.algo,
                          a = void 0 === r ? 'DEFAULT' : r,
                          n = e.keyReplacer,
                          o = void 0 === n ? 'sort' : n,
                          s = this.getCustomQueryParams(t)[encodeURIComponent(this.getSortParam())];
                        return s
                          ? (function (t, e, r) {
                              return (
                                (e = (function (t) {
                                  var e = (function (t) {
                                    if ('object' != S(t) || !t) return t;
                                    var e = t[Symbol.toPrimitive];
                                    if (void 0 !== e) {
                                      var r = e.call(t, 'string');
                                      if ('object' != S(r)) return r;
                                      throw new TypeError('@@toPrimitive must return a primitive value.');
                                    }
                                    return String(t);
                                  })(t);
                                  return 'symbol' == S(e) ? e : e + '';
                                })(e)) in t
                                  ? Object.defineProperty(t, e, {
                                      value: r,
                                      enumerable: !0,
                                      configurable: !0,
                                      writable: !0,
                                    })
                                  : (t[e] = r),
                                t
                              );
                            })({}, 'KEY_VALUE_REPLACER' === a ? o : 'sort', [decodeURIComponent(s)])
                          : '';
                      } catch (t) {
                        return this.onError('readSortWebUrl.js', t, i), -1;
                      }
                    },
                    readPageViewWebUrl: function (t) {
                      try {
                        var e = this.options.url,
                          r = (void 0 === e ? {} : e).pageViewParam,
                          a = void 0 === r ? {} : r,
                          n = a.algo,
                          o = void 0 === n ? 'DEFAULT' : n,
                          s = a.keyReplacer,
                          c = this.getCustomQueryParams(t),
                          l = {};
                        if ('KEY_VALUE_REPLACER' === o) {
                          var u = c[encodeURIComponent(s)];
                          u &&
                            (l = (function (t, e, r) {
                              return (
                                (e = (function (t) {
                                  var e = (function (t) {
                                    if ('object' != E(t) || !t) return t;
                                    var e = t[Symbol.toPrimitive];
                                    if (void 0 !== e) {
                                      var r = e.call(t, 'string');
                                      if ('object' != E(r)) return r;
                                      throw new TypeError('@@toPrimitive must return a primitive value.');
                                    }
                                    return String(t);
                                  })(t);
                                  return 'symbol' == E(e) ? e : e + '';
                                })(e)) in t
                                  ? Object.defineProperty(t, e, {
                                      value: r,
                                      enumerable: !0,
                                      configurable: !0,
                                      writable: !0,
                                    })
                                  : (t[e] = r),
                                t
                              );
                            })({}, s, [decodeURIComponent(u)]));
                        } else {
                          var d = c.viewType;
                          d && (l = {viewType: [d]});
                        }
                        return l;
                      } catch (t) {
                        return this.onError('readPageViewWebUrl.js', t, i), -1;
                      }
                    },
                    readPageSizeWebUrl: function (t) {
                      try {
                        var e = this.options.url.pageSizeParam,
                          r = e.algo,
                          a = void 0 === r ? 'DEFAULT' : r,
                          n = e.keyReplacer,
                          o = this.getCustomQueryParams(t),
                          s = {};
                        if ('KEY_VALUE_REPLACER' === a) {
                          var c = o[encodeURIComponent(n)];
                          c &&
                            (s = (function (t, e, r) {
                              return (
                                (e = (function (t) {
                                  var e = (function (t) {
                                    if ('object' != P(t) || !t) return t;
                                    var e = t[Symbol.toPrimitive];
                                    if (void 0 !== e) {
                                      var r = e.call(t, 'string');
                                      if ('object' != P(r)) return r;
                                      throw new TypeError('@@toPrimitive must return a primitive value.');
                                    }
                                    return String(t);
                                  })(t);
                                  return 'symbol' == P(e) ? e : e + '';
                                })(e)) in t
                                  ? Object.defineProperty(t, e, {
                                      value: r,
                                      enumerable: !0,
                                      configurable: !0,
                                      writable: !0,
                                    })
                                  : (t[e] = r),
                                t
                              );
                            })({}, n, [c]));
                        } else {
                          var l = o.rows;
                          l && (s = {rows: [l]});
                        }
                        return s;
                      } catch (t) {
                        return this.onError('readPageSizeWebUrl.js', t, i), -1;
                      }
                    },
                    readFacetsWebUrl: function () {
                      var t = this,
                        e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '';
                      try {
                        var r = this.options.url,
                          a = (void 0 === r ? {} : r).facetsParam,
                          n = void 0 === a ? {} : a,
                          o = this.getSearchQueryParam(),
                          s = this.getQueryParamSeparator(),
                          c = {},
                          l = this.readQueryParamsFromUrl(e),
                          u = this.getKeyValueSeparator();
                        switch (n.algo) {
                          case 'KEY_VALUE_REPLACER':
                            var d = e;
                            d || (d = this.getHashMode() ? window.location.hash : window.location.search);
                            var p = this.getHashMode() ? d : d.substr(1),
                              h = (p && p.split(s)) || [],
                              f = {};
                            h &&
                              h.length &&
                              h.forEach(function (e) {
                                if ('' !== e) {
                                  var r = '';
                                  if (e.indexOf(u) > 0) {
                                    var a = (function (t, e) {
                                        return (
                                          (function (t) {
                                            if (Array.isArray(t)) return t;
                                          })(t) ||
                                          (function (t, e) {
                                            var r =
                                              null == t
                                                ? null
                                                : ('undefined' != typeof Symbol && t[Symbol.iterator]) ||
                                                  t['@@iterator'];
                                            if (null != r) {
                                              var a,
                                                n,
                                                o,
                                                i,
                                                s = [],
                                                c = !0,
                                                l = !1;
                                              try {
                                                if (((o = (r = r.call(t)).next), 0 === e)) {
                                                  if (Object(r) !== r) return;
                                                  c = !1;
                                                } else
                                                  for (
                                                    ;
                                                    !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e);
                                                    c = !0
                                                  );
                                              } catch (t) {
                                                (l = !0), (n = t);
                                              } finally {
                                                try {
                                                  if (!c && null != r.return && ((i = r.return()), Object(i) !== i))
                                                    return;
                                                } finally {
                                                  if (l) throw n;
                                                }
                                              }
                                              return s;
                                            }
                                          })(t, e) ||
                                          (function (t, e) {
                                            if (t) {
                                              if ('string' == typeof t) return F(t, e);
                                              var r = {}.toString.call(t).slice(8, -1);
                                              return (
                                                'Object' === r && t.constructor && (r = t.constructor.name),
                                                'Map' === r || 'Set' === r
                                                  ? Array.from(t)
                                                  : 'Arguments' === r ||
                                                      /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                                                    ? F(t, e)
                                                    : void 0
                                              );
                                            }
                                          })(t, e) ||
                                          (function () {
                                            throw new TypeError(
                                              'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                                            );
                                          })()
                                        );
                                      })((r = e.split(u)), 2),
                                      n = a[0],
                                      o = a[1];
                                    f[n] = o;
                                  }
                                  t.isFilterStr(decodeURIComponent(r[0])) && (c[r[0]] = [r[1]]);
                                }
                              });
                            break;
                          case 'HASH':
                            Object.keys(l).forEach(function (e) {
                              e !== o && t.isFilterStr(e) && (c[e] = [decodeURIComponent(window.atob(l[e]))]);
                            });
                            break;
                          default:
                            Object.keys(l).forEach(function (e) {
                              e !== o && t.isFilterStr(e) && (c[e] = l[e]);
                            });
                        }
                        return c;
                      } catch (t) {
                        return this.onError('readFacetsWebUrl.js', t, i), -1;
                      }
                    },
                    readPageNoWebUrl: function (t) {
                      try {
                        var e = this.options.url,
                          r = (void 0 === e ? {} : e).pageNoParam,
                          a = void 0 === r ? {} : r,
                          n = a.algo,
                          o = void 0 === n ? 'DEFAULT' : n,
                          s = a.keyReplacer,
                          c = a.usePageNo,
                          l = this.getCustomQueryParams(t),
                          u = {};
                        if ('KEY_VALUE_REPLACER' === o) {
                          var d = l[encodeURIComponent(s)];
                          d && (u = w({}, s, [d]));
                        } else {
                          var p = l[c ? 'page' : 'start'];
                          p && (u = w({}, c ? 'page' : 'start', [p]));
                        }
                        return u;
                      } catch (t) {
                        return this.onError('readPageNoWebUrl.js', t, i), -1;
                      }
                    },
                    readQueryParamsFromUrl: function (t) {
                      var e = this;
                      try {
                        var r = this.options.url,
                          a = (void 0 === r ? {} : r).facetsParam,
                          n = void 0 === a ? {} : a,
                          o = this.getSearchQueryParam(),
                          s = this.getBrowseQueryParam(),
                          c = this.getQueryParamSeparator(),
                          l = this.getKeyValueSeparator(),
                          u = this.getSearchParamValue(t),
                          d = '',
                          p = (d = this.getHashMode() ? ('#' === u[0] ? u.substr(1) : u) : u.substr(1))
                            ? d.split(c)
                            : [],
                          h = {};
                        return (
                          p.forEach(function (t) {
                            if ('' !== t) {
                              var r = t.split(l);
                              if (e.isFilterStr(decodeURIComponent(r[0])))
                                switch (n.algo) {
                                  case 'HASH':
                                    h.filter = [r];
                                    break;
                                  case 'KEY_VALUE_REPLACER':
                                    Object.keys(h).includes(r[0]) ? h[r[0]].push(r[1]) : (h[r[0]] = [r[1]]);
                                    break;
                                  default:
                                    t.includes('category-filter'.concat(l))
                                      ? (h[r[0]] = [decodeURIComponent(r[1])])
                                      : Object.keys(h).includes('filter')
                                        ? r.length > 2
                                          ? h.filter.push(decodeURIComponent(r.splice(1, r.length).join(':')))
                                          : h.filter.push(decodeURIComponent(r[1]))
                                        : r.length > 2
                                          ? (h.filter = [decodeURIComponent(r.splice(1, r.length).join(':'))])
                                          : (h.filter = [decodeURIComponent(r[1])]);
                                }
                              else
                                r[0] === o || r[0] === s
                                  ? (h[r[0]] = [r[1]])
                                  : (h[decodeURIComponent(r[0])] = [decodeURIComponent(r[1])]);
                            }
                          }),
                          h
                        );
                      } catch (t) {
                        return this.onError('readQueryParamsFromUrl.js', t, i), -1;
                      }
                    },
                    getValuesSeparatorFacets: d.getValuesSeparatorFacets,
                    getQueryParamSeparator: d.getQueryParamSeparator,
                    getRangeSeparator: d.getRangeSeparator,
                    getSortParam: d.getSortParam,
                    getPageViewParam: d.getPageViewParam,
                    getPageSizeParam: d.getPageSizeParam,
                    getPageNoParam: d.getPageNoParam,
                    isFilterStr: R,
                    getHashMode: d.getHashMode,
                    getUpdateUrls: d.getUpdateUrls,
                    getAllowExternalUrlParams: d.getAllowExternalUrlParams,
                    getBrowseQueryParam: d.getBrowseQueryParam,
                    getSearchQueryParam: d.getSearchQueryParam,
                    getKeyValueSeparator: d.getKeyValueSeparator,
                    getHeightDiffToTriggerNextPage: d.getHeightDiffToTriggerNextPage,
                    getPaginationType: d.getPaginationType,
                    getSearchParamValue: d.getSearchParamValue,
                    getProductType: d.getProductType,
                    getDefaultOpen: d.getDefaultOpen,
                    getSortAction: d.getSortAction,
                    getPageSizeAction: d.getPageSizeAction,
                    getPaginationAction: d.getPaginationAction,
                    setRoutingStrategies: function (t) {
                      try {
                        var e = this.getPaginationType(),
                          r = this.getPageNoParam(),
                          a = this.getHashMode() ? window.location.hash : window.location.search,
                          n = this.getQueryParams(this.getHashMode() ? a.split('#')[1] : a.split('?')[1]),
                          o = this.getQueryParams(
                            this.getHashMode() ? t.split('#')[1] : (null == t ? void 0 : t.split('?')[1]) || ''
                          ),
                          s =
                            ('INFINITE_SCROLL' === e || 'CLICK_N_SCROLL' === e) &&
                            n[r] !== o[r] &&
                            d.deepCompareUrlParams.bind(this)(n, o),
                          c = t;
                        '' === t && (c = window.location.pathname),
                          s ? history.replaceState(null, '', c) : history.pushState(null, '', c);
                      } catch (e) {
                        this.onError(
                          'Failed to update URL, falling back to window.location.href - setRoutingStrategies.js',
                          e,
                          i
                        ),
                          (window.location.href = t);
                      }
                    },
                  };
                function C(t) {
                  try {
                    this.state.startPageNo = Number(t);
                  } catch (t) {
                    this.onError('setPageStart.js', t, i);
                  }
                }
                function N() {
                  try {
                    var t = this.getSearchResults();
                    if (!t) return null;
                    var e = t.numberOfProducts,
                      r = t.products,
                      a = t.start;
                    a = Number(a);
                    var n = Number(this.state.pageSize),
                      o = 0;
                    e > 0 && (o = e % n === 0 ? e / n : Math.floor(e / n) + 1);
                    var s = Math.floor(a / n) + 1,
                      c = !(a + n >= e || a >= e),
                      l = !(a - n < 0 || a <= 0);
                    return {
                      numberOfProducts: e,
                      start: a,
                      productsLn: r.length,
                      rows: n,
                      noOfPages: o,
                      currentPage: s || 0,
                      isNext: c,
                      isPrev: l,
                    };
                  } catch (t) {
                    return this.onError('getPaginationInfo.js', t, i), -1;
                  }
                }
                function O(t) {
                  try {
                    'number' == typeof t &&
                      t === parseInt(t, 10) &&
                      ((this.state.pageSize = Number(t)), (this.state.startPageNo = 0));
                  } catch (t) {
                    this.onError('setPageSize.js', t, i);
                  }
                }
                function T(t) {
                  try {
                    Array.isArray(t) ? (this.options.productAttributes = t) : (this.options.productAttributes = '*');
                  } catch (t) {
                    this.onError('setProductAttributes.js', t, i);
                  }
                }
                function L(t) {
                  try {
                    var e = this.options.variants,
                      r = void 0 === e ? {} : e;
                    'boolean' == typeof t && (r.enabled = t), (this.options.variants = r);
                  } catch (t) {
                    this.onError('setShowVariants.js', t, i);
                  }
                }
                function I(t) {
                  try {
                    var e = this.options.variants,
                      r = void 0 === e ? {} : e;
                    'number' == typeof t && (r.count = t), (this.options.variants = r);
                  } catch (t) {
                    this.onError('setVariantsCount.js', t, i);
                  }
                }
                function j(t) {
                  try {
                    var e = this.options.variants,
                      r = void 0 === e ? {} : e;
                    Array.isArray(t) && (r.attributes = t), (this.options.variants = r);
                  } catch (t) {
                    this.onError('setVariantsAttributes.js', t, i);
                  }
                }
                function k(t) {
                  try {
                    var e = this.options.variants,
                      r = void 0 === e ? {} : e;
                    'string' == typeof t && t.length > 0 && (r.groupBy = t), (this.options.variants = r);
                  } catch (t) {
                    this.onError('setVariantsGroupBy.js', t, i);
                  }
                }
                function _() {
                  try {
                    return (this.state.responseObj && this.state.responseObj.searchMetaData) || null;
                  } catch (t) {
                    return this.onError('getSearchMetaDetails.js', t, i), -1;
                  }
                }
                function V() {
                  try {
                    var t = this.getResponseObj();
                    return (t && t.response) || null;
                  } catch (t) {
                    return this.onError('getSearchResults.js', t, i), -1;
                  }
                }
                function x() {
                  try {
                    var t = this.getSearchMeta();
                    return (t && t.queryParams) || null;
                  } catch (t) {
                    return this.onError('getSearchQueryParams.js', t, i), -1;
                  }
                }
                function M() {
                  try {
                    if (this.state.responseObj) {
                      var t = this.state.responseObj.searchMetaData.queryParams;
                      return t[this.getSearchQueryParam()] || t[this.getBrowseQueryParam()];
                    }
                    return '';
                  } catch (t) {
                    return this.onError('getSearchQuery.js', t, i), -1;
                  }
                }
                function X(t) {
                  return (
                    (X =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    X(t)
                  );
                }
                const D = function t(e) {
                  if (null === e) return null;
                  if ('object' !== X(e)) return e;
                  var r = Array.isArray(e) ? [] : {};
                  return (
                    Object.keys(e).forEach(function (a) {
                      var n = e[a];
                      r[a] = t(n);
                    }),
                    r
                  );
                };
                function B(t) {
                  return (
                    (B =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    B(t)
                  );
                }
                function W(t) {
                  return (
                    (function (t) {
                      if (Array.isArray(t)) return H(t);
                    })(t) ||
                    (function (t) {
                      if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
                        return Array.from(t);
                    })(t) ||
                    (function (t, e) {
                      if (t) {
                        if ('string' == typeof t) return H(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return (
                          'Object' === r && t.constructor && (r = t.constructor.name),
                          'Map' === r || 'Set' === r
                            ? Array.from(t)
                            : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                              ? H(t, e)
                              : void 0
                        );
                      }
                    })(t) ||
                    (function () {
                      throw new TypeError(
                        'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                      );
                    })()
                  );
                }
                function H(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function z(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(t);
                    e &&
                      (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                      })),
                      r.push.apply(r, a);
                  }
                  return r;
                }
                function Q(t) {
                  for (var e = 1; e < arguments.length; e++) {
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2
                      ? z(Object(r), !0).forEach(function (e) {
                          K(t, e, r[e]);
                        })
                      : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
                        : z(Object(r)).forEach(function (e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                          });
                  }
                  return t;
                }
                function K(t, e, r) {
                  return (
                    (e = (function (t) {
                      var e = (function (t) {
                        if ('object' != B(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                          var r = e.call(t, 'string');
                          if ('object' != B(r)) return r;
                          throw new TypeError('@@toPrimitive must return a primitive value.');
                        }
                        return String(t);
                      })(t);
                      return 'symbol' == B(e) ? e : e + '';
                    })(e)) in t
                      ? Object.defineProperty(t, e, {value: r, enumerable: !0, configurable: !0, writable: !0})
                      : (t[e] = r),
                    t
                  );
                }
                function q() {
                  var t = this,
                    e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
                    r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : '';
                  try {
                    var s = this.state,
                      c = s.userInput,
                      l = s.isHistory,
                      u = s.isBack,
                      p = '' === e ? c : e;
                    if (
                      ((this.state.userInput = p),
                      (this.state.currentApiUrl = this.getNewUrlState(!0)),
                      this.state.isLoading)
                    )
                      return !1;
                    this.state.isLoading = !0;
                    var h = this,
                      f = this.options.variants,
                      g = this.getProductType();
                    if (!this.getHashMode() && this.getUpdateUrls() && !l && !u) {
                      this.state.isBack = !1;
                      var y = this.state.currentWebUrl.split(''.concat(g.toLocaleLowerCase(), '?'))[1];
                      if (decodeURIComponent(window.location.search) !== '?'.concat(d.decodeQueryParam(y)))
                        return this.setUrl(!0), !1;
                    }
                    this.callBack(this, o);
                    var v = new Headers(),
                      m = d.getDefaultRequestHeaders(this);
                    Object.keys(m).forEach(function (t) {
                      v.append(t, m[t]);
                    });
                    var b = fetch(this.state.currentApiUrl, {headers: v, method: 'GET'}),
                      S = function (e, r) {
                        (t.state.isLoading = !1), (t.state.userInput = p), e && t.callBack(h, e, {error: r});
                      };
                    return (
                      b
                        .then(function (e) {
                          return (t.state.requestId = e && e.headers ? e.headers.get('X-Request-Id') : ''), e.json();
                        })
                        .then(function (e) {
                          if (((t.state.isLoading = !1), (t.state.userInput = p), e && !e.error)) {
                            var o = D(e);
                            f && f.enabled && (o = t.processVariantMap(o)), (t.state.responseObj = o);
                            var i = t.getDidYouMeanFromResponse();
                            i && ((t.state.didYouMean = i), (t.state.noResultQuery = t.state.userInput));
                            var s = o,
                              c = s.facets,
                              d = s.response,
                              g = void 0 === d ? {} : d;
                            if (c) {
                              var y = t.getFacets(),
                                v = t.modifyFacetsList(y);
                              o.facets = Q(Q({}, c), {}, {text: {list: v}});
                            }
                            if (g) {
                              var m = g.products,
                                b = void 0 === m ? [] : m,
                                E = t.getPaginationType();
                              'INFINITE_SCROLL' === E || 'CLICK_N_SCROLL' === E
                                ? (t.state.products =
                                    'prev' === r
                                      ? [].concat(W(b), W(t.state.products))
                                      : [].concat(W(t.state.products), W(b)))
                                : 'FIXED_PAGINATION' === E && (t.state.products = b);
                            }
                            (t.state.responseObj = o),
                              t.setSort(),
                              t.getUpdateUrls() &&
                                l &&
                                !u &&
                                ((t.state.isBack = !1), t.setUrl(!1), t.updateSelectedFacetsCount()),
                              t.callBack(h, n);
                          } else S(a, e.error);
                        })
                        .catch(function (t) {
                          return S(a, t), -1;
                        }),
                      !0
                    );
                  } catch (t) {
                    return this.onError('getResultsFromApi.js', t, i), -1;
                  }
                }
                function Y(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function G() {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  try {
                    var e = this.options.variants.mapping,
                      r = void 0 === e ? {} : e,
                      a = Object.keys(r),
                      n = D(t);
                    if (t.response && t.response.products) {
                      var o = n.response.products.map(function (t) {
                        var e = D(t),
                          n = e,
                          o = n.variants,
                          i = void 0 === o ? [] : o,
                          s = n.relevantDocument,
                          c = e;
                        if ('variant' === s && i.length > 0) {
                          var l = (function (t, e) {
                            return (
                              (function (t) {
                                if (Array.isArray(t)) return t;
                              })(t) ||
                              (function (t, e) {
                                var r =
                                  null == t
                                    ? null
                                    : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                                if (null != r) {
                                  var a,
                                    n,
                                    o,
                                    i,
                                    s = [],
                                    c = !0,
                                    l = !1;
                                  try {
                                    if (((o = (r = r.call(t)).next), 0 === e)) {
                                      if (Object(r) !== r) return;
                                      c = !1;
                                    } else
                                      for (; !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e); c = !0);
                                  } catch (t) {
                                    (l = !0), (n = t);
                                  } finally {
                                    try {
                                      if (!c && null != r.return && ((i = r.return()), Object(i) !== i)) return;
                                    } finally {
                                      if (l) throw n;
                                    }
                                  }
                                  return s;
                                }
                              })(t, e) ||
                              (function (t, e) {
                                if (t) {
                                  if ('string' == typeof t) return Y(t, e);
                                  var r = {}.toString.call(t).slice(8, -1);
                                  return (
                                    'Object' === r && t.constructor && (r = t.constructor.name),
                                    'Map' === r || 'Set' === r
                                      ? Array.from(t)
                                      : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                                        ? Y(t, e)
                                        : void 0
                                  );
                                }
                              })(t, e) ||
                              (function () {
                                throw new TypeError(
                                  'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                                );
                              })()
                            );
                          })(i, 1);
                          (e = l[0]),
                            a.forEach(function (t) {
                              var a = r[t];
                              c[t] = e[a];
                            });
                        }
                        var u = [];
                        return (
                          i.forEach(function (t) {
                            var e = t;
                            a.forEach(function (a) {
                              var n = r[a];
                              n && (e[a] = t[n]);
                            }),
                              u.push(e);
                          }),
                          (c.variants = u),
                          c
                        );
                      });
                      n.response.products = o;
                    }
                    return n;
                  } catch (t) {
                    return this.onError('processVariantsMap.js', t, i), -1;
                  }
                }
                function $(t, e) {
                  try {
                    return this.state.products.find(function (r) {
                      return r[t] === e;
                    });
                  } catch (t) {
                    return this.onError('getProductByPropValue.js', t, i), -1;
                  }
                }
                function Z() {
                  var t = this;
                  try {
                    var e = this.getSearchQueryParams(),
                      r = e,
                      a = r[e],
                      n = r.filter;
                    this.state.userInput = a;
                    var o = [],
                      s = '__',
                      c = ':';
                    if (n) {
                      if (Array.isArray(n))
                        n.forEach(function (t) {
                          var e = t.replaceAll(c, s);
                          (e = encodeURIComponent(e).replaceAll(s, c)), o.push(e);
                        });
                      else {
                        var l = n.replaceAll(c, s);
                        (l = encodeURIComponent(l).replaceAll(s, c)), (o = [l]);
                      }
                      r.filter = o;
                    }
                    var u = this.getFilterFromParams(o);
                    this.state.rangeFacet = u.rangeFacet;
                    var d = u.selectedFilters,
                      p = null;
                    d
                      ? Object.keys(d).forEach(function (e) {
                          if (t.isCategoryFacet(e)) {
                            p = e;
                            var r = d[e][0].dataId;
                            (t.state.categoryFilter[p] = r.split('>')),
                              t.state.selectedFacets[p] && delete t.state.selectedFacets[p];
                          } else t.state.selectedFacets[e] = d[e];
                        })
                      : (this.state.selectedFacets = {}),
                      0 === Object.keys(this.state.categoryFilter).length &&
                        (this.state.categoryFilter = this.getCategoryFilterFromParams(r)),
                      (this.state.breadcrumbs = this.getBreadCrumbs(p));
                  } catch (t) {
                    this.onError('setStateFromData.js', t, i);
                  }
                }
                const J = function (t) {
                  try {
                    var e = t.siteName,
                      r = t.siteKey,
                      a = t.searchEndPoint,
                      n = t.defaultFilters,
                      o = t.spellCheck,
                      s = t.pageSize,
                      c = t.startPageNo,
                      l = t.facetDepth,
                      u = t.facetMultilevel,
                      d = t.facetMultiSelect,
                      p = t.updateUrls,
                      h = t.extraParams,
                      f = t.onEvent,
                      g = t.getCategoryId,
                      y = t.applyMultipleFilters,
                      v = t.hashMode;
                    (this.state.pageSize = s || this.state.pageSize),
                      (this.state.startPageNo = c || this.state.startPageNo),
                      (this.options.siteName = e || this.options.siteName),
                      (this.options.siteKey = r || this.options.siteKey),
                      (this.options.searchEndPoint = a || this.options.searchEndPoint),
                      (this.options.defaultFilters = n || this.options.defaultFilters),
                      (this.options.spellCheck = o || this.options.spellCheck),
                      (this.options.startPageNo = c || this.options.startPageNo),
                      (this.options.applyMultipleFilters = y || this.options.applyMultipleFilters),
                      (this.options.facetDepth = l || this.options.facetDepth),
                      (this.options.facetMultilevel = u || this.options.facetMultilevel),
                      (this.options.facetMultiSelect = d || this.options.facetMultiSelect),
                      (this.options.updateUrls = p || this.options.url.updateUrls || this.options.updateUrls),
                      (this.options.extraParams = h || this.options.extraParams),
                      (this.options.onEvent = f || this.options.onEvent),
                      (this.options.getCategoryId = g || this.options.getCategoryId),
                      (this.options.hashMode = v || this.getHashMode());
                  } catch (t) {
                    this.onError('setSearchConfigurations.js', t, i);
                  }
                };
                var tt = function (t) {
                    try {
                      var e = this.state,
                        r = e.urlState,
                        a = e.isHistory,
                        n = this.checkIfUnbxdKey();
                      if (this.getHashMode())
                        if (decodeURIComponent(window.location.hash) !== '#'.concat(decodeURIComponent(r))) {
                          if (((this.state.isBack = !0), !n)) return void this.options.onNoUnbxdKeyRouting();
                          this.renderFromUrl(t.state);
                        } else this.callBack(this, 'lastBack');
                      else if (a) {
                        if (((this.state.isBack = !0), !n)) return void this.options.onNoUnbxdKeyRouting();
                        this.renderFromUrl(t.state);
                      } else this.callBack(this, 'lastBack');
                    } catch (t) {
                      this.onError('onLocationChange', t, i);
                    }
                  },
                  et = function () {
                    return this.state.requestId;
                  };
                function rt(t, e) {
                  try {
                    var r = {};
                    return (
                      Object.keys(e).forEach(function (a) {
                        var n = e[a];
                        r[a] = t[n];
                      }),
                      r
                    );
                  } catch (t) {
                    return this.onError('getSwatches.js', t, i), -1;
                  }
                }
                function at() {
                  try {
                    var t = this.getResponseObj();
                    if (t && t.facets && t.facets.multilevel) {
                      var e = t.facets.multilevel.bucket || t.facets.multilevel.list || [];
                      return this.modifyFacetsList(e) || [];
                    }
                    return [];
                  } catch (t) {
                    return this.onError('getBucketedFacets.js', t, i), -1;
                  }
                }
                function nt() {
                  var t = this,
                    e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                  try {
                    var r = (this.options || {}).url,
                      a = (void 0 === r ? {} : r).facetsParam,
                      n = void 0 === a ? {} : a,
                      o = {},
                      s = {},
                      c = D(e);
                    if ('KEY_VALUE_REPLACER' === n.algo) {
                      var l = this,
                        u = this.getKeyValueSeparator();
                      'string' == typeof c && (c = Array(c)),
                        c.forEach(function () {
                          var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '').split(u),
                            r = decodeURIComponent(e[0]),
                            a = l.getKeyByValue(n.keyReplacer, r),
                            i = n.rangeFacets.includes(a),
                            c = [],
                            d = t.getValuesSeparatorFacets();
                          (c =
                            e[1] && e[1].includes(d)
                              ? e[1].split(d)
                              : e[1] && e[1].includes(encodeURIComponent(d))
                                ? e[1].split(encodeURIComponent(d))
                                : [e[1]]) &&
                            c.length > 0 &&
                            c.forEach(function (e) {
                              var c = decodeURIComponent(e),
                                u = n.valueReplacer[a] ? l.getKeyByValue(n.valueReplacer[a], c) : c;
                              if (i) {
                                var d = u.split(t.getRangeSeparator()),
                                  p = '['.concat(Number(d[0]), ' TO ').concat(Number(d[1]), ']');
                                s[r] ? s[r].push(p) : (s[r] = [p]);
                              } else {
                                var h = l.getFacetByValue(a, u);
                                if (h.actualFound) {
                                  var f = h.facetName,
                                    g = h.selectedvalue;
                                  o[f] ? o[f].push(g) : (o[f] = Array(g));
                                } else {
                                  var y = h.facetName,
                                    v = {name: h.selectedvalue.name, dataId: l.encodeFacetValue(u), count: 0};
                                  o[y] ? o[y].push(v) : 'category-filter' !== y && (o[y] = Array(v));
                                }
                              }
                            });
                        });
                    } else {
                      var d = this;
                      'HASH' === n.algo &&
                        (c = window.atob(c) ? window.atob(c).split(this.getQueryParamSeparator()) : []),
                        'string' == typeof c && (c = Array(c)),
                        c.forEach(function () {
                          (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '')
                            .split('%20OR%20')
                            .forEach(function () {
                              var t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '').split(
                                /%3A(.+)/
                              );
                              if (3 === t.length) {
                                var e = decodeURIComponent(t[1]);
                                if (
                                  ((e = e
                                    .replace(/(^")|("$)/g, '')
                                    .replace(/\"{2,}/g, '"')
                                    .replace(/\\\"/g, '"')
                                    .replace(/(^\[)|(\]$)/g, '')),
                                  t[1].indexOf('TO') > 0)
                                ) {
                                  var r = e.split(' TO '),
                                    a = t[0],
                                    n = '['.concat(Number(r[0]), ' TO ').concat(Number(r[1]), ']');
                                  s[a] ? s[a].push(n) : (s[a] = [n]);
                                } else {
                                  var i = t[0],
                                    c = t[1],
                                    l = d.cleanEncodedFacetValue(c),
                                    u = d.decodeFacetValue(l),
                                    p = d.getFacetByValue(i, u);
                                  if (p.actualFound) {
                                    var h = p.facetName,
                                      f = p.selectedvalue;
                                    o[h] ? o[h].push(f) : (o[h] = Array(f));
                                  } else {
                                    var g = p.facetName,
                                      y = {name: p.selectedvalue.name, dataId: l, count: 0};
                                    o[g] ? o[g].push(y) : (o[g] = Array(y));
                                  }
                                }
                              }
                            });
                        });
                    }
                    return {selectedFilters: o, rangeFacet: s};
                  } catch (t) {
                    return this.onError('getFilterFromParams.js', t, i), -1;
                  }
                }
                function ot(t) {
                  var e = this;
                  try {
                    var r = t.filter,
                      a = [];
                    if ((t['category-filter'] && (a = (r = t['category-filter']).split('>')), !r)) return {};
                    Array.isArray(r) || (r = [r]), (r = (r = this.getFilterFromParams(r) || {}).selectedFilters);
                    var n = {};
                    if (
                      (Object.keys(r).forEach(function (t) {
                        if (e.isCategoryFacet(t)) {
                          var a = r[t][0].dataId;
                          n[t] = a.split('>');
                        }
                      }),
                      a.length > 0 && a)
                    ) {
                      var o = [];
                      a.forEach(function (t) {
                        decodeURIComponent(t)
                          .split('>')
                          .forEach(function (t) {
                            o.push(decodeURIComponent(t));
                          });
                      }),
                        (n.categoryPath = o);
                    }
                    return n;
                  } catch (t) {
                    return this.onError('getCategoryFilterFromParams.js', t, i), -1;
                  }
                }
                function it() {
                  try {
                    var t = this.getResponseObj();
                    if (t) {
                      var e = t.facets;
                      return e && e.range && e.range.list ? e.range.list : [];
                    }
                    return [];
                  } catch (t) {
                    return this.onError('getRangeFacets.js', t, i), -1;
                  }
                }
                function st() {
                  try {
                    var t = this.getResponseObj();
                    if (t) {
                      var e = t.facets;
                      return e && e.text && e.text.list ? e.text.list : [];
                    }
                    return [];
                  } catch (t) {
                    return this.onError('getFacets.js', t, i), -1;
                  }
                }
                function ct() {
                  try {
                    return this.state.selectedFacets;
                  } catch (t) {
                    return this.onError('getSelectedFacets.js', t, i), -1;
                  }
                }
                function lt(t) {
                  try {
                    return this.getFacets().find(function (e) {
                      return e.facetName === t ? e : null;
                    });
                  } catch (t) {
                    return this.onError('getSelectedFacet.js', t, i), -1;
                  }
                }
                function ut(t) {
                  try {
                    var e = this.state.selectedFacets,
                      r = t.selectedFacetName,
                      a = '',
                      n = '',
                      o = 0,
                      s = this.getSelectedFacetValue(t);
                    if (s) {
                      var c = s.name,
                        l = s.dataId,
                        u = s.count;
                      (a = c), (n = l), (o = u);
                    }
                    return (
                      !this.isFacetAlreadyAdded(r, n) &&
                      (e[r] ? e[r].push({name: a, dataId: n, count: o}) : (e[r] = [{name: a, dataId: n, count: o}]),
                      this.callBack(this, 'added_facet', {selectedFacets: e[r]}),
                      this.options.applyMultipleFilters || (this.setPageStart(0), this.getResults.bind(this)()),
                      !0)
                    );
                  } catch (t) {
                    return this.onError('updateFacets.js', t, i), -1;
                  }
                }
                function dt(t) {
                  try {
                    var e = this.state.selectedFacets;
                    return (
                      this.clearFacets(!1),
                      Object.keys(t).map(function (r) {
                        return e[r] ? delete e[r] : (e[r] = t[r]), !0;
                      }),
                      this.setPageStart(0),
                      this.getResults.bind(this)(),
                      !0
                    );
                  } catch (t) {
                    return this.onError('applyFacets.js', t, i), -1;
                  }
                }
                function pt() {
                  var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                  try {
                    var e = this.state.selectedFacets;
                    Object.keys(e).map(function (t) {
                      return delete e[t];
                    }),
                      t && (this.setPageStart(0), this.getResults.bind(this)());
                  } catch (t) {
                    this.onError('clearFacets.js', t, i);
                  }
                }
                function ht(t) {
                  return (
                    (function (t) {
                      if (Array.isArray(t)) return ft(t);
                    })(t) ||
                    (function (t) {
                      if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
                        return Array.from(t);
                    })(t) ||
                    (function (t, e) {
                      if (t) {
                        if ('string' == typeof t) return ft(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return (
                          'Object' === r && t.constructor && (r = t.constructor.name),
                          'Map' === r || 'Set' === r
                            ? Array.from(t)
                            : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                              ? ft(t, e)
                              : void 0
                        );
                      }
                    })(t) ||
                    (function () {
                      throw new TypeError(
                        'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                      );
                    })()
                  );
                }
                function ft(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function gt(t) {
                  try {
                    var e = this.state.selectedFacets;
                    return (
                      Object.keys(t).map(function (r) {
                        var a = e[r] || [];
                        return (e[r] = [].concat(ht(a), ht(t[r]))), !0;
                      }),
                      !0
                    );
                  } catch (t) {
                    return this.onError('addFacets.js', t, i), -1;
                  }
                }
                function yt(t) {
                  try {
                    return this.state.selectedFacets[t];
                  } catch (t) {
                    return this.onError('findSelectedFacet.js', t, i), -1;
                  }
                }
                function vt() {
                  var t = this,
                    e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  try {
                    var r = e.parent,
                      a = void 0 === r ? null : r,
                      n = e.level,
                      o = void 0 === n ? null : n;
                    if (o)
                      if (this.state.categoryFilter[a])
                        0 == (o = Number(o) - 1)
                          ? delete this.state.categoryFilter[a]
                          : this.state.categoryFilter[a].splice(o, 6);
                      else {
                        var s = this.getBreadCrumbsList(a);
                        o > 1 &&
                          ((this.state.categoryFilter[a] = []),
                          s.forEach(function (e, r) {
                            if (r < o - 1) {
                              var n = e.value;
                              t.state.categoryFilter[a].push(n);
                            }
                          }));
                      }
                  } catch (t) {
                    this.onError('deleteCategoryFilter.js', t, i);
                  }
                }
                function mt(t, e) {
                  try {
                    var r = this.getSelectedFacets();
                    if (e) {
                      var a = r[t];
                      this.state.selectedFacets[t] = a.filter(function (t) {
                        return t.dataId !== e;
                      });
                    } else delete this.state.selectedFacets[t];
                    return this.state.selectedFacets;
                  } catch (t) {
                    return this.onError('deleteFacet.js', t, i), -1;
                  }
                }
                function bt(t) {
                  return (
                    (bt =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    bt(t)
                  );
                }
                function St(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(t);
                    e &&
                      (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                      })),
                      r.push.apply(r, a);
                  }
                  return r;
                }
                function Et(t) {
                  for (var e = 1; e < arguments.length; e++) {
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2
                      ? St(Object(r), !0).forEach(function (e) {
                          Pt(t, e, r[e]);
                        })
                      : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
                        : St(Object(r)).forEach(function (e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                          });
                  }
                  return t;
                }
                function Pt(t, e, r) {
                  return (
                    (e = (function (t) {
                      var e = (function (t) {
                        if ('object' != bt(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                          var r = e.call(t, 'string');
                          if ('object' != bt(r)) return r;
                          throw new TypeError('@@toPrimitive must return a primitive value.');
                        }
                        return String(t);
                      })(t);
                      return 'symbol' == bt(e) ? e : e + '';
                    })(e)) in t
                      ? Object.defineProperty(t, e, {value: r, enumerable: !0, configurable: !0, writable: !0})
                      : (t[e] = r),
                    t
                  );
                }
                function Ft(t, e) {
                  try {
                    var r = this.getSelectedFacet(t) || {facetName: t},
                      a = !1,
                      n = r.values,
                      o = void 0 === n ? [] : n,
                      s = {name: e};
                    if (o.length > 0)
                      for (var c = 0; c < o.length; c++) {
                        var l = o[c];
                        if (l.name === e) {
                          (a = !0), (s = l);
                          break;
                        }
                      }
                    return a
                      ? Et(Et({}, r), {}, {selectedvalue: s, actualFound: a})
                      : {facetName: t, actualFound: a, selectedvalue: {name: e, dataId: e, count: 0}};
                  } catch (t) {
                    return this.onError('getFacetByValue.js', t, i), -1;
                  }
                }
                function At(t) {
                  try {
                    var e = t.selectedFacetId;
                    return t.facetData.values.find(function (t) {
                      return t.dataId === e;
                    });
                  } catch (t) {
                    return this.onError('getSelectedFacetValue.js', t, i), -1;
                  }
                }
                function wt() {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  try {
                    var e = t.parent,
                      r = void 0 === e ? null : e,
                      a = t.name,
                      n = void 0 === a ? null : a,
                      o = t.level,
                      s = void 0 === o ? null : o,
                      c = this.getCategoryFacetByValue(n),
                      l = this.getBreadCrumbsList(r);
                    if ((s = Number(s)) && c)
                      if (this.state.categoryFilter[r] && s <= l.length)
                        (this.state.categoryFilter[r][s - 1] = c), this.callBack(this, 'deletedcategoryFilter');
                      else {
                        var u = [];
                        (u = l.map(function (t) {
                          return t.value;
                        })).push(c),
                          (this.state.categoryFilter[r] = u),
                          this.callBack(this, 'setCategoryFilter');
                      }
                  } catch (t) {
                    this.onError('setCategoryFilter.js', t, i);
                  }
                }
                function Rt(t) {
                  try {
                    if (t.length) {
                      var e = this.options.extraParams['facet.multilevel'];
                      this.state.categoryFilter[e] = [t];
                    }
                  } catch (t) {
                    this.onError('setDefaultCategoryFilter.js', t, i);
                  }
                }
                function Ut(t) {
                  try {
                    var e = t.start,
                      r = t.end,
                      a = t.facetName,
                      n = t.applyMultiple,
                      o = '['.concat(e, ' TO ').concat(r, ']');
                    if (n)
                      if (this.state.rangeFacet[a]) {
                        var s = this.state.rangeFacet[a].indexOf(o);
                        s < 0 ? this.state.rangeFacet[a].push(o) : this.state.rangeFacet[a].splice(s, 1);
                      } else this.state.rangeFacet[a] = [o];
                    else this.state.rangeFacet[a] = [o];
                    this.callBack(this, 'added_facet', {rangeFacet: this.state.rangeFacet[a]});
                  } catch (t) {
                    this.onError('setRangeFacet', t, i);
                  }
                }
                function Ct(t) {
                  try {
                    var e = (this.state || {}).rangeFacet,
                      r = void 0 === e ? {} : e;
                    r[t] && delete r[t], (this.state.rangeFacet = r);
                  } catch (t) {
                    this.onError('clearARangeFacet.js', t, i);
                  }
                }
                function Nt(t, e) {
                  try {
                    this.deleteFacet(t, e),
                      this.callBack(this, 'deleted_facet'),
                      this.options.applyMultipleFilters || (this.setPageStart(0), this.getResults.bind(this)());
                  } catch (t) {
                    this.onError('deleteAFacet.js', t, i);
                  }
                }
                function Ot(t, e) {
                  try {
                    var r = this.getSelectedFacets()[t] || [],
                      a = !1;
                    return (
                      r &&
                        (a = r.some(function () {
                          return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).dataId === e;
                        })),
                      a
                    );
                  } catch (t) {
                    return this.onError('isFacetAlreadyAdded.js', t, i), -1;
                  }
                }
                function Tt(t) {
                  try {
                    var e = this.state.rangeFacet;
                    return t ? e[t] : e;
                  } catch (t) {
                    return this.onError('getSelectedRanges.js', t, i), -1;
                  }
                }
                function Lt(t) {
                  return (
                    (Lt =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    Lt(t)
                  );
                }
                function It(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(t);
                    e &&
                      (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                      })),
                      r.push.apply(r, a);
                  }
                  return r;
                }
                function jt(t) {
                  for (var e = 1; e < arguments.length; e++) {
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2
                      ? It(Object(r), !0).forEach(function (e) {
                          kt(t, e, r[e]);
                        })
                      : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
                        : It(Object(r)).forEach(function (e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                          });
                  }
                  return t;
                }
                function kt(t, e, r) {
                  return (
                    (e = (function (t) {
                      var e = (function (t) {
                        if ('object' != Lt(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                          var r = e.call(t, 'string');
                          if ('object' != Lt(r)) return r;
                          throw new TypeError('@@toPrimitive must return a primitive value.');
                        }
                        return String(t);
                      })(t);
                      return 'symbol' == Lt(e) ? e : e + '';
                    })(e)) in t
                      ? Object.defineProperty(t, e, {value: r, enumerable: !0, configurable: !0, writable: !0})
                      : (t[e] = r),
                    t
                  );
                }
                function _t() {
                  try {
                    var t;
                    return (function (t) {
                      try {
                        var e = [];
                        return (
                          (t || []).forEach(function (t) {
                            for (
                              var r = t.values, a = r.counts, n = r.gap, o = D(t), i = [], s = [], c = 0;
                              c < a.length;
                              c += 2
                            ) {
                              var l = Number(a[c]),
                                u = {name: l, count: a[c + 1], dataId: l};
                              if ((s.push(u), s.length >= 2)) {
                                var d = s[0],
                                  p = s[1];
                                i.push({from: d, end: p}), s.shift();
                              }
                            }
                            if (1 === s.length) {
                              var h = s[0],
                                f = h.dataId + n,
                                g = {name: f, count: 0, dataId: f};
                              i.push({from: h, end: g});
                            }
                            var y = i[0].from.dataId,
                              v = i[i.length - 1].end.dataId;
                            (o.start = y),
                              (o.end = v),
                              (o.max = v),
                              (o.gap = n || 1),
                              (o.min = y),
                              (o.values = i),
                              e.push(jt(jt({}, o), {}, {values: i}));
                          }),
                          e
                        );
                      } catch (t) {
                        return (void 0).onError('processRangeFacets.js', t, i), -1;
                      }
                    })(this.getRangeFacets());
                  } catch (t) {
                    return this.onError('getRanges.js', t, i), -1;
                  }
                }
                function Vt(t) {
                  try {
                    var e = this.getAFacetByName(t)[0];
                    return !!e && 'category' === e.facetType;
                  } catch (t) {
                    return this.onError('isCategoryFacet.js', t, i), -1;
                  }
                }
                function xt(t) {
                  return (
                    (function (t) {
                      if (Array.isArray(t)) return Mt(t);
                    })(t) ||
                    (function (t) {
                      if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
                        return Array.from(t);
                    })(t) ||
                    (function (t, e) {
                      if (t) {
                        if ('string' == typeof t) return Mt(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return (
                          'Object' === r && t.constructor && (r = t.constructor.name),
                          'Map' === r || 'Set' === r
                            ? Array.from(t)
                            : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                              ? Mt(t, e)
                              : void 0
                        );
                      }
                    })(t) ||
                    (function () {
                      throw new TypeError(
                        'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                      );
                    })()
                  );
                }
                function Mt(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function Xt() {
                  try {
                    var t = this.getAllTextFacets(),
                      e = this.getAllRangeFacets(),
                      r = this.getAllCategory();
                    return [].concat(xt(r), xt(t), xt(e)).sort(this.sortFacets);
                  } catch (t) {
                    return this.onError('getAllFacets.js', t, i), -1;
                  }
                }
                function Dt(t) {
                  try {
                    var e = this.getAllFacets(),
                      r = [];
                    return (
                      t &&
                        (r = e.filter(function (e) {
                          return e.facetName === t;
                        })),
                      r
                    );
                  } catch (t) {
                    return this.onError('getAFacetByName.js', t, i), -1;
                  }
                }
                function Bt() {
                  try {
                    var t = this.state.categoryFilter;
                    return t ? Object.keys(t) : null;
                  } catch (t) {
                    return this.onError('getSelectedMultilevelFacet.js', t, i), -1;
                  }
                }
                function Wt(t) {
                  return (
                    (Wt =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    Wt(t)
                  );
                }
                function Ht(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(t);
                    e &&
                      (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                      })),
                      r.push.apply(r, a);
                  }
                  return r;
                }
                function zt(t) {
                  for (var e = 1; e < arguments.length; e++) {
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2
                      ? Ht(Object(r), !0).forEach(function (e) {
                          Qt(t, e, r[e]);
                        })
                      : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
                        : Ht(Object(r)).forEach(function (e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                          });
                  }
                  return t;
                }
                function Qt(t, e, r) {
                  return (
                    (e = (function (t) {
                      var e = (function (t) {
                        if ('object' != Wt(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                          var r = e.call(t, 'string');
                          if ('object' != Wt(r)) return r;
                          throw new TypeError('@@toPrimitive must return a primitive value.');
                        }
                        return String(t);
                      })(t);
                      return 'symbol' == Wt(e) ? e : e + '';
                    })(e)) in t
                      ? Object.defineProperty(t, e, {value: r, enumerable: !0, configurable: !0, writable: !0})
                      : (t[e] = r),
                    t
                  );
                }
                function Kt() {
                  try {
                    var t = this.getSelectedBucketedFacet(),
                      e = this.getSelectedRanges(),
                      r = this.getSelectedFacets();
                    return zt(zt(zt({}, t), e), r);
                  } catch (t) {
                    return this.onError('getAllSelectedFacets.js', t, i), -1;
                  }
                }
                function qt() {
                  try {
                    var t = this.getAllSelectedFacets() || {};
                    return Object.keys(t).length;
                  } catch (t) {
                    return this.onError('getSelectedFacetsCount.js', t, i), -1;
                  }
                }
                function Yt() {
                  try {
                    var t = this.getAllSelectedFacets() || {},
                      e = Object.keys(t),
                      r = 0;
                    return (
                      e.forEach(function (e) {
                        var a = t[e];
                        Array.isArray(a) && (r += a.length);
                      }),
                      r
                    );
                  } catch (t) {
                    return this.onError('getSelectedFacetValueCount.js', t, i), -1;
                  }
                }
                function Gt(t) {
                  try {
                    var e = this.getBucketedFacets(),
                      r = null;
                    if (e)
                      for (var a = 0; a < e.length; a++)
                        for (var n = e[a].values, o = 0; o < n.length; o++) {
                          var s = n[o],
                            c = s.dataId,
                            l = s.name;
                          if (c === t) {
                            r = l;
                            break;
                          }
                        }
                    return r;
                  } catch (t) {
                    return this.onError('getCategoryFacetByValue.js', t, i), -1;
                  }
                }
                function $t(t) {
                  return (
                    ($t =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    $t(t)
                  );
                }
                function Zt(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function Jt(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(t);
                    e &&
                      (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                      })),
                      r.push.apply(r, a);
                  }
                  return r;
                }
                function te(t) {
                  for (var e = 1; e < arguments.length; e++) {
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2
                      ? Jt(Object(r), !0).forEach(function (e) {
                          ee(t, e, r[e]);
                        })
                      : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
                        : Jt(Object(r)).forEach(function (e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                          });
                  }
                  return t;
                }
                function ee(t, e, r) {
                  return (
                    (e = (function (t) {
                      var e = (function (t) {
                        if ('object' != $t(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                          var r = e.call(t, 'string');
                          if ('object' != $t(r)) return r;
                          throw new TypeError('@@toPrimitive must return a primitive value.');
                        }
                        return String(t);
                      })(t);
                      return 'symbol' == $t(e) ? e : e + '';
                    })(e)) in t
                      ? Object.defineProperty(t, e, {value: r, enumerable: !0, configurable: !0, writable: !0})
                      : (t[e] = r),
                    t
                  );
                }
                var re = function () {
                    var t = this,
                      e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                    try {
                      var r = [];
                      return (
                        e.forEach(function (a, n) {
                          var o = a;
                          if (a.name) r.push(te(te({}, o), {}, {dataId: t.encodeFacetValue(a.name)}));
                          else {
                            var i = '';
                            n % 2 == 1 && ((i = e[n - 1]), r.push({name: i, count: o, dataId: t.encodeFacetValue(i)}));
                          }
                        }),
                        r
                      );
                    } catch (t) {
                      return this.onError('modifyValues', t, i), -1;
                    }
                  },
                  ae = function (t) {
                    var e = this;
                    try {
                      var r = [];
                      return (
                        (t || []).forEach(function (t) {
                          var a = D(t),
                            n = a.values,
                            o = a.displayName,
                            i = a.facetName,
                            s = a.filterField;
                          i || (o && (a.facetName = o), s && (a.facetName = s)),
                            (a.values = e.modifyValues(n)),
                            r.push(a);
                        }),
                        r
                      );
                    } catch (t) {
                      return this.onError('modifyFacetsList', t, i), -1;
                    }
                  };
                function ne(t) {
                  try {
                    var e = '0'.concat(t.charCodeAt(0).toString(16));
                    return '\\x'.concat(e.substr(e.length - 2));
                  } catch (t) {
                    return this.onError('hex', t, i), -1;
                  }
                }
                var oe = function (t) {
                    try {
                      var e = t
                        .replace(/\\/g, '\\\\')
                        .replace(/\n/g, '\\n')
                        .replace(/\t/g, '\\t')
                        .replace(/\v/g, '\\v')
                        .replace(/'/g, "'")
                        .replace(/"/g, '\\"')
                        .replace(/[\x00-\x1F\x80-\x9F]/g, ne);
                      return encodeURIComponent(e);
                    } catch (t) {
                      return (void 0).onError('encodeFacetValue', t, i), -1;
                    }
                  },
                  ie = function (t) {
                    try {
                      var e = t
                        .replace(/\\/g, '\\\\')
                        .replace(/\n/g, '\\n')
                        .replace(/\t/g, '\\t')
                        .replace(/\v/g, '\\v')
                        .replace(/'/g, "'")
                        .replace(/"/g, '\\"')
                        .replace(/[\x00-\x1F\x80-\x9F]/g, ne);
                      return encodeURIComponent(e);
                    } catch (t) {
                      return this.onError('encodeCategoryFacetValue', t, i), -1;
                    }
                  },
                  se = function (t) {
                    try {
                      return decodeURIComponent(t).replace(/\\"/g, '"');
                    } catch (t) {
                      return this.onError('decodeFacetValue', t, i), -1;
                    }
                  },
                  ce = function (t) {
                    try {
                      return t.replace(/[^\w\d]/g, '');
                    } catch (t) {
                      return this.onError('cleanFacetValue', t, i), -1;
                    }
                  },
                  le = function (t) {
                    try {
                      var e = '',
                        r = t.split('%22');
                      return (
                        (e =
                          1 === r.length
                            ? (function (t, e) {
                                return (
                                  (function (t) {
                                    if (Array.isArray(t)) return t;
                                  })(t) ||
                                  (function (t, e) {
                                    var r =
                                      null == t
                                        ? null
                                        : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                                    if (null != r) {
                                      var a,
                                        n,
                                        o,
                                        i,
                                        s = [],
                                        c = !0,
                                        l = !1;
                                      try {
                                        if (((o = (r = r.call(t)).next), 0 === e)) {
                                          if (Object(r) !== r) return;
                                          c = !1;
                                        } else
                                          for (
                                            ;
                                            !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e);
                                            c = !0
                                          );
                                      } catch (t) {
                                        (l = !0), (n = t);
                                      } finally {
                                        try {
                                          if (!c && null != r.return && ((i = r.return()), Object(i) !== i)) return;
                                        } finally {
                                          if (l) throw n;
                                        }
                                      }
                                      return s;
                                    }
                                  })(t, e) ||
                                  (function (t, e) {
                                    if (t) {
                                      if ('string' == typeof t) return Zt(t, e);
                                      var r = {}.toString.call(t).slice(8, -1);
                                      return (
                                        'Object' === r && t.constructor && (r = t.constructor.name),
                                        'Map' === r || 'Set' === r
                                          ? Array.from(t)
                                          : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                                            ? Zt(t, e)
                                            : void 0
                                      );
                                    }
                                  })(t, e) ||
                                  (function () {
                                    throw new TypeError(
                                      'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                                    );
                                  })()
                                );
                              })(r, 2)[1]
                            : (r = r.slice(1, -1)).join('%22')),
                        e
                      );
                    } catch (t) {
                      return this.onError('cleanEncodedFacetValue', t, i), -1;
                    }
                  },
                  ue = function (t, e) {
                    return (
                      Object.keys(t).find(function (r) {
                        return t[r] === e;
                      }) || e
                    );
                  },
                  de = function () {
                    try {
                      return this.state.categoryFilter;
                    } catch (t) {
                      return this.onError('getSelectedBucketedFacet', t, i), -1;
                    }
                  },
                  pe = function () {
                    try {
                      this.setPageStart(0), this.getResults.bind(this)();
                    } catch (t) {
                      this.onError('applyRangeFacet', t, i);
                    }
                  },
                  he = function (t, e) {
                    try {
                      return t.position > e.position ? 1 : -1;
                    } catch (t) {
                      return this.onError('sortFacets', t, i), -1;
                    }
                  },
                  fe = function () {
                    try {
                      return this.getFacets().map(function (t) {
                        var e = D(t);
                        return (e.facetType = 'text'), e;
                      });
                    } catch (t) {
                      return this.onError('getAllTextFacets', t, i), -1;
                    }
                  },
                  ge = function () {
                    try {
                      return this.getRanges().map(function (t) {
                        var e = D(t);
                        return (e.facetType = 'range'), e;
                      });
                    } catch (t) {
                      return this.onError('getAllRangeFacets', t, i), -1;
                    }
                  },
                  ye = function () {
                    try {
                      return this.getBucketedFacets().map(function (t) {
                        var e = D(t);
                        return (e.facetType = 'category'), e;
                      });
                    } catch (t) {
                      return this.onError('getAllCategory', t, i), -1;
                    }
                  };
                function ve(t) {
                  try {
                    var e = this.getBreadCrumbs(t),
                      r = [],
                      a = e;
                    if (e)
                      for (
                        var n = function () {
                            if (a.level) {
                              var t = a,
                                e = t.level,
                                n = t.values,
                                o = t.filterField;
                              n.forEach(function (t) {
                                r.push({level: e, filterField: o, value: t.value || t.name});
                              });
                            }
                            if (!a.child) return 1;
                            a = a.child;
                          },
                          o = 0;
                        o < this.options.facetDepth && !n();
                        o++
                      );
                    return r;
                  } catch (t) {
                    return this.onError('getBreadCrumbsList.js', t, i), -1;
                  }
                }
                function me(t) {
                  try {
                    var e = this.getResponseObj(),
                      r = [];
                    if (e && e.facets && e.facets.multilevel && t) {
                      var a = e.facets.multilevel.list;
                      if (a)
                        a.forEach(function (e) {
                          var a = e.filterField,
                            n = e.breadcrumb;
                          a === t && (r = n);
                        });
                      else {
                        var n = e.facets.multilevel.breadcrumb;
                        r = n || null;
                      }
                    }
                    return r;
                  } catch (t) {
                    return this.onError('getBreadCrumbs.js', t, i), -1;
                  }
                }
                function be(t) {
                  try {
                    this.setSort(t), this.setPageStart(0), this.getResults.bind(this)();
                  } catch (t) {
                    this.onError('applySort.js', t, i);
                  }
                }
                function Se(t) {
                  try {
                    if (void 0 !== t) this.state.selectedSort = t;
                    else {
                      var e = this.getSearchQueryParams();
                      this.state.selectedSort = e.sort ? e.sort : '';
                    }
                  } catch (t) {
                    this.onError('setSort.js', t, i);
                  }
                }
                var Ee = function () {
                  return this.state.selectedSort;
                };
                function Pe() {
                  try {
                    var t = this.getResponseObj() || {};
                    return t && t.didYouMean ? t.didYouMean : [];
                  } catch (t) {
                    return this.onError('getDidYouMeanFromResponse.js', t, i), -1;
                  }
                }
                function Fe() {
                  try {
                    return (this.state.didYouMean || []).map(function (t) {
                      return t.suggestion;
                    });
                  } catch (t) {
                    return this.onError('getSpellCheckSuggested.js', t, i), -1;
                  }
                }
                function Ae(t) {
                  this.options.spellCheck.enabled = !!t;
                }
                function we() {
                  try {
                    var t = this.getResponseObj() || {};
                    return (t && t.banner && t.banner.banners && t.banner.banners) || [];
                  } catch (t) {
                    return this.onError('getbanners.js', t, i), -1;
                  }
                }
                var Re = function (t, e) {
                    (this.state.userInput = t), this.callBack(this, e, {value: t});
                  },
                  Ue = function () {
                    (this.state.selectedFacets = {}),
                      (this.state.rangeFacet = {}),
                      (this.state.categoryFilter = {}),
                      (this.state.breadcrumbs = {});
                  },
                  Ce = function () {
                    this.resetFacets(),
                      (this.state.didYouMean = null),
                      (this.state.startPageNo = 0),
                      (this.state.selectedSort = ''),
                      (this.state.responseObj = null),
                      (this.state.userInput = ''),
                      (this.state.pageSize = this.state.pageSize || this.options.pagesize.pageSize);
                  };
                function Ne(t) {
                  return (
                    (Ne =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    Ne(t)
                  );
                }
                const Oe = function t(e) {
                  if (!e) return e;
                  var r,
                    a = Array.isArray(e) ? [] : {};
                  return (
                    Object.keys(e).forEach(function (n) {
                      (r = e[n]), (a[n] = 'object' === Ne(r) ? t(r) : r);
                    }),
                    a
                  );
                };
                function Te(t) {
                  return (
                    (Te =
                      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                        ? function (t) {
                            return typeof t;
                          }
                        : function (t) {
                            return t &&
                              'function' == typeof Symbol &&
                              t.constructor === Symbol &&
                              t !== Symbol.prototype
                              ? 'symbol'
                              : typeof t;
                          }),
                    Te(t)
                  );
                }
                function Le(t) {
                  return (
                    (function (t) {
                      if (Array.isArray(t)) return je(t);
                    })(t) ||
                    (function (t) {
                      if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
                        return Array.from(t);
                    })(t) ||
                    Ie(t) ||
                    (function () {
                      throw new TypeError(
                        'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                      );
                    })()
                  );
                }
                function Ie(t, e) {
                  if (t) {
                    if ('string' == typeof t) return je(t, e);
                    var r = {}.toString.call(t).slice(8, -1);
                    return (
                      'Object' === r && t.constructor && (r = t.constructor.name),
                      'Map' === r || 'Set' === r
                        ? Array.from(t)
                        : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                          ? je(t, e)
                          : void 0
                    );
                  }
                }
                function je(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a;
                }
                function ke(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                    var a = Object.getOwnPropertySymbols(t);
                    e &&
                      (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                      })),
                      r.push.apply(r, a);
                  }
                  return r;
                }
                function _e(t) {
                  for (var e = 1; e < arguments.length; e++) {
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2
                      ? ke(Object(r), !0).forEach(function (e) {
                          Ve(t, e, r[e]);
                        })
                      : Object.getOwnPropertyDescriptors
                        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
                        : ke(Object(r)).forEach(function (e) {
                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                          });
                  }
                  return t;
                }
                function Ve(t, e, r) {
                  return (
                    (e = Me(e)) in t
                      ? Object.defineProperty(t, e, {value: r, enumerable: !0, configurable: !0, writable: !0})
                      : (t[e] = r),
                    t
                  );
                }
                function xe(t, e) {
                  for (var r = 0; r < e.length; r++) {
                    var a = e[r];
                    (a.enumerable = a.enumerable || !1),
                      (a.configurable = !0),
                      'value' in a && (a.writable = !0),
                      Object.defineProperty(t, Me(a.key), a);
                  }
                }
                function Me(t) {
                  var e = (function (t) {
                    if ('object' != Te(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                      var r = e.call(t, 'string');
                      if ('object' != Te(r)) return r;
                      throw new TypeError('@@toPrimitive must return a primitive value.');
                    }
                    return String(t);
                  })(t);
                  return 'symbol' == Te(e) ? e : e + '';
                }
                var Xe = (function () {
                  return (
                    (t = function t(e) {
                      !(function (t, e) {
                        if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
                      })(this, t),
                        (this.options = _e(_e({}, r), e)),
                        (this.state = {
                          queryRef: {},
                          userInput: '',
                          responseObj: null,
                          selectedFacets: {},
                          currentWebUrl: '',
                          currentApiUrl: '',
                          didYouMean: null,
                          startPageNo: this.options.startPageNo || 0,
                          isLoading: !1,
                          selectedSort: '',
                          isUrlUpdated: !1,
                          rangeSliderList: [],
                          rangeFacet: {},
                          categoryFilter: {},
                          breadcrumbs: {},
                          urlState: '',
                          noResultQuery: '',
                          pageSize:
                            this.options.pagesize && this.options.pagesize.pageSize
                              ? this.options.pagesize.pageSize
                              : 12,
                          urlLoad: !1,
                          isHistory: window.history,
                          isBack: !1,
                          products: [],
                          requestId: null,
                          unbxdKeys: [
                            'filter',
                            'category-filter',
                            'rows',
                            'start',
                            'page',
                            'count',
                            'sort',
                            'viewType',
                            this.getBrowseQueryParam(),
                            this.getSearchQueryParam(),
                            this.getSortParam(),
                            this.getPageViewParam(),
                            this.getPageSizeParam(),
                            this.getPageNoParam(),
                            'uc_param',
                          ],
                        });
                      var a = this.options,
                        n = a.getCategoryId,
                        o = a.setCategoryId,
                        i = '/search?';
                      'CATEGORY' === this.getProductType() && (i = '/category?'),
                        (this.getCategoryId = n),
                        (this.setCategoryId = o),
                        (this.apiUrl = this.getBaseUrl() + i),
                        (this.webUrl = this.getBaseUrl() + i);
                    }),
                    (e = [
                      {
                        key: 'getResponseObj',
                        value: function () {
                          try {
                            var t = this.state.responseObj;
                            return t ? Oe(t) : null;
                          } catch (t) {
                            this.onError('getResponseObj', t, i);
                          }
                        },
                      },
                      {
                        key: 'orderQueryParams',
                        value: function () {
                          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                          try {
                            var e = (this.options || {}).url,
                              r = (void 0 === e ? {} : e).orderOfQueryParams,
                              a = void 0 === r ? [] : r,
                              n = Object.values(t),
                              o = a.filter(function (t) {
                                return n.includes(t);
                              }),
                              s = n.filter(function (t) {
                                return !o.includes(t);
                              });
                            return [].concat(Le(o), Le(s));
                          } catch (t) {
                            return this.onError('orderQueryParams', t, i), -1;
                          }
                        },
                      },
                      {
                        key: 'getUrlParamString',
                        value: function () {
                          var t = this,
                            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
                            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                          try {
                            var a = Object.keys(r),
                              n = '',
                              o = (this.options || {}).url,
                              s = void 0 === o ? {} : o,
                              c = s.facetsParam,
                              l = void 0 === c ? {} : c,
                              u = s.seoFriendlyUrl,
                              p = s.orderOfQueryParams,
                              h = void 0 === p ? [] : p,
                              f = this.getQueryParamSeparator(),
                              g = this.getSearchQueryParam(),
                              y = this.getBrowseQueryParam(),
                              v = this.getKeyValueSeparator();
                            return (
                              u && h.length && (a = Array.from(new Set([this.orderQueryParams(a), a].flat(1)))),
                              a.forEach(function (e, o) {
                                var i = r[e],
                                  s = '';
                                i.forEach(function (r, a) {
                                  'KEY_VALUE_REPLACER' === l.algo && t.isFilterStr(e)
                                    ? (n = ''.concat(n).concat(e).concat(v).concat(r))
                                    : 'HASH' === l.algo && t.isFilterStr(e)
                                      ? (0 === a ? (s = r) : (s += '&'.concat(r)),
                                        (n = ''
                                          .concat(n)
                                          .concat(e, '=')
                                          .concat(window.btoa(d.encodeEachFacetValue(decodeURIComponent(s))))))
                                      : (n = ''
                                          .concat(n)
                                          .concat(encodeURIComponent(e))
                                          .concat(v)
                                          .concat(e === g || e === y ? r : encodeURIComponent(r))),
                                    a !== i.length - 1 && (n = ''.concat(n).concat(f));
                                }),
                                  o !== a.length - 1 && (n = ''.concat(n).concat(f));
                              }),
                              n.length > 0 && (n = e + n),
                              n
                            );
                          } catch (t) {
                            return this.onError('getUrlParamString', t, i), -1;
                          }
                        },
                      },
                      {
                        key: 'getUrlStr',
                        value: function (t) {
                          var e = this;
                          try {
                            var r = (this.options || {}).url,
                              a = (void 0 === r ? {} : r).queryParamSeparator,
                              n = this.getQueryParamSeparator(),
                              o = this.getKeyValueSeparator(),
                              s = this.getSearchQueryParam(),
                              c = this.getBrowseQueryParam(),
                              l = {},
                              u = t.split(''.concat(n).concat(s).concat(o))[1] || t.split('?'.concat(s).concat(o))[1];
                            void 0 !== u && (l[s] = [u.split(a ? n : /\&\w+\-?\w+?=/gi)[0]]);
                            var d = t.split(''.concat(n).concat(c).concat(o))[1] || t.split('?'.concat(c).concat(o))[1];
                            void 0 !== d && (l[c] = [d.split(a ? n : /\&\w+\-?\w+?=/gi)[0]]);
                            var p = this.readSortWebUrl(t),
                              h = this.readFacetsWebUrl(t),
                              f = this.readPageSizeWebUrl(t),
                              g = this.readPageViewWebUrl(t),
                              y = this.readPageNoWebUrl(t);
                            if (
                              ((l = _e(_e(_e(_e(_e(_e({}, l), p), h), f), g), y)), this.getAllowExternalUrlParams())
                            ) {
                              var v = this.readQueryParamsFromUrl(
                                this.getHashMode() ? window.location.hash.slice(1) : window.location.search
                              );
                              Object.keys(v).forEach(function (t) {
                                var r = v[t];
                                (e.state.unbxdKeys.indexOf(t) < 0 || 'uc_param' === t) &&
                                  !e.isFilterStr(t) &&
                                  v[t].length &&
                                  '' !== r &&
                                  (l[t] = v[t]);
                              });
                            }
                            return this.getUrlParamString(this.getHashMode() ? '#' : '?', l);
                          } catch (t) {
                            return this.onError('getUrlStr', t, i), -1;
                          }
                        },
                      },
                      {
                        key: 'urlSearchParamsToStr',
                        value: function () {
                          var t = this,
                            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                          try {
                            var r = {},
                              a = (this.options || {}).url,
                              n = (void 0 === a ? {} : a).facetsParam,
                              o = void 0 === n ? {} : n,
                              s = this.getSearchQueryParam();
                            return (
                              Object.entries(e).forEach(function (a) {
                                var n = (function (t, e) {
                                    return (
                                      (function (t) {
                                        if (Array.isArray(t)) return t;
                                      })(t) ||
                                      (function (t, e) {
                                        var r =
                                          null == t
                                            ? null
                                            : ('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator'];
                                        if (null != r) {
                                          var a,
                                            n,
                                            o,
                                            i,
                                            s = [],
                                            c = !0,
                                            l = !1;
                                          try {
                                            if (((o = (r = r.call(t)).next), 0 === e)) {
                                              if (Object(r) !== r) return;
                                              c = !1;
                                            } else
                                              for (
                                                ;
                                                !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e);
                                                c = !0
                                              );
                                          } catch (t) {
                                            (l = !0), (n = t);
                                          } finally {
                                            try {
                                              if (!c && null != r.return && ((i = r.return()), Object(i) !== i)) return;
                                            } finally {
                                              if (l) throw n;
                                            }
                                          }
                                          return s;
                                        }
                                      })(t, e) ||
                                      Ie(t, e) ||
                                      (function () {
                                        throw new TypeError(
                                          'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
                                        );
                                      })()
                                    );
                                  })(a, 2),
                                  i = n[0],
                                  c = n[1];
                                i !== s &&
                                  e[i].length &&
                                  '' !== c &&
                                  ('HASH' === o.algo && t.isFilterStr(decodeURIComponent(i))
                                    ? (r[i] = [window.atob(e[i])])
                                    : (r[i] = e[i])),
                                  i === s && (r[s] = d.encodeQueryParam(e[i]));
                              }),
                              this.getUrlParamString(this.getHashMode() ? '#' : '?', r)
                            );
                          } catch (t) {
                            return this.onError('urlSearchParamsToStr', t, i), -1;
                          }
                        },
                      },
                      {
                        key: 'checkIfUnbxdKey',
                        value: function () {
                          var t = this;
                          try {
                            var e = new URLSearchParams(
                                this.getHashMode() ? window.location.hash.substring(1) : window.location.search
                              ),
                              r = !1;
                            return (
                              Object.keys(e).forEach(function (e) {
                                t.state.unbxdKeys.indexOf(e) > -1 && (r = !0);
                              }),
                              r
                            );
                          } catch (t) {
                            this.onError('checkIfUnbxdKey', t, i);
                          }
                        },
                      },
                      {
                        key: 'convertToHashString',
                        value: function (t) {
                          try {
                            var e = this.getUrlStr(t);
                            return '?' === e.charAt(0) && (e = e.substring(1)), e;
                          } catch (t) {
                            this.onError('convertToHashString', t, i);
                          }
                        },
                      },
                      {
                        key: 'setUrl',
                        value: function (t) {
                          try {
                            var e = this.options,
                              r = e.searchPath,
                              a = e.onQueryRedirect,
                              n = this.getProductType(),
                              o = this.state,
                              s = o.urlLoad,
                              c = o.isHistory,
                              l = o.responseObj,
                              u = void 0 === l ? {} : l,
                              d = u.redirect,
                              p = u.didYouMean,
                              h = void 0 === p ? [] : p;
                            if ('function' == typeof a && d && d.value) {
                              this.state.userInput = '';
                              var f = this.getUrlStr('redirected=true');
                              return (
                                this.getHashMode() && (f = '#'.concat(this.convertToHashString(f))), void a(this, d, f)
                              );
                            }
                            var g = this.getNewUrlState(!1).split(''.concat(n.toLocaleLowerCase(), '?'))[1];
                            this.state.urlState = g;
                            var y = window.location.pathname.includes(r);
                            if (
                              (h.length && h[0].suggestion
                                ? (this.state.queryRef = {replaceNext: !0})
                                : this.state.queryRef.replaceNext && (this.state.queryRef = {}),
                              this.getHashMode())
                            ) {
                              var v = '#'.concat(g);
                              if (y && v !== window.location.hash) {
                                var m = this.convertToHashString(g);
                                this.setRoutingStrategies(m);
                              }
                            } else {
                              var b = '?'.concat(g),
                                S = this.getUrlStr(b);
                              c &&
                                !s &&
                                y &&
                                (decodeURI(S) !== decodeURI(window.location.search) &&
                                  this.setRoutingStrategies(''.concat(S)),
                                (this.state.urlLoad = !1)),
                                t && y && (window.location.search = S);
                            }
                          } catch (t) {
                            return this.onError('setUrl', t, i), -1;
                          }
                        },
                      },
                      {
                        key: 'updateSelectedFacetsCount',
                        value: function () {
                          var t = this;
                          try {
                            var e = '',
                              r = this.options.url,
                              a = (void 0 === r ? {} : r).facetsParam,
                              n = void 0 === a ? {} : a,
                              o = this.getSearchQueryParam(),
                              s = this.getBrowseQueryParam(),
                              c = this.getKeyValueSeparator();
                            e =
                              ('KEY_VALUE_REPLACER' !== n.algo && 'HASH' !== n.algo) || n.showFilterStr
                                ? this.getQueryParams()
                                : this.getCustomQueryParams();
                            var l = this.getProductType(),
                              u = o;
                            if (('SEARCH' !== l && (e[(u = s)] = this.getCategoryId()), 'object' === Te(e) && e[u])) {
                              var d = e['KEY_VALUE_REPLACER' === n.algo ? n.filterReplacer : 'filter'];
                              if ('KEY_VALUE_REPLACER' === n.algo && !n.showFilterStr) {
                                var p = [];
                                Object.keys(e).forEach(function (r) {
                                  t.isFilterStr(decodeURIComponent(r)) && (p.length, p.push(r + c + e[r]));
                                }),
                                  (d = p);
                              }
                              var h = this.getFilterFromParams(d);
                              this.state.selectedFacets = n.addToUrl ? h.selectedFilters : this.state.selectedFacets;
                            }
                          } catch (t) {
                            this.onError('updateSelectedFacetsCount', t, i);
                          }
                        },
                      },
                      {
                        key: 'callBack',
                        value: function (t, e) {
                          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                          try {
                            (0, this.options.onEvent)(this, e, r);
                          } catch (t) {
                            this.onError('callback', t, i);
                          }
                        },
                      },
                      {
                        key: 'onError',
                        value: function () {
                          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
                            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : '',
                            a = this.options,
                            n = a.debugMode;
                          (0, a.onEvent)(this, r, {error: e}),
                            n && console.error('Something went wrong in '.concat(t, ': ').concat(e));
                        },
                      },
                    ]),
                    e && xe(t.prototype, e),
                    Object.defineProperty(t, 'prototype', {writable: !1}),
                    t
                  );
                  var t, e;
                })();
                !(function (t) {
                  var e = t.prototype;
                  (e.changeInput = Re),
                    (e.resetFacets = Ue),
                    (e.resetAll = Ce),
                    (function (t) {
                      t = Object.assign(t, U);
                    })(e),
                    (function (t) {
                      Object.assign(t, {setPageStart: C, getPaginationInfo: N, setPageSize: O});
                    })(e),
                    (function (t) {
                      t = Object.assign(t, {
                        setProductAttributes: T,
                        setShowVariants: L,
                        setVariantsCount: I,
                        setVariantAttributes: j,
                        setVariantsGroupBy: k,
                        getSearchResults: V,
                        getSearchMeta: _,
                        getSearchQueryParams: x,
                        getSearchQuery: M,
                        getResults: q,
                        processVariantMap: G,
                        getProductByPropValue: $,
                        setStateFromData: Z,
                        setSearchConfigurations: J,
                        onLocationChange: tt,
                        getRequestId: et,
                      });
                    })(e),
                    (function (t) {
                      Object.assign(t, {getSwatches: rt});
                    })(e),
                    (function (t) {
                      t = Object.assign(t, {
                        getBucketedFacets: at,
                        getSelectedBucketedFacet: de,
                        getFilterFromParams: nt,
                        getCategoryFilterFromParams: ot,
                        getRangeFacets: it,
                        getFacets: st,
                        getSelectedFacets: ct,
                        getSelectedFacet: lt,
                        updateFacets: ut,
                        applyFacets: dt,
                        clearFacets: pt,
                        addFacets: gt,
                        findSelectedFacet: yt,
                        deleteCategoryFilter: vt,
                        deleteFacet: mt,
                        getFacetByValue: Ft,
                        getSelectedFacetValue: At,
                        setCategoryFilter: wt,
                        setDefaultCategoryFilter: Rt,
                        setRangeFacet: Ut,
                        clearARangeFacet: Ct,
                        deleteAFacet: Nt,
                        applyRangeFacet: pe,
                        isFacetAlreadyAdded: Ot,
                        getSelectedRanges: Tt,
                        getRanges: _t,
                        sortFacets: he,
                        isCategoryFacet: Vt,
                        getAllFacets: Xt,
                        getAFacetByName: Dt,
                        getSelectedMultilevelFacet: Bt,
                        getAllTextFacets: fe,
                        getAllRangeFacets: ge,
                        getAllCategory: ye,
                        getAllSelectedFacets: Kt,
                        getSelectedFacetsCount: qt,
                        getSelectedFacetValueCount: Yt,
                        encodeFacetValue: oe,
                        modifyFacetsList: ae,
                        modifyValues: re,
                        decodeFacetValue: se,
                        cleanFacetValue: ce,
                        getCategoryFacetByValue: Gt,
                        encodeCategoryFacetValue: ie,
                        cleanEncodedFacetValue: le,
                        getKeyByValue: ue,
                      });
                    })(e),
                    (function (t) {
                      t = Object.assign(t, {getBreadCrumbsList: ve, getBreadCrumbs: me});
                    })(e),
                    (function (t) {
                      t = Object.assign(t, {applySort: be, getSelectedSort: Ee, setSort: Se});
                    })(e),
                    (function (t) {
                      t = Object.assign(t, {
                        getDidYouMeanFromResponse: Pe,
                        getSpellCheckSuggested: Fe,
                        setSpellCheck: Ae,
                      });
                    })(e),
                    (function (t) {
                      t = Object.assign(t, {getBanners: we});
                    })(e);
                })(Xe);
                const De = Xe;
                return e.default;
              })()),
            (t.exports = e());
        },
        330(t) {
          'use strict';
          t.exports = JSON.parse(
            '{"name":"@unbxd-ui/vanilla-search-library","version":"2.1.14","description":"A JavaScript library for building performant and quick search experiences with Unbxd","main":"public/dist/js/vanillaSearch.js","repository":{"type":"git","url":"git+https://github.com/unbxd/search-JS-library.git"},"bugs":{"url":"https://github.com/unbxd/search-JS-library/issues"},"homepage":"https://github.com/unbxd/search-JS-library#readme","scripts":{"start":"webpack-dev-server --open --config ./webpack/webpack.config.js","build":"webpack --config ./webpack/webpack.prod.config.js","server":"http-server ./public","generate-docs":"jsdoc -c ./docs/jsDoc.json ","upload-s3":"node s3Upload.js","build:dev":"webpack --config ./webpack/webpack.dev.build.js","test":"webpack --config ./webpack/webpack.dev.build.js","prepare":"husky install","pre-commit":"lint-staged"},"devDependencies":{"@babel/core":"^7.26.9","@babel/node":"^7.10.5","@babel/plugin-proposal-class-properties":"^7.10.4","@babel/plugin-proposal-export-default-from":"^7.10.4","@babel/plugin-syntax-dynamic-import":"^7.8.3","@babel/plugin-transform-arrow-functions":"^7.10.4","@babel/preset-env":"^7.26.9","@babel/preset-react":"^7.26.3","autoprefixer":"^9.8.6","babel-loader":"^8.4.1","compression-webpack-plugin":"^11.1.0","css-loader":"^3.6.0","css-minimizer-webpack-plugin":"^7.0.0","eslint":"^8.54.0","file-loader":"^6.2.0","html-loader":"^5.1.0","html-webpack-inline-source-plugin":"0.0.10","html-webpack-plugin":"^5.6.3","http-server":"^14.1.1","husky":"^8.0.0","jsdoc":"^4.0.4","lint-staged":"^14.0.1","minami":"^1.2.3","mini-css-extract-plugin":"^2.9.2","node-forge":">=0.10.0","path":"^0.12.7","postcss-loader":"^3.0.0","prettier":"1.19.1","sass":"^1.85.1","sass-loader":"^8.0.2","style-loader":"^1.3.0","terser-webpack-plugin":"^4.2.3","url-loader":"^4.1.1","webpack":"^5.98.0","webpack-bundle-analyzer":"^4.10.2","webpack-cli":"^5.1.4","webpack-dev-server":"^4.15.2","webpack-s3-plugin":"^0.1.0"},"keywords":["unbxd","search library","ecommerce search"],"author":"Unbxd","license":"ISC","dependencies":{"@unbxd-ui/unbxd-search-core":"0.5.13","babel-runtime":"^6.26.0","dompurify":"^3.2.4","element-dataset":"^2.2.6"},"lint-staged":{"src/**/*.+(js|json|ts|tsx)":["eslint --no-verify"],"src/**/*.{js,jsx,ts,tsx,json,css,scss,md}":["prettier --write"]}}'
          );
        },
      },
      e = {};
    function r(a) {
      var n = e[a];
      if (void 0 !== n) return n.exports;
      var o = (e[a] = {exports: {}});
      return t[a].call(o.exports, o, o.exports, r), o.exports;
    }
    (r.n = (t) => {
      var e = t && t.__esModule ? () => t.default : () => t;
      return r.d(e, {a: e}), e;
    }),
      (r.d = (t, e) => {
        for (var a in e) r.o(e, a) && !r.o(t, a) && Object.defineProperty(t, a, {enumerable: !0, get: e[a]});
      }),
      (r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e));
    var a = {};
    return (
      (() => {
        'use strict';
        r.d(a, {default: () => Pe});
        var t = r(759),
          e = r.n(t);
        const n = {
          beforeApiCall: 'BEFORE_API_CALL',
          afterApiCall: 'AFTER_API_CALL',
          beforeRender: 'BEFORE_RENDER',
          beforeNoResultRender: 'BEFORE_NO_RESULTS_RENDER',
          afterNoResultRender: 'AFTER_NO_RESULTS_RENDER',
          afterRender: 'AFTER_RENDER',
          deleteFacet: 'DELETE_FACET',
          facetClick: 'FACETS_CLICK',
          deleteFacetValue: 'DELETE_FACET_VALUE',
          clearSort: 'CLEAR_SORT',
          changeSort: 'CHANGE_SORT',
          pageNext: 'PAGE_NEXT',
          pagePrev: 'PAGE_PREV',
          changeInput: 'CHANGE_INPUT',
          setCategoryFilter: 'SET_CATEGORY_FILTER',
          deleteCategoryFilter: 'DELETE_CATEGORY_FILTER',
          pageSizeChange: 'PAGESIZE_CHANGE',
          configError: 'CONFIG_ERROR',
          runtimeError: 'RUNTIME_ERROR',
          fetchError: 'FETCH_ERROR',
        };
        const o = {
          clearCategoryFilter: 'clearCategoryFilter',
          setCategoryFilter: 'setCategoryFilter',
          changeSwatch: 'changeSwatch',
          clearPriceRange: 'clearPriceRange',
          applyRange: 'applyRange',
          prev: 'prev',
          next: 'next',
          firstPage: 'firstPage',
          lastPage: 'lastPage',
          clearSort: 'clearSort',
          changeSort: 'changeSort',
          deleteFacet: 'deleteFacet',
          deleteFacetValue: 'deleteFacetValue',
          changeFacet: 'changeFacet',
        };
        var i = {
            openFacet: 'UNX-accordian-open',
            closeFacet: 'UNX-accordian-close',
            openBtn: 'UNX-facet-open',
            closeBtn: 'UNX-facet-close',
            viewMore: 'UNX-view-more',
            viewLess: 'UNX-view-less',
          },
          s = {
            UNX_gridBtn: 'UNX_gridBtn',
            UNX_listBtn: 'UNX_listBtn',
            UNX_loadMore: 'UNX_loadMore',
            UNX_variant: 'UNX_variant',
            UNX_spellCheck: 'UNX_spellCheck',
            UNX_pagesize: 'UNX_pagesize',
            UNX_pageNumber: 'UNX_pageNumber',
            UNX_unbxdSorter: 'UNX_unbxdSorter',
            UNX_uFilter: 'UNX_uFilter',
            UNX_rangeslider: 'UNX_rangeslider',
            UNX_facetLevel: 'UNX_facetLevel',
            UNX_searchFacets: 'UNX_searchFacets',
            UNX_swatchClrBtn: 'UNX_swatchClrBtn',
          };
        const c = function (t, e, r, a) {
          try {
            t.addEventListener(e, function (t) {
              for (var e = t.target; e && e !== this; ) e.matches(r) && a.call(e, t), (e = e.parentNode);
            });
          } catch (t) {
            this.onError('delegate.js', t, n.runtimeError);
          }
        };
        function l(t, e) {
          var r = t.facetName,
            a = t.facetType,
            n = e.name,
            o = e.count,
            i = e.dataId,
            s = this.options.facet,
            c = s.facetClass,
            l = s.selectedFacetClass,
            u = s.removeFacetsSelectorClass,
            d = this.testIds.UNX_uFilter,
            p = 'deleteSelectedFacetValue';
          'range' === a && (p = 'deleteSelectedRange');
          var h = ' '.concat(c, ' ').concat(l, ' ');
          return [
            '<div class="UNX-selected-facets-wrap">',
            '<button data-test-id="'
              .concat(d, '" class="UNX-selected-facet-btn UNX-change-facet ')
              .concat(h, '" data-facet-name="')
              .concat(r, '" data-facet-action="')
              .concat(p, '" data-id="')
              .concat(i, '">'),
            '<span class="UNX-facet-text">'.concat(n, '</span> <span class="UNX-facet-count">(').concat(o, ')</span>'),
            '</button>',
            '<button class="UNX-delete-facet '
              .concat(u, ' ')
              .concat(h, '" data-id="')
              .concat(i, '" data-facet-action="')
              .concat(p, '" data-facet-name="')
              .concat(r, '">x</button></div>'),
          ].join('');
        }
        function u(t, e, r) {
          var a = e.clearAllText,
            n = e.clearFacetsSelectorClass,
            o = this.selectedFacetClass ? this.selectedFacetClass : r.selectedFacetClass;
          return t.length > 0
            ? [
                '<div class="UNX-facets-selections">',
                '<h5 class="UNX-selected-facet-header">Selected Filters</h5>',
                '<div class="UNX-selected-facets-inner">'.concat(t, '</div>'),
                '<button class="'
                  .concat(n, ' ')
                  .concat(o, '" data-facet-action="clearAllFacets">')
                  .concat(a, '</button>'),
                '</div>',
              ].join('')
            : '';
        }
        const d = function (t, e) {
          if (!t) return '';
          var r = t || {},
            a = r.currentPage,
            n = r.isNext,
            o = r.isPrev,
            i = r.noOfPages,
            s = r.productsLn,
            c = r.numberOfProducts,
            l = r.rows,
            u = e || {},
            d = u.pageClass,
            p = u.selectedPageClass,
            h = u.pageLimit,
            f = this.testIds.UNX_pageNumber,
            g = void 0 === f ? '' : f;
          if (c <= s) return '';
          var y = '<button class="UNX-next-btn UNX-page-next '
              .concat(d, '" data-page-no="')
              .concat(a * l, '" data-page-action="next">></button>'),
            v = '<button class="UNX-prev-btn UNX-page-prev '
              .concat(d, '" data-page-no="')
              .concat((a - 2) * l, '" data-page-action="prev"><</button>'),
            m = '<button class="UNX-prev-btn UNX-page-next '.concat(d, '"  data-page-action="firstPage"><<</button>'),
            b = '<button class="UNX-prev-btn UNX-page-prev '.concat(d, '"  data-page-action="lastPage">>></button>'),
            S = '',
            E = i < h ? i : h,
            P = 1,
            F = Math.ceil(h / 2),
            A = a - F;
          A > 0 && ((P = A), (E = a + F));
          var w = a + F;
          w >= i && ((P -= w - i) <= 0 && (P = 1), (E = i));
          for (var R = P; R <= E; R++) {
            var U = ''.concat(g).concat(R),
              C = R === a ? p : '';
            S += '<button data-test-id="'
              .concat(U, '" data-page-action="paginate" data-page-no="')
              .concat((R - 1) * l, '" class="UNX-page-button ')
              .concat(d, ' ')
              .concat(C, '">')
              .concat(R, '</button>');
          }
          return (
            n ||
              ((y = '<button disabled class="UNX-next-btn UNX-page-next">></button>'),
              (b = '<button disabled class="UNX-next-btn UNX-page-next">>></button>')),
            o ||
              ((v = '<button disabled class="UNX-prev-btn UNX-page-prev"><</button>'),
              (m = '<button disabled class="UNX-prev-btn UNX-page-next"><<</button>')),
            [
              '<div class="UNX-pagination-block">',
              m,
              v,
              '<div class="UNX-page-no-block">'.concat(S, '</div>'),
              y,
              b,
              '</div>',
            ].join('')
          );
        };
        function p(t) {
          var e = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).pageClass,
            r = void 0 === e ? '' : e;
          return '<div class="UNX-click-scroll"><button data-test-id="'
            .concat(this.testIds.UNX_loadMore, '" data-page-action="next" class="UNX-click-n-scroll ')
            .concat(r, '">Load More</button></div>');
        }
        const h = function (t, e, r, a) {
          var n = '',
            o = a.multiLevelFacetSelectorClass,
            i = a.facetClass,
            s = this.testIds.UNX_facetLevel;
          e &&
            e.forEach(function (t) {
              var e = t.level,
                r = t.filterField,
                a = t.value,
                c = 'data-test-id="'.concat(s).concat(e, '"'),
                l = ''.concat(o, '  UNX-category-level-').concat(e);
              n += [
                '<button '
                  .concat(c, ' data-parent="')
                  .concat(r, '" data-level="')
                  .concat(e, '" data-name="')
                  .concat(a, '"'),
                'class=" '.concat(l, ' UNX-selected-crumb ').concat(i, '" data-action = "clearCategoryFilter">'),
                '<span class="UNX-category-icon"></span><label class="UNX-facet-text">'.concat(
                  decodeURIComponent(a),
                  '</label>'
                ),
                '</button>',
              ].join('');
            });
          var c = t.level,
            l = t.values,
            u = t.filterField,
            d = t.multiLevelField;
          d || (d = u);
          var p = 'data-test-id="'.concat(s).concat(c, '"'),
            h = 'UNX-category-level-'.concat(c),
            f = l.map(function (t) {
              var e = t.name,
                a = t.count,
                n = t.dataId;
              return (
                r && r.length > 0 && e.toUpperCase().indexOf(r.toUpperCase()) < 0 && (i += ' UNX-search-hidden'),
                [
                  '<button '.concat(p, ' data-parent="').concat(d, '" data-level="').concat(c, '"'),
                  'class="'
                    .concat(o, ' ')
                    .concat(h, ' ')
                    .concat(i, '" data-name="')
                    .concat(n, '" data-action = "setCategoryFilter">'),
                  '<label class="UNX-facet-text">'
                    .concat(e, '</label><label class="UNX-facet-count">(')
                    .concat(a, ')</label></button>'),
                ].join('')
              );
            });
          return '' !== (n += '<div class="UNX-category-values">'.concat(f.join(''), '</div>'))
            ? ['<div class="UNX-multi-facet-wrap">', ''.concat(n, '</div>')].join('')
            : '';
        };
        const f = function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            e = '',
            r = ((arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}) || {}).selectorClass,
            a = void 0 === r ? '' : r;
          return (
            t &&
              t.forEach(function (t, r) {
                var n = t.level,
                  o = t.filterField,
                  i = t.value,
                  s = ''.concat(a, ' UNX-bread-crumb-item');
                r > 0 && (e += '<span class="UNX-slash"> / </span>'),
                  (e += [
                    '<button data-parent="'
                      .concat(o, '" data-level="')
                      .concat(n, '" class="')
                      .concat(s, '" data-name="')
                      .concat(i, '" data-action = "clearCategoryFilter">'),
                    ''.concat(decodeURIComponent(i), '</button>'),
                  ].join(''));
              }),
            '<div class="bread-crumb-main">'.concat(e, '</div>')
          );
        };
        const g = function (t) {
          var e = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}) || {},
            r = e.options,
            a = void 0 === r ? [] : r,
            n = e.pageSizeClass,
            o = void 0 === n ? '' : n,
            i = e.selectedPageSizeClass,
            s = void 0 === i ? '' : i,
            c = this.testIds.UNX_pagesize,
            l = void 0 === c ? '' : c,
            u =
              '<label class="UNX-hidden" for="unxPageSize">Sort By</label><select id="unxPageSize" name="unxPageSize" class="UNX-select-pagesize '.concat(
                o,
                '">'
              );
          return (
            a &&
              a.forEach(function (e, r) {
                var a = 'data-test-id="'.concat(l).concat(r + 1, '"');
                u +=
                  t == e
                    ? '<option selected '
                        .concat(a, ' class="')
                        .concat(s, '" id="')
                        .concat(e, '">')
                        .concat(e, '</option>')
                    : '<option '.concat(a, ' id="').concat(e, '">').concat(e, '</option>');
              }),
            '<div class="UNX-pagesize-block">'.concat((u += '</select>'), '</div>')
          );
        };
        const y = {
          productId: 'uniqueId',
          searchBoxEl: null,
          searchButtonEl: null,
          siteKey: 'demo-spanish-unbxd809051588861207',
          apiKey: 'f19768e22b49909798bc2411fa3dd963',
          searchPath: '',
          searchTrigger: 'click',
          searchEndPoint: 'https://search.unbxd.io/',
          products: {
            el: null,
            template: function (t, e, r, a, n) {
              var o = t.unxTitle,
                i = t.unxImageUrl,
                s = t.uniqueId,
                c = t.unxStrikePrice,
                l = t.unxPrice,
                u = t.unxDescription,
                d = n.productItemClass,
                p = n.defaultImage,
                h = Array.isArray(i) ? i[0] : i;
              h || (h = p);
              var f = '<div class="UNX-img-wrapper"><img class="UNX-img-block" width="100%" height="100%" alt="'
                  .concat(o, '" src="')
                  .concat(h, '"/></div>'),
                g = '<span class="UNX-sale-price">'.concat(l, '</span>'),
                y = '';
              c && (y = '<span class="UNX-strike-price">'.concat(c, '<span>'));
              var v = '',
                m = '';
              'GRID' === a
                ? (v = 'UNX-grid-card')
                : ((v = 'UNX-list-card'), (m = '<p class="UNX-description">'.concat(u, '</p>')));
              var b = '',
                S = r || {},
                E = S.btnList,
                P = S.imgList;
              return (
                E && (b = '<div class="UNX-swatch-wrapper">'.concat(E, '</div>')),
                P && (f = P),
                [
                  '<div id="'
                    .concat(s, '" data-id="')
                    .concat(s, '" data-prank="')
                    .concat(e, '" data-item="product" class="UNX-product-col ')
                    .concat(v, ' ')
                    .concat(d, '">'),
                  '<h3 class="UNX-product-number">'.concat(Math.floor(e), '</h3>'),
                  '<div class="UNX-images-block">'.concat(f, '</div>'),
                  '<div class="UNX-product-content">',
                  '<h3 class="UNX-product-title">'.concat(o, '</h3>'),
                  b,
                  m,
                  '<div class="UNX-price-row">'.concat(g, ' ').concat(y, '</div>'),
                  '</div>',
                  '</div>',
                ].join('')
              );
            },
            productItemClass: 'product-item',
            productType: 'SEARCH',
            gridCount: 1,
            searchTrigger: 'click',
            onProductClick: function (t, e) {},
            productAttributes: [
              'title',
              'uniqueId',
              'price',
              'sku',
              'imageUrl',
              'displayPrice',
              'salePrice',
              'sortPrice',
              'productDescription',
              'unbxd_color_mapping',
              'colorName',
              'color',
              'productUrl',
            ],
            attributesMap: {
              unxTitle: 'title',
              unxImageUrl: 'imageUrl',
              unxPrice: 'salePrice',
              unxStrikePrice: 'displayPrice',
              unxId: 'uniqueId',
              unxDescription: 'productDescription',
            },
            defaultImage: 'https://libraries.unbxdapi.com/sdk-assets/defaultImage.svg',
            tagName: 'DIV',
            htmlAttributes: {class: 'UNX-search-results-block UNX-result-wrapper'},
            events: {},
          },
          defaultFilters: {},
          noResults: {
            template: function (t) {
              return '<div class="UNX-no-results"> No Results found '.concat(t, ' </div>');
            },
          },
          onEvent: function (t, e) {},
          startPageNo: 0,
          productView: {
            enabled: !0,
            el: null,
            template: function (t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              try {
                var r = !this.getSearchResults(),
                  a = e.selectedViewTypeClass,
                  o = void 0 === a ? '' : a,
                  i = e.viewTypeClass,
                  s = void 0 === i ? '' : i,
                  c = this.testIds,
                  l = c.UNX_gridBtn,
                  u = void 0 === l ? '' : l,
                  d = c.UNX_listBtn,
                  p = void 0 === d ? '' : d,
                  h = 'UNX-list-btn '.concat(s),
                  f = 'UNX-grid-btn '.concat(s),
                  g = 'data-test-id='.concat(u),
                  y = 'data-test-id='.concat(p);
                'LIST' === t && (h += ' '.concat(o)), 'GRID' === t && (f += ' '.concat(o));
                var v = '<button id="listBtn" class="'
                    .concat(h, '" ')
                    .concat(y, ' data-view-action="LIST" >List</button>'),
                  m = '<button '
                    .concat(g, ' id="gridBtn" class="')
                    .concat(f, '" data-view-action="GRID" >Grid</button>');
                return (
                  r &&
                    ((v = '<button '
                      .concat(y, ' id="listBtn" disabled class="')
                      .concat(h, ' disabled-btn" data-view-action="LIST" >List</button>')),
                    (m = '<button '
                      .concat(g, ' id="gridBtn" disabled class="')
                      .concat(f, '  disabled-btn"data-view-action="GRID" >Grid</button>'))),
                  ''.concat(v, ' ').concat(m)
                );
              } catch (t) {
                this.onError('productViewtype > renderProductViewType', t, n.runtimeError);
              }
            },
            action: 'click',
            viewTypeClass: 'UNX-product-view',
            selectedViewTypeClass: 'UNX-selected-product-view',
            defaultViewType: 'GRID',
            tagName: 'DIV',
            htmlAttributes: {class: 'product-view-container'},
            events: {},
          },
          loader: {
            template: function () {
              return '<div class="UNX-loader">Loading search results....</div>';
            },
            el: null,
          },
          variants: void 0,
          extraParams: {version: 'V2'},
          spellCheck: {
            enabled: !0,
            el: null,
            template: function (t, e) {
              var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                a = r || {},
                n = a.start,
                o = a.productsLn,
                i = a.numberOfProducts,
                s = this.options.spellCheck,
                c = s.selectorClass,
                l = void 0 === c ? '' : c,
                u = s.enabled,
                d = t;
              if ('SEARCH' !== this.options.productType) {
                var p = this.getCategoryId() || '',
                  h = decodeURIComponent(p).split('>');
                d = h[h.length - 1] || h[0];
              }
              var f = this.testIds.UNX_spellCheck,
                g = void 0 === f ? '' : f,
                y = e
                  ? '<p class="UNX-no-result"> Your search "<strong>'
                      .concat(e, '</strong>" did not match any products. Did you mean <button data-test-id="')
                      .concat(g, '" data-action="getSuggestion" class="')
                      .concat(l, '">')
                      .concat(t, '</button>? </p>')
                  : '',
                v = '',
                m = '';
              return (
                i > 0 &&
                  (m = '<span class="UNX-result-info">  -  '
                    .concat(n + 1, ' to ')
                    .concat(o + n, ' of ')
                    .concat(i, ' products</span>')),
                r &&
                  Object.keys(r).length > 0 &&
                  d &&
                  (u || (d = e || t),
                  (v = '<p class="UNX-suggestion-p">Showing results for <strong>'
                    .concat(d, '</strong> ')
                    .concat(m, '</p>'))),
                ['<div class="UNX-spellcheck-block">', y, v, '</div>'].join('')
              );
            },
            selectorClass: 'UNX-suggestion',
            tagName: 'DIV',
            htmlAttributes: {class: 'UNX-spellcheck-wrapper'},
            events: {},
          },
          breadcrumb: {
            enabled: !0,
            el: null,
            selectorClass: 'UNX-bread-crumb',
            template: f,
            tagName: 'DIV',
            htmlAttributes: {class: 'UNX-breadcrumbs-block'},
            events: {},
          },
          url: {
            updateUrls: !0,
            hashMode: !1,
            allowExternalUrlParams: !1,
            seoFriendlyUrl: !1,
            searchQueryParam: {addToUrl: !0, algo: 'KEY_VALUE_REPLACER', keyReplacer: 'q'},
            browseQueryParam: {addToUrl: !0, algo: 'KEY_VALUE_REPLACER', keyReplacer: 'p'},
            orderOfQueryParams: [],
            queryParamSeparator: '&',
            keyValueSeparator: '=',
            pageViewParam: {
              addToUrl: !1,
              algo: 'KEY_VALUE_REPLACER',
              keyReplacer: 'viewType',
              valuesReplacer: {GRID: 'GRID', LIST: 'LIST'},
            },
            sortParam: {addToUrl: !0, algo: 'KEY_VALUE_REPLACER', keyReplacer: 'sort', valueReplacer: {}},
            pageSizeParam: {addToUrl: !0, algo: 'KEY_VALUE_REPLACER', keyReplacer: 'rows'},
            pageNoParam: {addToUrl: !0, algo: 'KEY_VALUE_REPLACER', keyReplacer: 'start', usePageNo: !1},
            facetsParam: {
              addToUrl: !0,
              algo: 'KEY_VALUE_REPLACER',
              showFilterStr: !1,
              filterReplacer: 'filter',
              multiValueSeparator: ',',
              valueReplacer: {},
              keyReplacer: {},
              rangeSeparator: '-',
              rangeFacets: [],
            },
          },
          sort: {
            enabled: !0,
            el: null,
            selectedSortClass: 'UNX-selected-sort',
            sortClass: 'UNX-sort-item',
            template: function (t) {
              var e = '',
                r = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}) || {},
                a = r.options,
                n = void 0 === a ? [] : a,
                o = r.sortClass,
                i = void 0 === o ? '' : o,
                s = r.selectedSortClass,
                c = void 0 === s ? '' : s,
                l = this.testIds.UNX_unbxdSorter,
                u = void 0 === l ? '' : l;
              return (
                n &&
                  n.forEach(function (r) {
                    var a = r.value,
                      n = void 0 === a ? '' : a,
                      o = r.text,
                      i = void 0 === o ? '' : o;
                    e +=
                      n == t
                        ? '<option value="'.concat(n, '" class="').concat(c, '" selected>').concat(i, '</option>')
                        : '<option value="'.concat(n, '">').concat(i, '</option>');
                  }),
                [
                  '<div class="UNX-sort-block">',
                  '<span class="UNX-sort-header">Sort By</span>',
                  '<label class="UNX-hidden" for="unxSortSelect">Sort By</label>',
                  '<select data-test-id="'
                    .concat(u, '" name="unxSortSelect" data-action="changeSort" id="unxSortSelect" class="')
                    .concat(i, '">'),
                  '<option value="">Relevancy</option>',
                  e,
                  '</select>',
                  '</div>',
                ].join('')
              );
            },
            options: [
              {value: 'price desc', text: 'Price High to Low'},
              {value: 'price asc', text: ' Price Low to High'},
            ],
            action: 'change',
            tagName: 'DIV',
            htmlAttributes: {class: 'UNX-sort-block-lb'},
            events: {},
          },
          selectedFacets: {
            enabled: !0,
            selectedFacetClass: 'UNX-selected-facet-btn',
            el: null,
            template: u,
            itemTemplate: l,
            clearAllText: 'Clear All',
            tagName: 'DIV',
            htmlAttributes: {class: 'UNX-selected-facet-lb'},
            events: {},
            facetAction: 'click',
            clearFacetsSelectorClass: 'UNX-clear-facet',
            removeFacetsSelectorClass: 'UNX-remove-facet',
          },
          facet: {
            facetsEl: null,
            facetTemplate: function (t, e, r, a, n) {
              var o = t.displayName,
                i = t.facetName,
                s = t.facetType,
                c = t.values,
                l = n.facetClass,
                u = n.applyMultipleFilters,
                d = n.isCollapsible,
                p = n.isSearchable,
                h = n.searchPlaceHolder,
                f = n.textFacetWrapper,
                g = n.enableViewMore,
                y = n.viewMoreText,
                v = n.viewMoreLimit,
                m = n.actionBtnClass,
                b = n.actionChangeClass,
                S = n.applyButtonText,
                E = n.clearButtonText,
                P = '',
                F = '',
                A = this.getSelectedFacets()[i],
                w = !!(A && A.length > 0);
              g &&
                'text' === s &&
                c.length > v &&
                ((F = 'UNX-view-more'),
                document.querySelector(':root').style.setProperty('--viewMoreHeight', ''.concat(32 * v, 'px')),
                (P = '<div class="UNX-view-more-row "><button class="'
                  .concat(m, '" data-facet-name="')
                  .concat(i, '" data-action="viewMore" data-id="')
                  .concat(y[0], '">')
                  .concat(y[0], '</button></div>')));
              var R = '',
                U = '';
              w &&
                (R = '<button class="UNX-facet-clear '
                  .concat(l, ' "data-facet-action="deleteFacet" data-facet-name="')
                  .concat(i, '">')
                  .concat(E, '</button>')),
                u &&
                  w &&
                  (U = '<button class="UNX-facet-primary '
                    .concat(l, ' "data-facet-action="applyFacets" >')
                    .concat(S, '</button>'));
              var C = '',
                N = '';
              return (
                d &&
                  (C = r
                    ? '<div class="UNX-facet-header '
                        .concat(m, ' UNX-facet-open"  data-facet-name="')
                        .concat(i, '" data-facet-action="facetClose"> <h3>')
                        .concat(o, '</h3> </div>')
                    : '<div class="UNX-facet-header '
                        .concat(m, ' UNX-facet-close"  data-facet-name="')
                        .concat(i, '" data-facet-action="facetOpen"> <h3>')
                        .concat(o, '</h3></div>')),
                p &&
                  null !== a &&
                  (N = '<div class="UNX-searchable-facets"><label class="UNX-hidden" for="'
                    .concat(i, '_searchBox">')
                    .concat(h, '</label><input  id="')
                    .concat(i, '_searchBox" name="')
                    .concat(i, '_searchBox" data-test-id="')
                    .concat(this.testIds.UNX_searchFacets, '" class="UNX-facet-search ')
                    .concat(b, '" value="')
                    .concat(a, '"  data-facet-name="')
                    .concat(i, '" data-facet-action="searchFacets" type="text" placeholder="')
                    .concat(h, '"/></div>')),
                [
                  '<div class="UNX-text-facet-wrap">',
                  C,
                  '<div class="UNX-facets-all">',
                  N,
                  '<div class="UNX-facets '.concat(f, ' ').concat(F, '">').concat(e, '</div>'),
                  P,
                  '<div class="UNX-facet-footer">'.concat(U, ' ').concat(R, '</div>'),
                  '</div>',
                  '</div>',
                ].join('')
              );
            },
            facetItemTemplate: function (t, e, r) {
              var a = t.facetName,
                n = t.isSelected,
                o = e.name,
                i = e.count,
                s = e.dataId,
                c = this.options.facet,
                l = c.facetClass,
                u = c.selectedFacetClass,
                d = this.testIds.UNX_uFilter;
              r && r.length > 0 && o.toUpperCase().indexOf(r.toUpperCase()) < 0 && (l += ' UNX-search-hidden');
              var p = 'changeFacet';
              return (
                n && ((l += ' '.concat(u)), (p = 'deleteFacetValue')),
                [
                  '<button data-test-id="'
                    .concat(d, '" data-facet-name="')
                    .concat(a, '" data-facet-action="')
                    .concat(p, '" class="UNX-change-facet ')
                    .concat(l, '" data-id="')
                    .concat(s, '">'),
                  '<span class="UNX-facet-text">'
                    .concat(o, '</span> <span class="UNX-facet-count">(')
                    .concat(i, ')</span>'),
                  '</button>',
                ].join('')
              );
            },
            facetMultiSelect: !0,
            facetClass: 'UNX-facets-block',
            facetAction: 'click',
            selectedFacetClass: 'UNX-selected-facet-btn',
            selectedFacetsEl: null,
            selectedFacetTemplate: u,
            selectedFacetItemTemplate: l,
            selectedFacetConfig: {},
            clearAllText: 'Clear All',
            rangeTemplate: function (t, e) {
              var r = this,
                a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              try {
                var o = t.facetName,
                  i = t.values,
                  s = void 0 === i ? [] : i,
                  c = '',
                  l = a.facetClass,
                  u = a.selectedFacetClass,
                  d = a.applyMultipleFilters,
                  p = a.applyButtonText,
                  h = a.clearButtonText,
                  f = e.length > 0;
                s.forEach(function (t) {
                  var e = t.from,
                    a = t.end,
                    n = r.isSelectedRange(o, t) ? 'UNX-selected-facet-btn '.concat(l, ' ').concat(u) : ''.concat(l);
                  c += [
                    '<button class="'
                      .concat(n, ' UNX-range-facet UNX-change-facet" data-action="setRange" data-facet-name="')
                      .concat(o, '" data-start="')
                      .concat(e.dataId, '" data-end="')
                      .concat(a.dataId, '" >'),
                    '<span class="UNX-facet-text">'.concat(e.name, '  -  ').concat(a.name, '</span>'),
                    '<span class="UNX-facet-count">('.concat(e.count, ')</span>'),
                    '</button>',
                  ].join('');
                });
                var g = '',
                  y = '';
                return (
                  f &&
                    (d &&
                      (y = '<button class="UNX-default-btn '
                        .concat(l, ' UNX-facet-primary" data-action="applyRange"> ')
                        .concat(p, '</button>')),
                    (g = '<button class="UNX-default-btn UNX-facet-clear  '
                      .concat(l, '" data-action="clearRangeFacets">')
                      .concat(h, '</button>'))),
                  [
                    '<div class="UNX-range-wrapper">',
                    c,
                    '<div class="UNX-price-action-row">',
                    y,
                    g,
                    '<div>',
                    '</div>',
                  ].join('')
                );
              } catch (t) {
                this.onError('facets > renderRangeFacets.js', t, n.runtimeError);
              }
            },
            rangeWidgetConfig: {minLabel: '', maxLabel: '', prefix: '$'},
            facetMultilevel: !0,
            facetMultilevelName: 'Category',
            multiLevelFacetSelectorClass: 'UNX-multilevel-facet',
            multiLevelFacetTemplate: h,
            facetDepth: 4,
            clearFacetsSelectorClass: 'UNX-clear-facet',
            removeFacetsSelectorClass: 'UNX-remove-facet',
            onFacetLoad: function (t) {},
            applyMultipleFilters: !1,
            applyButtonText: 'Apply',
            clearButtonText: 'clear',
            actionBtnClass: 'UNX-action-item',
            actionChangeClass: 'UNX-action-change',
            isCollapsible: !0,
            isSearchable: !0,
            searchPlaceHolder: 'Search Filter',
            textFacetWrapper: 'UNX-facets-item',
            defaultOpen: 'ALL',
            enableViewMore: !1,
            viewMoreText: ['show all', 'show less'],
            viewMoreLimit: 3,
            tagName: 'DIV',
            htmlAttributes: {class: 'UNX-facets-results-block'},
            events: {},
          },
          pagination: {
            enabled: !0,
            el: null,
            template: function (t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.options.pagination,
                r = this.getPaginationType();
              return 'CLICK_N_SCROLL' === r ? p.bind(this)(t, e) : 'FIXED_PAGINATION' === r ? d.bind(this)(t, e) : '';
            },
            pageClass: 'UNX-page-items',
            preloaderClass: '',
            postloaderClass: '',
            selectedPageClass: 'UNX-selected-page-item',
            type: 'CLICK_N_SCROLL',
            infiniteScrollTriggerEl: window,
            heightDiffToTriggerNextPage: 100,
            virtualization: !0,
            bufferPages: 1,
            onPaginate: function (t) {},
            action: 'click',
            pageLimit: 6,
            tagName: 'DIV',
            htmlAttributes: {class: 'UNX-pagination-size-block'},
            events: {},
          },
          pagesize: {
            enabled: !0,
            pageSize: 12,
            options: [8, 12, 16, 20, 24],
            pageSizeClass: 'UNX-pagesize',
            selectedPageSizeClass: 'UNX-selected-pagesize',
            action: 'change',
            template: g,
            el: null,
            tagName: 'DIV',
            htmlAttributes: {class: 'UNX-page-size-block'},
            events: {},
          },
          banner: {
            enabled: !0,
            el: null,
            template: function () {
              var t,
                e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                r = ((arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}) || {}).openNewTab;
              return (
                (t = e
                  ? e
                      .map(function (t) {
                        var e = t.imageUrl,
                          a = t.landingUrl,
                          n = t.bannerHtml;
                        if (n) return n;
                        var o = '';
                        return (
                          a && (o += 'href='.concat(a)),
                          r && (o += '  target="_blank"'),
                          '<a class="UNX-banner-wrap" '
                            .concat(o, ' ><img style="max-width:100%" src="')
                            .concat(e, '"/></a>')
                        );
                      })
                      .join('')
                  : ''),
                ''.concat(t)
              );
            },
            count: 1,
            openNewTab: !1,
            tagName: 'DIV',
            htmlAttributes: {class: 'UNX-banner-block'},
            events: {},
          },
          swatches: {
            enabled: !1,
            attributesMap: {},
            swatchClass: 'UNX-swatch-btn',
            template: function () {
              var t = this,
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                a = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}) || {}).swatchImgs,
                n = void 0 === a ? [] : a,
                o = '',
                i = '',
                s = '',
                c = (e || {}).swatchClass,
                l = void 0 === c ? '' : c,
                u = this.testIds.UNX_swatchClrBtn,
                d = void 0 === u ? '' : u,
                p = (r || {}).unxTitle,
                h = void 0 === p ? '' : p;
              return (
                n.length > 1 &&
                  (n.forEach(function (e, r) {
                    var a = t.generateRid('unx_swatch_'),
                      n = 0 === r ? '' : ' UNX-swatch-hidden',
                      i = 0 === r ? ' UNX-selected-swatch' : '',
                      c = e.split('::');
                    c &&
                      ((o += [
                        '<button value="swatch color '
                          .concat(c[0], '" data-test-id="')
                          .concat(d)
                          .concat(r, '" data-swatch-id="')
                          .concat(a, '" data-action="changeSwatch" class="')
                          .concat(l, ' ')
                          .concat(a, ' ')
                          .concat(i, '" style="background-color:')
                          .concat(c[0], '"> swatch color ')
                          .concat(c[0], ' </button>'),
                      ].join('')),
                      (s += '<div id="'
                        .concat(a, '" class="UNX-img-wrapper ')
                        .concat(n, '"><img alt="')
                        .concat(h, ' for the ')
                        .concat(c[0], '" class="UNX-img-block" src="')
                        .concat(c[1], '"/></div>')));
                  }),
                  (i = '<div class="UNX-swatch-color-list">'.concat(o, '</div>'))),
                {btnList: i, imgList: s}
              );
            },
          },
          unbxdAnalytics: !1,
          onAction: function (t, e) {},
          onQueryRedirect: function (t, e, r) {
            if (e) {
              var a = e.value;
              return (
                'url' === e.type &&
                  (history.state && history.state.replace && history.replaceState(null, '', r), (location.href = a)),
                !1
              );
            }
          },
          onBackFromRedirect: function (t) {
            new URLSearchParams(t ? location.hash.substring(1) : location.search).get('redirected') && history.go(-1);
          },
          onNoUnbxdKeyRouting: function () {
            history.go();
          },
          debugMode: !0,
        };
        const v = function () {
          try {
            var t = this.getBanners() || [],
              e = this.options.banner,
              r = void 0 === e ? {} : e;
            this.bannerWrapper.innerHTML = this.options.banner.template(t, r);
          } catch (t) {
            this.onError('Banners > renderBannerUI', t, n.runtimeError);
          }
        };
        var m = function (t) {
          var e = t.target;
          this.viewState.lastDidYouMean = '';
          var r = ('click' === this.options.facet.facetAction ? e : e.options[e.selectedIndex]).dataset,
            a = r.facetName,
            n = r.facetAction,
            o = r.id,
            i = r.action,
            s = r.end,
            c = r.start,
            l = this.getStateFromUrl(),
            u = this.getSelectedFacets(),
            d = u ? Object.keys(u).length : 0,
            p = Object.keys(l.selectedFacets).length,
            h = this.options,
            f = h.productType,
            g = h.facet.applyMultipleFilters,
            y = this.events,
            v = this.actions,
            m = this.state.rangeFacet[a],
            b = Object.keys(l.rangeFacet);
          if (n === v.changeFacet) {
            var S = this.getSelectedFacet(a),
              E = {selectedFacetName: a, selectedFacetId: o, facetData: S};
            (this.viewState.lastAction = 'addedAFacet'),
              this.options.onEvent(this, y.facetClick, {facetName: a, facetData: S}),
              this.updateFacets(E),
              this.getCallbackActions({facetName: a, facetAction: n, id: o}, 'facetClick');
          }
          if (
            ('deleteSelectedFacetValue' === n &&
              this.findSelectedFacet(a) &&
              ((this.viewState.lastAction = 'deletedAfacet'),
              this.deleteAFacet.bind(this)(a, o),
              this.options.onEvent(this, y.deleteFacetValue, {facetName: a}),
              this.getCallbackActions({facetName: a, facetAction: n, id: o}, 'facetClick'),
              this.setPageStart(0),
              this.getResults()),
            n === v.deleteFacetValue && this.findSelectedFacet(a))
          ) {
            (this.viewState.lastAction = 'deletedAfacet'),
              this.deleteAFacet.bind(this)(a, o),
              this.options.onEvent(this, y.deleteFacetValue, {facetName: a}),
              this.getCallbackActions({facetName: a, facetAction: n, id: o}, 'facetClick');
            var P = u[a].length;
            p > 0 && 1 === d && 0 === P && g && (this.setPageStart(0), this.getResults());
          }
          n === v.deleteFacet &&
            this.findSelectedFacet(a) &&
            ((this.viewState.lastAction = 'deletedAfacet'),
            this.deleteAFacet.bind(this)(a),
            this.options.onEvent(this, y.deleteFacet, {facetName: a}),
            this.getCallbackActions({facetName: a, facetAction: n, id: o}, 'facetClick'),
            l.selectedFacets[a] &&
              ((this.viewState.lastAction = 'clearAFacet'), this.setPageStart(0), this.getResults()));
          if (
            ('applyFacets' === n &&
              ((this.viewState.lastAction = 'applyFacets'), this.setPageStart(0), this.getResults()),
            'clearAllFacets' === n &&
              ((this.viewState.lastAction = 'clearAllFacets'),
              (this.state.selectedFacets = []),
              (this.state.rangeFacet = []),
              this.setPageStart(0),
              this.getResults()),
            'deleteSelectedRange' === n)
          ) {
            var F = r.facetName,
              A = r.id,
              w = A.replace(/[^\w\s]/gi, '').split(' TO ');
            this.setRangeFacet({start: w[0], end: w[1], facetName: F, applyMultiple: !0}),
              this.getCallbackActions({facetName: F, facetAction: n, id: A}, 'facetClick'),
              this.setPageStart(0),
              this.getResults();
          }
          if (
            (i === v.setCategoryFilter &&
              ('SEARCH' === f
                ? (this.setCategoryFilter(r), this.options.onEvent(this, y.setCategoryFilter, r))
                : this.setCategoryId(r, this),
              this.setPageStart(0),
              this.getResults(),
              this.getCallbackActions(r, 'facetClick')),
            i === v.clearCategoryFilter &&
              ('SEARCH' === f
                ? (this.deleteCategoryFilter(r), this.options.onEvent(this, y.deleteCategoryFilter, r))
                : this.setCategoryId(r, this),
              this.setPageStart(0),
              this.getResults(),
              this.getCallbackActions(r, 'facetClick')),
            'setRange' === i)
          ) {
            var R = !1;
            m && 1 === m.length && b.length > 0 && (R = this.isSelectedRange(a, {from: {name: c}, end: {name: s}})),
              R || this.setRangeFacet({start: c, end: s, facetName: a, applyMultiple: !0}),
              R && ((this.state.rangeFacet = []), this.applyRangeFacet()),
              g || (this.setPageStart(0), this.applyRangeFacet()),
              this.getCallbackActions({facetName: a, facetAction: n, id: o}, 'facetClick');
          }
          'clearRangeFacets' === i &&
            ((this.state.rangeFacet = []), this.renderFacets(), b.length > 0 && this.applyRangeFacet()),
            i === v.applyRange &&
              (this.applyRangeFacet(),
              this.options.onEvent(this, i, {facetName: a}),
              this.getCallbackActions({facetName: a}, 'facetClick')),
            i === v.clearPriceRange &&
              a &&
              (this.clearARangeFacet(a),
              this.getResults.bind(this)(),
              this.options.onEvent(this, i, {facetName: a}),
              this.getCallbackActions({facetName: a}, 'facetClick')),
            (this.viewState.lastAction = i);
        };
        function b() {
          var t = this;
          try {
            var e = this.options.facet,
              r = void 0 === e ? {} : e,
              a = r.defaultOpen,
              o = r.applyMultipleFilters,
              i = this.viewState,
              s = i.expandedFacets;
            if ('updatedRangeSlider' === i.lastAction && o) return !1;
            var c = this.getAllFacets() || [],
              l = this.facetWrappers,
              u = void 0 === l ? [] : l,
              d = this.getSelectedFacets() || {};
            u.forEach(function (e) {
              (e.innerHTML = ''),
                c.forEach(function (r, n) {
                  var o = r.facetType,
                    i = r.facetName;
                  void 0 === s[i] && 'ALL' === a && (s[i] = !0), 'FIRST' === a && 0 == n && (s[i] = !0);
                  var c = t.isExpandedFacet(i),
                    l = t.getSearchFacetsText(i) || '',
                    u = d[i];
                  'text' === o && (e.innerHTML += t.renderTextFacet(r, u, c, l)),
                    'range' === o && (e.innerHTML += t.renderRangeFacet(r, c, '')),
                    'category' === o && (e.innerHTML += t.renderMultiLevelFacet(r, c, l)),
                    (t.viewState.facetElementMap[i] = i);
                });
            }),
              this.options.facet.onFacetLoad.bind(this)(c);
          } catch (t) {
            this.onError('Facets > renderFacets.js', t, n.runtimeError);
          }
        }
        function S(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            r = arguments.length > 2 ? arguments[2] : void 0,
            a = arguments.length > 3 ? arguments[3] : void 0,
            o = arguments.length > 4 ? arguments[4] : void 0;
          try {
            var i = [],
              s = t.facetName,
              c = t.values,
              l = void 0 === c ? [] : c,
              u = this.cssList,
              d = u.openFacet,
              p = u.closeFacet,
              h = this,
              f = this.options.facet,
              g = f.isCollapsible,
              y = !1;
            if (
              (l.length > 0 &&
                (i = l.map(function () {
                  var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    n = r.dataId;
                  return (
                    (t.isSelected = e.some(function (t) {
                      return t.dataId === n;
                    })),
                    t.isSelected && (y = t.isSelected),
                    h.options.facet.facetItemTemplate.bind(h)(t, r, a)
                  );
                })),
              o)
            )
              return i.join('');
            t.isSelected = y;
            var v = this.options.facet.facetTemplate.bind(this)(t, i.join(''), r, a, f),
              m = r ? d : p;
            return g || (m = ''), '<div class="UNX-facet-item-d '.concat(s, ' ').concat(m, '">').concat(v, '</div>');
          } catch (t) {
            this.onError('facets > renderTextFacet.js', t, n.runtimeError);
          }
        }
        function E() {
          var t = this;
          try {
            for (
              var e = this.getSelectedFacets() || {},
                r = this.getSelectedRanges() || {},
                a = Object.keys(e),
                o = '',
                i = this.options,
                s = i.selectedFacets,
                c = void 0 === s ? {} : s,
                l = i.facet,
                u = void 0 === l ? {} : l,
                d = u.selectedFacetItemTemplate ? u.selectedFacetItemTemplate.bind(this) : c.itemTemplate.bind(this),
                p = function () {
                  var r = a[h],
                    n = t.isCategoryFacet(r),
                    i = e[r] || [],
                    s = t.getAFacetByName(r);
                  n ||
                    i.forEach(function (t) {
                      var e = t.name,
                        r = t.count,
                        a = t.dataId;
                      o += d(s[0], {name: e, dataId: a || e, count: r || 0}, u, c);
                    });
                },
                h = 0;
              h < a.length;
              h++
            )
              p();
            for (
              var f = Object.keys(r),
                g = function () {
                  var e = f[y],
                    a = t.getAFacetByName(e);
                  r[e].forEach(function (t) {
                    o += d(a[0], {name: t.replace(/[^\w\s]/gi, ''), dataId: t}, u, c);
                  });
                },
                y = 0;
              y < f.length;
              y++
            )
              g();
            var v = u.selectedFacetTemplate ? u.selectedFacetTemplate.bind(this) : c.template.bind(this);
            this.selectedFacetWrappers.forEach(function (t) {
              t.innerHTML = v(o, u, c);
            });
          } catch (t) {
            this.onError('facets > renderSelectedFacets.js', t, n.runtimeError);
          }
        }
        function P() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 ? arguments[1] : void 0;
          try {
            var r = '',
              a = this,
              o = this.cssList,
              i = o.openFacet,
              s = void 0 === i ? '' : i,
              c = o.closeFacet,
              l = void 0 === c ? '' : c,
              u = t.facetName,
              d = this.options.facet,
              p = void 0 === d ? {} : d,
              h = p.isCollapsible,
              f = this.getBreadCrumbsList(u) || [],
              g = a.options.facet.multiLevelFacetTemplate.bind(this)(t, f, '', p);
            r += a.options.facet.facetTemplate.bind(a)(t, g, e, null, p);
            var y = e ? s : l;
            return (
              h || (y = ''),
              '<div class="'
                .concat(u, ' UNX-facet-item-d UNX-multilivel-facets-block UNX-multilevel-block ')
                .concat(y, '">')
                .concat(r, '</div>')
            );
          } catch (t) {
            this.onError('facets > renderMultiLevelFacet.js', t, n.runtimeError);
          }
        }
        function F() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 ? arguments[1] : void 0;
          try {
            var r = t.facetName,
              a = this.cssList,
              o = a.openFacet,
              i = void 0 === o ? '' : o,
              s = a.closeFacet,
              c = void 0 === s ? '' : s,
              l = this.options.facet,
              u = void 0 === l ? {} : l,
              d = u.isCollapsible,
              p = this.state.rangeFacet[r] || [];
            t.isSelected = p.length > 0;
            var h = this.options.facet.rangeTemplate.bind(this)(t, p, u),
              f = this.options.facet.facetTemplate.bind(this)(t, h, e, null, u),
              g = e ? i : c;
            return (
              d || (g = ''),
              '<div class="'.concat(r, ' UNX-facet-item-d range-facets-block ').concat(g, '">').concat(f, '</div>')
            );
          } catch (t) {
            this.onError('facets > renderRangeFacet.js', t, n.runtimeError);
          }
        }
        var A = function (t, e) {
            var r = this.getSelectedRanges(t),
              a = e.from,
              n = e.end,
              o = '['.concat(a.name, ' TO ').concat(n.name, ']');
            return !!(r && r.indexOf(o) >= 0);
          },
          w = function () {
            (this.state.selectedFacets = {}), (this.state.rangeFacet = []), (this.state.categoryFilter = {});
          },
          R = function (t) {
            var e = this.viewState.expandedFacets,
              r = !1;
            return !0 === (void 0 === e ? {} : e)[t] && (r = !0), r;
          },
          U = function (t, e) {
            (this.viewState.searchFacetsText[t] = e), this.reRenderTextFacet(t);
          },
          C = function (t) {
            return this.viewState.searchFacetsText[t] || '';
          },
          N = function (t) {
            var e = this.options.facet.facetClass,
              r = void 0 === e ? '' : e,
              a = this.getSearchFacetsText(t) || '';
            (document.querySelectorAll('.'.concat(t, ' .').concat(r)) || []).forEach(function (t) {
              var e = (t.dataset || {}).id;
              e && e.toUpperCase().indexOf(a.toUpperCase()) >= 0
                ? t.classList.remove('UNX-search-hidden')
                : t.classList.add('UNX-search-hidden');
            });
          },
          O = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.setRangeFacet(t);
            var e = t.facetName;
            this.getCallbackActions({facetName: e, facetAction: 'changeFacet', id: e}, 'facetClick'),
              (this.viewState.lastAction = 'updatedRangeSlider'),
              this.setPageStart(0),
              this.applyRangeFacet();
          },
          T = function () {
            if (this.options.facet.applyMultipleFilters) {
              var t = this.getStateFromUrl() || {},
                e = t.selectedFacets,
                r = void 0 === e ? {} : e,
                a = t.selectedRanges;
              (this.state.selectedFacets = r), (this.state.selectedRanges = a);
            }
          };
        function L() {
          var t = this;
          try {
            var e = this.viewState.productViewType,
              r = this.searchResultsWrapper,
              a = this.options.pagination.type,
              o = this.options.noResults,
              i = o.el ? o.el : r.getElementsByClassName('UNX-no-results')[0],
              s = this.viewState,
              c = (s.noResultLoaded, s.isInfiniteStarted),
              l = this.options.products,
              u = (void 0 === l ? {} : l).productItemClass,
              d = 'LIST' === e ? 'UNX-list-block' : 'UNX-grid-block';
            if (
              (r.classList.remove('UNX-list-block'),
              r.classList.remove('UNX-grid-block'),
              r.classList.add(d),
              o.el ? (i.innerHTML = '') : r.classList.remove('UNX-no-results-wrap'),
              (r.style.minHeight = '100vh'),
              c)
            ) {
              var p,
                h = this.getSearchResults();
              if (
                (h &&
                  0 === (null === (p = h.products) || void 0 === p ? void 0 : p.length) &&
                  (this.viewState.noResultLoaded = !0),
                this.viewState.noResultLoaded)
              ) {
                if (((r.innerHTML = this.renderSearch()), '' !== r.innerHTML))
                  Array.from(r.children).forEach(function (e) {
                    t.individualProductObserver.observe(e);
                  }),
                    window.scrollTo(0, 0),
                    (this.viewState.noResultLoaded = !1);
                else this.preLoaderObserver.disconnect(), this.postLoaderObserver.disconnect(), this.handleNoResults();
              } else {
                var f = this.getProductsPerPage(),
                  g = r.querySelectorAll('.'.concat(u)),
                  y = document.createElement('div');
                y.innerHTML = this.renderSearch();
                var v = Array.from(y.children),
                  m = this.getResponseObj().response.start,
                  b = void 0 === m ? 0 : m,
                  S = null,
                  E = new Set();
                g.forEach(function (t) {
                  var e = parseInt(t.dataset.prank, 10);
                  E.add(e);
                });
                for (var P = 0; P < g.length; P++) {
                  var F = g[P];
                  if (parseInt(F.dataset.prank, 10) > b) {
                    S = F;
                    break;
                  }
                }
                var A = v.filter(function (t) {
                  var e = parseInt(t.dataset.prank, 10);
                  return !E.has(e);
                });
                if (S) {
                  A.forEach(function (e) {
                    r.insertBefore(e, S), t.individualProductObserver.observe(e);
                  });
                  var w = document.querySelector('.'.concat(u, '[data-prank="').concat(b + f + 1, '"]'));
                  w && w.scrollIntoView();
                } else {
                  A.forEach(function (e) {
                    r.appendChild(e), 'INFINITE_SCROLL' === a && t.individualProductObserver.observe(e);
                  });
                  var R = document.querySelector('.'.concat(u, '[data-prank="').concat(b, '"]'));
                  R && R.scrollIntoView();
                }
                this.preLoaderObserver.disconnect();
                var U = document.querySelector(
                  this.options.pagination.preloaderClass
                    ? '.UNX-pre-loader.'.concat(this.options.pagination.preloaderClass)
                    : '.UNX-pre-loader'
                );
                if ((this.preLoaderObserver.observe(U), 'INFINITE_SCROLL' === this.options.pagination.type)) {
                  this.postLoaderObserver.disconnect();
                  var C = document.querySelector(
                    this.options.pagination.postloaderClass
                      ? '.UNX-post-loader.'.concat(this.options.pagination.postloaderClass)
                      : '.UNX-post-loader'
                  );
                  this.postLoaderObserver.observe(C);
                }
              }
              this.viewState.isInfiniteStarted = !1;
            } else {
              if (((r.innerHTML = ''), (r.innerHTML = this.renderSearch()), '' !== r.innerHTML)) {
                if ((window.scrollTo(0, 0), 'INFINITE_SCROLL' === a || 'CLICK_N_SCROLL' === a))
                  Array.from(r.children).forEach(function (e) {
                    t.individualProductObserver.observe(e);
                  });
              } else
                ('INFINITE_SCROLL' !== a && 'CLICK_N_SCROLL' !== a) ||
                  (this.preLoaderObserver.disconnect(), this.postLoaderObserver.disconnect(), this.handleNoResults());
            }
          } catch (t) {
            this.onError('renderProducts.js', t, n.runtimeError);
          }
        }
        const I = function () {
          var t = this;
          try {
            var e = this.getResponseObj().response;
            if (!e) return '';
            var r = e.products,
              a = this,
              o = this.options.swatches,
              i = this.options.products.gridCount,
              s = this.viewState.productViewType,
              c = '',
              l = e.start,
              u = '';
            return (
              'GRID' === s && i && i > 1
                ? r.forEach(function (e, r) {
                    var n = r % i;
                    0 === n && (c += '<div class="UNX-row">');
                    var d = r + l + 1,
                      p = t.mapProductAttrs(e);
                    o.enabled && (u = t.renderSwatchBtns(e)),
                      (c += a.options.products.template.bind(a)(p, d, u, s, t.options.products)),
                      n === i - 1 && (c += '</div>');
                  })
                : (c = r
                    .map(function (e, r) {
                      var n = r + l + 1,
                        i = t.mapProductAttrs(e);
                      return (
                        o.enabled && (u = t.renderSwatchBtns(e)),
                        a.options.products.template.bind(a)(i, n, u, s, t.options.products)
                      );
                    })
                    .join('')),
              c
            );
          } catch (t) {
            this.options.onError('searchResults > renderSearch', t, n.runtimeError);
          }
        };
        var j = function (t) {
          var e = t.path || (t.composedPath && t.composedPath()),
            r = this.options.products,
            a = r.productItemClass,
            n = r.attributesMap,
            o = a.replace('.', ''),
            i = t.target.dataset,
            s = e.find(function (t) {
              return t.className.indexOf(o) >= 0;
            }),
            c = i || {},
            l = c.action,
            u = c.swatchId;
          if (l === this.actions.changeSwatch && u)
            return (
              s.querySelectorAll('.UNX-img-wrapper').forEach(function (t) {
                var e = s.querySelector('.'.concat(t.id));
                t.id === u
                  ? (t.classList.remove('UNX-swatch-hidden'),
                    s.querySelector('.'.concat(u)).classList.add('UNX-selected-swatch'))
                  : (t.classList.add('UNX-swatch-hidden'), e.classList.remove('UNX-selected-swatch'));
              }),
              this.options.onEvent(this, i.action),
              !1
            );
          var d = null;
          if (((i = s.dataset).id && (d = this.getProductByPropValue(n.unxId, i.id)), d && s.dataset.prank)) {
            var p = this.options.url,
              h = (void 0 === p ? {} : p).pageNoParam,
              f = (void 0 === h ? {} : h).usePageNo,
              g = void 0 !== f && f;
            d.prank = s.dataset.prank;
            var y = Math.ceil(Number(d.prank) / Number(this.getProductsPerPage()));
            g ? this.setPageNoParam(y) : this.setPageNoParam(Number((y - 1) * Number(this.getProductsPerPage())));
          }
          this.options.products.onProductClick(d, t), this.getCallbackActions(d, 'click');
        };
        const k = function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '';
          try {
            return this.options.noResults.template(t);
          } catch (t) {
            this.onError('searchresults > renderNoResults', t, n.runtimeError);
          }
        };
        const _ = function () {
          try {
            var t,
              e = this.searchResultsWrapper,
              r = this.options,
              a = r.onEvent,
              o = r.noResults,
              i = this.events,
              s = i.beforeNoResultRender,
              c = i.afterNoResultRender,
              l = this.getQueryParams() || {},
              u = this.getSearchQuery(),
              d = 'UNX-no-results-wrap',
              p = this.state.responseObj.redirect || {};
            if (Object.keys(p).length) return;
            try {
              a(this, s);
            } catch (t) {
              this.onError('reRender', t, n.runtimeError);
            }
            (this.viewState.noResultLoaded = !0),
              null !== (t = this.options.noResults) && void 0 !== t && t.el
                ? (o.el.classList.add(d), (e.innerHTML = ''), (o.el.innerHTML = this.renderNoResults(u)))
                : (e.classList.add(d), (e.innerHTML = this.renderNoResults(u))),
              l.filter || this.renderFacets();
            try {
              a(this, c);
            } catch (t) {
              this.onError('reRender', t, n.runtimeError);
            }
          } catch (t) {
            this.onError('searchresults > handleNoResults', t, n.runtimeError);
          }
        };
        var V = function (t) {
          var e = this.options.products.attributesMap;
          return (
            Object.keys(e).forEach(function (r) {
              var a = t[r],
                n = e[r];
              a || (t[r] = t[n]);
            }),
            t
          );
        };
        const x = function () {
          try {
            var t = this.options.productView,
              e = void 0 === t ? {} : t;
            if (e.el) {
              var r = this.viewState.productViewType,
                a = this.getSearchResults();
              a && 0 === a.numberOfProducts
                ? (this.productViewTypeWrapper.innerHTML = '')
                : (this.productViewTypeWrapper.innerHTML = this.options.productView.template.bind(this)(r, e));
            }
          } catch (t) {
            this.onError('ProductViewType > renderProductViewTypeUI', t, n.runtimeError);
          }
        };
        var M = function () {
          var t = {},
            e = !0,
            r = 0,
            a = arguments.length;
          '[object Boolean]' === Object.prototype.toString.call(arguments[0]) && ((e = arguments[0]), r++);
          for (
            var n = function (r) {
              for (var a in r)
                Object.prototype.hasOwnProperty.call(r, a) &&
                  (e && '[object Object]' === Object.prototype.toString.call(r[a])
                    ? (t[a] = M(!0, t[a], r[a]))
                    : (t[a] = r[a]));
            };
            r < a;
            r++
          ) {
            n(arguments[r]);
          }
          return t;
        };
        const X = M;
        function D(t) {
          var e = t.target,
            r = this.options.productView.action,
            a = this.viewState.productViewType,
            n = (('click' === r ? e : e.options[e.selectedIndex]).dataset || {}).viewAction;
          if ((this.checkFacets(), a !== n)) {
            this.viewState.productViewType = n;
            var o = this.options.extraParams,
              i = void 0 === o ? {} : o;
            (this.options.extraParams = X(!0, {}, i, {viewType: n})),
              (this.state.productViewType = this.viewState.productViewType),
              (this.state.isBack = !1),
              (this.viewState.lastAction = 'viewType'),
              this.setUrl(!1),
              this.renderProductViewTypeUI(),
              this.renderProducts();
          }
        }
        const B = function () {
          try {
            var t = this.options.pagination,
              e = void 0 === t ? {} : t,
              r = (e || {}).type,
              a = '';
            if ('INFINITE_SCROLL' !== r) {
              var o = this.getPaginationInfo();
              o && (a = e.template.bind(this)(o, e));
            }
            return a;
          } catch (t) {
            this.onError('Pagination > renderPagination.js', t, n.runtimeError);
          }
        };
        const W = function () {
          var t = this;
          try {
            return new Promise(function () {
              var e = t.options,
                r = e.url,
                a = (void 0 === r ? {} : r).pageNoParam,
                n = (void 0 === a ? {} : a).usePageNo,
                o = void 0 !== n && n,
                i = e.pagination.infiniteScrollTriggerEl,
                s = (e.products.productItemClass, t.getPaginationType());
              window;
              'INFINITE_SCROLL' === s || ('CLICK_N_SCROLL' === s && t.options.products.el);
              var c = document.querySelector(
                  t.options.pagination.postloaderClass
                    ? '.UNX-post-loader.'.concat(t.options.pagination.postloaderClass)
                    : '.UNX-post-loader'
                ),
                l = document.querySelector(
                  t.options.pagination.preloaderClass
                    ? '.UNX-pre-loader.'.concat(t.options.pagination.preloaderClass)
                    : '.UNX-pre-loader'
                );
              (t.individualProductObserver = new IntersectionObserver(
                function (e) {
                  e.forEach(function (e) {
                    if (e.isIntersecting) {
                      var r = parseInt(e.target.dataset.prank),
                        a = t.getCurrentUrlPage(),
                        n = t.getProductsPerPage(),
                        i = Math.ceil(r / n);
                      i !== a && (o ? t.setPageNoParam(i) : t.setPageNoParam((i - 1) * n));
                    }
                  });
                },
                {threshold: [0.5, 0.75, 1]}
              )),
                (t.preLoaderObserver = new IntersectionObserver(
                  function (e) {
                    var r = t.getCurrentUrlPage();
                    e.forEach(function (e) {
                      if (
                        e.isIntersecting &&
                        !t.state.isLoading &&
                        !t.viewState.isInfiniteStarted &&
                        (o ? r > 1 : 1 !== t.getFirstPrank())
                      ) {
                        t.preLoaderObserver.disconnect();
                        var a,
                          n = t.getProductsPerPage();
                        if (((t.viewState.isInfiniteStarted = !0), o)) a = parseInt((r - 2) * n, 10);
                        else {
                          var i = t.getFirstPrank() - n - 1;
                          i < 0 && (i = 0), (a = parseInt(i, 10));
                        }
                        t.setPageStart(a), t.getResults('', !0, 'prev');
                      }
                    });
                  },
                  {threshold: 0, rootMargin: '0px 0px 0px 0px'}
                )),
                (t.postLoaderObserver = new IntersectionObserver(
                  function (e) {
                    if (e[0].isIntersecting && !t.state.isLoading && !t.viewState.isInfiniteStarted) {
                      var r = (t.getPaginationInfo() || {}).numberOfProducts,
                        a = t.getLastPrank();
                      a < r &&
                        (t.postLoaderObserver.disconnect(),
                        (t.viewState.isInfiniteStarted = !0),
                        t.setPageStart(a),
                        t.getResults('', !0, 'next'));
                    }
                  },
                  {threshold: 0, rootMargin: '0px 0px 0px 0px'}
                )),
                t.preLoaderObserver.observe(l),
                'INFINITE_SCROLL' === s && t.postLoaderObserver.observe(c);
            });
          } catch (t) {
            this.onError('infiniteScroller.js', t, n.runtimeError);
          }
        };
        var H = function (t, e, r) {
          'FIXED_PAGINATION' === t.options.pagination.type &&
            ((t.viewState.lastAction = 'pagination'), t.setPageStart(e)),
            t.getResults('', !0, r),
            t.options.onEvent(t, t.events.pageNext, {value: e});
        };
        function z(t) {
          try {
            var e = this.getPaginationInfo() || {},
              r = this.options.onEvent,
              a = e.start,
              o = e.rows,
              i = e.isNext,
              s = e.isPrev,
              c = e.noOfPages;
            if ('CLICK_N_SCROLL' === this.options.pagination.type) {
              if (t === this.actions.next && i) {
                this.viewState.isInfiniteStarted = !0;
                var l = this.getLastPrank();
                this.setPageStart(l), H(this, null, t);
              }
            } else {
              if (t === this.actions.next) i && H(this, a + o);
              if (t === this.actions.prev) {
                var u = a - o;
                s &&
                  ((this.viewState.lastAction = 'pagination'), H(this, u), r(this, this.events.pagePrev, {value: u}));
              }
              if (t === this.actions.firstPage) {
                s && ((this.viewState.lastAction = 'pagination'), H(this, 0));
              }
              if (t === this.actions.lastPage) {
                var d = (c - 1) * o;
                i && ((this.viewState.lastAction = 'pagination'), H(this, d));
              }
            }
          } catch (t) {
            this.onError('Pagination > renderNewResults', t, n.runtimeError);
          }
        }
        function Q(t) {
          var e = t.target.dataset,
            r = e.pageAction,
            a = e.pageNo;
          this.checkFacets(),
            (this.viewState.lastDidYouMean = ''),
            'paginate' === r
              ? ((this.viewState.lastAction = 'pagination'), this.setPageStart(a), this.getResults())
              : this.renderNewResults(r);
        }
        var K = function () {
            var t = this.options,
              e = t.url,
              r = (void 0 === e ? {} : e).pageSizeParam,
              a = void 0 === r ? {} : r,
              n = a.keyReplacer,
              o = void 0 === n ? '' : n,
              i = a.addToUrl,
              s = a.algo,
              c = void 0 === s ? 'DEFAULT' : s,
              l = t.pagesize,
              u = (void 0 === l ? {} : l).pageSize;
            if (i) {
              var d = this.readQueryParamsFromUrl(this.options.hashMode ? location.hash.slice(1) : location.search);
              return Number(d['KEY_VALUE_REPLACER' === c ? o : 'rows']);
            }
            return this.state.pageSize || u;
          },
          q = function () {
            var t = this.options.url,
              e = (void 0 === t ? {} : t).pageNoParam,
              r = void 0 === e ? {} : e,
              a = r.algo,
              n = void 0 === a ? 'DEFAULT' : a,
              o = r.usePageNo,
              i = void 0 !== o && o,
              s = r.keyReplacer,
              c = void 0 === s ? '' : s,
              l = r.addToUrl;
            if (i) {
              if (!this.viewState.page)
                if (l) {
                  var u = this.readQueryParamsFromUrl(this.options.hashMode ? location.hash.slice(1) : location.search),
                    d = Number(u['KEY_VALUE_REPLACER' === n ? c : i ? 'page' : 'start']);
                  this.viewState.page = Number(d);
                } else this.viewState.page = 1;
              return this.viewState.page;
            }
            if (!this.viewState.start)
              if (l) {
                var p = this.readQueryParamsFromUrl(this.options.hashMode ? location.hash.slice(1) : location.search),
                  h = Number(p['KEY_VALUE_REPLACER' === n ? c : i ? 'page' : 'start']);
                this.viewState.start = Number(h / K.call(this) + 1);
              } else this.viewState.start = 1;
            return this.viewState.start;
          },
          Y = function (t) {
            var e = this.options.url,
              r = (void 0 === e ? {} : e).pageNoParam,
              a = void 0 === r ? {} : r,
              n = a.algo,
              o = a.usePageNo,
              i = void 0 !== o && o,
              s = a.keyReplacer,
              c = a.addToUrl,
              l = t;
            if (((this.viewState[i ? 'page' : 'start'] = Number(t)), c)) {
              var u = this.readQueryParamsFromUrl(this.options.hashMode ? location.hash.slice(1) : location.search);
              (u['KEY_VALUE_REPLACER' === n ? s : i ? 'page' : 'start'] = [l]),
                history.replaceState(null, null, this.urlSearchParamsToStr(u));
            }
          },
          G = function () {
            var t = document.getElementsByClassName(this.options.products.productItemClass || 'product-item');
            return 0 === t.length ? 1 : parseInt(t[0].dataset.prank, 10);
          },
          $ = function () {
            var t = document.getElementsByClassName(this.options.products.productItemClass || 'product-item');
            return 0 === t.length ? null : parseInt(t[t.length - 1].dataset.prank, 10);
          };
        function Z(t) {
          var e = t.target;
          this.viewState.lastDidYouMean = '';
          var r = e.dataset,
            a = r.action,
            n = r.value,
            o = e.value || n || '',
            i = this.events.changeSort;
          this.checkFacets(),
            a === this.actions.clearSort && (this.applySort(''), this.options.onEvent(this, a)),
            a === this.actions.changeSort && (this.applySort(o), this.options.onEvent(this, i, {sort: o}));
        }
        const J = function () {
          var t = this;
          try {
            var e = this.getSearchResults(),
              r = this.options.sort,
              a = void 0 === r ? {} : r,
              o = this.sortWrappers,
              i = void 0 === o ? [] : o;
            i &&
              i.forEach(function (r) {
                var n = '';
                e && e.numberOfProducts > 0 && (n = t.options.sort.template.bind(t)(t.getSelectedSort(), a)),
                  (r.innerHTML = n);
              });
          } catch (t) {
            this.onError('Sort > renderSort', t, n.runtimeError);
          }
        };
        var tt = function () {
          try {
            var t = '' === this.options.searchBoxEl.value ? '*' : this.options.searchBoxEl.value;
            if (!t.replace(/\s/g, '').length) return !1;
            (this.options.productType = 'SEARCH'),
              (t = 0 === t.indexOf('#') ? t.replace('#', '') : t)
                ? (this.resetAll(),
                  this.changeInput(t, this.events.changeInput),
                  (this.options.products.productType = 'SEARCH'),
                  (this.viewState.loadedFromSuggestion = !1),
                  (this.state.selectedSort = ''),
                  this.setPageStart(0),
                  this.resetViewState(),
                  this.getResults())
                : (this.searchResultsWrapper.innerHTML = null);
          } catch (t) {
            this.onError('input > setInputValue.js', t, n.runtimeError);
          }
        };
        const et = function () {
          try {
            var t = this.state.userInput,
              e = void 0 === t ? '' : t,
              r = this.getPaginationInfo() || {},
              a = this.getDidYouMeanFromResponse() || [],
              o = this.options.pagination.type,
              i = this.options.spellCheck.enabled,
              s = this.viewState,
              c = s.loadedFromSuggestion,
              l = s.lastDidYouMean;
            if ('FIXED_PAGINATION' !== o && r) {
              var u = r.start,
                d = r.productsLn;
              (r.productsLn = d + u), (r.start = 0);
            }
            var p = a.length > 0 ? a[0].suggestion : '',
              h = '';
            p && !c
              ? ((this.viewState.lastDidYouMean = e),
                (this.viewState.loadedFromSuggestion = !0),
                i && this.getResults(p))
              : (this.viewState.lastDidYouMean = ''),
              (h = this.options.spellCheck.template.bind(this)(e, l, r)),
              !i && p && (h = this.options.spellCheck.template.bind(this)(p, e, r)),
              this.spellCheckWrappers.forEach(function (t) {
                t.innerHTML = h;
              });
          } catch (t) {
            this.onError('didYouMean > renderDidYouMean.js', t, n.runtimeError);
          }
        };
        var rt = function (t) {
          var e = this.getSpellCheckSuggested() || [],
            r = e.length,
            a = (t.target || {}).dataset,
            n = this.state.userInput,
            o = void 0 === n ? '' : n;
          a &&
            'getSuggestion' === a.action &&
            (this.resetAll(),
            this.setPageStart(0),
            this.getResults(r ? e[0] : o),
            (this.viewState.lastDidYouMean = null),
            (this.viewState.loadedFromSuggestion = !1));
        };
        function at() {}
        function nt() {
          var t = this;
          try {
            var e,
              r = this.getSelectedMultilevelFacet() || [];
            'CATEGORY' === this.options.products.productType &&
              -1 !==
                (null === (e = window.unbxdAnalyticsConf) || void 0 === e || null === (e = e.page) || void 0 === e
                  ? void 0
                  : e.indexOf('categoryPath')) &&
              (r = ['categoryPath']);
            var a = '';
            return (
              r &&
                r.forEach(function (e) {
                  var r = t.getBreadCrumbsList(e) || [],
                    n = t.options.breadcrumb,
                    o = void 0 === n ? {} : n;
                  a += t.options.breadcrumb.template(r, o);
                }),
              a
            );
          } catch (t) {
            this.onError('Breadcrumbs > actions.js', t, n.runtimeError);
          }
        }
        const ot = function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          try {
            var e = this.getSwatches(t, this.options.swatches.attributesMap) || {},
              r = this.options.swatches,
              a = void 0 === r ? {} : r;
            return this.options.swatches.template.bind(this)(e, a, t);
          } catch (t) {
            this.onError('Swatches > renderSwatchBtns', t, n.runtimeError);
          }
        };
        var it = function (t) {
            var e = t.target;
            this.viewState.lastDidYouMean = '';
            var r = ('click' === this.options.pagesize.action ? e : e.options[e.selectedIndex]).id,
              a = this.events.pageSizeChange;
            r &&
              (this.checkFacets(),
              this.setPageSize(Number(r)),
              this.getResults.bind(this)(),
              this.options.onEvent(this, a, {count: r}));
          },
          st = function () {
            try {
              var t = this.options.pagesize,
                e = void 0 === t ? {} : t,
                r = e.pageSize;
              (this.getQueryParams() || {}) && (r = this.state.pageSize);
              var a = this.getSearchResults();
              a && 0 === a.numberOfProducts
                ? (this.pageSizeWrapper.innerHTML = '')
                : (this.pageSizeWrapper.innerHTML = this.options.pagesize.template.bind(this)(r, e));
            } catch (t) {
              this.onError('Pagesize > renderPageSize', t, n.runtimeError);
            }
          },
          ct = function (t) {
            window.Unbxd.track('search', {query: t});
          },
          lt = function (t) {
            var e = t.uniqueId,
              r = t.sku,
              a = t.prank;
            window.Unbxd.track('click', {pid: e || r, prank: a, requestId: null});
          },
          ut = function () {
            var t = this.getSearchResults(),
              e = this.getSearchQuery(),
              r = this.options.productType,
              a = t.products,
              n = {pids_list: []};
            if (a) {
              var o = [];
              a.forEach(function (t) {
                var e = t.sku,
                  r = t.uniqueId || e;
                o.push(r);
              }),
                (n.pids_list = o),
                'SEARCH' === r
                  ? ((n.query = e), window.Unbxd.track('search_impression', n))
                  : ('CATEGORY' !== r && 'BROWSE' !== r) ||
                    (window.UnbxdAnalyticsConf &&
                      ((n.page = window.UnbxdAnalyticsConf.page || ''),
                      (n.page_type = window.UnbxdAnalyticsConf.page_type || '')),
                    window.Unbxd.track('browse_impression', n));
            }
          },
          dt = function () {
            var t = this.getSelectedFacets(),
              e = this.state.rangeFacet,
              r = this.state.categoryFilter,
              a = Object.keys(t),
              n = Object.keys(e),
              o = Object.keys(r),
              i = {};
            a.forEach(function (e) {
              var r = t[e],
                a = [];
              r.forEach(function (t) {
                a.push(t.name);
              }),
                (i[e] = a);
            }),
              n.forEach(function (t) {
                var r = e[t][0];
                if (r) {
                  var a = r.replace(/\[|\]/g, '').split(',');
                  i[t] = a;
                }
              }),
              o.forEach(function (t) {
                var e = r[t].join('>');
                i[t] = e;
              });
            var s = this.getSearchQuery();
            window.Unbxd.track('facets', {query: s, facets: i});
          },
          pt = function () {
            window.UnbxdAnalyticsConf && window.Unbxd.track('categoryPage', window.UnbxdAnalyticsConf);
          },
          ht = function (t, e) {
            var r = window.Unbxd || null,
              a = this.options.unbxdAnalytics;
            if (!r || !a || (r && !r.track)) return !1;
            if (t)
              switch (e) {
                case 'CHANGE_INPUT':
                  this.trackSearch(t);
                  break;
                case 'click':
                  this.trackProductClick(t);
                  break;
                case 'AFTER_API_CALL':
                  this.trackImpression();
                  break;
                case 'facetClick':
                  this.trackFacetClick(t, e);
                  break;
                case 'categoryPage':
                  this.trackCategoryPageLoad(t, e);
              }
          };
        const ft = {unxPageSize: 'unxPageSize'};
        const gt = function () {
          var t = this,
            e = this.options,
            r = e.onEvent,
            a = e.spellCheck,
            o = e.pagination,
            i = e.productType,
            s = e.searchBoxEl,
            c = e.loader,
            l = e.breadcrumb,
            u = e.productView,
            d = this.getPaginationType(),
            p = this.events,
            h = p.beforeRender,
            f = p.afterRender;
          try {
            r(this, h);
          } catch (t) {
            this.onError('reRender', t, n.runtimeError);
          }
          c.el && (c.el.innerHTML = '');
          var g = this.getSearchResults(),
            y = this.viewState.lastAction;
          'SEARCH' === i && s && (s.value = this.state.userInput), 'SEARCH' !== i && s && (s.value = '');
          var v = this.paginationWrappers,
            m = this.breadcrumbWrapper;
          g && 0 === g.numberOfProducts ? this.handleNoResults() : this.renderProducts(),
            this.renderFacets(),
            this.renderSelectedFacets(),
            this.renderBannerUI(),
            u.enabled && this.renderProductViewTypeUI(),
            this.renderPageSize(),
            this.renderSort(),
            l.enabled && (m.innerHTML = this.renderBreadCrumbs());
          var b = this.getSpellCheckSuggested();
          a.el && this.renderDidYouMean(b),
            'pagination' === y && o.onPaginate.bind(this)(this.getPaginationInfo()),
            'INFINITE_SCROLL' !== d &&
              v.forEach(function (e) {
                e.innerHTML = t.renderPagination();
              });
          try {
            r(this, f);
          } catch (t) {
            this.onError('reRender', t, n.runtimeError);
          }
        };
        const yt = function () {
          var t = this,
            e = this.options,
            r = e.searchButtonEl,
            a = e.searchTrigger,
            n = e.products,
            o = e.facet,
            i = e.productView,
            s = e.pagination,
            c = e.sort,
            l = e.pagesize,
            u = e.spellCheck,
            d = e.searchBoxEl,
            p = e.breadcrumb,
            h = e.selectedFacets,
            f = o || {},
            g = f.actionBtnClass,
            y = f.actionChangeClass;
          d &&
            d.addEventListener('keydown', function (e) {
              e.target.value;
              13 === e.keyCode && t.setInputValue.bind(t)();
            }),
            s.enabled &&
              this.paginationWrappers.forEach(function (e) {
                t.delegate(e, s.action, '.'.concat(s.pageClass), t.paginationAction.bind(t));
              }),
            o.facetsEl &&
              this.facetWrappers.forEach(function (e) {
                t.delegate(e, o.facetAction, '.'.concat(o.facetClass), t.findChangedFacet.bind(t)),
                  t.delegate(e, 'change', '.' + y, t.extraActionsChange.bind(t)),
                  t.delegate(e, 'keyup', '.' + y, t.extraActionsChange.bind(t)),
                  t.delegate(e, 'click', '.' + g, t.extraActions.bind(t));
              }),
            r && r.addEventListener(a, this.setInputValue.bind(this)),
            u.el &&
              this.spellCheckWrappers.forEach(function (e) {
                t.delegate(e, 'click', '.'.concat(u.selectorClass), t.setSuggestion.bind(t));
              }),
            this.delegate(
              this.searchResultsWrapper,
              'click',
              '.'.concat(n.productItemClass),
              this.onProductItemClick.bind(this)
            ),
            c.el &&
              this.sortWrappers.forEach(function (e) {
                t.delegate(e, c.action, '.'.concat(c.sortClass), t.sortAction.bind(t));
              }),
            o.selectedFacetsEl
              ? this.selectedFacetWrappers.forEach(function (e) {
                  t.delegate(e, o.facetAction, '.'.concat(o.selectedFacetClass), t.findChangedFacet.bind(t));
                })
              : this.selectedFacetWrappers.forEach(function (e) {
                  t.delegate(e, h.facetAction, '.'.concat(h.selectedFacetClass), t.findChangedFacet.bind(t));
                }),
            this.breadcrumbWrapper &&
              this.delegate(this.breadcrumbWrapper, 'click', '.' + p.selectorClass, this.findChangedFacet.bind(this)),
            this.productViewTypeWrapper &&
              this.delegate(
                this.productViewTypeWrapper,
                i.action,
                '.' + i.viewTypeClass,
                this.onPageViewTypeClick.bind(this)
              );
          var v = this.getPaginationType();
          if (
            (('INFINITE_SCROLL' !== v && 'CLICK_N_SCROLL' !== v) || this.setUpInfiniteScroll(),
            this.delegate(this.pageSizeWrapper, l.action, '.'.concat(l.pageSizeClass), this.onClickPageSize.bind(this)),
            !this.viewState.initialised)
          ) {
            window.addEventListener('popstate', this.onLocationChange.bind(this), !1);
            var m = this.getQueryParams();
            Object.keys(m).length > 0 && this.renderFromUrl(), (this.viewState.initialised = !0);
          }
        };
        function vt(t) {
          return (
            (vt =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                      ? 'symbol'
                      : typeof t;
                  }),
            vt(t)
          );
        }
        const mt = {
          ALLOWED_QUERY_PARAM_SEPARATORS: ['&', '~', '^', ',', '_', ':', ';', '|', '$', '@'],
          ALLOWED_VALUE_SEPARATORS: ['&', '~', '^', ',', '-', '_', ':', ';', '|', '$', '@'],
          ALLOWED_RANGE_SEPARATORS: ['-'],
        };
        var bt = {
            moduleName: 'pagination',
            config: {
              enabled: {datatype: 'boolean'},
              type: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'string',
                allowedOptions: ['CLICK_N_SCROLL', 'FIXED_PAGINATION', 'INFINITE_SCROLL'],
              },
              el: {
                required: function (t) {
                  return t.enabled && 'INFINITE_SCROLL' !== t.type;
                },
                datatype: 'element',
              },
              template: {
                required: function (t) {
                  return t.enabled && 'INFINITE_SCROLL' !== t.type;
                },
                datatype: 'function',
              },
              pageClass: {datatype: 'string'},
              selectedPageClass: {datatype: 'string'},
              onPaginate: {datatype: 'function'},
              pageLimit: {
                required: function (t) {
                  return t.enabled && 'FIXED_PAGINATION' === t.type;
                },
                datatype: 'number',
              },
              infiniteScrollTriggerEl: {
                required: function (t) {
                  return t.enabled && 'INFINITE_SCROLL' === t.type;
                },
                datatype: 'element',
              },
              heightDiffToTriggerNextPage: {
                required: function (t) {
                  return t.enabled && 'INFINITE_SCROLL' === t.type;
                },
                datatype: 'number',
              },
              action: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'string',
                allowedOptions: ['click', 'change'],
              },
              tagName: {datatype: 'string'},
              htmlAttributes: {datatype: 'object'},
            },
          },
          St = {
            moduleName: 'banner',
            config: {
              enabled: {datatype: 'boolean'},
              el: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'element',
              },
              template: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'function',
              },
              openNewTab: {datatype: 'boolean'},
              tagName: {datatype: 'string'},
              htmlAttributes: {datatype: 'object'},
            },
          },
          Et = {
            moduleName: 'loader',
            config: {
              el: {required: !0, datatype: 'element'},
              template: {
                required: function (t) {
                  return t.el;
                },
                datatype: 'function',
              },
            },
          },
          Pt = {
            moduleName: 'sorting',
            config: {
              enabled: {datatype: 'boolean'},
              el: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'element',
              },
              options: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'array',
              },
              sortClass: {datatype: 'string'},
              selectedSortClass: {datatype: 'string'},
              template: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'function',
              },
              action: {datatype: 'string', allowedOptions: ['click', 'change']},
              tagName: {datatype: 'string'},
              htmlAttributes: {datatype: 'object'},
            },
          },
          Ft = {
            moduleName: 'No results',
            config: {
              el: {required: !0, datatype: 'element'},
              template: {
                required: function (t) {
                  return t.el;
                },
                datatype: 'function',
              },
            },
          },
          At = {
            moduleName: 'swatches',
            config: {
              enabled: {datatype: 'boolean'},
              attributesMap: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'object',
                customValidations: function (t) {
                  t.enabled &&
                    0 === Object.keys(t.attributesMap).length &&
                    console.error('SDK Config error in swatches: attributesMap should not be an empty object');
                },
              },
              swatchClass: {datatype: 'string'},
              template: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'function',
              },
            },
          },
          wt = {
            moduleName: 'spellcheck',
            config: {
              enabled: {datatype: 'boolean'},
              el: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'element',
              },
              template: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'function',
              },
              selectorClass: {datatype: 'string'},
              tagName: {datatype: 'string'},
              htmlAttributes: {datatype: 'object'},
            },
          },
          Rt = {
            moduleName: 'products',
            config: {
              el: {required: !0, datatype: 'element'},
              productType: {required: !0, datatype: 'string', allowedOptions: ['SEARCH', 'CATEGORY']},
              template: {required: !0, datatype: 'function'},
              productAttributes: {
                required: !0,
                datatype: 'array',
                customValidations: function (t) {
                  0 === t.productAttributes.length &&
                    console.error('SDK Config error in products: productAttributes should not be an empty array');
                },
              },
              attributesMap: {
                required: !0,
                datatype: 'object',
                customValidations: function (t) {
                  0 === Object.keys(t.attributesMap).length &&
                    console.error('SDK Config error in products: attributesMap should not be an empty object');
                },
              },
              gridCount: {datatype: 'number'},
              productItemClass: {required: !0, datatype: 'string'},
              onProductClick: {datatype: 'function'},
              defaultImage: {datatype: 'string'},
              tagName: {datatype: 'string'},
              htmlAttributes: {datatype: 'object'},
            },
          },
          Ut = {
            moduleName: 'page size',
            config: {
              enabled: {datatype: 'boolean'},
              el: {required: !0, datatype: 'element'},
              pageSize: {
                datatype: 'number',
                customValidations: function (t) {
                  t.options.includes(t.pageSize) ||
                    console.error('SDK Config error in pagesize: pageSize should be among options'),
                    t.pageSize < 0 &&
                      console.error('SDK Config error in pagesize: pageSize cannot be a negative value');
                },
              },
              options: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'array',
                customValidations: function (t) {
                  t.options.some(function (t) {
                    return t < 0;
                  }) && console.error('SDK Config error in pagesize: options cannot contain negative values.');
                },
              },
              pageSizeClass: {datatype: 'string'},
              selectedPageSizeClass: {datatype: 'string'},
              action: {datatype: 'string', allowedOptions: ['click', 'change']},
              template: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'function',
              },
              tagName: {datatype: 'string'},
              htmlAttributes: {datatype: 'object'},
            },
          },
          Ct = {
            moduleName: 'product view',
            config: {
              enabled: {datatype: 'boolean'},
              el: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'element',
              },
              template: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'function',
              },
              defaultViewType: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'string',
                allowedOptions: ['GRID', 'LIST'],
              },
              action: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'string',
                allowedOptions: ['click', 'change'],
              },
              viewTypeClass: {datatype: 'string'},
              selectedViewTypeClass: {datatype: 'string'},
              tagName: {datatype: 'string'},
              htmlAttributes: {datatype: 'object'},
            },
          },
          Nt = {
            moduleName: 'breadcrumbs',
            config: {
              enabled: {datatype: 'boolean'},
              el: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'element',
              },
              template: {
                required: function (t) {
                  return t.enabled;
                },
                datatype: 'function',
              },
              selectorClass: {datatype: 'string'},
              tagName: {datatype: 'string'},
              htmlAttributes: {datatype: 'object'},
            },
          },
          Ot = {
            moduleName: 'facets',
            config: {
              facetsEl: {required: !0, datatype: 'element'},
              facetTemplate: {
                required: function (t) {
                  return t.facetsEl;
                },
                datatype: 'function',
              },
              facetItemTemplate: {
                required: function (t) {
                  return t.facetsEl;
                },
                datatype: 'function',
              },
              facetMultiSelect: {datatype: 'boolean'},
              facetClass: {datatype: 'string'},
              facetAction: {
                required: function (t) {
                  return t.facetsEl;
                },
                datatype: 'string',
                allowedOptions: ['click', 'change'],
              },
              selectedFacetClass: {datatype: 'string'},
              selectedFacetsEl: {datatype: 'element'},
              selectedFacetTemplate: {datatype: 'function'},
              selectedFacetItemTemplate: {datatype: 'function'},
              selectedFacetConfig: {datatype: 'object'},
              clearAllText: {datatype: 'string'},
              rangeTemplate: {datatype: 'function'},
              rangeWidgetConfig: {datatype: 'object'},
              facetMultilevel: {datatype: 'boolean'},
              facetMultilevelName: {
                required: function (t) {
                  return t.facetsEl && t.facetMultilevel;
                },
                datatype: 'string',
              },
              multiLevelFacetSelectorClass: {datatype: 'string'},
              multiLevelFacetTemplate: {
                required: function (t) {
                  return t.facetsEl && t.facetMultilevel;
                },
                datatype: 'function',
              },
              facetDepth: {datatype: 'number'},
              clearFacetsSelectorClass: {datatype: 'string'},
              removeFacetsSelectorClass: {datatype: 'string'},
              onFacetLoad: {datatype: 'function'},
              applyMultipleFilters: {datatype: 'boolean'},
              applyButtonText: {
                required: function (t) {
                  return t.facetsEl && t.applyMultipleFilters;
                },
                datatype: 'string',
              },
              clearButtonText: {
                required: function (t) {
                  return t.facetsEl && t.applyMultipleFilters;
                },
                datatype: 'string',
              },
              actionBtnClass: {datatype: 'string'},
              actionChangeClass: {datatype: 'string'},
              isCollapsible: {datatype: 'boolean'},
              defaultOpen: {
                required: function (t) {
                  return t.facetsEl && t.isCollapsible;
                },
                datatype: 'string',
                allowedOptions: ['ALL', 'FIRST', 'NONE'],
              },
              isSearchable: {datatype: 'boolean'},
              searchPlaceHolder: {
                required: function (t) {
                  return t.facetsEl && t.isSearchable;
                },
                datatype: 'string',
              },
              enableViewMore: {datatype: 'boolean'},
              viewMoreText: {
                required: function (t) {
                  return t.facetsEl && t.enableViewMore;
                },
                datatype: 'array',
              },
              viewMoreLimit: {
                required: function (t) {
                  return t.facetsEl && t.enableViewMore;
                },
                datatype: 'number',
              },
              tagName: {datatype: 'string'},
              htmlAttributes: {datatype: 'object'},
            },
          },
          Tt = {
            moduleName: 'facetsParam',
            config: {
              addToUrl: {required: !1, datatype: 'boolean'},
              algo: {
                required: function (t) {
                  return t.addToUrl;
                },
                datatype: 'string',
                allowedOptions: ['DEFAULT', 'KEY_VALUE_REPLACER', 'HASH'],
              },
              multiValueSeparator: {
                required: function (t) {
                  return 'KEY_VALUE_REPLACER' === t.algo;
                },
                datatype: 'string',
                allowedOptions: mt.ALLOWED_VALUE_SEPARATORS,
              },
              keyReplacer: {
                required: !1,
                datatype: 'object',
                customValidations: function (t) {
                  var e = Object.values(t.keyReplacer);
                  new Set(e).size !== e.length &&
                    console.error('SDK Config error in facetsParam: keysReplacer values should not be duplicate');
                },
              },
              valueReplacer: {
                required: !1,
                datatype: 'object',
                customValidations: function (t) {
                  var e = t.valueReplacer;
                  Object.values(e).forEach(function (t) {
                    var e = Object.values(t);
                    new Set(e).size !== e.length &&
                      console.error('SDK Config error in facetsParam: valueReplacer values should not be duplicate');
                  });
                },
              },
              rangeFacets: {
                required: function (t) {
                  return 'KEY_VALUE_REPLACER' === t.algo;
                },
                datatype: 'array',
              },
              rangeSeparator: {
                required: function (t) {
                  return 'KEY_VALUE_REPLACER' === t.algo;
                },
                datatype: 'string',
                allowedOptions: mt.ALLOWED_RANGE_SEPARATORS,
              },
            },
          },
          Lt = {
            moduleName: 'pageViewParam',
            config: {
              addToUrl: {required: !1, datatype: 'boolean'},
              keyReplacer: {required: !1, datatype: 'string'},
              valuesReplacer: {required: !1, datatype: 'object'},
            },
          },
          It = {
            moduleName: 'sortParam',
            config: {
              addToUrl: {required: !1, datatype: 'boolean'},
              keyReplacer: {required: !1, datatype: 'string'},
              valueReplacer: {required: !1, datatype: 'object'},
            },
          },
          jt = {
            moduleName: 'pageNoParam',
            config: {
              addToUrl: {required: !1, datatype: 'boolean'},
              keyReplacer: {required: !1, datatype: 'string'},
              usePageNo: {required: !1, datatype: 'boolean'},
            },
          },
          kt = {
            moduleName: 'pageSizeParam',
            config: {addToUrl: {required: !1, datatype: 'boolean'}, keyReplacer: {required: !1, datatype: 'string'}},
          },
          _t = {
            moduleName: 'url',
            config: {
              seoFriendlyUrl: {
                required: !1,
                datatype: 'boolean',
                customValidations: function (t) {
                  t.seoFriendlyUrl ||
                    ((t.searchQueryParam.addToUrl = !0),
                    (t.searchQueryParam.algo = 'DEFAULT'),
                    (t.searchQueryParam.keyReplacer = 'q'),
                    (t.browseQueryParam.addToUrl = !0),
                    (t.browseQueryParam.algo = 'DEFAULT'),
                    (t.browseQueryParam.keyReplacer = 'p'),
                    (t.pageViewParam.addToUrl = !1),
                    (t.pageViewParam.algo = 'DEFAULT'),
                    (t.pageViewParam.keyReplacer = 'viewType'),
                    (t.sortParam.addToUrl = !0),
                    (t.sortParam.algo = 'DEFAULT'),
                    (t.sortParam.keyReplacer = 'sort'),
                    (t.pageSizeParam.addToUrl = !0),
                    (t.pageSizeParam.algo = 'DEFAULT'),
                    (t.pageSizeParam.keyReplacer = 'rows'),
                    (t.pageNoParam.addToUrl = !0),
                    (t.pageNoParam.algo = 'DEFAULT'),
                    (t.pageNoParam.usePageNo = !1),
                    (t.pageNoParam.keyReplacer = 'start'),
                    (t.facetsParam.addToUrl = !0),
                    (t.facetsParam.algo = 'DEFAULT'),
                    (t.orderOfQueryParams = ['QUERY', 'FILTERS', 'PAGE_NUMBER', 'PAGE_SIZE', 'SORT', 'VIEW_TYPE']),
                    (t.queryParamSeparator = '&'),
                    (t.keyValueSeparator = '='));
                },
              },
              queryParamSeparator: {
                required: !0,
                datatype: 'string',
                allowedOptions: mt.ALLOWED_QUERY_PARAM_SEPARATORS,
              },
            },
          },
          Vt = {
            moduleName: 'Others',
            config: {
              siteKey: {required: !0, datatype: 'string'},
              apiKey: {required: !0, datatype: 'string'},
              searchBoxEl: {required: !0, datatype: 'element'},
              searchButtonEl: {datatype: 'element'},
              unbxdAnalytics: {datatype: 'boolean'},
              extraParams: {datatype: 'object'},
              defaultFilters: {datatype: 'object'},
              searchEndPoint: {datatype: 'string'},
            },
          };
        function xt(t) {
          return (
            (xt =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                      ? 'symbol'
                      : typeof t;
                  }),
            xt(t)
          );
        }
        const Mt = function () {
          var t = this,
            e = this.options,
            r = e.banner,
            a = e.facet,
            o = e.breadcrumb,
            i = e.spellCheck,
            s = e.sort,
            c = e.pagination,
            l = e.loader,
            u = e.noResults,
            d = e.swatches,
            p = e.pagesize,
            h = e.products,
            f = e.productView,
            g = e.url,
            y = g.facetsParam,
            v = g.pageViewParam,
            m = g.sortParam,
            b = g.pageSizeParam,
            S = g.pageNoParam,
            E = function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                a = r.moduleName,
                o = void 0 === a ? '' : a,
                i = r.config,
                s = void 0 === i ? {} : i;
              Object.keys(s).map(function (r) {
                var a,
                  i,
                  c = s[r],
                  l = c.datatype,
                  u = c.required,
                  d = void 0 !== u && u,
                  p = c.allowedOptions,
                  h = void 0 === p ? [] : p,
                  f = c.customValidations,
                  g = void 0 === f ? null : f;
                if (('function' == typeof d && (d = d(e)), xt(e[r]) !== l || ('object' === l && null === e[r])))
                  if ('element' === l || 'array' === l)
                    if ('element' === l) {
                      var y = !((i = e[r]),
                      ('object' === ('undefined' == typeof Node ? 'undefined' : vt(Node))
                        ? i instanceof Node
                        : i && 'object' === vt(i) && 'number' == typeof i.nodeType && 'string' == typeof i.nodeName) ||
                        (function (t) {
                          return 'object' === ('undefined' == typeof HTMLElement ? 'undefined' : vt(HTMLElement))
                            ? t instanceof HTMLElement
                            : t &&
                                'object' === vt(t) &&
                                null !== t &&
                                1 === t.nodeType &&
                                'string' == typeof t.nodeName;
                        })(e[r]) ||
                        ((a = e[r]), a instanceof NodeList));
                      if ((d && (!e[r] || y)) || (!d && e[r] && y)) {
                        if (e[r] === window) return null;
                        t.onError(o, "'".concat(r, "' is not a valid DOM selector"), n.configError);
                      }
                    } else
                      'array' !== l ||
                        Array.isArray(e[r]) ||
                        t.onError(o, "'".concat(r, "' should be of ").concat(l, ' datatype'), n.configError);
                  else t.onError(o, "'".concat(r, "' should be of ").concat(l, ' datatype'), n.configError);
                d && !e[r] && 'element' !== l && t.onError(o, "'".concat(r, "' is required"), n.configError),
                  h.length &&
                    !h.includes(e[r]) &&
                    t.onError(o, 'Only '.concat(h.join(', '), " are allowed for '").concat(r, "'"), n.configError),
                  g && g(e);
              });
            };
          E(c, bt),
            E(r, St),
            E(s, Pt),
            E(u, Ft),
            E(d, At),
            E(i, wt),
            E(p, Ut),
            E(a, Ot),
            E(this.options, Vt),
            E(l, Et),
            E(u, Ft),
            E(h, Rt),
            E(f, Ct),
            E(o, Nt),
            E(y, Tt),
            E(v, Lt),
            E(m, It),
            E(S, jt),
            E(b, kt),
            E(this.options.url, _t);
        };
        const Xt = function () {
          (this.validateConfigs = Mt.bind(this)),
            this.validateConfigs(),
            this.createLayout(),
            (this.unxSelectors = ft),
            this.renderDidYouMean.bind(this),
            this.options.onEvent.bind(this),
            this.options.products.onProductClick.bind(this),
            (this.reRender = gt.bind(this)),
            (this.bindEvents = yt.bind(this)),
            this.bindEvents();
          var t = this.getQueryParams(),
            e = Object.keys(t).length,
            r = this.options.productView,
            a = r.defaultViewType,
            n = r.enabled;
          if (e > 0) {
            var o =
                t[
                  'KEY_VALUE_REPLACER' === this.options.url.pageViewParam.algo
                    ? this.options.url.pageViewParam.keyReplacer
                    : 'viewType'
                ],
              i = this.getKeyByValue(this.options.url.pageViewParam.valuesReplacer, decodeURIComponent(o || a));
            i &&
              ((this.viewState.productViewType = i),
              (this.options.extraParams.viewType = i),
              (this.state.productViewType = i));
          } else this.options.extraParams.viewType = a;
          n && this.renderProductViewTypeUI();
        };
        function Dt(t) {
          return (
            (function (t) {
              if (Array.isArray(t)) return Bt(t);
            })(t) ||
            (function (t) {
              if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator'])
                return Array.from(t);
            })(t) ||
            (function (t, e) {
              if (t) {
                if ('string' == typeof t) return Bt(t, e);
                var r = {}.toString.call(t).slice(8, -1);
                return (
                  'Object' === r && t.constructor && (r = t.constructor.name),
                  'Map' === r || 'Set' === r
                    ? Array.from(t)
                    : 'Arguments' === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                      ? Bt(t, e)
                      : void 0
                );
              }
            })(t) ||
            (function () {
              throw new TypeError(
                'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
              );
            })()
          );
        }
        function Bt(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
          return a;
        }
        const Wt = function () {
          var t = this;
          (this.searchResultsWrapper = this.createtSearchWrapper()),
            (this.bannerWrapper = this.createBannerWrapper()),
            (this.breadcrumbWrapper = this.createBreadcrumbWrapper()),
            (this.pageSizeWrapper = this.createPageSizeWrapper()),
            (this.productViewTypeWrapper = this.createProductViewTypeWrapper()),
            (this.paginationWrappers = []),
            (this.facetWrappers = []),
            (this.sortWrappers = []),
            (this.selectedFacetWrappers = []),
            (this.spellCheckWrappers = []);
          var e = function () {
              var e = t.createSelectedFacetWrapper();
              return t.selectedFacetWrappers.push(e), e;
            },
            r = this.options,
            a = r.facet,
            n = r.breadcrumb,
            o = r.banner,
            i = r.sort,
            s = r.products,
            c = r.pagesize,
            l = r.pagination,
            u = r.productView,
            d = r.selectedFacets,
            p = a.facetsEl,
            h = this.options.spellCheck.el,
            f = this.getPaginationType();
          if (h) {
            var g = h;
            g.length || (g = [h]),
              g.forEach(function (e) {
                var r;
                (e.innerHTML = ''), e.appendChild(((r = t.createSpellCheckWrapper()), t.spellCheckWrappers.push(r), r));
              });
          }
          if (p) {
            var y = p;
            p.length || (y = [p]),
              y.forEach(function (e) {
                var r;
                (e.innerHTML = ''), e.appendChild(((r = t.createFacetWrapper()), t.facetWrappers.push(r), r));
              });
          }
          var v = i.el;
          if (v) {
            var m = v;
            v.length || (m = [v]),
              m.forEach(function (e) {
                var r;
                (e.innerHTML = ''),
                  i.enabled && e.appendChild(((r = t.createSortWrapper()), t.sortWrappers.push(r), r));
              });
          }
          if (a.selectedFacetsEl) (a.selectedFacetsEl.innerHTML = ''), a.selectedFacetsEl.appendChild(e());
          else {
            var b = d.el;
            if (d.enabled && b) {
              var S = b;
              b.length || (S = [b]),
                S.forEach(function (t) {
                  (t.innerHTML = ''), t.appendChild(e());
                });
            }
          }
          if (
            (n.el && ((n.el.innerHTML = ''), n.enabled && n.el.appendChild(this.breadcrumbWrapper)),
            o.el && ((o.el.innerHTML = ''), o.enabled && (o.template.bind(this), o.el.appendChild(this.bannerWrapper))),
            s.el)
          ) {
            if (((s.el.innerHTML = ''), 'INFINITE_SCROLL' === f || 'CLICK_N_SCROLL' === f)) {
              var E,
                P = document.createElement('div');
              (E = P.classList).add.apply(E, ['UNX-pre-loader'].concat(Dt([l.preloaderClass].filter(Boolean)))),
                (P.style.height = this.getHeightDiffToTriggerNextPage() + 'px'),
                s.el.appendChild(P);
            }
            if ((s.el.appendChild(this.searchResultsWrapper), 'INFINITE_SCROLL' === f)) {
              var F,
                A = document.createElement('div');
              (F = A.classList).add.apply(F, ['UNX-post-loader'].concat(Dt([l.postloaderClass].filter(Boolean)))),
                (A.style.height = this.getHeightDiffToTriggerNextPage() + 'px'),
                s.el.appendChild(A);
            }
          }
          c.el && ((c.el.innerHTML = ''), c.enabled && c.el.appendChild(this.pageSizeWrapper)),
            u.el && ((u.el.innerHTML = ''), u.el.appendChild(this.productViewTypeWrapper));
          var w = l.el;
          if (w) {
            var R = w;
            w.length || (R = [w]),
              R.forEach(function (e) {
                var r;
                (e.innerHTML = ''),
                  l.enabled && e.appendChild(((r = t.createPaginationWrapper()), t.paginationWrappers.push(r), r));
              });
          }
        };
        function Ht() {
          var t = this.options.products,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        function zt() {
          var t = this.options.facet,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        function Qt() {
          var t = this.options.banner,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        function Kt() {
          var t = this.options.breadcrumb,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        function qt() {
          var t = this.options.pagesize,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        function Yt() {
          var t = this.options.sort,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        function Gt() {
          var t = this.options.selectedFacets,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        function $t() {
          var t = this.options.spellCheck,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        function Zt() {
          var t = this.options.pagination,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        function Jt() {
          var t = this.options.productView,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
          return this.createElement(e, Object.assign({}, a), n, this);
        }
        const te = function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : window,
            n = document.createElement(t);
          Object.keys(e).forEach(function (t) {
            n.setAttribute(t, e[t]);
          });
          var o = Object.keys(r);
          return (
            o.length > 0 &&
              o.forEach(function (t) {
                n.addEventListener(t, r[t].bind(a));
              }),
            n
          );
        };
        var ee = function (t) {
            var e = this.options.products,
              r = Object.assign({}, e, t);
            this.options.products = r;
          },
          re = function (t) {
            var e = this.options.facet,
              r = Object.assign({}, e, t);
            this.options.facet = r;
          },
          ae = function (t) {
            var e = this.options;
            this.setConfig(e, t), this.initialize();
          },
          ne = function (t) {
            var e = this.options.onAction,
              r = t.target,
              a = r.dataset,
              n = this.cssList,
              o = n.openFacet,
              i = n.closeFacet,
              s = n.openBtn,
              c = n.closeBtn,
              l = n.viewMore,
              u = n.viewLess,
              d = this.options.facet,
              p = d.viewMoreText,
              h = d.textFacetWrapper;
            if (a) {
              var f = a.facetAction,
                g = a.facetName,
                y = a.action,
                v = this.viewState.facetElementMap,
                m = r.closest('.'.concat(v[g]));
              if (
                ('facetOpen' === f &&
                  ((this.viewState.expandedFacets[g] = !0),
                  r.classList.add(s),
                  r.classList.remove(c),
                  r.setAttribute('data-facet-action', 'facetClose'),
                  m.classList.remove(i),
                  m.classList.add(o)),
                'facetClose' === f &&
                  ((this.viewState.expandedFacets[g] = !1),
                  r.classList.remove(s),
                  r.classList.add(c),
                  r.setAttribute('data-facet-action', 'facetOpen'),
                  m.classList.remove(o),
                  m.classList.add(i)),
                'viewMore' === y)
              ) {
                r.setAttribute('data-action', 'viewLess'), (r.innerHTML = p[1]);
                var b = m.querySelector('.'.concat(h));
                b.classList.remove(l), b.classList.add(u);
              }
              if ('viewLess' === y) {
                r.setAttribute('data-action', 'viewMore'), (r.innerHTML = p[0]);
                var S = m.querySelector('.'.concat(h));
                S.classList.remove(u), S.classList.add(l);
              }
            }
            e(t, this);
          },
          oe = function (t) {
            var e = this.options.onAction,
              r = t.target.dataset;
            if (r) {
              var a = r.facetAction,
                n = r.facetName;
              'searchFacets' === a && this.setSearchFacetsText(n, t.target.value);
            }
            e(t, this);
          },
          ie = function () {
            this.resetAll(),
              (this.options.productType = 'CATEGORY'),
              (this.options.products.productType = 'CATEGORY'),
              this.getCallbackActions(this, 'categoryPage'),
              this.getResults();
          },
          se = function () {
            this.resetAll(),
              (this.options.productType = 'BROWSE'),
              (this.options.products.productType = 'BROWSE'),
              this.getCallbackActions(this, 'categoryPage'),
              this.getResults();
          },
          ce = function () {
            (this.viewState.lastDidYouMean = null),
              (this.viewState.searchFacetsText = {}),
              (this.viewState.lastDidYouMean = null),
              (this.viewState.expandedFacets = {});
          },
          le = function () {
            return (
              (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 'unx_') +
              Math.random().toString(36).substr(2, 9)
            );
          },
          ue = function () {};
        const de = function (t) {
          var e = t.prototype;
          (e.renderBannerUI = v),
            (e.setSearchWidget = ee),
            (e.setFacetWidget = re),
            (e.updateConfig = ae),
            (e.createLayout = Wt),
            (e.initialize = Xt),
            (e.extraActions = ne),
            (e.extraActionsChange = oe),
            (e.getCategoryPage = ie),
            (e.getBrowsePage = se),
            (e.resetViewState = ce),
            (e.generateRid = le),
            (e.createElement = te),
            (e.createFacetsLayout = ue),
            (function (t) {
              t = Object.assign(t, {
                createtSearchWrapper: Ht,
                createFacetWrapper: zt,
                createBannerWrapper: Qt,
                createBreadcrumbWrapper: Kt,
                createPageSizeWrapper: qt,
                createSortWrapper: Yt,
                createSelectedFacetWrapper: Gt,
                createSpellCheckWrapper: $t,
                createPaginationWrapper: Zt,
                createProductViewTypeWrapper: Jt,
              });
            })(e),
            (function (t) {
              t = Object.assign(t, {setInputValue: tt});
            })(e),
            (function (t) {
              t = Object.assign(t, {onPageViewTypeClick: D, renderProductViewTypeUI: x});
            })(e),
            (function (t) {
              t = Object.assign(t, {
                findChangedFacet: m,
                isSelectedRange: A,
                clearAllFacets: w,
                isExpandedFacet: R,
                setSearchFacetsText: U,
                getSearchFacetsText: C,
                reRenderTextFacet: N,
                renderTextFacet: S,
                renderRangeFacet: F,
                renderMultiLevelFacet: P,
                renderFacets: b,
                renderSelectedFacets: E,
                checkFacets: T,
                setRangeSlider: O,
              });
            })(e),
            (function (t) {
              t = Object.assign(t, {renderProducts: L});
            })(e),
            (function (t) {
              t = Object.assign(t, {
                renderSearch: I,
                onProductItemClick: j,
                renderNoResults: k,
                handleNoResults: _,
                mapProductAttrs: V,
              });
            })(e),
            (function (t) {
              t = Object.assign(t, {
                renderPagination: B,
                renderNewResults: z,
                paginationAction: Q,
                setUpInfiniteScroll: W,
                getProductsPerPage: K,
                getCurrentUrlPage: q,
                setPageNoParam: Y,
                getFirstPrank: G,
                getLastPrank: $,
              });
            })(e),
            (function (t) {
              t = Object.assign(t, {sortAction: Z, renderSort: J});
            })(e),
            (function (t) {
              t = Object.assign(t, {renderDidYouMean: et, setSuggestion: rt});
            })(e),
            (function (t) {
              t = Object.assign(t, {onBreadCrumbClick: at, renderBreadCrumbs: nt});
            })(e),
            (function (t) {
              t = Object.assign(t, {renderSwatchBtns: ot});
            })(e),
            (function (t) {
              t = Object.assign(t, {pageSizeUi: g, onClickPageSize: it, renderPageSize: st});
            })(e),
            (function (t) {
              t = Object.assign(t, {
                trackSearch: ct,
                getCallbackActions: ht,
                trackProductClick: lt,
                trackImpression: ut,
                trackFacetClick: dt,
                trackCategoryPageLoad: pt,
              });
            })(e);
        };
        const pe = function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.options = X(!0, {}, t, e);
          var r = e.facet,
            a = e.swatches,
            n = e.products,
            o = e.productView;
          r &&
            ((this.options.facetMultilevel = r.facetMultilevel ? r.facetMultilevel : t.facet.facetMultilevel),
            (this.options.facetMultiSelect =
              'boolean' == typeof r.facetMultiSelect ? r.facetMultiSelect : t.facet.facetMultiSelect),
            (this.options.facetDepth = r.facetDepth ? r.facetDepth : t.facet.facetDepth),
            (this.options.applyMultipleFilters =
              'boolean' == typeof r.applyMultipleFilters ? r.applyMultipleFilters : t.facet.applyMultipleFilters)),
            this.setPageSize(this.state.pageSize || this.options.pagesize.pageSize),
            n
              ? ((this.options.productAttributes = n.productAttributes
                  ? n.productAttributes
                  : t.products.productAttributes),
                (this.options.productType = n.productType ? n.productType : t.products.productType))
              : ((this.options.productType = t.products.productType),
                (this.options.productAttributes = t.products.productAttributes)),
            a && (this.options.showSwatches = a && a.enabled ? a.enabled : t.swatches.enabled),
            o &&
              ((this.viewState.productViewType = o.defaultViewType ? o.defaultViewType : t.productView.defaultViewType),
              (this.options.productView.productViewType = this.viewState.productViewType),
              (this.state.productViewType = this.viewState.productViewType));
        };
        function he(t) {
          return (
            (he =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
                      ? 'symbol'
                      : typeof t;
                  }),
            he(t)
          );
        }
        function fe(t, e) {
          for (var r = 0; r < e.length; r++) {
            var a = e[r];
            (a.enumerable = a.enumerable || !1),
              (a.configurable = !0),
              'value' in a && (a.writable = !0),
              Object.defineProperty(t, ge(a.key), a);
          }
        }
        function ge(t) {
          var e = (function (t, e) {
            if ('object' != he(t) || !t) return t;
            var r = t[Symbol.toPrimitive];
            if (void 0 !== r) {
              var a = r.call(t, e || 'default');
              if ('object' != he(a)) return a;
              throw new TypeError('@@toPrimitive must return a primitive value.');
            }
            return ('string' === e ? String : Number)(t);
          })(t, 'string');
          return 'symbol' == he(e) ? e : e + '';
        }
        function ye(t, e, r) {
          return (
            (e = me(e)),
            (function (t, e) {
              if (e && ('object' == he(e) || 'function' == typeof e)) return e;
              if (void 0 !== e) throw new TypeError('Derived constructors may only return object or undefined');
              return (function (t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
              })(t);
            })(t, ve() ? Reflect.construct(e, r || [], me(t).constructor) : e.apply(t, r))
          );
        }
        function ve() {
          try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (t) {}
          return (ve = function () {
            return !!t;
          })();
        }
        function me(t) {
          return (
            (me = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            me(t)
          );
        }
        function be(t, e) {
          return (
            (be = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return (t.__proto__ = e), t;
                }),
            be(t, e)
          );
        }
        var Se = r(330),
          Ee = (function (t) {
            function e(t) {
              var r, a, c;
              return (
                (function (t, e) {
                  if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
                })(this, e),
                ((c = ye(this, e, [t])).viewState = {
                  productViewType: c.state.productViewType || y.productView.defaultViewType,
                  isInfiniteStarted:
                    'INFINITE_SCROLL' ===
                      (null === (r = c.options) || void 0 === r || null === (r = r.pagination) || void 0 === r
                        ? void 0
                        : r.type) ||
                    'CLICK_N_SCROLL' ===
                      (null === (a = c.options) || void 0 === a || null === (a = a.pagination) || void 0 === a
                        ? void 0
                        : a.type),
                  lastAction: '',
                  selectedRange: {},
                  expandedFacets: {},
                  searchFacetsText: {},
                  noResultLoaded: !1,
                  lastDidYouMean: null,
                  loadedFromSuggestion: !1,
                  setFromSuggest: !1,
                  facetElementMap: {},
                  initialised: !1,
                }),
                (c.setConfig = pe.bind(c)),
                c.setConfig(y, t),
                (c.events = n),
                (c.actions = o),
                (c.cssList = i),
                (c.testIds = s),
                c.options.onEvent(c, 'before_initialised'),
                c.updateConfig(),
                c.options.onBackFromRedirect(c.getHashMode()),
                c.options.onEvent(c, 'initialised'),
                (c.sdkVersion = Se.version),
                c
              );
            }
            return (
              (function (t, e) {
                if ('function' != typeof e && null !== e)
                  throw new TypeError('Super expression must either be null or a function');
                (t.prototype = Object.create(e && e.prototype, {
                  constructor: {value: t, writable: !0, configurable: !0},
                })),
                  Object.defineProperty(t, 'prototype', {writable: !1}),
                  e && be(t, e);
              })(e, t),
              (r = e),
              (a = [
                {
                  key: 'callBack',
                  value: function (t, e) {
                    this.getCallbackActions(t, e);
                    var r = this.options,
                      a = r.onEvent,
                      o = r.loader,
                      i = r.facet,
                      s = r.productView,
                      c = this.events,
                      l = c.beforeApiCall,
                      u = c.afterApiCall,
                      d = (this.getQueryParams() || {})[this.getPageViewParam()];
                    if (
                      ('viewType' === this.viewState.lastAction &&
                        ((d = this.viewState.productViewType),
                        (this.options.extraParams.viewType = d),
                        (this.viewState.lastAction = '')),
                      d ||
                        ((d = this.viewState.productViewType || s.defaultViewType),
                        (this.viewState.productViewType = d),
                        (this.options.extraParams.viewType = d)),
                      this.viewState.productViewType !== d &&
                        ((this.viewState.productViewType = this.getKeyByValue(
                          this.options.url.pageViewParam.valuesReplacer,
                          decodeURIComponent(d)
                        )),
                        (this.options.extraParams.viewType = d)),
                      e === l)
                    ) {
                      try {
                        a(this, l);
                      } catch (t) {
                        this.onError('callback', t, n.runtimeError);
                      }
                      o && o.el && (o.el.innerHTML = o.template(this));
                    }
                    if (e === u) {
                      try {
                        a(this, u);
                      } catch (t) {
                        this.onError('callback', t, n.runtimeError);
                      }
                      this.state.products.length > 0 && (this.viewState.noResultLoaded = !1), this.reRender();
                    }
                    if (('added_facet' === e || 'deleted_facet' === e) && i.applyMultipleFilters) {
                      try {
                        a(this, 'added_facet');
                      } catch (t) {
                        this.onError('callback', t, n.runtimeError);
                      }
                      this.renderFacets();
                    }
                    if ('FETCH_ERROR' === e)
                      try {
                        o && o.el && (o.el.innerHTML = ''), a(this, 'FETCH_ERROR');
                      } catch (t) {
                        this.onError('callback', t, n.fetchError);
                      }
                  },
                },
                {
                  key: 'delegate',
                  value: function (t, e, r, a) {
                    return c(t, e, r, a);
                  },
                },
              ]) && fe(r.prototype, a),
              l && fe(r, l),
              Object.defineProperty(r, 'prototype', {writable: !1}),
              r
            );
            var r, a, l;
          })(e());
        de(Ee);
        const Pe = Ee;
      })(),
      (a = a.default)
    );
  })()
);
!(function (t, e) {
  'object' == typeof exports && 'undefined' != typeof module
    ? e(exports)
    : 'function' == typeof define && define.amd
      ? define(['exports'], e)
      : e(((t = 'undefined' != typeof globalThis ? globalThis : t || self).noUiSlider = {}));
})(this, function (ot) {
  'use strict';
  function n(t) {
    return 'object' == typeof t && 'function' == typeof t.to;
  }
  function st(t) {
    t.parentElement.removeChild(t);
  }
  function at(t) {
    return null != t;
  }
  function lt(t) {
    t.preventDefault();
  }
  function i(t) {
    return 'number' == typeof t && !isNaN(t) && isFinite(t);
  }
  function ut(t, e, r) {
    0 < r &&
      (ft(t, e),
      setTimeout(function () {
        dt(t, e);
      }, r));
  }
  function ct(t) {
    return Math.max(Math.min(t, 100), 0);
  }
  function pt(t) {
    return Array.isArray(t) ? t : [t];
  }
  function e(t) {
    t = (t = String(t)).split('.');
    return 1 < t.length ? t[1].length : 0;
  }
  function ft(t, e) {
    t.classList && !/\s/.test(e) ? t.classList.add(e) : (t.className += ' ' + e);
  }
  function dt(t, e) {
    t.classList && !/\s/.test(e)
      ? t.classList.remove(e)
      : (t.className = t.className.replace(new RegExp('(^|\\b)' + e.split(' ').join('|') + '(\\b|$)', 'gi'), ' '));
  }
  function ht(t) {
    var e = void 0 !== window.pageXOffset,
      r = 'CSS1Compat' === (t.compatMode || '');
    return {
      x: e ? window.pageXOffset : (r ? t.documentElement : t.body).scrollLeft,
      y: e ? window.pageYOffset : (r ? t.documentElement : t.body).scrollTop,
    };
  }
  function s(t, e) {
    return 100 / (e - t);
  }
  function a(t, e, r) {
    return (100 * e) / (t[r + 1] - t[r]);
  }
  function l(t, e) {
    for (var r = 1; t >= e[r]; ) r += 1;
    return r;
  }
  function r(t, e, r) {
    if (r >= t.slice(-1)[0]) return 100;
    var n = l(r, t),
      i = t[n - 1],
      o = t[n],
      t = e[n - 1],
      n = e[n];
    return t + ((r = r), a((o = [i, o]), o[0] < 0 ? r + Math.abs(o[0]) : r - o[0], 0) / s(t, n));
  }
  function o(t, e, r, n) {
    if (100 === n) return n;
    var i = l(n, t),
      o = t[i - 1],
      s = t[i];
    return r
      ? (s - o) / 2 < n - o
        ? s
        : o
      : e[i - 1]
        ? t[i - 1] + ((t = n - t[i - 1]), (i = e[i - 1]), Math.round(t / i) * i)
        : n;
  }
  (ot.PipsMode = void 0),
    ((H = ot.PipsMode || (ot.PipsMode = {})).Range = 'range'),
    (H.Steps = 'steps'),
    (H.Positions = 'positions'),
    (H.Count = 'count'),
    (H.Values = 'values'),
    (ot.PipsType = void 0),
    ((H = ot.PipsType || (ot.PipsType = {}))[(H.None = -1)] = 'None'),
    (H[(H.NoValue = 0)] = 'NoValue'),
    (H[(H.LargeValue = 1)] = 'LargeValue'),
    (H[(H.SmallValue = 2)] = 'SmallValue');
  var u =
    ((t.prototype.getDistance = function (t) {
      for (var e = [], r = 0; r < this.xNumSteps.length - 1; r++) e[r] = a(this.xVal, t, r);
      return e;
    }),
    (t.prototype.getAbsoluteDistance = function (t, e, r) {
      var n = 0;
      if (t < this.xPct[this.xPct.length - 1]) for (; t > this.xPct[n + 1]; ) n++;
      else t === this.xPct[this.xPct.length - 1] && (n = this.xPct.length - 2);
      r || t !== this.xPct[n + 1] || n++;
      for (
        var i,
          o = 1,
          s = (e = null === e ? [] : e)[n],
          a = 0,
          l = 0,
          u = 0,
          c = r
            ? (t - this.xPct[n]) / (this.xPct[n + 1] - this.xPct[n])
            : (this.xPct[n + 1] - t) / (this.xPct[n + 1] - this.xPct[n]);
        0 < s;

      )
        (i = this.xPct[n + 1 + u] - this.xPct[n + u]),
          100 < e[n + u] * o + 100 - 100 * c
            ? ((a = i * c), (o = (s - 100 * c) / e[n + u]), (c = 1))
            : ((a = ((e[n + u] * i) / 100) * o), (o = 0)),
          r ? ((l -= a), 1 <= this.xPct.length + u && u--) : ((l += a), 1 <= this.xPct.length - u && u++),
          (s = e[n + u] * o);
      return t + l;
    }),
    (t.prototype.toStepping = function (t) {
      return (t = r(this.xVal, this.xPct, t));
    }),
    (t.prototype.fromStepping = function (t) {
      return (function (t, e, r) {
        if (100 <= r) return t.slice(-1)[0];
        var n = l(r, e),
          i = t[n - 1],
          o = t[n],
          t = e[n - 1],
          n = e[n];
        return ((r - t) * s(t, n) * ((o = [i, o])[1] - o[0])) / 100 + o[0];
      })(this.xVal, this.xPct, t);
    }),
    (t.prototype.getStep = function (t) {
      return (t = o(this.xPct, this.xSteps, this.snap, t));
    }),
    (t.prototype.getDefaultStep = function (t, e, r) {
      var n = l(t, this.xPct);
      return (
        (100 === t || (e && t === this.xPct[n - 1])) && (n = Math.max(n - 1, 1)), (this.xVal[n] - this.xVal[n - 1]) / r
      );
    }),
    (t.prototype.getNearbySteps = function (t) {
      t = l(t, this.xPct);
      return {
        stepBefore: {
          startValue: this.xVal[t - 2],
          step: this.xNumSteps[t - 2],
          highestStep: this.xHighestCompleteStep[t - 2],
        },
        thisStep: {
          startValue: this.xVal[t - 1],
          step: this.xNumSteps[t - 1],
          highestStep: this.xHighestCompleteStep[t - 1],
        },
        stepAfter: {startValue: this.xVal[t], step: this.xNumSteps[t], highestStep: this.xHighestCompleteStep[t]},
      };
    }),
    (t.prototype.countStepDecimals = function () {
      var t = this.xNumSteps.map(e);
      return Math.max.apply(null, t);
    }),
    (t.prototype.hasNoSize = function () {
      return this.xVal[0] === this.xVal[this.xVal.length - 1];
    }),
    (t.prototype.convert = function (t) {
      return this.getStep(this.toStepping(t));
    }),
    (t.prototype.handleEntryPoint = function (t, e) {
      t = 'min' === t ? 0 : 'max' === t ? 100 : parseFloat(t);
      if (!i(t) || !i(e[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
      this.xPct.push(t), this.xVal.push(e[0]);
      e = Number(e[1]);
      t ? this.xSteps.push(!isNaN(e) && e) : isNaN(e) || (this.xSteps[0] = e), this.xHighestCompleteStep.push(0);
    }),
    (t.prototype.handleStepPoint = function (t, e) {
      e &&
        (this.xVal[t] !== this.xVal[t + 1]
          ? ((this.xSteps[t] = a([this.xVal[t], this.xVal[t + 1]], e, 0) / s(this.xPct[t], this.xPct[t + 1])),
            (e = (this.xVal[t + 1] - this.xVal[t]) / this.xNumSteps[t]),
            (e = Math.ceil(Number(e.toFixed(3)) - 1)),
            (e = this.xVal[t] + this.xNumSteps[t] * e),
            (this.xHighestCompleteStep[t] = e))
          : (this.xSteps[t] = this.xHighestCompleteStep[t] = this.xVal[t]));
    }),
    t);
  function t(e, t, r) {
    var n;
    (this.xPct = []),
      (this.xVal = []),
      (this.xSteps = []),
      (this.xNumSteps = []),
      (this.xHighestCompleteStep = []),
      (this.xSteps = [r || !1]),
      (this.xNumSteps = [!1]),
      (this.snap = t);
    var i = [];
    for (
      Object.keys(e).forEach(function (t) {
        i.push([pt(e[t]), t]);
      }),
        i.sort(function (t, e) {
          return t[0][0] - e[0][0];
        }),
        n = 0;
      n < i.length;
      n++
    )
      this.handleEntryPoint(i[n][1], i[n][0]);
    for (this.xNumSteps = this.xSteps.slice(0), n = 0; n < this.xNumSteps.length; n++)
      this.handleStepPoint(n, this.xNumSteps[n]);
  }
  var c = {
      to: function (t) {
        return void 0 === t ? '' : t.toFixed(2);
      },
      from: Number,
    },
    p = {
      target: 'target',
      base: 'base',
      origin: 'origin',
      handle: 'handle',
      handleLower: 'handle-lower',
      handleUpper: 'handle-upper',
      touchArea: 'touch-area',
      horizontal: 'horizontal',
      vertical: 'vertical',
      background: 'background',
      connect: 'connect',
      connects: 'connects',
      ltr: 'ltr',
      rtl: 'rtl',
      textDirectionLtr: 'txt-dir-ltr',
      textDirectionRtl: 'txt-dir-rtl',
      draggable: 'draggable',
      drag: 'state-drag',
      tap: 'state-tap',
      active: 'active',
      tooltip: 'tooltip',
      pips: 'pips',
      pipsHorizontal: 'pips-horizontal',
      pipsVertical: 'pips-vertical',
      marker: 'marker',
      markerHorizontal: 'marker-horizontal',
      markerVertical: 'marker-vertical',
      markerNormal: 'marker-normal',
      markerLarge: 'marker-large',
      markerSub: 'marker-sub',
      value: 'value',
      valueHorizontal: 'value-horizontal',
      valueVertical: 'value-vertical',
      valueNormal: 'value-normal',
      valueLarge: 'value-large',
      valueSub: 'value-sub',
    },
    mt = {tooltips: '.__tooltips', aria: '.__aria'};
  function f(t, e) {
    if (!i(e)) throw new Error("noUiSlider: 'step' is not numeric.");
    t.singleStep = e;
  }
  function d(t, e) {
    if (!i(e)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
    t.keyboardPageMultiplier = e;
  }
  function h(t, e) {
    if (!i(e)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
    t.keyboardMultiplier = e;
  }
  function m(t, e) {
    if (!i(e)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
    t.keyboardDefaultStep = e;
  }
  function g(t, e) {
    if ('object' != typeof e || Array.isArray(e)) throw new Error("noUiSlider: 'range' is not an object.");
    if (void 0 === e.min || void 0 === e.max) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
    t.spectrum = new u(e, t.snap || !1, t.singleStep);
  }
  function v(t, e) {
    if (((e = pt(e)), !Array.isArray(e) || !e.length)) throw new Error("noUiSlider: 'start' option is incorrect.");
    (t.handles = e.length), (t.start = e);
  }
  function b(t, e) {
    if ('boolean' != typeof e) throw new Error("noUiSlider: 'snap' option must be a boolean.");
    t.snap = e;
  }
  function S(t, e) {
    if ('boolean' != typeof e) throw new Error("noUiSlider: 'animate' option must be a boolean.");
    t.animate = e;
  }
  function x(t, e) {
    if ('number' != typeof e) throw new Error("noUiSlider: 'animationDuration' option must be a number.");
    t.animationDuration = e;
  }
  function y(t, e) {
    var r,
      n = [!1];
    if (('lower' === e ? (e = [!0, !1]) : 'upper' === e && (e = [!1, !0]), !0 === e || !1 === e)) {
      for (r = 1; r < t.handles; r++) n.push(e);
      n.push(!1);
    } else {
      if (!Array.isArray(e) || !e.length || e.length !== t.handles + 1)
        throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
      n = e;
    }
    t.connect = n;
  }
  function w(t, e) {
    switch (e) {
      case 'horizontal':
        t.ort = 0;
        break;
      case 'vertical':
        t.ort = 1;
        break;
      default:
        throw new Error("noUiSlider: 'orientation' option is invalid.");
    }
  }
  function E(t, e) {
    if (!i(e)) throw new Error("noUiSlider: 'margin' option must be numeric.");
    0 !== e && (t.margin = t.spectrum.getDistance(e));
  }
  function P(t, e) {
    if (!i(e)) throw new Error("noUiSlider: 'limit' option must be numeric.");
    if (((t.limit = t.spectrum.getDistance(e)), !t.limit || t.handles < 2))
      throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
  }
  function C(t, e) {
    var r;
    if (!i(e) && !Array.isArray(e))
      throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (Array.isArray(e) && 2 !== e.length && !i(e[0]) && !i(e[1]))
      throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (0 !== e) {
      for (
        Array.isArray(e) || (e = [e, e]),
          t.padding = [t.spectrum.getDistance(e[0]), t.spectrum.getDistance(e[1])],
          r = 0;
        r < t.spectrum.xNumSteps.length - 1;
        r++
      )
        if (t.padding[0][r] < 0 || t.padding[1][r] < 0)
          throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
      var n = e[0] + e[1],
        e = t.spectrum.xVal[0];
      if (1 < n / (t.spectrum.xVal[t.spectrum.xVal.length - 1] - e))
        throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
    }
  }
  function N(t, e) {
    switch (e) {
      case 'ltr':
        t.dir = 0;
        break;
      case 'rtl':
        t.dir = 1;
        break;
      default:
        throw new Error("noUiSlider: 'direction' option was not recognized.");
    }
  }
  function V(t, e) {
    if ('string' != typeof e) throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
    var r = 0 <= e.indexOf('tap'),
      n = 0 <= e.indexOf('drag'),
      i = 0 <= e.indexOf('fixed'),
      o = 0 <= e.indexOf('snap'),
      s = 0 <= e.indexOf('hover'),
      a = 0 <= e.indexOf('unconstrained'),
      l = 0 <= e.indexOf('drag-all'),
      e = 0 <= e.indexOf('smooth-steps');
    if (i) {
      if (2 !== t.handles) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
      E(t, t.start[1] - t.start[0]);
    }
    if (a && (t.margin || t.limit))
      throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
    t.events = {tap: r || o, drag: n, dragAll: l, smoothSteps: e, fixed: i, snap: o, hover: s, unconstrained: a};
  }
  function A(t, e) {
    if (!1 !== e)
      if (!0 === e || n(e)) {
        t.tooltips = [];
        for (var r = 0; r < t.handles; r++) t.tooltips.push(e);
      } else {
        if ((e = pt(e)).length !== t.handles) throw new Error('noUiSlider: must pass a formatter for all handles.');
        e.forEach(function (t) {
          if ('boolean' != typeof t && !n(t))
            throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        }),
          (t.tooltips = e);
      }
  }
  function k(t, e) {
    if (e.length !== t.handles) throw new Error('noUiSlider: must pass a attributes for all handles.');
    t.handleAttributes = e;
  }
  function M(t, e) {
    if (!n(e)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
    t.ariaFormat = e;
  }
  function U(t, e) {
    if (!n((r = e)) || 'function' != typeof r.from)
      throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
    var r;
    t.format = e;
  }
  function D(t, e) {
    if ('boolean' != typeof e) throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
    t.keyboardSupport = e;
  }
  function O(t, e) {
    t.documentElement = e;
  }
  function L(t, e) {
    if ('string' != typeof e && !1 !== e) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
    t.cssPrefix = e;
  }
  function T(e, r) {
    if ('object' != typeof r) throw new Error("noUiSlider: 'cssClasses' must be an object.");
    'string' == typeof e.cssPrefix
      ? ((e.cssClasses = {}),
        Object.keys(r).forEach(function (t) {
          e.cssClasses[t] = e.cssPrefix + r[t];
        }))
      : (e.cssClasses = r);
  }
  function gt(e) {
    var r = {margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: c, format: c},
      n = {
        step: {r: !1, t: f},
        keyboardPageMultiplier: {r: !1, t: d},
        keyboardMultiplier: {r: !1, t: h},
        keyboardDefaultStep: {r: !1, t: m},
        start: {r: !0, t: v},
        connect: {r: !0, t: y},
        direction: {r: !0, t: N},
        snap: {r: !1, t: b},
        animate: {r: !1, t: S},
        animationDuration: {r: !1, t: x},
        range: {r: !0, t: g},
        orientation: {r: !1, t: w},
        margin: {r: !1, t: E},
        limit: {r: !1, t: P},
        padding: {r: !1, t: C},
        behaviour: {r: !0, t: V},
        ariaFormat: {r: !1, t: M},
        format: {r: !1, t: U},
        tooltips: {r: !1, t: A},
        keyboardSupport: {r: !0, t: D},
        documentElement: {r: !1, t: O},
        cssPrefix: {r: !0, t: L},
        cssClasses: {r: !0, t: T},
        handleAttributes: {r: !1, t: k},
      },
      i = {
        connect: !1,
        direction: 'ltr',
        behaviour: 'tap',
        orientation: 'horizontal',
        keyboardSupport: !0,
        cssPrefix: 'noUi-',
        cssClasses: p,
        keyboardPageMultiplier: 5,
        keyboardMultiplier: 1,
        keyboardDefaultStep: 10,
      };
    e.format && !e.ariaFormat && (e.ariaFormat = e.format),
      Object.keys(n).forEach(function (t) {
        if (at(e[t]) || void 0 !== i[t]) n[t].t(r, (at(e[t]) ? e : i)[t]);
        else if (n[t].r) throw new Error("noUiSlider: '" + t + "' is required.");
      }),
      (r.pips = e.pips);
    var t = document.createElement('div'),
      o = void 0 !== t.style.msTransform,
      t = void 0 !== t.style.transform;
    r.transformRule = t ? 'transform' : o ? 'msTransform' : 'webkitTransform';
    return (
      (r.style = [
        ['left', 'top'],
        ['right', 'bottom'],
      ][r.dir][r.ort]),
      r
    );
  }
  function j(t, f, o) {
    var i,
      l,
      a,
      n,
      s,
      u,
      c = window.navigator.pointerEnabled
        ? {start: 'pointerdown', move: 'pointermove', end: 'pointerup'}
        : window.navigator.msPointerEnabled
          ? {start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp'}
          : {start: 'mousedown touchstart', move: 'mousemove touchmove', end: 'mouseup touchend'},
      p =
        window.CSS &&
        CSS.supports &&
        CSS.supports('touch-action', 'none') &&
        (function () {
          var t = !1;
          try {
            var e = Object.defineProperty({}, 'passive', {
              get: function () {
                t = !0;
              },
            });
            window.addEventListener('test', null, e);
          } catch (t) {}
          return t;
        })(),
      d = t,
      S = f.spectrum,
      h = [],
      m = [],
      g = [],
      v = 0,
      b = {},
      x = t.ownerDocument,
      y = f.documentElement || x.documentElement,
      w = x.body,
      E = 'rtl' === x.dir || 1 === f.ort ? 0 : 100;
    function P(t, e) {
      var r = x.createElement('div');
      return e && ft(r, e), t.appendChild(r), r;
    }
    function C(t, e) {
      var r,
        t = P(t, f.cssClasses.origin),
        n = P(t, f.cssClasses.handle);
      return (
        P(n, f.cssClasses.touchArea),
        n.setAttribute('data-handle', String(e)),
        f.keyboardSupport &&
          (n.setAttribute('tabindex', '0'),
          n.addEventListener('keydown', function (t) {
            return (function (t, e) {
              if (V() || A(e)) return !1;
              var r = ['Left', 'Right'],
                n = ['Down', 'Up'],
                i = ['PageDown', 'PageUp'],
                o = ['Home', 'End'];
              f.dir && !f.ort ? r.reverse() : f.ort && !f.dir && (n.reverse(), i.reverse());
              var s = t.key.replace('Arrow', ''),
                a = s === i[0],
                l = s === i[1],
                i = s === n[0] || s === r[0] || a,
                n = s === n[1] || s === r[1] || l,
                r = s === o[0],
                o = s === o[1];
              if (!(i || n || r || o)) return !0;
              if ((t.preventDefault(), n || i)) {
                var u = i ? 0 : 1,
                  u = nt(e)[u];
                if (null === u) return !1;
                !1 === u && (u = S.getDefaultStep(m[e], i, f.keyboardDefaultStep)),
                  (u *= l || a ? f.keyboardPageMultiplier : f.keyboardMultiplier),
                  (u = Math.max(u, 1e-7)),
                  (u *= i ? -1 : 1),
                  (u = h[e] + u);
              } else u = o ? f.spectrum.xVal[f.spectrum.xVal.length - 1] : f.spectrum.xVal[0];
              return Q(e, S.toStepping(u), !0, !0), I('slide', e), I('update', e), I('change', e), I('set', e), !1;
            })(t, e);
          })),
        void 0 !== f.handleAttributes &&
          ((r = f.handleAttributes[e]),
          Object.keys(r).forEach(function (t) {
            n.setAttribute(t, r[t]);
          })),
        n.setAttribute('role', 'slider'),
        n.setAttribute('aria-orientation', f.ort ? 'vertical' : 'horizontal'),
        0 === e ? ft(n, f.cssClasses.handleLower) : e === f.handles - 1 && ft(n, f.cssClasses.handleUpper),
        (t.handle = n),
        t
      );
    }
    function N(t, e) {
      return !!e && P(t, f.cssClasses.connect);
    }
    function e(t, e) {
      return !(!f.tooltips || !f.tooltips[e]) && P(t.firstChild, f.cssClasses.tooltip);
    }
    function V() {
      return d.hasAttribute('disabled');
    }
    function A(t) {
      return l[t].hasAttribute('disabled');
    }
    function k() {
      s &&
        (Y('update' + mt.tooltips),
        s.forEach(function (t) {
          t && st(t);
        }),
        (s = null));
    }
    function M() {
      k(),
        (s = l.map(e)),
        X('update' + mt.tooltips, function (t, e, r) {
          s &&
            f.tooltips &&
            !1 !== s[e] &&
            ((t = t[e]), !0 !== f.tooltips[e] && (t = f.tooltips[e].to(r[e])), (s[e].innerHTML = t));
        });
    }
    function U(t, e) {
      return t.map(function (t) {
        return S.fromStepping(e ? S.getStep(t) : t);
      });
    }
    function D(d) {
      var h = (function (t) {
          if (t.mode === ot.PipsMode.Range || t.mode === ot.PipsMode.Steps) return S.xVal;
          if (t.mode !== ot.PipsMode.Count)
            return t.mode === ot.PipsMode.Positions
              ? U(t.values, t.stepped)
              : t.mode === ot.PipsMode.Values
                ? t.stepped
                  ? t.values.map(function (t) {
                      return S.fromStepping(S.getStep(S.toStepping(t)));
                    })
                  : t.values
                : [];
          if (t.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var e = t.values - 1, r = 100 / e, n = []; e--; ) n[e] = e * r;
          return n.push(100), U(n, t.stepped);
        })(d),
        m = {},
        t = S.xVal[0],
        e = S.xVal[S.xVal.length - 1],
        g = !1,
        v = !1,
        b = 0;
      return (
        (h = h
          .slice()
          .sort(function (t, e) {
            return t - e;
          })
          .filter(function (t) {
            return !this[t] && (this[t] = !0);
          }, {}))[0] !== t && (h.unshift(t), (g = !0)),
        h[h.length - 1] !== e && (h.push(e), (v = !0)),
        h.forEach(function (t, e) {
          var r,
            n,
            i,
            o,
            s,
            a,
            l,
            u,
            t = t,
            c = h[e + 1],
            p = d.mode === ot.PipsMode.Steps,
            f = (f = p ? S.xNumSteps[e] : f) || c - t;
          for (void 0 === c && (c = t), f = Math.max(f, 1e-7), r = t; r <= c; r = Number((r + f).toFixed(7))) {
            for (
              a = (o = (i = S.toStepping(r)) - b) / (d.density || 1), u = o / (l = Math.round(a)), n = 1;
              n <= l;
              n += 1
            )
              m[(s = b + n * u).toFixed(5)] = [S.fromStepping(s), 0];
            (a = -1 < h.indexOf(r) ? ot.PipsType.LargeValue : p ? ot.PipsType.SmallValue : ot.PipsType.NoValue),
              !e && g && r !== c && (a = 0),
              (r === c && v) || (m[i.toFixed(5)] = [r, a]),
              (b = i);
          }
        }),
        m
      );
    }
    function O(i, o, s) {
      var t,
        a = x.createElement('div'),
        n =
          (((t = {})[ot.PipsType.None] = ''),
          (t[ot.PipsType.NoValue] = f.cssClasses.valueNormal),
          (t[ot.PipsType.LargeValue] = f.cssClasses.valueLarge),
          (t[ot.PipsType.SmallValue] = f.cssClasses.valueSub),
          t),
        l =
          (((t = {})[ot.PipsType.None] = ''),
          (t[ot.PipsType.NoValue] = f.cssClasses.markerNormal),
          (t[ot.PipsType.LargeValue] = f.cssClasses.markerLarge),
          (t[ot.PipsType.SmallValue] = f.cssClasses.markerSub),
          t),
        u = [f.cssClasses.valueHorizontal, f.cssClasses.valueVertical],
        c = [f.cssClasses.markerHorizontal, f.cssClasses.markerVertical];
      function p(t, e) {
        var r = e === f.cssClasses.value;
        return e + ' ' + (r ? u : c)[f.ort] + ' ' + (r ? n : l)[t];
      }
      return (
        ft(a, f.cssClasses.pips),
        ft(a, 0 === f.ort ? f.cssClasses.pipsHorizontal : f.cssClasses.pipsVertical),
        Object.keys(i).forEach(function (t) {
          var e, r, n;
          (r = i[(e = t)][0]),
            (n = i[t][1]),
            (n = o ? o(r, n) : n) !== ot.PipsType.None &&
              (((t = P(a, !1)).className = p(n, f.cssClasses.marker)),
              (t.style[f.style] = e + '%'),
              n > ot.PipsType.NoValue &&
                (((t = P(a, !1)).className = p(n, f.cssClasses.value)),
                t.setAttribute('data-value', String(r)),
                (t.style[f.style] = e + '%'),
                (t.innerHTML = String(s.to(r)))));
        }),
        a
      );
    }
    function L() {
      n && (st(n), (n = null));
    }
    function T(t) {
      L();
      var e = D(t),
        r = t.filter,
        t = t.format || {
          to: function (t) {
            return String(Math.round(t));
          },
        };
      return (n = d.appendChild(O(e, r, t)));
    }
    function j() {
      var t = i.getBoundingClientRect(),
        e = 'offset' + ['Width', 'Height'][f.ort];
      return 0 === f.ort ? t.width || i[e] : t.height || i[e];
    }
    function z(n, i, o, s) {
      function e(t) {
        var e,
          r = (function (e, t, r) {
            var n = 0 === e.type.indexOf('touch'),
              i = 0 === e.type.indexOf('mouse'),
              o = 0 === e.type.indexOf('pointer'),
              s = 0,
              a = 0;
            0 === e.type.indexOf('MSPointer') && (o = !0);
            if ('mousedown' === e.type && !e.buttons && !e.touches) return !1;
            if (n) {
              var l = function (t) {
                t = t.target;
                return t === r || r.contains(t) || (e.composed && e.composedPath().shift() === r);
              };
              if ('touchstart' === e.type) {
                n = Array.prototype.filter.call(e.touches, l);
                if (1 < n.length) return !1;
                (s = n[0].pageX), (a = n[0].pageY);
              } else {
                l = Array.prototype.find.call(e.changedTouches, l);
                if (!l) return !1;
                (s = l.pageX), (a = l.pageY);
              }
            }
            (t = t || ht(x)), (i || o) && ((s = e.clientX + t.x), (a = e.clientY + t.y));
            return (e.pageOffset = t), (e.points = [s, a]), (e.cursor = i || o), e;
          })(t, s.pageOffset, s.target || i);
        return (
          !!r &&
          !(V() && !s.doNotReject) &&
          ((e = d),
          (t = f.cssClasses.tap),
          !(
            (e.classList ? e.classList.contains(t) : new RegExp('\\b' + t + '\\b').test(e.className)) && !s.doNotReject
          ) &&
            !(n === c.start && void 0 !== r.buttons && 1 < r.buttons) &&
            (!s.hover || !r.buttons) &&
            (p || r.preventDefault(), (r.calcPoint = r.points[f.ort]), void o(r, s)))
        );
      }
      var r = [];
      return (
        n.split(' ').forEach(function (t) {
          i.addEventListener(t, e, !!p && {passive: !0}), r.push([t, e]);
        }),
        r
      );
    }
    function H(t) {
      var e,
        r,
        n = ct(
          (n =
            (100 *
              (t -
                ((n = i),
                (e = f.ort),
                (r = n.getBoundingClientRect()),
                (n = (t = n.ownerDocument).documentElement),
                (t = ht(t)),
                /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (t.x = 0),
                e ? r.top + t.y - n.clientTop : r.left + t.x - n.clientLeft))) /
            j())
        );
      return f.dir ? 100 - n : n;
    }
    function F(t, e) {
      'mouseout' === t.type && 'HTML' === t.target.nodeName && null === t.relatedTarget && _(t, e);
    }
    function R(t, e) {
      if (-1 === navigator.appVersion.indexOf('MSIE 9') && 0 === t.buttons && 0 !== e.buttonsProperty) return _(t, e);
      t = (f.dir ? -1 : 1) * (t.calcPoint - e.startCalcPoint);
      G(0 < t, (100 * t) / e.baseSize, e.locations, e.handleNumbers, e.connect);
    }
    function _(t, e) {
      e.handle && (dt(e.handle, f.cssClasses.active), --v),
        e.listeners.forEach(function (t) {
          y.removeEventListener(t[0], t[1]);
        }),
        0 === v &&
          (dt(d, f.cssClasses.drag),
          K(),
          t.cursor && ((w.style.cursor = ''), w.removeEventListener('selectstart', lt))),
        f.events.smoothSteps &&
          (e.handleNumbers.forEach(function (t) {
            Q(t, m[t], !0, !0, !1, !1);
          }),
          e.handleNumbers.forEach(function (t) {
            I('update', t);
          })),
        e.handleNumbers.forEach(function (t) {
          I('change', t), I('set', t), I('end', t);
        });
    }
    function B(t, e) {
      var r, n, i, o;
      e.handleNumbers.some(A) ||
        (1 === e.handleNumbers.length &&
          ((o = l[e.handleNumbers[0]].children[0]), (v += 1), ft(o, f.cssClasses.active)),
        t.stopPropagation(),
        (n = z(c.move, y, R, {
          target: t.target,
          handle: o,
          connect: e.connect,
          listeners: (r = []),
          startCalcPoint: t.calcPoint,
          baseSize: j(),
          pageOffset: t.pageOffset,
          handleNumbers: e.handleNumbers,
          buttonsProperty: t.buttons,
          locations: m.slice(),
        })),
        (i = z(c.end, y, _, {
          target: t.target,
          handle: o,
          listeners: r,
          doNotReject: !0,
          handleNumbers: e.handleNumbers,
        })),
        (o = z('mouseout', y, F, {
          target: t.target,
          handle: o,
          listeners: r,
          doNotReject: !0,
          handleNumbers: e.handleNumbers,
        })),
        r.push.apply(r, n.concat(i, o)),
        t.cursor &&
          ((w.style.cursor = getComputedStyle(t.target).cursor),
          1 < l.length && ft(d, f.cssClasses.drag),
          w.addEventListener('selectstart', lt, !1)),
        e.handleNumbers.forEach(function (t) {
          I('start', t);
        }));
    }
    function r(t) {
      t.stopPropagation();
      var i,
        o,
        s,
        e = H(t.calcPoint),
        r =
          ((i = e),
          (s = !(o = 100)),
          l.forEach(function (t, e) {
            var r, n;
            A(e) ||
              ((r = m[e]),
              ((n = Math.abs(r - i)) < o || (n <= o && r < i) || (100 === n && 100 === o)) && ((s = e), (o = n)));
          }),
          s);
      !1 !== r &&
        (f.events.snap || ut(d, f.cssClasses.tap, f.animationDuration),
        Q(r, e, !0, !0),
        K(),
        I('slide', r, !0),
        I('update', r, !0),
        f.events.snap ? B(t, {handleNumbers: [r]}) : (I('change', r, !0), I('set', r, !0)));
    }
    function q(t) {
      var t = H(t.calcPoint),
        t = S.getStep(t),
        e = S.fromStepping(t);
      Object.keys(b).forEach(function (t) {
        'hover' === t.split('.')[0] &&
          b[t].forEach(function (t) {
            t.call(it, e);
          });
      });
    }
    function X(t, e) {
      (b[t] = b[t] || []),
        b[t].push(e),
        'update' === t.split('.')[0] &&
          l.forEach(function (t, e) {
            I('update', e);
          });
    }
    function Y(t) {
      var n = t && t.split('.')[0],
        i = n ? t.substring(n.length) : t;
      Object.keys(b).forEach(function (t) {
        var e = t.split('.')[0],
          r = t.substring(e.length);
        (n && n !== e) || (i && i !== r) || ((((e = r) !== mt.aria && e !== mt.tooltips) || i === r) && delete b[t]);
      });
    }
    function I(r, n, i) {
      Object.keys(b).forEach(function (t) {
        var e = t.split('.')[0];
        r === e &&
          b[t].forEach(function (t) {
            t.call(it, h.map(f.format.to), n, h.slice(), i || !1, m.slice(), it);
          });
      });
    }
    function W(t, e, r, n, i, o, s) {
      var a;
      return (
        1 < l.length &&
          !f.events.unconstrained &&
          (n && 0 < e && ((a = S.getAbsoluteDistance(t[e - 1], f.margin, !1)), (r = Math.max(r, a))),
          i && e < l.length - 1 && ((a = S.getAbsoluteDistance(t[e + 1], f.margin, !0)), (r = Math.min(r, a)))),
        1 < l.length &&
          f.limit &&
          (n && 0 < e && ((a = S.getAbsoluteDistance(t[e - 1], f.limit, !1)), (r = Math.min(r, a))),
          i && e < l.length - 1 && ((a = S.getAbsoluteDistance(t[e + 1], f.limit, !0)), (r = Math.max(r, a)))),
        f.padding &&
          (0 === e && ((a = S.getAbsoluteDistance(0, f.padding[0], !1)), (r = Math.max(r, a))),
          e === l.length - 1 && ((a = S.getAbsoluteDistance(100, f.padding[1], !0)), (r = Math.min(r, a)))),
        !((r = ct((r = !s ? S.getStep(r) : r))) === t[e] && !o) && r
      );
    }
    function $(t, e) {
      var r = f.ort;
      return (r ? e : t) + ', ' + (r ? t : e);
    }
    function G(t, r, n, e, i) {
      var o = n.slice(),
        s = e[0],
        a = f.events.smoothSteps,
        l = [!t, t],
        u = [t, !t];
      (e = e.slice()),
        t && e.reverse(),
        1 < e.length
          ? e.forEach(function (t, e) {
              e = W(o, t, o[t] + r, l[e], u[e], !1, a);
              !1 === e ? (r = 0) : ((r = e - o[t]), (o[t] = e));
            })
          : (l = u = [!0]);
      var c = !1;
      e.forEach(function (t, e) {
        c = Q(t, n[t] + r, l[e], u[e], !1, a) || c;
      }),
        c &&
          (e.forEach(function (t) {
            I('update', t), I('slide', t);
          }),
          null != i && I('drag', s));
    }
    function J(t, e) {
      return f.dir ? 100 - t - e : t;
    }
    function K() {
      g.forEach(function (t) {
        var e = 50 < m[t] ? -1 : 1,
          e = 3 + (l.length + e * t);
        l[t].style.zIndex = String(e);
      });
    }
    function Q(t, e, r, n, i, o) {
      return (
        !1 !== (e = i ? e : W(m, t, e, r, n, !1, o)) &&
        ((e = e),
        (m[(t = t)] = e),
        (h[t] = S.fromStepping(e)),
        (e = 'translate(' + $(J(e, 0) - E + '%', '0') + ')'),
        (l[t].style[f.transformRule] = e),
        Z(t),
        Z(t + 1),
        !0)
      );
    }
    function Z(t) {
      var e, r;
      a[t] &&
        ((r = 100),
        (e =
          'translate(' +
          $(J((e = (e = 0) !== t ? m[t - 1] : e), (r = (r = t !== a.length - 1 ? m[t] : r) - e)) + '%', '0') +
          ')'),
        (r = 'scale(' + $(r / 100, '1') + ')'),
        (a[t].style[f.transformRule] = e + ' ' + r));
    }
    function tt(t, e) {
      return null === t || !1 === t || void 0 === t
        ? m[e]
        : ('number' == typeof t && (t = String(t)),
          !1 === (t = !1 !== (t = f.format.from(t)) ? S.toStepping(t) : t) || isNaN(t) ? m[e] : t);
    }
    function et(t, e, r) {
      var n = pt(t),
        t = void 0 === m[0];
      (e = void 0 === e || e),
        f.animate && !t && ut(d, f.cssClasses.tap, f.animationDuration),
        g.forEach(function (t) {
          Q(t, tt(n[t], t), !0, !1, r);
        });
      var i,
        o = 1 === g.length ? 0 : 1;
      for (
        t &&
        S.hasNoSize() &&
        ((r = !0),
        (m[0] = 0),
        1 < g.length &&
          ((i = 100 / (g.length - 1)),
          g.forEach(function (t) {
            m[t] = t * i;
          })));
        o < g.length;
        ++o
      )
        g.forEach(function (t) {
          Q(t, m[t], !0, !0, r);
        });
      K(),
        g.forEach(function (t) {
          I('update', t), null !== n[t] && e && I('set', t);
        });
    }
    function rt(t) {
      if ((t = void 0 === t ? !1 : t)) return 1 === h.length ? h[0] : h.slice(0);
      t = h.map(f.format.to);
      return 1 === t.length ? t[0] : t;
    }
    function nt(t) {
      var e = m[t],
        r = S.getNearbySteps(e),
        n = h[t],
        i = r.thisStep.step,
        t = null;
      if (f.snap) return [n - r.stepBefore.startValue || null, r.stepAfter.startValue - n || null];
      !1 !== i && n + i > r.stepAfter.startValue && (i = r.stepAfter.startValue - n),
        (t = n > r.thisStep.startValue ? r.thisStep.step : !1 !== r.stepBefore.step && n - r.stepBefore.highestStep),
        100 === e ? (i = null) : 0 === e && (t = null);
      e = S.countStepDecimals();
      return (
        null !== i && !1 !== i && (i = Number(i.toFixed(e))),
        [(t = null !== t && !1 !== t ? Number(t.toFixed(e)) : t), i]
      );
    }
    ft((t = d), f.cssClasses.target),
      0 === f.dir ? ft(t, f.cssClasses.ltr) : ft(t, f.cssClasses.rtl),
      0 === f.ort ? ft(t, f.cssClasses.horizontal) : ft(t, f.cssClasses.vertical),
      ft(t, 'rtl' === getComputedStyle(t).direction ? f.cssClasses.textDirectionRtl : f.cssClasses.textDirectionLtr),
      (i = P(t, f.cssClasses.base)),
      (function (t, e) {
        var r = P(e, f.cssClasses.connects);
        (l = []), (a = []).push(N(r, t[0]));
        for (var n = 0; n < f.handles; n++) l.push(C(e, n)), (g[n] = n), a.push(N(r, t[n + 1]));
      })(f.connect, i),
      (u = f.events).fixed ||
        l.forEach(function (t, e) {
          z(c.start, t.children[0], B, {handleNumbers: [e]});
        }),
      u.tap && z(c.start, i, r, {}),
      u.hover && z(c.move, i, q, {hover: !0}),
      u.drag &&
        a.forEach(function (e, t) {
          var r, n, i, o, s;
          !1 !== e &&
            0 !== t &&
            t !== a.length - 1 &&
            ((r = l[t - 1]),
            (n = l[t]),
            (i = [e]),
            (o = [r, n]),
            (s = [t - 1, t]),
            ft(e, f.cssClasses.draggable),
            u.fixed && (i.push(r.children[0]), i.push(n.children[0])),
            u.dragAll && ((o = l), (s = g)),
            i.forEach(function (t) {
              z(c.start, t, B, {handles: o, handleNumbers: s, connect: e});
            }));
        }),
      et(f.start),
      f.pips && T(f.pips),
      f.tooltips && M(),
      Y('update' + mt.aria),
      X('update' + mt.aria, function (t, e, o, r, s) {
        g.forEach(function (t) {
          var e = l[t],
            r = W(m, t, 0, !0, !0, !0),
            n = W(m, t, 100, !0, !0, !0),
            i = s[t],
            t = String(f.ariaFormat.to(o[t])),
            r = S.fromStepping(r).toFixed(1),
            n = S.fromStepping(n).toFixed(1),
            i = S.fromStepping(i).toFixed(1);
          e.children[0].setAttribute('aria-valuemin', r),
            e.children[0].setAttribute('aria-valuemax', n),
            e.children[0].setAttribute('aria-valuenow', i),
            e.children[0].setAttribute('aria-valuetext', t);
        });
      });
    var it = {
      destroy: function () {
        for (
          Y(mt.aria),
            Y(mt.tooltips),
            Object.keys(f.cssClasses).forEach(function (t) {
              dt(d, f.cssClasses[t]);
            });
          d.firstChild;

        )
          d.removeChild(d.firstChild);
        delete d.noUiSlider;
      },
      steps: function () {
        return g.map(nt);
      },
      on: X,
      off: Y,
      get: rt,
      set: et,
      setHandle: function (t, e, r, n) {
        if (!(0 <= (t = Number(t)) && t < g.length)) throw new Error('noUiSlider: invalid handle number, got: ' + t);
        Q(t, tt(e, t), !0, !0, n), I('update', t), r && I('set', t);
      },
      reset: function (t) {
        et(f.start, t);
      },
      disable: function (t) {
        null != t
          ? (l[t].setAttribute('disabled', ''), l[t].handle.removeAttribute('tabindex'))
          : (d.setAttribute('disabled', ''),
            l.forEach(function (t) {
              t.handle.removeAttribute('tabindex');
            }));
      },
      enable: function (t) {
        null != t
          ? (l[t].removeAttribute('disabled'), l[t].handle.setAttribute('tabindex', '0'))
          : (d.removeAttribute('disabled'),
            l.forEach(function (t) {
              t.removeAttribute('disabled'), t.handle.setAttribute('tabindex', '0');
            }));
      },
      __moveHandles: function (t, e, r) {
        G(t, e, m, r);
      },
      options: o,
      updateOptions: function (e, t) {
        var r = rt(),
          n = ['margin', 'limit', 'padding', 'range', 'animate', 'snap', 'step', 'format', 'pips', 'tooltips'];
        n.forEach(function (t) {
          void 0 !== e[t] && (o[t] = e[t]);
        });
        var i = gt(o);
        n.forEach(function (t) {
          void 0 !== e[t] && (f[t] = i[t]);
        }),
          (S = i.spectrum),
          (f.margin = i.margin),
          (f.limit = i.limit),
          (f.padding = i.padding),
          f.pips ? T(f.pips) : L(),
          (f.tooltips ? M : k)(),
          (m = []),
          et(at(e.start) ? e.start : r, t);
      },
      target: d,
      removePips: L,
      removeTooltips: k,
      getPositions: function () {
        return m.slice();
      },
      getTooltips: function () {
        return s;
      },
      getOrigins: function () {
        return l;
      },
      pips: T,
    };
    return it;
  }
  function z(t, e) {
    if (!t || !t.nodeName) throw new Error('noUiSlider: create requires a single element, got: ' + t);
    if (t.noUiSlider) throw new Error('noUiSlider: Slider was already initialized.');
    e = j(t, gt(e), e);
    return (t.noUiSlider = e);
  }
  var H = {__spectrum: u, cssClasses: p, create: z};
  (ot.create = z), (ot.cssClasses = p), (ot.default = H), Object.defineProperty(ot, '__esModule', {value: !0});
});
function getSiteName() {
  return 'ss-unbxd-ganz-prod-blue-illusion-anz23461767337513';
}
function getApiKey() {
  return 'f0fbd430892f8712a86e026003eb807a';
}

// Fetch active currency once on load
const getActiveCountryCode = (() => {
  const countryCode = (window.Shopify && window.Shopify.country) || null;
  return () => countryCode;
})();

const countryPriceFacetMap = {
  AU: 'price_AUD',
  NZ: 'price_NZD',
  US: 'price_USD',
};
const activePriceFacet = countryPriceFacetMap[getActiveCountryCode()] || 'price';

// Global store for grouped product swatch data (keyed by original product uniqueId)
window._unbxdSwatchData = {};

// store for Quick View / Wishlist (keyed by uniqueId) — only fields needed for the modal
window._unbxdProductStore = {};

// Determine if this is a browse (collections) page or search page
const isCollectionPage = window.location.pathname.includes('/collections');
const VIEW_LAYOUT_STORAGE_KEY = 'unx_selected_layout_view';
const SHOPIFY_PLACEHOLDER_IMAGE_URL = '/assets/placeholder.svg';

function getStoredLayoutViewMode() {
  try {
    const mode = localStorage.getItem(VIEW_LAYOUT_STORAGE_KEY);
    return mode === 'alt' || mode === 'default' ? mode : null;
  } catch (e) {
    return null;
  }
}

function setStoredLayoutViewMode(mode) {
  if (mode !== 'alt' && mode !== 'default') return;
  try {
    localStorage.setItem(VIEW_LAYOUT_STORAGE_KEY, mode);
  } catch (e) {
    // Ignore storage failures (private mode / blocked storage).
  }
}

const searchJSConfig = {
  loader: {
    el: document.getElementById('loaderEl'),
    template: function template() {
      return '<div class="UNX-loader">Loading search results....</div>';
    },
  },
  siteKey: getSiteName(),
  apiKey: getApiKey(),
  searchBoxEl: document.getElementById('input.search__input'),
  searchButtonEl: document.getElementById('span.search-icon'),
  products: {
    productType: 'SEARCH',
    el: '.results-main',
    template: function template(product, idx, swatchUI, productViewType, products) {
      const {unxTitle, unxImageUrl, uniqueId, unxStrikePrice, unxPrice, unxDescription} = product;
      const {productItemClass, defaultImage} = products;
      const isOutOfStock =
        product.availability === false ||
        String(product.availability).toLowerCase() === 'false' ||
        product.available === false;
      // Check if product is "in-store only" (not available for online sale)
      const productTags = Array.isArray(product.tags)
        ? product.tags
        : typeof product.tags === 'string'
          ? product.tags.split(',').map((t) => t.trim())
          : [];
      const isInStoreOnly = productTags.some((tag) => tag.toLowerCase() === 'in-store only');
      const addToBagLabel = isOutOfStock ? 'Notify Me' : 'Add to Bag';
      const addToBagAriaLabel = isOutOfStock ? `${unxTitle} is Sold Out` : `${unxTitle} - Add to Bag`;
      let imgUrl = Array.isArray(unxImageUrl) ? unxImageUrl[0] : unxImageUrl;
      const images = product.images || [];

      let imgUrl2 = Array.isArray(images) && images.length > 1 ? images[images.length - 2] : null;

      const videoUrls = Array.isArray(product.video_urls) ? product.video_urls : [];
      const hoverVideoUrl = videoUrls.find((u) => u.toLowerCase().endsWith('.mp4')) || '';

      // Store only Quick View–required fields
      window._unbxdProductStore[uniqueId] = {
        id: product.id || uniqueId,
        uniqueId: uniqueId,
        title: unxTitle,
        handle: product.handle || uniqueId,
        imageUrl: imgUrl,
        images: images,
        available: product.available,
        availability: product.availability,
        variants: (product.variants || []).map(function (v) {
          return {
            id: v.id || v.variantId || v.v_variantId || '',
            v_Size: v.v_Size || '',
            v_Color: v.v_Color || '',
            title: v.title || '',
            v_availableForSale: v.v_availableForSale,
            available: v.available,
            availability: v.availability,
          };
        }),
      };

      if (!imgUrl) {
        imgUrl = defaultImage;
      }
      // No fallback for imgUrl2 - if no secondary image, hover effect won't show
      let imagesUI = `<div class="UNX-img-wrapper">
                              <img loading="lazy" class="UNX-img-block" width="100%" height="100%" alt="${unxTitle}" src="${imgUrl}" onerror="this.src='${defaultImage}';"  />
                          </div>`;
      // Currency-aware pricing
      const activeCountryCode = getActiveCountryCode();
      const currencyPriceMap = {
        AU: {price: product?.price_AUD, compareAt: product?.compareAtPrice_AUD, currencyLabel: 'AUD'},
        NZ: {price: product?.price_NZD, compareAt: product?.compareAtPrice_NZD, currencyLabel: 'NZD'},
        US: {price: product?.price_USD, compareAt: product?.compareAtPrice_USD, currencyLabel: 'USD'},
      };
      const currencyData = currencyPriceMap[activeCountryCode] || null;
      const currencyLabel = currencyData?.currencyLabel || '';
      const displayPrice = currencyData?.price || 0.0;
      const compareAtPrice = currencyData?.compareAt;
      let cardType = ``;
      if (productViewType === 'GRID') {
        cardType = 'UNX-grid-card';
      } else {
        cardType = 'UNX-list-card';
      }
      // Get product URL and handle from product data
      // Prepend Shopify region root so URLs are region-aware:
      const _shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const _rootPrefix = _shopifyRoot === '/' ? '' : _shopifyRoot.replace(/\/$/, '');
      const _rawProductUrl = product.unxProductUrl || product.productUrl || `/products/${uniqueId}`;
      const productUrl = _rootPrefix + (_rawProductUrl.startsWith('/') ? _rawProductUrl : '/' + _rawProductUrl);
      const productHandle = product.handle || uniqueId;

      // Generate Shopify-style responsive image markup
      function createImageDataSrcSet(image, sizes) {
        let srcSet = [];

        for (var size of sizes) {
          let url = image.includes('?') ? `${image}&width=${size}` : `${image}?width=${size}`;

          srcSet.push(`${url} ${size}w`);
        }
        return srcSet.join(',');
      }

      function createImage(imageUrl, title, sizes) {
        let srcSet = createImageDataSrcSet(imageUrl, sizes);
        return `<img class="product-media__image lazyautosizes lazyloaded component-image__image" data-aspectratio="1.0" data-sizes="auto" src="${imageUrl}" alt="${title}"
      srcset="${srcSet}" width="" height="" loading="eager" sizes="(min-width: 1740px) 20vw, (min-width: 1392px) 25vw, (min-width: 1044px) 33vw, (min-width: 750px) 50vw, 100vw"
      transitiontoproduct="false" data_max_resolution="${imageUrl}" fetchpriority="auto"/>`;
      }
      const imageSizes = [160, 320, 480, 640, 800, 960];

      // Secondary hover slot — video takes priority over secondary image
      let secondaryImageUI = '';
      if (hoverVideoUrl) {
        secondaryImageUI = `<div class="product-card__image--secondary">
                    <div class="component-video__wrapper aspect-ratio aspect-ratio--2-3">
                        <video playsinline="playsinline" class="component-video__video" preload="none" autoplay="autoplay" muted="muted" loop="loop"
                               aria-label="${unxTitle}" width="1080" height="1920"
                               ${imgUrl2 ? 'poster="' + (imgUrl2.includes('?') ? imgUrl2 + '&width=600' : imgUrl2 + '?width=600') + '"' : ''}
                               disablepictureinpicture="true" disableremoteplayback="true" x-webkit-airplay="deny">
                            <source src="${hoverVideoUrl}" type="video/mp4"><img alt="${unxTitle}" src="${imgUrl2 ? (imgUrl2.includes('?') ? imgUrl2 + '&width=600' : imgUrl2 + '?width=600') : ''}">
                        </video>
                    </div>
                </div>`;
      } else if (imgUrl2 && imgUrl2 !== imgUrl) {
        secondaryImageUI = `<div class="product-card__image--secondary">
                    <div class="component-image__wrapper aspect-ratio aspect-ratio--2-3">
                        ${createImage(imgUrl2, unxTitle, imageSizes)}
                    </div>
                </div>`;
      }

      // Badges from meta_badges field
      const metaBadges = product.meta_badges || [];
      const badgesArray = Array.isArray(metaBadges) ? metaBadges : typeof metaBadges === 'string' ? [metaBadges] : [];
      const badgesUI =
        badgesArray.length > 0
          ? `<div class="product-badges product-card__badges" data-product-badges="">
                    ${badgesArray
                      .map((badge) => {
                        const badgeSlug = badge
                          .toLowerCase()
                          .replace(/&/g, '')
                          .replace(/\s+/g, '-')
                          .replace(/-+/g, '-')
                          .replace(/^-|-$/g, '');
                        return `<div class="badge badge__${badgeSlug}">${badge}</div>`;
                      })
                      .join('')}
                </div>`
          : '';

      // Price display - matches native Blue Illusion markup
      const formatPriceWithTwoDecimals = function (value) {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? numericValue.toFixed(2) : value;
      };
      const formattedDisplayPrice = formatPriceWithTwoDecimals(displayPrice);
      const formattedCompareAtPrice = formatPriceWithTwoDecimals(compareAtPrice);
      const priceDisplay =
        compareAtPrice && parseFloat(compareAtPrice) > parseFloat(displayPrice)
          ? `<span class="visually-hidden">Sale price</span><span>$${formattedDisplayPrice} ${currencyLabel}</span><span class="visually-hidden">Regular price</span><span class="product-card__compare-price ns-font-4 ns-text-striked ns-ml-2">$${formattedCompareAtPrice} ${currencyLabel}</span>`
          : `<span>$${formattedDisplayPrice} ${currencyLabel}</span>`;

      // Parse grouped_products for product-level swatches
      let groupedProducts = [];
      try {
        const gpRaw = product.grouped_products;
        if (gpRaw && typeof gpRaw === 'string' && gpRaw !== '[]') {
          groupedProducts = JSON.parse(gpRaw);
        } else if (Array.isArray(gpRaw)) {
          groupedProducts = gpRaw;
        }
      } catch (e) {
        console.error('Error parsing grouped_products:', e);
      }

      // Build current product object for swatch data store
      const currentProductForSwatch = {
        title: unxTitle,
        id: product.id || uniqueId,
        uniqueId: uniqueId,
        availability: product.availability,
        available: product.available,
        price: product.price || unxPrice,
        imageUrl: imgUrl,
        productUrl: productUrl,
        meta_badges: product.meta_badges || [],
        meta_promotion_values: product.meta_promotion_values || [],
        meta_promotion_handles: product.meta_promotion_handles || [],
        images: product.images || [],
        variants: product.variants || [],
        price_AUD: product.price_AUD,
        price_NZD: product.price_NZD,
        price_USD: product.price_USD,
        compareAtPrice_AUD: product.compareAtPrice_AUD,
        compareAtPrice_NZD: product.compareAtPrice_NZD,
        compareAtPrice_USD: product.compareAtPrice_USD,
        handle: productHandle,
        swatch_image_url: product.swatch_image_url || '',
        product_hex: product.product_hex || [],
        video_urls: product.video_urls || [],
      };

      groupedProducts.forEach(function (gp) {
        if (!Array.isArray(gp.video_urls)) gp.video_urls = [];
      });

      // Combine current product + grouped products
      const allSwatchProducts = [currentProductForSwatch, ...groupedProducts];

      // Store in global map for swatch click handler
      window._unbxdSwatchData[uniqueId] = allSwatchProducts;

      // Build swatch UI from grouped products
      let swatchesUI = '';
      if (allSwatchProducts.length > 1) {
        let swatchItems = '';
        allSwatchProducts.forEach((sp, i) => {
          const spMainImg = Array.isArray(sp.imageUrl) ? sp.imageUrl[0] : sp.imageUrl;
          // Use swatch_image_url, fallback to product_hex color
          const spSwatchImg = sp.swatch_image_url || '';
          const spHexArr = sp.product_hex || [];
          const spHex = Array.isArray(spHexArr) ? spHexArr[0] : spHexArr;
          const swatchStyle = spSwatchImg
            ? `background-image: url(${spSwatchImg});`
            : spHex
              ? `background-color: ${spHex};`
              : '';
          const spTitle = sp.title || '';
          const spId = sp.uniqueId || sp.id || '';
          const activeClass = i === 0 ? ' swatch--active' : '';
          swatchItems += `<li>
                        <button type="button" class="swatch UNX-product-swatch${activeClass}"
                                title="${spTitle}"
                                aria-label="Switch to ${spTitle}"
                                data-swatch-action="switchProduct"
                                data-swatch-product-id="${spId}"
                                data-swatch-tile-id="${uniqueId}"
                                style="${swatchStyle}">
                        </button>
                    </li>`;
        });
        swatchesUI = `<div class="product-card__swatches swatches">
                    <ul class="swatches__list list-none">${swatchItems}</ul>
                </div>`;
      }

      // Promotion values from meta_promotion_values field
      const metaPromotionValues = product.meta_promotion_values || [];
      const promotionArray = Array.isArray(metaPromotionValues)
        ? metaPromotionValues
        : typeof metaPromotionValues === 'string'
          ? [metaPromotionValues]
          : [];
      const metaPromotionHandles = product.meta_promotion_handles || [];
      const promotionHandle = Array.isArray(metaPromotionHandles) ? metaPromotionHandles[0] : metaPromotionHandles;
      const promotionModifier = promotionHandle ? ` product-card__promotion--${promotionHandle}` : '';
      const promotionUI =
        promotionArray.length > 0
          ? `<div class="product-card__promotion${promotionModifier} caption">${promotionArray.join(', ')}</div>`
          : '';

      return `<li class="results-grid__tile" data-id="${uniqueId}" data-prank="${idx}"><product-card data-product-card="" class="product-card" id="${uniqueId}">
              <div class="product-card__top">
                  ${badgesUI}
                  <div class="product-card__image">
                      <a href="${productUrl}">
                          <div class="component-image__wrapper aspect-ratio aspect-ratio--2-3">
                              ${createImage(imgUrl, unxTitle, imageSizes)}
                          </div>
                          ${secondaryImageUI}
                      </a>
                  </div>
                  ${
                    isInStoreOnly
                      ? ''
                      : `<div class="product-card__actions ns-relative">
                      <button type="submit" 
                              data-product-modal-trigger="${productHandle}" 
                              data-product-modal-type="${isOutOfStock ? 'notify' : 'add'}"
                              aria-label="${addToBagAriaLabel}" 
                              class="product-card__add body-small">
                          <span class="hide show--min-lg">${addToBagLabel}</span>
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Add to Bag" class="icon icon--add hide show--max-lg">
                              <path d="M5 1V3V5M5 5V9M5 5H1M5 5H9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg>
                      </button>
                  </div>`
                  }
              </div>
              <div class="product-card__meta">
                  <h4 id="product-title-${uniqueId}-unbxd-search" class="product-card__title body-small">
                      <a href="${productUrl}">${unxTitle}</a>
                  </h4>
                  <div class="product-card__price body-small">
                      <a href="${productUrl}" aria-describedby="product-title-${uniqueId}-unbxd-search">
                          ${priceDisplay}
                      </a>
                  </div>
                  ${
                    isInStoreOnly
                      ? ''
                      : `<button aria-label="Add to Wishlist" 
                          data-product-modal-trigger="${productHandle}" 
                          data-product-modal-type="wishlist" 
                          data-wishlist-icon="${uniqueId}" 
                          class="product-card__wishlist btn--none">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Heart Icon" class="icon icon--heart">
                          <path d="M3.4543 11.7241C5.60157 15.6966 9.98827 18.8966 11.9566 20C13.9249 18.8966 18.3984 15.6966 20.5457 11.7241C21.6193 9.73794 21.0825 4 15.7143 4C14.1038 4 13.245 4.96158 11.9566 6.28571C10.6683 4.96158 9.89618 4 8.28566 4C2.91748 4 2.38073 9.73794 3.4543 11.7241Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" vector-effect="non-scaling-stroke" class="icon--fill"></path>
                      </svg>
                  </button>`
                  }
              </div>
              ${swatchesUI}
              ${promotionUI}
          </product-card></li>`;
    },
    productAttributes: [
      'title',
      'id',
      'uniqueId',
      'available',
      'availability',
      'price',
      'sku',
      'imageUrl',
      'productUrl',
      'meta_badges',
      'images',
      'variants',
      'price_AUD',
      'price_NZD',
      'price_USD',
      'compareAtPrice_AUD',
      'compareAtPrice_NZD',
      'compareAtPrice_USD',
      'handle',
      'grouped_products',
      'swatch_image_url',
      'product_hex',
      'tags',
      'video_urls',
      'meta_promotion_values',
      'meta_promotion_handles',
    ],
    attributesMap: {
      unxTitle: 'title',
      unxImageUrl: 'imageUrl',
      unxPrice: 'price',
      unxStrikePrice: 'discountPrice',
      unxId: 'uniqueId',
      unxDescription: 'productDescription',
      unxProductUrl: 'productUrl',
    },
    gridCount: 1, // Set to 1 to prevent SDK from creating .UNX-row wrappers
    productItemClass: 'results-grid__tile',
    onProductClick: function onProductClick(product, e) {
      localStorage.setItem('unx_product_clicked', product.uniqueId);
      const {
        options: {
          url: {hashMode, queryParamSeparator, keyValueSeparator},
        },
      } = window.unbxdSearch;
    },
    defaultImage: SHOPIFY_PLACEHOLDER_IMAGE_URL,
    htmlAttributes: {
      class: 'results-grid results-grid--default list-inline UNX-search-results-block UNX-result-wrapper',
      'data-grid': 'true',
      'data-results-grid': 'true',
      'data-layout-mobile': '2',
      'data-layout-mobile-alt': '1',
      'data-layout-desktop': '4',
      'data-layout-desktop-alt': '3',
      'data-image-sizes-alt': '(min-width: 85.5rem) calc(85.5rem / 3), (min-width: 61.875rem) calc(100vw / 3), 100vw',
    },
    tagName: 'ul',
  },
  facet: {
    facetsEl: null, // Set dynamically at init time
    actionBtnClass: 'UNX-action-item',
    actionChangeClass: 'UNX-action-change',
    facetTemplate: function facetTemplate(facetObj, children, isExpanded, facetSearchTxt, facet) {
      const {displayName, facetName, multiLevelField, facetType, values} = facetObj;

      // Only render the price range facet that matches the active country
      const allPriceFacets = Object.values(countryPriceFacetMap);
      if (allPriceFacets.includes(facetName) && facetName !== activePriceFacet) {
        return '';
      }

      const {
        facetClass,
        applyMultipleFilters,
        isCollapsible,
        isSearchable,
        searchPlaceHolder,
        textFacetWrapper,
        enableViewMore,
        viewMoreText,
        viewMoreLimit,
        applyButtonText,
        clearButtonText,
      } = facet;
      const {actionBtnClass, actionChangeClass} = this.options;

      const selected = this.getSelectedFacets()[facetName];
      const isFtr = selected && selected.length > 0 ? true : false;

      // Determine panel state
      const panelClass = isExpanded ? 'accordion__panel open' : 'accordion__panel';
      const panelStyle = isExpanded ? 'height: auto;' : 'height: 0px;';
      const ariaExpanded = isExpanded ? 'true' : 'false';

      // Plus icon SVG
      const plusIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Plus Icon" class="icon icon--plus"><path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" vector-effect="non-scaling-stroke"></path></svg>`;

      // Minus icon SVG
      const minusIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Minus Icon" class="icon icon--minus"><path d="M19 12H5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" vector-effect="non-scaling-stroke"></path></svg>`;

      // Determine column count based on facet type
      const columnCount = facetType === 'text' && values.length > 6 ? '2' : '1';

      // Detect color facet for swatch grid layout
      const isColorFacet = facetName.toLowerCase().includes('colour') || facetName.toLowerCase().includes('color');
      const listClass = isColorFacet
        ? 'results-filter__filter-list results-filter__color-swatch-grid'
        : 'results-filter__filter-list results-filter__filter-list--columns';
      const columnsAttr = isColorFacet ? '' : `data-list-columns="${columnCount}"`;

      if (facetName === 'v_Size_uFilter') {
        const sizeOrder = [
          'XXS',
          'XXSP',
          'XS',
          'XS/S',
          'XS-P',
          'S',
          'S/M',
          'S-P',
          'M',
          'M/L',
          'M-P',
          'L',
          'L-P',
          '2L',
          'XL',
          'XL/3',
          'XL-P',
          '3L',
        ];
        const sizeOrderUpper = sizeOrder.map(function (s) {
          return s.toUpperCase();
        });
        const sortedValues = values.slice().sort(function (a, b) {
          const aName = a.name.toUpperCase();
          const bName = b.name.toUpperCase();
          const aIdx = sizeOrderUpper.indexOf(aName);
          const bIdx = sizeOrderUpper.indexOf(bName);
          const aIsNum = !isNaN(parseFloat(a.name)) && isFinite(a.name);
          const bIsNum = !isNaN(parseFloat(b.name)) && isFinite(b.name);
          if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
          if (aIdx !== -1) return -1;
          if (bIdx !== -1) return 1;
          if (aIsNum && bIsNum) return parseFloat(a.name) - parseFloat(b.name);
          return aName.localeCompare(bName);
        });
        const facetItemTemplateFn = this.options.facet.facetItemTemplate.bind(this);
        const selectedSizeValues = this.getSelectedFacets()[facetName] || [];
        children = sortedValues
          .map(function (v) {
            const isValueSelected = selectedSizeValues.some(function (s) {
              return s.dataId === v.dataId;
            });
            const perValueFacet = Object.assign({}, facetObj, {isSelected: isValueSelected});
            return facetItemTemplateFn(perValueFacet, v, facetSearchTxt);
          })
          .join('');
      }

      return `<div class="accordion__label">
              <button type="button" aria-expanded="${ariaExpanded}" class="accordion__trigger ${actionBtnClass}" data-facet-name="${facetName}" data-facet-action="${isExpanded ? 'facetClose' : 'facetOpen'}">
                  ${displayName}
                  <span class="accordion__trigger-indicator">${plusIcon}${minusIcon}</span>
              </button>
          </div>
          <div class="${panelClass}" style="${panelStyle}">
              <div class="accordion__body">
                  <div data-results-filter-content="true">
                      <ul ${columnsAttr} class="${listClass}">
                          ${children}
                      </ul>
                  </div>
              </div>
          </div>`;
    },
    facetItemTemplate: function facetItemTemplate(facet, value, facetSearchTxt) {
      const {facetName, isSelected} = facet;
      const {name, count, dataId} = value;
      let {facetClass, selectedFacetClass} = this.options.facet;
      const {UNX_uFilter} = this.testIds;

      let hiddenClass = '';
      if (facetSearchTxt && facetSearchTxt.length > 0) {
        if (name.toUpperCase().indexOf(facetSearchTxt.toUpperCase()) < 0) {
          hiddenClass = ' UNX-search-hidden';
        }
      }

      let action = 'changeFacet';
      let selectedClass = '';
      if (isSelected) {
        action = 'deleteFacetValue';
        selectedClass = ` ${selectedFacetClass}`;
      }

      const inputId = `facet--${facetName}--${dataId}`;
      const checkedAttr = isSelected ? 'checked' : '';

      // Color swatch facet - detect by facet name containing "colour" or "color"
      const isColorFacet = facetName.toLowerCase().includes('colour') || facetName.toLowerCase().includes('color');

      if (isColorFacet) {
        // Color name to CSS color mapping
        const colorMap = {
          black: '#000000',
          white: '#FFFFFF',
          red: '#CC0000',
          blue: '#0055AA',
          navy: '#001F5B',
          green: '#2E7D32',
          yellow: '#F9A825',
          orange: '#E65100',
          pink: '#E91E63',
          purple: '#7B1FA2',
          grey: '#9E9E9E',
          gray: '#9E9E9E',
          brown: '#6D4C41',
          cream: '#FFFDD0',
          gold: '#C9A84C',
          silver: '#C0C0C0',
          khaki: '#C3B091',
          neutral: '#E8DFD0',
          multi: 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
          multicolour: 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
          multicolor: 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
          floral: 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 25%, #88D8B0 50%, #FF6B9D 75%, #C084FC 100%)',
          stripe: 'repeating-linear-gradient(45deg, #333 0px, #333 4px, #fff 4px, #fff 8px, #888 8px, #888 12px)',
        };

        const colorKey = name.toLowerCase().trim();
        const normalizedColorKey = colorKey.replace(/[\s\-_/]+/g, '');
        const colorValue =
          colorMap[colorKey] ||
          colorMap[normalizedColorKey] ||
          (normalizedColorKey.includes('multi') ? colorMap.multi : colorKey);
        const isGradient = colorValue.includes('gradient');
        const bgStyle = isGradient ? `background: ${colorValue};` : `background-color: ${colorValue};`;
        const needsBorder = ['white', 'cream', 'neutral'].includes(colorKey);
        const borderClass = needsBorder ? ' UNX-color-swatch--bordered' : '';
        const selectedSwatchClass = isSelected ? ' UNX-color-swatch--selected' : '';

        return `<li data-nosto-element="facet-setting" class="results-filter__filter-value results-filter__color-swatch-item${hiddenClass}">
                  <div data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}" class="UNX-change-facet UNX-color-facet-item ${facetClass}${selectedClass}" data-id="${dataId}" title="${name} (${count})">
                      <input id="${inputId}" type="checkbox" ${checkedAttr} class="UNX-color-swatch-input" data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}" data-id="${dataId}">
                      <label for="${inputId}" class="UNX-color-swatch-label" data-id="${dataId}" data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}">
                          <span class="UNX-color-swatch${borderClass}${selectedSwatchClass}" style="${bgStyle}" data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}" data-id="${dataId}"></span>
                          <span class="UNX-color-swatch-name" data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}" data-id="${dataId}">${name} (${count})</span>
                      </label>
                  </div>
              </li>`;
      }

      // Default checkbox facet
      return `<li data-nosto-element="facet-setting" class="results-filter__filter-value${hiddenClass}">
              <div data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}" class="UNX-change-facet ${facetClass}${selectedClass}" data-id="${dataId}">
                  <input id="${inputId}" type="checkbox" ${checkedAttr} data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}" data-id="${dataId}">
                  <label for="${inputId}" class="UNX-facet-text" data-id="${dataId}" data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}">
                      <span class="text" data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}" data-id="${dataId}">${name} (${count})</span>
                  </label>
              </div>
          </li>`;
    },
    facetMultiSelect: true,
    facetClass: 'UNX-facets-block',
    facetAction: 'click',
    selectedFacetClass: 'UNX-selected-facet-btn',
    selectedFacetsEl: null, // Will be set dynamically
    selectedFacetTemplate: function selectedFacetTemplate(selections, facet, selectedFacetsConfig) {
      const {clearAllText, clearFacetsSelectorClass, facetClass, selectedFacetClass} = facet;

      const crossIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Cross Icon" class="icon icon--cross" data-facet-action="clearAllFacets"><path d="m18 18-6.06-6m0 0L6 6.12M11.94 12 18 6m-6.06 6L6 17.88" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" data-facet-action="clearAllFacets"></path></svg>`;

      if (selections.length > 0) {
        return `<ul class="results-filter__applied-filters">
                  <li>
                      <div class="results-filter__applied-filter results-filter__applied-filter--clear-all btn-none ${clearFacetsSelectorClass} ${selectedFacetClass}" data-facet-action="clearAllFacets">
                          ${clearAllText}${crossIcon}
                      </div>
                  </li>
                  ${selections}
              </ul>`;
      } else {
        return ``;
      }
    },
    selectedFacetItemTemplate: function selectedFacetItemTemplate(
      selectedFacet,
      selectedFacetItem,
      facetConfig,
      selectedFacetsConfig
    ) {
      const {facetName, facetType, displayName} = selectedFacet;
      const {name, count, dataId} = selectedFacetItem;
      const {removeFacetsSelectorClass, facetClass, selectedFacetClass} = this.options.facet;
      const {UNX_uFilter} = this.testIds;

      let action = 'deleteSelectedFacetValue';
      if (facetType === 'range') {
        action = 'deleteSelectedRange';
      }

      const crossIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Cross Icon" class="icon icon--cross" data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}" data-id="${dataId}"><path d="m18 18-6.06-6m0 0L6 6.12M11.94 12 18 6m-6.06 6L6 17.88" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke" data-facet-name="${facetName}" data-facet-action="${action}" data-id="${dataId}"></path></svg>`;

      // Use displayName if available, otherwise format facetName
      const facetLabel =
        displayName ||
        facetName
          .replace(/_/g, ' ')
          .replace(/uFilter/g, '')
          .trim();

      return `<li>
              <div class="results-filter__applied-filter btn-none ${removeFacetsSelectorClass} ${selectedFacetClass}" data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-facet-action="${action}" data-id="${dataId}" title="Remove ${facetLabel} ${name}">
                  ${facetLabel}: ${name}${crossIcon}
              </div>
          </li>`;
    },
    selectedFacetConfig: {
      tagName: 'DIV',
      htmlAttributes: {
        style: 'display: contents;',
      },
      events: {},
    },
    clearAllText: 'Clear All',
    rangeTemplate: function rangeTemplate(range, selectedRange, facet) {
      const {facetName, start, end, gap, max} = range;
      const {rangeWidgetConfig, clearButtonText} = facet;
      const {prefix} = rangeWidgetConfig;

      // The SDK computes `end` from the last data bucket (e.g. 350+gap=400),
      // discarding the API's configured end (e.g. 500). Retrieve the true end
      // from the raw API response so inputs and the slider span the full range.
      const rawFacets = typeof this.getRangeFacets === 'function' ? this.getRangeFacets() : [];
      const rawFacet = rawFacets.find(function (f) {
        return f.facetName === facetName;
      });
      const trueEnd = rawFacet && rawFacet.values && rawFacet.values.end != null ? rawFacet.values.end : end;

      let min = start;
      let maxVal = trueEnd;

      // If there's a selected range, use those values
      if (selectedRange.length > 0) {
        const sel = selectedRange[0].replace(/[^\w\s]/gi, '').split(' TO ');
        min = parseInt(sel[0]) || start;
        maxVal = parseInt(sel[1]) || trueEnd;
      }

      const rangId = `${facetName}_slider`;

      return `<li class="results-filter__filter-value results-filter__range-slider">
              <div class="UNX-range-slider-wrap" id="${facetName}" data-id="${facetName}">
                  <div class="UNX-range-inputs-container">
                      <div class="UNX-range-input-group">
                          <span class="UNX-range-prefix">${prefix}</span>
                          <input type="number" 
                                 id="${rangId}_min" 
                                 class="UNX-range-input UNX-range-min-input" 
                                 value="${min}" 
                                 min="${start}" 
                                 max="${maxVal}"
                                 data-facet-name="${facetName}"
                                 data-range-type="min"
                                 placeholder="Min">
                          <span class="UNX-range-separator">to</span>
                          <span class="UNX-range-prefix">${prefix}</span>
                          <input type="number" 
                                 id="${rangId}_max" 
                                 class="UNX-range-input UNX-range-max-input" 
                                 value="${maxVal}" 
                                 min="${min}" 
                                 max="${trueEnd}"
                                 data-facet-name="${facetName}"
                                 data-range-type="max"
                                 placeholder="Max">
                      </div>
                  </div>
                  <div id="${rangId}" data-x="${min}" data-y="${maxVal}" data-range-end="${trueEnd}" class="UNX-range-slider-wrapper"></div>
              </div>
          </li>`;
    },
    rangeWidgetConfig: {
      minLabel: '',
      maxLabel: '',
      prefix: '$',
    },
    facetMultilevel: false,
    facetMultilevelName: 'Category',
    multiLevelFacetSelectorClass: 'UNX-multilevel-facet',
    //   multiLevelFacetTemplate: function multiLevelFacetTemplate(facet, selectedCategories, facetSearchTxt, facetConfig) {
    //       let UI = "";
    //       let { multiLevelFacetSelectorClass, facetClass } = facetConfig;
    //       const { UNX_facetLevel } = this.testIds;
    //       if (selectedCategories) {
    //           selectedCategories.forEach((item) => {
    //               const { level, filterField, value } = item;
    //               let lTid = `data-test-id="${UNX_facetLevel}${level}"`;
    //               const levelCss = `${ multiLevelFacetSelectorClass }  UNX-category-level-${ level }`;
    //               UI += `<button ${ lTid } data-parent="${filterField}" data-level="${level}" data-name="${value}" class= " ${levelCss} UNX-selected-crumb ${facetClass}" data-action = "clearCategoryFilter">
    //                   <span class= "UNX-category-icon"></span>
    //                   <label class="UNX-facet-text">${decodeURIComponent(value)}</label>
    //               </button>`
    //           });
    //       }
    //       const { level, displayName, values, filterField } = facet;
    //       let { multiLevelField } = facet;
    //       if (!multiLevelField) {
    //           multiLevelField = filterField;
    //       }
    //       let lTid = `data-test-id="${UNX_facetLevel}${level}"`;
    //       let levelCss = `UNX-category-level-${ level }`;
    //       const valueUI = values.map((item) => {
    //           const { name, count, dataId } = item;
    //           if (facetSearchTxt && facetSearchTxt.length> 0) {
    //               if (name.toUpperCase().indexOf(facetSearchTxt.toUpperCase()) <0) {
    //                   facetClass += " UNX-search-hidden";
    //               }
    //           }
    //           return (`<button ${ lTid } data-parent="${multiLevelField}" data-level="${level}" class= "${multiLevelFacetSelectorClass} ${levelCss} ${facetClass}" data-name="${dataId}" data-action = "setCategoryFilter">
    //               <label class= "UNX-facet-text"> ${ name }</label>
    //               <label class="UNX-facet-count">(${count})</label>
    //           </button>`)
    //       });
    //       UI += `<div class= "UNX-category-values"> ${ valueUI.join("") }</div> `;
    //       if (UI !== "") {
    //           return `<div class= "UNX-multi-facet-wrap">${ UI }</div>`
    //       } else {
    //           return "";
    //       }
    //   },
    facetDepth: 4,
    clearFacetsSelectorClass: 'UNX-clear-facet',
    removeFacetsSelectorClass: 'UNX-remove-facet',
    onFacetLoad: function onFacetLoad(facets) {
      let _this = this;
      let self = this;
      let facet = this.options.facet;
      let rangeWidgetConfig = facet.rangeWidgetConfig;

      // Delay to ensure DOM is updated after facet render
      setTimeout(function () {
        facets.forEach(function (facetItem) {
          let facetType = facetItem.facetType,
            facetName = facetItem.facetName,
            gap = facetItem.gap;
          let prefix = rangeWidgetConfig.prefix;

          if (facetType === 'range') {
            const allPriceFacets = Object.values(countryPriceFacetMap);
            if (allPriceFacets.includes(facetName) && facetName !== activePriceFacet) {
              return;
            }
            const rangeId = `${facetName}_slider`;
            const sliderElem = document.getElementById(rangeId);

            // Check if noUiSlider is available
            if (typeof noUiSlider === 'undefined') {
              console.error('noUiSlider library is not loaded');
              return;
            }

            // Check if slider element exists
            if (!sliderElem) {
              console.error(`Slider element with id '${rangeId}' not found in DOM`);
              return;
            }

            let {end, max, min, start} = facetItem;
            const selectedValues = sliderElem.dataset;
            // Prefer the true API end stored by rangeTemplate; fall back to SDK-computed end
            const rangeEnd = selectedValues && selectedValues.rangeEnd ? Number(selectedValues.rangeEnd) : end;

            if (selectedValues) {
              start = Number(selectedValues.x);
              end = Number(selectedValues.y);
            }

            try {
              // Destroy existing slider if present
              if (sliderElem.noUiSlider) {
                sliderElem.noUiSlider.destroy();
              }

              _this[rangeId] = noUiSlider.create(sliderElem, {
                start: [start, end],
                connect: true,
                range: {
                  min: 0,
                  max: rangeEnd,
                },
                format: {
                  to: function (value) {
                    return Math.round(value);
                  },
                  from: function (value) {
                    return Math.round(value);
                  },
                },
                padding: 0,
                margin: 0,
              });

              // Update filter when slider is set
              _this[rangeId].on('set', function (data) {
                const newData = {
                  start: data[0],
                  end: data[1],
                  facetName: facetName,
                  gap: gap,
                };
                self.setRangeSlider(newData);
              });

              // Update input fields when slider moves
              _this[rangeId].on('slide', function (data) {
                const minInput = document.getElementById(`${rangeId}_min`);
                const maxInput = document.getElementById(`${rangeId}_max`);
                if (minInput) minInput.value = Math.round(data[0]);
                if (maxInput) maxInput.value = Math.round(data[1]);
              });

              // Add event listeners for input fields
              const minInput = document.getElementById(`${rangeId}_min`);
              const maxInput = document.getElementById(`${rangeId}_max`);
              const resetBtn = document.querySelector(`[data-facet-name="${facetName}"].UNX-range-reset-btn`);

              if (minInput) {
                minInput.addEventListener('keydown', function (e) {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    this.dispatchEvent(new Event('change'));
                  }
                });
                minInput.addEventListener('change', function () {
                  const minVal = parseInt(this.value) || 0;
                  const maxVal = parseInt(maxInput.value) || rangeEnd;
                  if (minVal <= maxVal) {
                    _this[rangeId].set([minVal, maxVal]);
                    const newData = {
                      start: minVal,
                      end: maxVal,
                      facetName: facetName,
                      gap: gap,
                    };
                    self.setRangeSlider(newData);
                  } else {
                    this.value = start;
                  }
                });
              }

              if (maxInput) {
                maxInput.addEventListener('keydown', function (e) {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    this.dispatchEvent(new Event('change'));
                  }
                });
                maxInput.addEventListener('change', function () {
                  const minVal = parseInt(minInput.value) || 0;
                  const maxVal = parseInt(this.value) || rangeEnd;
                  if (maxVal >= minVal) {
                    _this[rangeId].set([minVal, maxVal]);
                    const newData = {
                      start: minVal,
                      end: maxVal,
                      facetName: facetName,
                      gap: gap,
                    };
                    self.setRangeSlider(newData);
                  } else {
                    this.value = end;
                  }
                });
              }

              // Add reset button event listener
              if (resetBtn) {
                resetBtn.addEventListener('click', function () {
                  const originalMin = parseInt(this.dataset.originalMin) || start;
                  const originalMax = parseInt(this.dataset.originalMax) || end;
                  // Reset slider
                  _this[rangeId].set([originalMin, originalMax]);
                  // Reset inputs
                  if (minInput) minInput.value = originalMin;
                  if (maxInput) maxInput.value = originalMax;
                  // Clear facet
                  self.deleteFacet(facetName);
                });
              }
            } catch (error) {
              console.error(`Error creating slider for ${facetName}:`, error);
            }
          }
        });
      }, 100); // 100ms delay for DOM update
    },
    applyMultipleFilters: false,
    applyButtonText: 'Apply',
    clearButtonText: 'Clear',
    isCollapsible: true,
    defaultOpen: 'NONE',
    isSearchable: true,
    searchPlaceHolder: 'Search Filter',
    enableViewMore: false,
    viewMoreText: ['show all', 'show less'],
    viewMoreLimit: 3,
    htmlAttributes: {
      style: 'display: contents;',
    },
    tagName: 'DIV',
  },
  pagination: {
    enabled: true,
    el: null,
    type: 'FIXED_PAGINATION',
    action: 'click',
    template: function template(paginationData, pagination) {
      if (!paginationData || paginationData.noOfPages <= 1) return '';
      const {currentPage, isNext, isPrev, noOfPages, productsLn, numberOfProducts, rows} = paginationData;
      const {pageClass, selectedPageClass, pageLimit: cfgPageLimit} = pagination;
      const pageLimit = cfgPageLimit || 6;

      if (numberOfProducts <= productsLn) return '';

      const chevronLeft =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--chevron-left" aria-label="Chevron Left Icon" style="pointer-events:none"><path d="m15 18-6-6 6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/></svg>';
      const chevronRight =
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--chevron-right" aria-label="Chevron Right Icon" style="pointer-events:none"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/></svg>';

      let prevBtn = '';
      if (isPrev) {
        prevBtn = `<li style="cursor:pointer"><a class="pagination__arrow pagination__arrow--previous ${pageClass}" data-page-action="prev" aria-label="Previous page">${chevronLeft}</a></li>`;
      } else {
        prevBtn = `<li><span class="pagination__arrow pagination__arrow--previous pagination__arrow--disabled" aria-disabled="true" style="pointer-events:none;opacity:0.3">${chevronLeft}</span></li>`;
      }

      let nextBtn = '';
      if (isNext) {
        nextBtn = `<li style="cursor:pointer"><a class="pagination__arrow pagination__arrow--next ${pageClass}" data-page-action="next" aria-label="Next page">${chevronRight}</a></li>`;
      } else {
        nextBtn = `<li><span class="pagination__arrow pagination__arrow--next pagination__arrow--disabled" aria-disabled="true" style="pointer-events:none;opacity:0.3">${chevronRight}</span></li>`;
      }

      let pages = noOfPages < pageLimit ? noOfPages : pageLimit;
      let startPoint = 1;
      const r = Math.ceil(pageLimit / 2);
      if (currentPage - r > 0) {
        startPoint = currentPage - r;
        pages = currentPage + r;
      }
      if (currentPage + r >= noOfPages) {
        startPoint = Math.max(1, startPoint - (currentPage + r - noOfPages));
        pages = noOfPages;
      }

      let pageItems = '';
      const showLeadingEllipsis = startPoint > 1;
      const showTrailingEllipsis = pages < noOfPages;

      if (showLeadingEllipsis && startPoint > 1) {
        pageItems += `<li style="cursor:pointer"><a class="pagination__page pagination__page-link ${pageClass}" data-page-action="paginate" data-page-no="0" aria-label="Page 1">1</a></li>`;
        if (startPoint > 2) {
          pageItems += `<li><span class="pagination__page pagination__ellipsis" aria-label="…">…</span></li>`;
        }
      }

      for (let i = startPoint; i <= pages; i++) {
        if (i === currentPage) {
          pageItems += `<li class="active" style="cursor:default" aria-current="page" aria-label="Current page, Page ${i}"><span class="pagination__page ${pageClass} ${selectedPageClass}">${i}</span></li>`;
        } else {
          pageItems += `<li style="cursor:pointer"><a class="pagination__page pagination__page-link ${pageClass}" data-page-action="paginate" data-page-no="${(i - 1) * rows}" aria-label="Page ${i}">${i}</a></li>`;
        }
      }

      if (showTrailingEllipsis) {
        if (pages < noOfPages - 1) {
          pageItems += `<li><span class="pagination__page pagination__ellipsis" aria-label="…">…</span></li>`;
        }
        pageItems += `<li style="cursor:pointer"><a class="pagination__page pagination__page-link ${pageClass}" data-page-action="paginate" data-page-no="${(noOfPages - 1) * rows}" aria-label="Page ${noOfPages}">${noOfPages}</a></li>`;
      }

      return `<ol class="pagination" data-test-pagination-standard>${prevBtn}${pageItems}${nextBtn}</ol>`;
    },
    pageClass: 'UNX-page-items',
    selectedPageClass: 'UNX-selected-page-item',
    onPaginate: function onPaginate(paginationInfo) {
      const resultsEl =
        document.querySelector('.pagination__container') || document.querySelector('.results-container');
      if (resultsEl) {
        const offset = 120;
        const top = resultsEl.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({top: top, behavior: 'smooth'});
      }
    },
    pageLimit: 6,
    htmlAttributes: {
      class: 'pagination-nav pagination-nav--bottom',
    },
    tagName: 'NAV',
  },
  pagesize: {
    enabled: true, // Must be enabled for SDK to calculate startPageNo
    el: null, // No UI element - pageSize is fixed
    pageSize: 24,
    options: [8, 12, 16, 20, 24],
    pageSizeClass: 'UNX-pagesize',
    selectedPageSizeClass: 'UNX-selected-pagesize',
    action: 'change',
    template: function template(selected, pagesize) {
      const {UNX_pagesize} = this.testIds;
      let ui = `<label class="UNX-hidden" for="unxPageSize">Sort By</label><select aria-labelledby="unxPageSize" id="unxPageSize" aria-label="unxPageSize" name="unxPageSize" class="UNX-select-pagesize ${pagesize.pageSizeClass}">`;
      pagesize.options.forEach((opt, i) => {
        const tId = `data-test-id="${UNX_pagesize}${i + 1}"`;
        if (selected == opt) {
          ui += `<option selected ${tId} class="${pagesize.selectedPageSizeClass}" id="${opt}">${opt}</option>`;
        } else {
          ui += `<option ${tId} id="${opt}">${opt}</option>`;
        }
      });
      ui += `</select>`;
      return `<div class="UNX-pagesize-block">${ui}</div>`;
    },
    htmlAttributes: {
      class: 'UNX-page-size-block',
    },
    tagName: 'DIV',
  },
  sort: {
    enabled: true,
    el: null, // Set dynamically at init time
    options: (() => {
      const countryPriceFieldMap = {
        AU: 'price_AUD',
        NZ: 'price_NZD',
        US: 'price_USD',
      };
      const priceField = countryPriceFieldMap[getActiveCountryCode()] || 'price';
      return [
        {
          value: '',
          text: 'Featured',
        },
        {
          value: `${priceField} asc`,
          text: 'Price, low to high',
        },
        {
          value: `${priceField} desc`,
          text: 'Price, high to low',
        },
        {
          value: 'publishedAt desc',
          text: 'Latest',
        },
      ];
    })(),
    sortClass: 'UNX-sort-item',
    selectedSortClass: 'UNX-selected-sort',
    action: 'click',
    template: function template(selectedSort, sortConfig) {
      const {options, sortClass, selectedSortClass} = sortConfig;
      const {UNX_unbxdSorter} = this.testIds;

      // Plus icon SVG
      const plusIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Plus Icon" class="icon icon--plus"><path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" vector-effect="non-scaling-stroke"></path></svg>`;

      // Minus icon SVG
      const minusIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Minus Icon" class="icon icon--minus"><path d="M19 12H5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" vector-effect="non-scaling-stroke"></path></svg>`;

      let optionsUI = '';
      options.forEach((item, index) => {
        const {value, text} = item;
        const isSelected = value === selectedSort || (value === '' && !selectedSort);
        const radioId = `sidebar-sort--${index}`;

        optionsUI += `<li class="results-filter__filter-value">
                  <input id="${radioId}" type="radio" name="sidebar-sort_by" 
                         class="results-filter__sort-input ${sortClass}${isSelected ? ' ' + selectedSortClass : ''}" 
                         value="${value}" data-action="changeSort"
                         ${isSelected ? 'checked' : ''}>
                  <label for="${radioId}">${text}</label>
              </li>`;
      });

      return `<div class="accordion__label">
              <button type="button" aria-expanded="false" class="accordion__trigger UNX-action-item" data-facet-action="sortToggle">
                  Sort By
                  <span class="accordion__trigger-indicator">${plusIcon}${minusIcon}</span>
              </button>
          </div>
          <div class="accordion__panel" style="height: 0px;">
              <div class="accordion__body">
                  <ul class="results-filter__filter-list">
                      ${optionsUI}
                  </ul>
              </div>
          </div>`;
    },
    htmlAttributes: {
      style: 'display: contents;',
    },
    tagName: 'DIV',
  },
  productView: {
    enabled: true,
    defaultViewType: 'GRID',
    el: document.querySelector('.layout-switch__button-group'),
    viewTypeClass: 'UNX-product-view',
    selectedViewTypeClass: 'UNX-selected-product-view',
    action: 'click',
    template: function (selectedViewType, productViewType) {
      const isDisabled = this.getSearchResults() ? false : true;
      const {selectedViewTypeClass, viewTypeClass} = productViewType;
      const {UNX_gridBtn, UNX_listBtn} = this.testIds;
      let listBtnCss = `UNX-list-btn ${viewTypeClass}`;
      let gridBtnCss = `UNX-grid-btn ${viewTypeClass}`;
      const gTAttr = `data-test-id=${UNX_gridBtn}`;
      const lTAttr = `data-test-id=${UNX_listBtn}`;
      if (selectedViewType === 'LIST') {
        listBtnCss += ` ${selectedViewTypeClass}`;
      }
      if (selectedViewType === 'GRID') {
        gridBtnCss += ` ${selectedViewTypeClass}`;
      }
      let listBtn = `<button id="listBtn" class="${listBtnCss}" ${lTAttr} data-view-action="LIST" >List</button>`;
      let gridBtn = `<button ${gTAttr} id="gridBtn" class="${gridBtnCss}" data-view-action="GRID" >Grid</button>`;
      if (isDisabled) {
        listBtn = `<button ${lTAttr} id="listBtn" disabled class="${listBtnCss} disabled-btn" data-view-action="LIST" >List</button>`;
        gridBtn = `<button ${gTAttr} id="gridBtn" disabled class="${gridBtnCss}  disabled-btn"data-view-action="GRID" >Grid</button>`;
      }
      const savedMode = getStoredLayoutViewMode();
      const selectedMode = savedMode || 'default';
      const isAltSelected = selectedMode === 'alt';
      const altSelectedClass = isAltSelected ? ' is-selected' : '';
      const defaultSelectedClass = isAltSelected ? '' : ' is-selected';
      const altPressed = isAltSelected ? 'true' : 'false';
      const defaultPressed = isAltSelected ? 'false' : 'true';

      return `<div class="layout-switch__button-group"><span class="layout-switch__label">View</span><button type="button" aria-label="Display up to three products per grid row" aria-pressed="${altPressed}" data-results-layout-switch="alt" class="layout-switch layout-switch--alt btn-none body-small${altSelectedClass}"><span class="hide--min-lg">1</span><span class="hide--max-lg"><span class="hide--sidebar-open">3</span><span class="hide--sidebar-closed">2</span></span></button><button type="button" aria-label="Display up to four products per grid row" aria-pressed="${defaultPressed}" class="layout-switch layout-switch--default btn-none body-small${defaultSelectedClass}"><span class="hide--min-lg">2</span><span class="hide--max-lg"><span class="hide--sidebar-open">4</span><span class="hide--sidebar-closed">3</span></span></button></div>`;
    },
    htmlAttributes: {
      class: 'product-view-container',
    },
    tagName: 'DIV',
  },
  breadcrumb: {
    enabled: true,
    el: document.getElementById('breadcrumbContainer'),
    template: function template(breadcrumbs, breadcrumb) {
      let UI = ``;
      const {selectorClass} = breadcrumb;
      breadcrumbs.forEach((item, id) => {
        const {level, filterField, value} = item;
        const css = `${selectorClass} UNX-bread-crumb-item`;
        if (id > 0) {
          UI += `<span class= "UNX-slash" > / </span> `;
        }
        UI += `<button data-parent="${filterField}" data-level="${level}" class= "${css}" data-name="${value}" data-action = "clearCategoryFilter">
                      ${decodeURIComponent(value)}
                  </button> `;
      });
      return `<div class= "bread-crumb-main"> ${UI}</div>`;
    },
    selectorClass: 'UNX-bread-crumb',
    htmlAttributes: {
      class: 'UNX-breadcrumbs-block',
    },
    tagName: 'DIV',
  },
  spellCheck: {
    enabled: true,
    el: null,
    template: function (query, suggestion, pages) {
      const {numberOfProducts} = pages;
      const {selectorClass} = this.options.spellCheck;
      const {productType} = this.options;
      const {UNX_spellCheck} = this.testIds;

      if (numberOfProducts <= 0) {
        return ``;
      }

      let displayQuery = query;

      if (productType !== 'SEARCH') {
        const catId = this.getCategoryId() || '';
        const cId = decodeURIComponent(catId);
        const catPath = cId?.replace(/categoryPath:"|'|"/g, '');
        if (catPath) {
          displayQuery = catPath.replaceAll('>', ' > ');
        }
      }

      if (suggestion) {
        return `<div class="UNX-spellcheck-block">Your search "<strong>${suggestion}</strong>" did not match any products. Did you mean <Strong data-test-id="${UNX_spellCheck}" data-action="getSuggestion" class="${selectorClass}">${query}</Strong>?</p></div>`;
      }

      return `<div class="UNX-spellcheck-block"><p>Search: ${numberOfProducts} results for '${displayQuery}'</p></div>`;
    },
    selectorClass: 'UNX-suggestion',
    htmlAttributes: {
      class: 'UNX-spellcheck-wrapper',
    },
    tagName: 'DIV',
  },
  banner: {
    enabled: true,
    openNewTab: true,
    el: document.getElementById('bannerContainer'),
    template: function template(banners, bannerOpts) {
      const {openNewTab} = bannerOpts;
      const bannerUI = banners
        .map((item) => {
          const {imageUrl, landingUrl, bannerHtml} = item;
          if (bannerHtml) {
            return bannerHtml;
          }
          let hrefStr = ``;
          if (landingUrl) {
            hrefStr += `href=${landingUrl}`;
          }
          if (openNewTab) {
            hrefStr += `  target = "_blank"`;
          }
          return `<a class= "UNX-banner-wrap" ${hrefStr}> <img style="max-width:100%" src="${imageUrl}" /></a> `;
        })
        .join('');
      return `${bannerUI}`;
    },
    htmlAttributes: {
      class: 'UNX-banner-block',
    },
    tagname: 'DIV',
  },
  variants: {
    enabled: true,
    count: 100,
    groupBy: 'price',
    attributes: ['v_availableForSale', 'v_Size', 'v_Color', 'variantId'],
    mapping: {
      image_url: 'v_imageUrl',
    },
  },
  swatches: {
    enabled: false,
    attributesMap: {},
    swatchClass: 'UNX-swatch-btn',
    template: function template(swatchData, swatches, product) {
      return {btnList: '', imgList: ''};
    },
  },
  noResults: {
    el: document.querySelector('.UNX-no-results-wrapper'),
    template: function template(query) {
      const responseObj = window.unbxdSearch?.state?.responseObj || {};
      const hasSuggestion = responseObj?.didYouMean?.length > 0 || responseObj?.searchMetaData?.didYouMean?.length > 0;
      if (hasSuggestion) {
        return '';
      }
      return `<div class='UNX-no-results UNX-no-results--custom'>
                <div class="UNX-no-results__text">
                    <span>Pardon, we couldn't find anything for <b>"${query}"</b>.<br />
                    But there's always something beautiful waiting to be discovered.<br />
                    Perhaps you'd like to explore something new instead?</span>
                </div>
            </div>`;
    },
  },
  url: {
    hashMode: false,
    allowExternalUrlParams: true, // Allow facets from URL
    seoFriendlyUrl: true,
    orderOfQueryParams: [],
    queryParamSeparator: '&',
    keyValueSeparator: '=',
    browseQueryParam: {
      addToUrl: false,
      algo: 'KEY_VALUE_REPLACER',
      keyReplacer: 'p',
    },
    searchQueryParam: {
      addToUrl: true,
      algo: 'KEY_VALUE_REPLACER',
      keyReplacer: 'q',
    },
    pageViewParam: {
      addToUrl: false,
      algo: 'KEY_VALUE_REPLACER',
      keyReplacer: 'viewType',
      valuesReplacer: {
        GRID: 'g',
        LIST: 'l',
      },
    },
    sortParam: {
      addToUrl: true,
      algo: 'KEY_VALUE_REPLACER',
      keyReplacer: 'sort',
      valueReplacer: {
        'price asc': 'asc',
        'price desc': 'desc',
      },
    },
    facetsParam: {
      addToUrl: true,
      algo: 'KEY_VALUE_REPLACER',
      multiValueSeparator: ',',
      keyReplacer: {
        color_uFilter: 'color',
        size_uFilter: 'size',
      },
      valueReplacer: {
        color_uFilter: {Black: 'BLK'},
        size_uFilter: {XS: 'XSmall'},
      },
      facetsOrderInUrl: ['color_uFilter', 'price'],
      rangeFacets: [activePriceFacet],
      rangeSeparator: '-',
    },
    pageSizeParam: {addToUrl: true, keyReplacer: 'rows'},
    pageNoParam: {
      addToUrl: true,
      algo: 'KEY_VALUE_REPLACER',
      keyReplacer: 'page',
      usePageNo: true,
    },
  },
  hashMode: false,
  allowExternalUrlParams: true, // Defense-in-depth: block external params at root
  browseQueryParam: 'p',
  searchQueryParam: 'q',
  unbxdAnalytics: false,
  actionBtnClass: 'UNX-action-item',
  actionChangeClass: 'UNX-action-change',
  extraParams: {
    filter: function () {
      const countryCode = getActiveCountryCode();
      return countryCode ? `v_available_markets:"${countryCode}"` : '';
    },
    dimension: false,
  },
  debugMode: true,
  defaultFilters: {},
  searchEndPoint: 'https://search.unbxd.io/',
  onEvent: function template(instance, type, state) {
    // enter your code here
    console.log('onEvent', instance, type, state);
    if (type === 'AFTER_RENDER') {
      console.log('AFTER_RENDER', instance, type, state);
      updatePaginationValues(instance);
      syncResultsGridLayoutWithSelectedView();
      const responseObj = instance?.state?.responseObj;
      const hasDidYouMean = responseObj?.didYouMean?.length > 0 || responseObj?.searchMetaData?.didYouMean?.length > 0;
      if (responseObj?.response?.numberOfProducts === 0 && !hasDidYouMean) {
        renderNoResultUI();
      }
      updatePageTitle(responseObj?.response?.numberOfProducts, responseObj?.searchMetaData?.queryParams?.q);
      if (
        localStorage.getItem('unx_product_clicked') &&
        document.getElementById(localStorage.getItem('unx_product_clicked'))
      ) {
        setTimeout(function () {
          document
            .getElementById(localStorage.getItem('unx_product_clicked'))
            .scrollIntoView({behavior: 'smooth', block: 'center'});
          localStorage.removeItem('unx_product_clicked');
        }, 800);
      }
    }
  },
  onError: function template(module, err) {},
  setCategoryId: function template(param, self) {
    const {level, parent, name, action} = param;
    let page = ``;
    let pathArr = [];
    const l = Number(level);
    const breadCrumbs = self.getBreadCrumbsList('categoryPath');
    breadCrumbs.forEach((element, i) => {
      const {level, value} = element;
      if (l > Number(level) || Number(level) === 1) {
        pathArr.push(value);
      }
    });
    if (action !== 'clearCategoryFilter') {
      pathArr.push(decodeURIComponent(name));
    }
    page = pathArr.join('>');
    if (window.UnbxdAnalyticsConf) {
      window.UnbxdAnalyticsConf.page = 'categoryPath:"' + page + '"';
    }
    const banner = document.querySelector('.banner .catVal');
    if (banner) {
      banner.innerHTML = page.replace(/>/g, ' > ');
    }
  },
};

const getCategoryName = () => {
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  return pathParts.length > 0 ? pathParts[pathParts.length - 1] : '';
};

// Initialize search - wait for DOM elements to be ready
function initUnbxdSearch() {
  if (typeof UnbxdSearch === 'undefined' || window.unbxdSearch) return false;

  const resultsMain =
    document.querySelector('.results-container .results-main') || document.querySelector('.results-main');
  if (!resultsMain) return false;

  // Wrap products in a dedicated container so the SDK only manages this
  // wrapper, keeping pagination as a separate child of .results-main.
  let productsWrapper = resultsMain.querySelector('.UNX-products-wrapper');
  if (!productsWrapper) {
    productsWrapper = document.createElement('div');
    productsWrapper.className = 'UNX-products-wrapper';
    productsWrapper.style.display = 'contents';
    while (resultsMain.firstChild) {
      productsWrapper.appendChild(resultsMain.firstChild);
    }
    resultsMain.appendChild(productsWrapper);
  }
  searchJSConfig.products.el = productsWrapper;

  // Find and set facet containers at runtime (desktop or mobile based on viewport)
  const isMobile = (window.outerWidth || window.innerWidth) < 992;
  const desktopFilters = document.querySelector('.results-sidebar__form div.results-filters');
  const mobileFilters = document.querySelector('.results-filter__drawer div.results-filters');

  // Choose the appropriate container based on viewport
  const resultsFilters = isMobile ? mobileFilters || desktopFilters : desktopFilters || mobileFilters;

  if (resultsFilters) {
    // Remove existing applied filters UL if present
    const existingAppliedFilters = resultsFilters.querySelector('.results-filter__applied-filters');
    if (existingAppliedFilters) {
      existingAppliedFilters.remove();
    }

    // Find or create accordion wrapper
    let accordionWrapper = resultsFilters.querySelector('div.accordion');
    if (!accordionWrapper) {
      accordionWrapper = document.createElement('div');
      accordionWrapper.className = 'accordion';
      resultsFilters.appendChild(accordionWrapper);
    }
    // Clear existing Shopify facets
    accordionWrapper.innerHTML = '';

    // Create sort container as first child in accordion
    let sortContainer = document.createElement('div');
    sortContainer.className = 'UNX-sort-accordion-item';
    sortContainer.style.display = 'contents';
    accordionWrapper.appendChild(sortContainer);
    searchJSConfig.sort.el = sortContainer;

    // Create a separate facets container AFTER sort container (also with display:contents)
    let facetsContainer = document.createElement('div');
    facetsContainer.className = 'UNX-facets-container';
    facetsContainer.style.display = 'contents';
    accordionWrapper.appendChild(facetsContainer);
    searchJSConfig.facet.facetsEl = facetsContainer;

    // Create selected facets container (applied filters) BEFORE the accordion
    let selectedFacetsContainer = document.createElement('div');
    selectedFacetsContainer.className = 'UNX-selected-facets-container';
    selectedFacetsContainer.style.display = 'contents';
    resultsFilters.insertBefore(selectedFacetsContainer, accordionWrapper);
    searchJSConfig.facet.selectedFacetsEl = selectedFacetsContainer;
  }

  // Create pagination element inside .results-main (but outside the products
  // wrapper) so it stays put when the SDK re-renders products.
  let paginationEl = resultsMain.querySelector("[data-pagination='true']");
  if (!paginationEl) {
    paginationEl = document.createElement('div');
    paginationEl.setAttribute('data-pagination', 'true');
    paginationEl.className = 'pagination-nav pagination-nav--bottom';
    paginationEl.setAttribute('aria-label', 'Pagination navigation');
  }
  paginationEl.innerHTML = '';
  resultsMain.appendChild(paginationEl);
  searchJSConfig.pagination.el = paginationEl;

  // Point spellCheck at the search header target so the SDK renders
  // "X results for 'query'" and "Did you mean" directly into it.
  const searchHeader =
    document.querySelector('[data-unbxd-search-header]') || document.querySelector('.main-search__header p');
  if (searchHeader) {
    searchHeader.innerHTML = '';
    searchJSConfig.spellCheck.el = searchHeader;
  }
  // browse config
  if (isCollectionPage) {
    // Use browse config for collection pages
    const browseConfig = {
      ...searchJSConfig,
      products: {
        ...searchJSConfig.products,
        productType: 'CATEGORY',
      },
      url: {
        ...searchJSConfig.url,
        pageSizeParam: {...searchJSConfig.url.pageSizeParam, addToUrl: false},
        pageNoParam: {...searchJSConfig.url.pageNoParam, addToUrl: false},
      },
    };
    window.unbxdSearch = new UnbxdSearch(browseConfig);

    // Set up category and trigger browse
    if (!window.unbxdSearch?.state?.isLoading) {
      const category = getCategoryName();
      window.UnbxdAnalyticsConf = window.UnbxdAnalyticsConf || {};
      window.UnbxdAnalyticsConf['page'] = `category_handle_uFilter:"${category === 'all' ? 'all-products' : category}"`;
      window.UnbxdAnalyticsConf['page_type'] = 'BOOLEAN';
      window.unbxdSearch.getCategoryPage();
    }
  } else {
    // Use search config for search pages
    window.unbxdSearch = new UnbxdSearch(searchJSConfig);
  }

  return true;
}

// Try to initialize with retry mechanism
// Match recommendations init style: initialize on DOM readiness, not full window load.

function startInitRetry() {
  let attempts = 0;
  const maxAttempts = 20; // Try for 10 seconds (20 x 500ms)

  function tryInit() {
    if (initUnbxdSearch()) {
      return; // Success
    }

    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(tryInit, 500); // Retry every 500ms
    } else {
      console.error('Could not find .results-main container for Unbxd Search after ' + maxAttempts + ' attempts');
    }
  }

  tryInit();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startInitRetry);
} else {
  startInitRetry();
}

window.addEventListener('load', function () {
  syncResultsGridLayoutWithSelectedView();
});

const updatePaginationValues = (instance) => {
  try {
    const paginationNav = document.querySelector('.pagination-nav');
    if (paginationNav) {
      paginationNav.style.display = '';
    }
  } catch (e) {
    console.error('Error updating pagination values:', e);
  }
};

// Keep results grid classes in sync with the selected "View" option.
function applyResultsGridLayout(viewMode) {
  const resultsGrid =
    document.querySelector('.results-main ul.results-grid') || document.querySelector('.results-grid');
  if (!resultsGrid) return;

  resultsGrid.classList.remove('results-grid--default', 'results-grid--alt');
  resultsGrid.classList.add(viewMode === 'alt' ? 'results-grid--alt' : 'results-grid--default');
}

function syncResultsGridLayoutWithSelectedView() {
  const viewGroup = document.querySelector('.layout-switch__button-group');
  if (!viewGroup) return;

  const savedMode = getStoredLayoutViewMode();
  if (savedMode) {
    viewGroup.querySelectorAll('.layout-switch').forEach(function (btn) {
      const isAltBtn = btn.classList.contains('layout-switch--alt');
      const isSelected = savedMode === 'alt' ? isAltBtn : !isAltBtn;
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  const selectedBtn =
    viewGroup.querySelector('.layout-switch.is-selected') ||
    viewGroup.querySelector('.layout-switch[aria-pressed="true"]') ||
    viewGroup.querySelector('.layout-switch.layout-switch--default');

  if (!selectedBtn) return;

  const selectedMode = selectedBtn.classList.contains('layout-switch--alt') ? 'alt' : 'default';
  applyResultsGridLayout(selectedMode);
}

// Accordion toggle handler for sort (SDK handles facet open/close via re-render)
function toggleSortAccordionPanel(trigger) {
  if (!trigger) return;
  const panel = trigger.closest('.accordion__label')?.nextElementSibling;
  if (!panel) return;

  const isOpen = panel.classList.contains('open');

  if (isOpen) {
    panel.classList.remove('open');
    panel.style.height = '0px';
    trigger.setAttribute('aria-expanded', 'false');
  } else {
    panel.classList.add('open');
    panel.style.height = 'auto';
    trigger.setAttribute('aria-expanded', 'true');
  }
}

function expandSortAccordionPanel(trigger) {
  if (!trigger) return;
  const panel = trigger.closest('.accordion__label')?.nextElementSibling;
  if (!panel) return;

  panel.classList.add('open');
  panel.style.height = 'auto';
  trigger.setAttribute('aria-expanded', 'true');
}

function collapseSortAccordionPanel() {
  const sortTriggers = Array.from(document.querySelectorAll('[data-facet-action="sortToggle"]'));
  sortTriggers.forEach(function (trigger) {
    const panel = trigger.closest('.accordion__label')?.nextElementSibling;
    if (!panel) return;
    panel.classList.remove('open');
    panel.style.height = '0px';
    trigger.setAttribute('aria-expanded', 'false');
  });
}

function toggleSortFromNavbar() {
  const sidebar = document.querySelector('aside.results-sidebar');
  const isSidebarHidden = sidebar && sidebar.classList.contains('is-hidden');

  const mobileDrawer = document.querySelector('.results-filter__drawer.filters-drawer.hide--min-lg');
  const shouldOpenMobileDrawer =
    window.innerWidth <= 992 && mobileDrawer && !mobileDrawer.classList.contains('is-visible');

  if (shouldOpenMobileDrawer || isSidebarHidden) {
    toggleResultsSidebarVisibility();
  }

  const sortTriggers = Array.from(document.querySelectorAll('[data-facet-action="sortToggle"]'));
  const visibleTrigger = sortTriggers.find(function (el) {
    return el.offsetParent !== null;
  });
  const sortTrigger = visibleTrigger || sortTriggers[0];

  if (!sortTrigger) return;
  expandSortAccordionPanel(sortTrigger);
}

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-facet-action="sortToggle"]');
  if (!trigger) return;
  toggleSortAccordionPanel(trigger);
});

// Toggle sidebar visibility from top navbar filter/sort buttons.
function toggleResultsSidebarVisibility() {
  const sidebar = document.querySelector('.results-sidebar');
  const mobileDrawer = document.querySelector('.results-filter__drawer.filters-drawer.hide--min-lg');

  if (sidebar) {
    const isSidebarVisible = sidebar.classList.contains('is-visible');
    sidebar.classList.toggle('is-visible', !isSidebarVisible);
    sidebar.classList.toggle('is-hidden', isSidebarVisible);
  }

  if (mobileDrawer) {
    const isDrawerVisible = mobileDrawer.classList.contains('is-visible');
    mobileDrawer.classList.toggle('is-visible', !isDrawerVisible);
    mobileDrawer.classList.toggle('is-hidden', isDrawerVisible);
  }

  if (window.innerWidth <= 768) {
    const mobileHeader = document.querySelector('header.header');
    if (mobileHeader) {
      mobileHeader.style.display = 'none';
    }
    // here add class on body unbxd-scroll-lock
    document.body.classList.add('unbxd-scroll-lock');
  }
}

function hideMobileFacetDrawer() {
  if (window.innerWidth <= 992) {
    const mobileDrawer = document.querySelector('.results-filter__drawer.filters-drawer.hide--min-lg.is-visible');
    if (mobileDrawer) {
      mobileDrawer.classList.remove('is-visible');
    }
    // remove display none from the header
    const mobileHeader = document.querySelector('header.header');
    if (mobileHeader) {
      mobileHeader.style.display = 'block';
    }
    // here remove class on body unbxd-scroll-lock
    document.body.classList.remove('unbxd-scroll-lock');
  }
}
document.addEventListener('click', function (e) {
  const navbarToggleBtn = e.target.closest('.results-navbar__toggle-buttons [data-results-filter-toggle]');
  if (navbarToggleBtn) {
    e.preventDefault();
    const toggleType = navbarToggleBtn.getAttribute('data-results-filter-toggle');
    if (toggleType === 'sort') {
      toggleSortFromNavbar();
    } else {
      collapseSortAccordionPanel();
      toggleResultsSidebarVisibility();
    }
    return;
  }

  const sortToggleBtn = e.target.closest('[data-test-search-sort-toggle]');
  if (sortToggleBtn) {
    e.preventDefault();
    toggleSortFromNavbar();
    return;
  }

  const closeBtn = e.target.closest('button.results-sidebar__close');
  if (!closeBtn) return;
  e.preventDefault();
  toggleResultsSidebarVisibility();
});
// close mobile facet drawer when the close button is clicked
document.addEventListener('click', function (e) {
  const closeBtn = e.target.closest('.filters-drawer__header svg.icon--cross');
  if (!closeBtn) return;
  e.preventDefault();
  hideMobileFacetDrawer();
});
//  close mobile facet drawer when the Apply button is clicked
document.addEventListener('click', function (e) {
  const applyBtn = e.target.closest('.filters-drawer__footer button[data-results-filter-toggle]');
  if (!applyBtn) return;
  e.preventDefault();
  hideMobileFacetDrawer();
});
// close mobile facet drawer when clicking outside of it
document.addEventListener('click', function (e) {
  if (window.innerWidth > 992) return;
  const drawer = document.querySelector('.results-filter__drawer.filters-drawer.hide--min-lg.is-visible');
  if (!drawer) return;
  if (drawer.contains(e.target)) return;
  if (e.target.closest('[data-results-filter-toggle]')) return;
  hideMobileFacetDrawer();
});
// Delegated click handler for theme-like layout switch (2/3/4 columns based on sidebar state).
document.addEventListener('click', function (e) {
  const layoutBtn = e.target.closest('.layout-switch__button-group .layout-switch');
  if (!layoutBtn) return;

  const viewGroup = layoutBtn.closest('.layout-switch__button-group');
  if (!viewGroup) return;

  viewGroup.querySelectorAll('.layout-switch').forEach(function (btn) {
    const isSelected = btn === layoutBtn;
    btn.classList.toggle('is-selected', isSelected);
    btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
  });

  const selectedMode = layoutBtn.classList.contains('layout-switch--alt') ? 'alt' : 'default';
  setStoredLayoutViewMode(selectedMode);
  applyResultsGridLayout(selectedMode);
});

function renderNoResultUI() {
  // Hide UI elements when result count is zero
  const navbar = document.querySelector('.results-navbar');
  const sidebar = document.querySelector('.results-sidebar');
  const pagination = document.querySelector('.pagination-nav');
  const resultsMain = document.querySelector('.results-main');

  if (navbar) {
    navbar.style.display = 'none';
  }
  if (resultsMain) {
    // set width to 100%
    resultsMain.style.width = '100%';
  }
  if (sidebar) {
    sidebar.style.display = 'none';
  }
  if (pagination) {
    pagination.style.display = 'none';
  }
}

//  titile - Search: 43 results found for "red"– Blue Illusion
//  it should be work on the search page only not on the category page
function updatePageTitle(numberOfProducts, query) {
  if (window.location.pathname.includes('/search')) {
    let title = `Search: ${numberOfProducts} results found for "${query}"– Blue Illusion`;
    document.title = title;
  }
}
// ============================================================
// Shopify Quick View (Product Modal) for Unbxd Search Results
// ============================================================
// Blue Illusion's Shopify theme uses <product-modal> web component
// with [data-product-modal-trigger] buttons. Since Unbxd renders
// product cards dynamically, the theme's handlers may not pick them
// up. This delegated handler ensures Quick View works on Unbxd results.
// ============================================================
if (typeof window.initUnbxdQuickView === 'function') {
  window.initUnbxdQuickView();
} else {
  console.warn('Unbxd Quick View shared module not found: window.initUnbxdQuickView');
}

// Reload once when viewport width changes on resize.
let initialViewportWidth = window.outerWidth || window.innerWidth;
let resizeReloadTimer = null;

window.addEventListener('resize', function () {
  clearTimeout(resizeReloadTimer);
  resizeReloadTimer = setTimeout(function () {
    const currentWidth = window.outerWidth || window.innerWidth;
    if (currentWidth !== initialViewportWidth) {
      initialViewportWidth = currentWidth;
      window.location.reload();
    }
  }, 200);
});
